(function () {
	'use strict';

	angular
		.module('kapdec', [
			'facebook',
			'ngAnimate',
			'ngTouch',
			'ngSanitize',
			'ngMessages',
			'ngAria',
			'ngResource',
			'ngStorage',
			'ui.router',
			'ui.bootstrap',
			'ui.select',
			'toastr',
			'ngIdle',
			'ngFileUpload',
			'uiCropper',
			'oc.lazyLoad',
			'angularMoment',
			'chart.js'])

		.config(function ($stateProvider, $urlRouterProvider, $locationProvider, IdleProvider, KeepaliveProvider, config, $httpProvider, toastrConfig, FacebookProvider) {

			$urlRouterProvider.when('/', '/home')
				.otherwise('/');

			// $locationProvider.html5Mode({
			//   enabled: true,
			//   requireBase: false
			// });

			// $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
			$httpProvider.interceptors.push('authInterceptor');
			$httpProvider.interceptors.push('http-interceptor-buffer');
			FacebookProvider.init('245879932667544');
			// Configure Idle settings
			var timeOutTimerValue = config.logOutTimerByMinutes * 60;
			var timeOutWarningTimerValue = config.warningTimerByMinutes * 60;
			IdleProvider.idle(timeOutTimerValue); // in seconds
			IdleProvider.timeout(timeOutWarningTimerValue); // in seconds

			// toastr settings
			angular.extend(toastrConfig, {
				progressBar: true,
				positionClass: 'toast-top-left',
				preventDuplicates: false,
				preventOpenDuplicates: true,
			});


		})

})();


(function () {

    'use strict';

    angular.module('kapdec')

        .controller('editSubscriptionController', function (config, _, Upload, Auth, appPattern, LoadPageData, $localStorage, FilterOption, $sce, $scope, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
            var vm = this;
            vm.updated = false;
            vm.loader = true;
            vm.isBusy = false;
            vm.pattern = appPattern;
            vm.submitted = false;
            vm.errors = {};
            vm.subscription = {};
            // vm.subscription.purchase = [{ currency: '', mrp: '' },{ currency: '', mrp: '' }];


            vm.init = function () {
                LoadPageData.subscription.getCurrency().$promise.then(function (res) {
                    if (res && res.data) {
                        vm.loader = false;
                        vm.currency = res.data;
                        // console.log(res)
                    }
                },
                    function (error) {
                        if (error && error.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });

                if ($state.params.id) {
                    LoadPageData.subscription.getById({ controller: $state.params.id }).
                    $promise.then(function (res) {
                        if (res && res.data) {
                            vm.subscription = res.data;
                            vm.subscription.duration =vm.subscription.duration +'';
                        }
                    });
                }
                vm.duration = [{ _id: '15 days', name: "15 days" }, { _id: '1 month', name: "1 month" },
                { _id: '2 month', name: "2 month" }, { _id: '3 month', name: "3 month" },
                { _id: '6 month', name: "6 month" }, { _id: '9 month', name: "9 month" },
                { _id: '1 year', name: "1 year" }
                ];


            };
            vm.init();

            /**
              get purchase add remove functionality
            **/

            vm.addOption = function () {
                if (vm.subscription.purchase.length < vm.currency.length) {
                    vm.subscription.purchase.push({ currency: '', mrp: '' });
                }
            }
            vm.delOption = function (i) {
                if (vm.subscription.purchase.length) {
                    vm.subscription.purchase.splice(i, 1);
                }
            };

            /**
              add new Subscription functionality
            **/
            vm.addSubscription = function (form) {
                vm.submitted = true;
                if (form.$valid) {
                    vm.isBusy = true;

                    LoadPageData.subscription.create(vm.subscription).$promise.then(function (res) {
                        // console.log("badge",res);
                        if (res) {
                            vm.isBusy = false;
                            toastr.success(res.message + ' Subscription added', "Successfully!");
                            $state.go("admin.managesubscription");
                        }
                    }, function (error) {
                        console.log(error)
                        vm.isBusy = false;
                        vm.errors.other = error.data.message;
                        $timeout(function () { vm.errors = {}; }, 3500);
                    });
                }

            };
            /**
              update Subscription functionality
            **/
            vm.updateSubscription = function (form) {
                vm.submitted = true;
                if (form.$valid) {
                    vm.isBusy = true;

                    LoadPageData.subscription.update({ id: vm.subscription._id }, vm.subscription).$promise.then(function (res) {
                        console.log("Subscription", res);
                        if (res) {
                            vm.isBusy = false;
                            
                            toastr.success(res.message + ' Subscription updated', "Successfully!");
                            $state.go("admin.managesubscription");
                        }
                    }, function (error) {
                        console.log(error)
                        vm.isBusy = false;
                        vm.errors.other = error.data.message;
                        $timeout(function () { vm.errors = {}; }, 3500);
                    });

                }
            };


        });

})();


(function () {

    'use strict';

    angular.module('kapdec').controller('TestQuesModalController', function (config, _, Auth, TestQuesService, LoadPageData, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log, SystemEnum) {
        var vm = this;
        //console.log(vm)
        
        vm.updated = false;
        vm.loader = true;
        vm.isBusy = false;
        vm.submitted = false;
        vm.errors = {};
        vm.ques = {};
        vm.data = {};
        var quesData={};
        vm.filterCountry = FilterOption().filter;
        vm.filterGrade = FilterOption().filter;
        vm.filterUnit = FilterOption().filter;
        vm.filterChapter = FilterOption().filter;
        vm.filterTopic = FilterOption().filter;
       
        vm.getEnum = function () {
            // vm.level =[
            //     {displayName:'Very Easy',_id:'1'},
            //     {displayName:'Easy',_id:'1'},
            //     {displayName:'Medium',_id:'1'},
            //     {displayName:'Difficult',_id:'1'},
            //     {displayName:'Very Difficult',_id:'1'},
            // ]
            SystemEnum.getParentChild({ id: 2 }).$promise.then(function (res) {
                if (res && res.data) {
                    vm.level = res.data;
                }
            });
        }
        
        vm.getEnum();
        function init() {
           // console.log($state.params.questionId)
            //console.log($state.params.questionId)
            //getGradeByCountry();
            if ($state.params.questionId) {
                vm.ques._id = $state.params.questionId;
                TestQuesService.getbyid({ id: vm.ques._id }).$promise.then(function (data) {
                   
                    if (data) {
                        vm.data = data.data;
                        if (data) {
                           // console.log(country1)
                             quesData = data.data;
                             vm.ques.country=quesData.country;
                             vm.ques.grade=quesData.grade;
                          
                            vm.ques.course = quesData.course;
                            vm.getUnits(quesData.topic);
                            vm.getChapters(quesData.unit);
                            vm.getTopics(quesData.course);
                            vm.getGradeByCountry(quesData.country);
                            vm.getCourse(quesData.grade);
                            vm.ques._id = quesData._id;
                            vm.ques.unit = quesData.unit;
                            vm.ques.chapter = quesData.chapter;
                            vm.ques.topic = quesData.topic;
                            vm.ques.level = quesData.level;
                            vm.ques.heading = quesData.heading;
                            vm.ques.questionDescription = quesData.questionDescription;
                            vm.ques.explaination = quesData.explaination;  //spell mistake
                            vm.ques.answerChoices = quesData.answerChoices;
                            vm.ques.correctChoice = quesData.correctChoice;
                        }
                    }
                });
            }
        }
       
      // console.log(vm)
        vm.getCurriculum = function () {
            LoadPageData.curriculum.get().$promise.then(function (resp) {
              // console.log('curriculum', resp);
              if (resp && resp.data) {
                vm.curriculum = resp.data;
               
              }
            });
          };
          vm.getCurriculum();
        vm.getGradeByCountry = function (country) {
          //  vm.grades =[];
          //  vm.courses =[];
          //  vm.topics=[];
          //  vm.units=[];
          //  vm.chapters=[];
            var filter = FilterOption().filter;
            filter.where["country"] = country;
            

            LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
              if (res && res.data && res.data.data) {
                vm.grades = res.data.data;
               // vm.ques.country=countryId;
             
              }
            });
          }
      
          vm.getCourse = function (grade) {
            //vm.grades =[];
           // vm.courses =[];
            //vm.topics=[];
           // vm.units=[];
           // vm.chapters=[];
            var filter = FilterOption().filter;
            filter.where["grade"] = grade;
            LoadPageData.course.getAll(filter).$promise.then(function (res) {
              if (res && res.data && res.data.data) {
                vm.courses = res.data.data;
               // vm.ques.grade=gradeId;
              }
            },
              function (error) {
                if (error && error.status == -1) {
                  toastr.error("we are offline! try later", "Oops!");
                }
              });
          }
          init();
        //function getCourse() {
           // LoadPageData.course.getCourses().$promise.then(function (res) {
               // if (res && res.data) {
                   // console.log(res)
                   // vm.courses = res.data;
                   // if (vm.data) {
                  //      vm.getTopic(vm.class.course)
                 //   }
              //  }
           // },
               // function (error) {
                   // if (error && error.status == -1) {
                   //     toastr.error("we are offline! try later", "Oops!");
                  //  }
               // });

        //}
        // $timeout(function () {
        //     vm.isEditable = model || false;
        // }, 100);

        /**
          open modal closed functionality
        **/
        vm.cancel = function () {
            $state.go("admin.managequestion");
        };
        // vm.updatedModal = function () {
        //     vm.updated = true;
        //     $uibModalInstance.close(vm.updated);
        // }

        /**
          get units as per course functionality
        **/
        vm.getUnits = function (topic) {
            //vm.grades =[];
            //vm.courses =[];
            //vm.topics=[];
            //vm.units=[];
            //vm.chapters=[];
            if (topic) {
                vm.filterUnit.where.topic = topic;
                vm.filterUnit.type = 'filter';
            };

            LoadPageData.unit.getUnit(vm.filterUnit).$promise.then(function (resp) {
                // console.log('units', resp);
                if (resp && resp.data && resp.data.data) {
                    vm.units = resp.data.data;
                    vm.loader = false;
                    //console.log(resp.data.data[0].country)
                   // quesData.country=resp.data.data[0].country;
                    //quesData.grade=resp.data.data[0].grade;
                   
                    vm.getGradeByCountry(resp.data.data[0].country);
                    vm.getCourse(resp.data.data[0].grade);
                    vm.ques.country=String(resp.data.data[0].country);
                    vm.ques.grade=String(resp.data.data[0].grade);
                  //  vm.ques.country=quesData.country;
                   // vm.ques.grade=quesData.grade;
                }
            });


        }
        vm.getChapters = function (unitId) {
            //vm.grades =[];
            //vm.courses =[];
            //vm.topics=[];
            //vm.units=[];
            vm.chapters=[];
            if (unitId) {
                vm.filterChapter.type = 'filter';
                vm.filterChapter.where.unit = unitId;

                LoadPageData.chapter.getChapter(vm.filterChapter).$promise.then(function (resp) {
                    // console.log('chapter', resp);
                    if (resp && resp.data && resp.data.data) {
                        vm.chapters = resp.data.data;
                       
                       
                    }
                });
            }

        };
        /**
          get topic as per course unit chapter functionality
        **/
        vm.getTopics = function (course) {
            //vm.grades =[];
           // vm.courses =[];
           // vm.topics=[];
           // vm.units=[];
            //vm.chapters=[];
           // TestQuesService.getByChapetId({ controller: course }).$promise.then(function (res) {
              //  console.log("quest", res);
            //});
            if (course) {
                vm.filterTopic.type = 'filter';
                vm.filterTopic.where.course = course;

                LoadPageData.topic.getTopic(vm.filterTopic).$promise.then(function (res) {
                    // console.log("topicres",res);
                    if (res && res.data && res.data.data && res.data.data.length) {
                        vm.topics = res.data.data;
                        
                    }
                });
            }

        };
        /**
          get options add remove functionality
        **/
        // vm.options =  [ {id: 1, name:'option 1'},{ id: 2, name: 'option 2'}];
        vm.ques.answerChoices = [{ option: 1, value: '' }, { option: 2, value: '' }];
        vm.addOption = function () {
            if (vm.ques.answerChoices.length < 4) {
                var opted = vm.ques.answerChoices.length + 1;
                vm.ques.answerChoices.push({ option: opted, value: '' });
            }
        }
        vm.delOption = function (i) {
            if (vm.ques.answerChoices.length > 2) {
                vm.ques.answerChoices.splice(i, 1);
            }
        };

        
        // ##################  view update form binding ###############
       
        vm.updateQuestion = function (form) {
            vm.submitted = true;
            if (form.$valid) {
                vm.isBusy = true;
                var service = {};
                if (vm.ques._id) {
                    service = TestQuesService.update({ id: vm.ques._id }, vm.ques);
                }
                else {
                    service = TestQuesService.create(vm.ques);
                }
                service.$promise.then(function (res) {
                    console.log("quest", res);
                    if (res) {
                        vm.isBusy = false;

                        // vm.updatedModal();
                        toastr.success(res.message + ' question updated', "Successfully!");
                        $state.go("admin.managequestion");
                    }
                }, function (error) {
                    console.log(error)
                    vm.isBusy = false;
                    vm.errors.other = error.data.message;
                    $timeout(function () { vm.errors = {}; }, 3500);
                });

            }
        };


    });
})();
(function () {

    'use strict';

    angular.module('kapdec')
        .factory('User', function ($resource, config) {

            var rootpath = config.baseUrl;
            return $resource(rootpath + '/api/users/:id/:controller', {
                id: '@_id'
            },
                {
                    changePassword: {
                        method: 'PUT',
                        params: {
                            controller: 'password'
                        }
                    },
                    createSubAdmin: {
                        method: 'POST',
                        params: {
                            id: 'create',
                            controller: 'subAdmin'
                        }
                    },
                    update: {
                        method: 'POST',
                        params: {
                            id: 'update'
                        }
                    },
                    updateDetails: {
                        //method: 'POST',
                        method: "PUT",
          params: {
            id: '@id'
          }
                    },
                    
                    removeImage: {
                        method: 'POST',
                        params: {
                            id: 'removeImage'
                        }
                    },
                    get: {
                        method: 'GET',
                        params: {
                            id: 'me'
                        }
                    },
                    myChildren: {
                        method: 'GET',
                        params: {
                            id: 'myChildren'
                        }
                    },
                    
                    addChildren: {
                        method: 'POST',
                        params: {
                            id: 'addChildren'
                        }
                    },
                    addChildrenCheck: {
                        method: 'POST',
                        params: {
                            id: 'addChildrenCheck'
                        }
                    },
                   // addChildrenAddTeacher: {
                      //  method: 'POST',
                      //  params: {
                      //      id: 'addChildrenAddTeacher'
                      //  }
                   // },
                    getByUid: {
                        method: 'GET',
                        params: {
                            id: '@id'
                        }
                    },
                    showStudent: {
                        method: 'GET',
                        params: {
                            id: '@id'
                        }
                    },
                    getAllUser: {
                        method: 'POST',
                        params: {
                            id: 'all'
                        }
                    },
                    getuserFind: {
                        method: 'POST',
                        params: {
                            id: 'userFind'
                        }
                    },
                    getSubAdmin: {
                        method: 'POST',
                        params: {
                            id: 'subAdmin'
                        }
                    },
                    getAll: {
                        method: 'GET',
                        isArray: true,
                    },
                    blockUser: {
                        method: "PUT",
                        params: {
                            id: 'block',
                            controller: '@id'
                        }

                    },
                    approveUser: {
                        method: "PUT",
                        params: {
                            id: 'approve',
                            controller: '@id'
                        }

                    },
                    approvePaid: {
                        method: "PUT",
                        params: {
                            id: 'IsPaid',
                            controller: '@id'
                        }

                    },
                    deleteUser: {
                        method: "PUT",
                        params: {
                            id: 'delete',
                            controller: '@id'
                        }
                    },
                    verifEmailbyParent: {
                        method: 'POST',
                        params: {
                            id:"verifyemailbyparent"
                        }
                    },
                    addNumber: {
                        method: 'PUT',
                        params: {
                            controller: 'add-phone-number'
                        }
                    },
                    logOut: {
                        method: 'GET',
                        params: {
                            id: 'logout'
                        }
                    }
                });

            // example:
            // User.addNumber({userId:$scope.userInfo._id, phoneNumber:parseInt($scope.phone.call_restaurant)}).$promise.then(function (response) {
            //    console.log(response);
            //      toastr.success("Number Added", "Successfully!");
            //  }, function (error) {
            //      toastr.error("Somthing is Wrong", "Error");
            // });

        })
        .factory('verifyEmail', function ($resource, config) {
            var rootpath = config.baseUrl;
            var obj = {};
            obj = $resource(rootpath + '/api/users/verify/:token', null,
                {
                    send: { method: 'GET', params: { token: '@token' } }
                });
            return obj;
        })
        .factory('addChildrenAddTeacher', function ($resource, config) {
            var rootpath = config.baseUrl;
            var obj = {};
            obj = $resource(rootpath + '/api/users/addChildrenAddTeacher/:email/:teacherId', null,
                {
                    send: { method: 'POST',params: { email: '@email',teacherId: '@teacherId' }}
                });
            return obj;
        })
        .factory('ResetPassword', function ($resource, config) {
            var rootpath = config.baseUrl;
            var obj = {};
            obj = $resource(rootpath + '/api/users/reset', null, { 'update': { method: 'PUT' } });
            return obj;
        })
        .factory('ForgotPassword', function ($resource, config) {
            var rootpath = config.baseUrl;
            var obj = {};
            obj = $resource(rootpath + '/api/users/forgot', null, { 'update': { method: 'PUT' } });
            return obj;
        })
       
        .factory('BlockByAdmin', function ($resource, config) {
            var rootpath = config.baseUrl;
            var obj = {};
            obj = $resource(rootpath + '/api/users/block', null, { 'update': { method: 'PUT' } });
            return obj;
        });



})();

(function () {

	'use strict';

	angular.module('kapdec')
		.value('redirectToUrlAfterLogin', { url: '/home' })
		.factory('Auth', function Auth($location, toastr, User, config, redirectToUrlAfterLogin, $timeout, $localStorage, $state, $rootScope, $http, $log, $q, ResetPassword, ForgotPassword) {
			var rootpath = config.baseUrl;
			var currentUser = {};
			if ($localStorage.access_token) {
				currentUser = User.get();
			}

			return {

				/**
				 * Authenticate user and save token
				 *
				 * @param  {Object}   user     - login info
				 * @param  {Function} callback - optional
				 * @return {Promise}
				 */
				login: function (user, callback) {
					var cb = callback || angular.noop;
					var deferred = $q.defer();

					$http.post(rootpath + '/auth/login', {
						data: user
					}).
						success(function (data) {
							$localStorage.access_token = data.token;
							currentUser = User.get();
							deferred.resolve(data);
							return cb();
						}).
						error(function (err) {
							delete $localStorage.access_token;
							// this.redirectToAttemptedUrl;
							currentUser = {};
							deferred.reject(err);
							return cb(err);
						}.bind(this));

					return deferred.promise;
				},

				/**
				 * Delete access token and user info
				 *
				 * @param  {Function}
				 */
				logout: function () {
					delete $localStorage.access_token;
					currentUser = {};
				},
				saveAttemptUrl: function () {
					if ($location.path().toLowerCase() !== '/home' || $location.path().toLowerCase() !== '/home/login' || $location.path().toLowerCase() !== '/home/signup') {
						redirectToUrlAfterLogin.url = $location.path();
						console.log("saveAttemptUrl redirectToUrlAfterLogin.url in if", redirectToUrlAfterLogin.url)
					} else {
						redirectToUrlAfterLogin.url = '/dashboard';
					}
				},
				redirectToAttemptedUrl: function () {
					if (redirectToUrlAfterLogin.url == '/home') {
						$state.go('dashboard.profile');
					} else {
						$location.path(redirectToUrlAfterLogin.url || '/dashboard/profile');
					}
				},
				/**
				 * Create a new user
				 *
				 * @param  {Object}   user     - user info
				 * @param  {Function} callback - optional
				 * @return {Promise}
				 */
				createUser: function (user, callback) {
					var cb = callback || angular.noop;

					return User.save(user,
						function (data) {
							if (data && data.data && data.data.token) {
								//   $localStorage.access_token = data.data.token;
								currentUser = User.get();
							}
							return cb(user);
						},
						function (err) {
							this.logout();
							return cb(err);
						}.bind(this)).$promise;
				},

				ForgotPassword: function (user, callback) {
					var cb = callback || angular.noop;

					return ForgotPassword.save(user,
						function (data) {
							return cb(data);
						},
						function (err) {
							return cb(err);
						}.bind(this)).$promise;
				},

				ResetPassword: function (user, callback) {
					var cb = callback || angular.noop;

					return ResetPassword.save(user,
						function (data) {
							return cb(data);
						},
						function (err) {
							return cb(err);
						}.bind(this)).$promise;
				},

				/**
				 * Change password
				 *
				 * @param  {String}   oldPassword
				 * @param  {String}   newPassword
				 * @param  {Function} callback    - optional
				 * @return {Promise}
				 */
				changePassword: function (oldPassword, newPassword, callback) {
					var cb = callback || angular.noop;

					return User.changePassword({ id: currentUser._id }, {
						oldPassword: oldPassword,
						newPassword: newPassword
					}, function (user) {
						return cb(user);
					}, function (err) {
						return cb(err);
					}).$promise;
				},

				/**
				 * Gets all available info on authenticated user
				 *
				 * @return {Object} user
				 */
				getCurrentUser: function () {
					return currentUser;
				},

				/**
				 * Check if a user is logged in
				 *
				 * @return {Boolean}
				 */
				isLoggedIn: function () {
					return currentUser.data && currentUser.data.hasOwnProperty('role');
				},

				/**
				 * Waits for currentUser to resolve before checking if user is logged in
				 */
				isLoggedInAsync: function (cb) {
					if (currentUser.hasOwnProperty('$promise')) {
						currentUser.$promise.then(function () {
							cb(true);
						}).catch(function () {
							cb(false);
						});
					} else if (currentUser.hasOwnProperty('role')) {
						cb(true);
					} else {
						cb(false);
					}
				},

				/**
				 * Check if a user is an admin, student, teacher
				 *
				 * @return {Boolean}
				 */
				//
				isStudent: function (cb) {
					if (currentUser.hasOwnProperty('$promise')) {
						currentUser.$promise.then(function () {
							if (currentUser.data && currentUser.data['role'] === 'student') {
								cb(true)
							} else {
								cb(false)
							}
						}).catch(function () {
							cb(false);
						});
					} else if (currentUser.hasOwnProperty('role')) {
						if (currentUser['role'] === 'student') {
							cb(true)
						} else {
							cb(false)
						}
					} else {
						cb(false);
					}
				},

				isTeacher: function (cb) {
					if (currentUser.hasOwnProperty('$promise')) {
						currentUser.$promise.then(function () {
							if (currentUser.data && currentUser.data['role'] === 'teacher') {
								cb(true)
							} else {
								cb(false)
							}
						}).catch(function () {
							cb(false);
						});
					} else if (currentUser.hasOwnProperty('role')) {
						if (currentUser['role'] === 'teacher') {
							cb(true)
						} else {
							cb(false)
						}
					} else {
						cb(false);
					}
				},

				isParent: function (cb) {
					debugger;
					if (currentUser.hasOwnProperty('$promise')) {
						currentUser.$promise.then(function () {
							if (currentUser.data && currentUser.data['role'] === 'parent') {
								cb(true)
							} else {
								cb(false)
							}
						}).catch(function () {
							cb(false);
						});
					} else if (currentUser.hasOwnProperty('role')) {
						if (currentUser['role'] === 'parent') {
							cb(true)
						} else {
							cb(false)
						}
					} else {
						cb(false);
					}
				},

				isAdmin: function (cb) {
					if (currentUser.hasOwnProperty('$promise')) {
						currentUser.$promise.then(function () {
							if (currentUser.data && (currentUser.data['role'] === 'admin' || currentUser.data['role'] === 'subAdmin')) {
								cb(true)
							} else {
								cb(false)
							}
						}).catch(function () {
							cb(false);
						});
					} else if (currentUser.hasOwnProperty('role')) {
						if (currentUser['role'] === 'admin' || currentUser['role'] === 'subAdmin') {
							cb(true)
						} else {
							cb(false)
						}
					} else {
						cb(false);
					}
				},

				/**
				 * Get auth token
				 */
				getToken: function () {
					return $localStorage.get('access_token');
				}
			};

		});

})();

(function () {

  'use strict';


  angular.module('kapdec')
    /** @ngInject */
    .constant('ENUMS', {

      contentTypeId: { 'welcomeNote': 19, 'privacyPolicy': 21, 'termConditions': 20 },
      SystemParent: { 'difLevelParentId': 3 },
      testExamType: { 'module': 16, 'chapter': 15 }




    })
    .constant('appPattern', {

      email: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
      contactNo: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g,
      stringNum: /^[A-Za-z0-9]$/,
      password: /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,20}$/,
      number: /^[0-9]{1,}$/,
      fullnamed: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/,
      fullname: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
      name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
      names: /^\s*([A-Za-z]{1,}([\.,] |[-']| ))+[A-Za-z]+\.?\s*$/,
      contactAll: /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{7,14}$/,
      contact: /^[0-9]{8,15}$/,

      email2: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
      url: /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/



    });



})();

(function() {

	'use strict';

	angular.module('kapdec')
		/*base64 getter setter global Base64 @ content.html*/

		.factory('_',function($window) {

			return $window._; // assumes lodash has already been loaded on the page

		})
		.factory('Utility',function(config,$resource,$localStorage,$location) {

			var utility = {};
			// var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9+/=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = Base64._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/rn/g, "n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = c1 = c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2 } else { c2 = e.charCodeAt(n + 1); c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3 } } return t } }

			var Base64 = {
				encode: function(str) {
					return btoa(str);
				},
				decode: function(str) {
					return atob(str);
				}
			};

			utility.setGeo = function() {
				try {

					// Create Base64 Object @ lib used in utility factory

					//ex: {"ip":"91.74.19.22","country_code":"AE","country_name":"United Arab Emirates","region_code":"DU","region_name":"Dubai","city":"Dubai","zip_code":"","time_zone":"Asia/Dubai","latitude":25.2639,"longitude":55.3081,"metro_code":0}
					// var getG = $resource('http://geo.qualaroo.com/json/', null, {'get': {method: 'GET' } });


					if(!$localStorage.access_token && !$localStorage.geoToken) {
						// getG.get().$promise.then( function(data){
						//   if(data && data.country_code ){
						//     return $localStorage.geoToken = Base64.encode( JSON.stringify(data) );
						//     return $localStorage.geoToken = Base64.encode(  JSON.stringify( {"country_code":"US","country_name":"United State"} ) );
						//   }
						//
						//  },
						// function(error){
						//   $localStorage.geoToken = Base64.encode(  JSON.stringify({"country_code":"US","country_name":"United State"})  );
						//   return true;
						// });
						$.get('http://ip-api.com/json/').done(
							function(res) {
								if(res && res.status == "success") {
									var data = {
										"ip": res.query,
										"country_code": res.countryCode,
										"country_name": res.country,
										"region_code": res.region,
										"region_name": res.regionName,
										"city": res.city,
										"zip_code": res.zip,
										"time_zone": res.timezone,
										"latitude": res.lat,
										"longitude": res.lan,
										"metro_code": 0
									};

									return $localStorage.geoToken = Base64.encode(JSON.stringify(data));
								}
							}
						).fail(function() {
							$localStorage.geoToken = Base64.encode(JSON.stringify({ "country_code": "US","country_name": "United State" }));
							return true;
						});

					} else {
						return true;
					}

				}
				catch(error) {
					$localStorage.geoToken = Base64.encode(JSON.stringify({ "country_code": "US","country_name": "United State" }));
					return true;
				}
			};


			utility.getGeo = function() {
				try {
					if($localStorage.geoToken) {
						var geo = Base64.decode($localStorage.geoToken);
						return JSON.parse(geo);
					}
					return true;
				} catch(err) {
					console.log(err);
				}
			};
			return utility;
		})

})();

(function() {

 'use strict';

 angular.module('kapdec')

.factory('authInterceptor', function($rootScope, $q, $stateParams, $localStorage, $location) {
  return {
    /************************* Add authorization token to headers *********************************/

    request: function(config) {
      config.headers = config.headers || {};
      if ( $localStorage.access_token ) {
        config.headers.Authorization = 'Bearer ' + $localStorage.access_token;
      }
      if($localStorage.geoToken){
        config.headers.gloc = $localStorage.geoToken;
      }
      return config;
    },
    /************************* Intercept 401s and redirect you to login ***************************/
    responseError: function(response) {
      if (response.status === 401) {
        
        delete $localStorage.access_token; // remove any stale tokens
        $location.path('/home/login');
        return $q.reject(response);
      }
      if (response.status === 402) {

        $location.path('/subscribe-required').search($stateParams);
        return $q.reject(response);
      }else {
        return $q.reject(response);
      }
    }
  };
})

//buffer requests to be send again
.factory('http-interceptor-buffer', ['$injector', function ($injector) {
      /** Holds all the requests, so they can be re-requested in future. */
      var buffer = [];

      /** Service initialized later because of circular dependency problem. */
      var $http;

      function retryHttpRequest(config, deferred) {
          config.headers['trytimes'] += 1;
          function successCallback(response) {
              deferred.resolve(response);
          }
          function errorCallback(response) {
              deferred.reject(response);
          }
          $http = $http || $injector.get('$http');
          $http(config).then(successCallback, errorCallback);
      }

      return {
    /**
    * Appends HTTP request configuration object with deferred response attached to buffer.
    */
          append: function (response, deferred) {
              buffer.push({
                  response: response,
                  deferred: deferred
              });
          },

    /**
    * Retries all the buffered requests clears the buffer.
    */
          retryAll: function (updater) {
              for (var i = 0; i < buffer.length; ++i) {
                  retryHttpRequest((buffer[i].response.config), buffer[i].deferred);
              }
              buffer = [];
          },
    /**
    * Reject all the buffered requests clears the buffer.
    */
          rejectAll: function () {
              for (var i = 0; i < buffer.length; ++i) {
                  buffer[i].deferred.resolve();
              }
              buffer = [];
          }
      };
  }]);


})();

(function () {

	'use strict';

	angular.module('kapdec')
		/*$resource syntax*/
		/*$resource(url,{paramDefaults},{actions},{options});*/
		.factory('LoadPageData', function ($resource, config) {
			var rootpath = config.baseUrl;
			var loadData = {};
			loadData.banner = $resource(rootpath + '/api/banner/:id/:controller', null,
				{
					'getBanner': {
						method: "GET",
						params: { id: 'getBanner' }
					},
					'getAll': {
						method: "POST"
					},
					'create': {
						method: "POST",
					},
					'update': {
						method: "POST",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'remove': {
						method: "DELETE",
						params: { id: '@id' }
					},
					'verify': {
						method: "GET",
						params: {
							id: 'verify',
							controller: '@id'
						}

					}
				}
			);
			loadData.team = $resource(rootpath + '/api/team/:id/:controller', null,
				{
					'getTeam': {
						method: "GET",
						params: { id: 'getTeam' }
					},
					'getAll': {
						method: "POST"
					},
					'create': {
						method: "POST",
					},
					'update': {
						method: "POST",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'remove': {
						method: "DELETE",
						params: { id: '@id' }
					},
					'verify': {
						method: "GET",
						params: {
							id: 'verify',
							controller: '@id'
						}

					}
				}
			);
			loadData.works = $resource(rootpath + '/api/works/getWork', null,
				{
					'getWork': { method: "GET", },
					'update': { method: "PUT", }
				}
			);
			loadData.curriculum = $resource(rootpath + '/api/country/curriculum', null,
				{
					'get': { method: "GET", },
				}
			);
			loadData.faqs = $resource(rootpath + '/api/faq/:id/:controller', null,
				{
					'getCategories': {
						method: "POST",
						params: { id: 'categories' }
					},
					'getQuestions': {
						method: "POST",
						params: {
							id: 'askedQuestion',
							controller: '@id'
						}
					},
					'getSearchQuestions': {
						method: "POST",
						params: {
							id: 'askedSearchQuestion'
						}
					},
					'getAllQuestions': {
						method: "POST"
					},
					'create': {
						method: "POST",
						params: { id: 'create' }
					},
					'update': {
						method: "PUT",
						params: {
							id: '@id'
						}
					},
					'remove': {
						method: "DELETE",
						params: { id: '@id' }
					},
					'verify': {
						method: "GET",
						params: {
							id: 'verify',
							controller: '@id'
						}
					}
				}
			);
			loadData.hierarchy = $resource(rootpath + '/api/:type/:id/:controller', null, {
				'getAll': {
					method: "POST",
					params: {
						type: '@type'
					}
				},
				'create': {
					method: "POST",
					params: {
						type: '@type',
						id: 'create'
					}
				},
				'topicUpdate': {
					method: "POST",
					params: {
						type: '@type',
						id: 'update',
						controller: '@id'
					}
				},
				'update': {
					method: "PUT",
					params: {
						type: '@type',
						id: 'update',
						controller: '@id'
					}
				},
				'remove': {
					method: "DELETE",
					params: {
						type: '@type',
						id: '@id'
					}
				},
				'verify': {
					method: "GET",
					params: {
						type: '@type',
						id: 'verify',
						controller: '@id'
					}

				}
			});
			loadData.content = $resource(rootpath + '/api/content/:id/:controller', null, {
				'get': {
					method: "GET",
					params: {
						id: 'show',
						controller: '@id'
					}
				},
				'create': {
					method: "POST",
					params: {
						id: 'create'
					}
				},
				'update': {
					method: "PUT",
					params: {
						id: '@id'
					}
				},
				'remove': {
					method: "DELETE",
					params: { id: '@id' }
				},
				'verify': {
					method: "GET",
					params: {
						id: 'verify',
						controller: '@id'
					}

				}
			});
			loadData.badges = $resource(rootpath + '/api/badge/:id/:controller', null, {
				'getActive': {
					method: "POST",
					params: {
						id: 'activeBadge'
					}
				},
				'getActiveBadge': {
					method: "POST",
					params: {
						id: 'activeChildBadge',
						controller: '@id'
					}
				},
				'getAll': {
					method: "POST",
					params: {
						id: 'all'
					}
				},
				'create': {
					method: "POST",
				},
				'update': {
					method: "POST",
					params: {
						id: 'update',
						controller: '@id'
					}
				},
				'remove': {
					method: "DELETE",
					params: { id: '@id' }
				},
				'verify': {
					method: "GET",
					params: {
						id: 'verify',
						controller: '@id'
					}

				}
			});
			loadData.subscription = $resource(rootpath + '/api/subcription/:id/:controller', null, {
				'getActive': {
					method: "POST",
					params: {
						id: 'getSubcriptions'
					}
				},
				'getAll': {
					method: "POST"
				},
				'AllSubscriptionData': {
					method: "POST",
					params: {
						id: 'AllSubscriptionData'
					}
				},
				'getCurrency': {
					method: "GET",
					url: rootpath + '/api/country/currency'
				},
				'requestFreeSubcription': {
					method: "POST",
					url: rootpath + '/api/purchase/requestFreeSubcription'
				},
				'create': {
					method: "POST",
					params: {
						id: 'create'
					}
				},
				'update': {
					method: "PUT",
					params: {
						id: '@id'
					}
				},
				'remove': {
					method: "DELETE",
					params: { id: '@id' }
				},
				'verify': {
					method: "GET",
					params: {
						id: 'verify',
						controller: '@id'
					}
				},
				'getById': {
					method: "GET",
					params: {
						id: 'getById',
						controller: '@id'
					}
				},
				'payment': {
					method: "POST",
					params: {
						id: 'payment',
					}
				}
			});
			loadData.transaction = $resource(rootpath + '/api/purchase/:id/:controller', null, {
				'getHistory': {
					method: "POST",
					params: {
						id: 'getHistory'
					}
				},
				'RefundTractionAdd': {
					method: "PUT",
					params: {
						id: 'RefundTractionAdd',
						controller: '@id'
					}
				},
				'getAll': {
					method: "POST"
				},
				'allowFree': {
					method: "POST",
					params: {
						id: 'allowFreeSubcription',
						controller: '@id'
					}
				},
				'refundPay': {
					method: "POST",
					params: {
						id: 'refundPay',
						controller: '@id'
					}
				},
				'create': {
					method: "POST",
					params: {
						id: 'create'
					}
				},
				'requestFree': {
					method: "POST",
					params: {
						id: 'requestFreeSubcription'
					}
				},
				'update': {
					method: "PUT",
					params: {
						id: '@id'
					}
				},
				'remove': {
					method: "DELETE",
					params: { id: '@id' }
				},
				'show': {
					method: "GET",
					params: {
						id: 'show',
						controller: '@id'
					}

				}
			});
			loadData.subscriber = $resource(rootpath + '/api/subscriber', null,
				{ 'add': { method: 'POST', isArray: false } });

			loadData.contents = $resource(rootpath + '/api/content/:id', { id: '@id' },
				{
					'getContent': { method: "GET", },
					'update': { method: "PUT", }
				}
			);
			loadData.grade = $resource(rootpath + '/api/grade/getGrade', null,
				{
					'getGrade': { method: "POST" }
				}
			);
			loadData.video = $resource(rootpath + '/api/video/getAll', null,
				{
					'getvideo': { method: "POST" }
				}
			);
			loadData.FindGrade = $resource(rootpath + '/api/grade/getFindGrade', null,
				{
					'getFindGrade': { method: "POST" }
				}
			);
			loadData.FindCourse = $resource(rootpath + '/api/course/getFindCourse', null,
				{
					'getFindCourse': { method: "POST" }
				}
			);
			loadData.CheckTopic = $resource(rootpath + '/api/Topic/getCheckTopic', null,
				{
					'getCheckTopic': { method: "POST" }
				}
			);
			loadData.CheckUnit = $resource(rootpath + '/api/unit/getCheckUnit', null,
				{
					'getCheckUnit': { method: "POST" }
				}
			);
			loadData.CheckChapter = $resource(rootpath + '/api/chapter/getCheckChapter', null,
				{
					'getCheckChapter': { method: "POST" }
				}
			);
			loadData.manageGrade = $resource(rootpath + '/api/grade/:id/:controller', null,
				{
					'getAll': { method: "POST" },
					//'getFindGrade': { method: "POST" },
					'update': {
						method: "PUT",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'create': {
						method: "POST",
						params: {
							id: 'create',
						}
					},
					'delete': {
						method: "DELETE",
						params: {
							id: 'delete',
							controller: '@id'
						}
					},
					'verify': {
						method: "GET",
						params: {
							id: 'verify',
							controller: '@id'
						}
					}

				}
			);
			loadData.course = $resource(rootpath + '/api/course/:id/:controller', null,
				{
					'getCourse': { method: "POST" },
					'getAll': {
						method: "POST",
						params: {
							id: 'getCourse'
						}
					},
					'getCourses': {
						method: "GET",
						params: {
							id: 'getAll'
						}
					},
					'update': {
						method: "PUT",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'create': {
						method: "POST",
						params: {
							id: 'create',
						}
					},
					'deleteSubject': {
						method: "DELETE",
						params: {
							id: 'delete',
							controller: '@id'
						}
					}
				}
			);
			loadData.manageTopic = $resource(rootpath + '/api/topic/:id/:controller', null,
				{
					'getCourse': { method: "POST" },
					'getAll': {
						method: "POST"
					},
					'update': {
						method: "POST",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'create': {
						method: "POST",
						params: {
							id: 'create',
						}
					},
					'deleteSubject': {
						method: "DELETE",
						params: {
							id: 'delete',
							controller: '@id'
						}
					}
				}
			);
			loadData.manageUnit = $resource(rootpath + '/api/unit/:id/:controller', null,
				{
					'getCourse': { method: "POST" },
					'getAll': {
						method: "POST"
					},
					'update': {
						method: "POST",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'create': {
						method: "POST",
						params: {
							id: 'create',
						}
					},
					'delete': {
						method: "DELETE",
						params: {
							id: 'delete',
							controller: '@id'
						}
					}
				}
			);
			loadData.manageChapter = $resource(rootpath + '/api/chapter/:id/:controller', null,
				{
					'getCourse': { method: "POST" },
					'getAll': {
						method: "POST"
					},
					'update': {
						method: "POST",
						params: {
							id: 'update',
							controller: '@id'
						}
					},
					'create': {
						method: "POST",
						params: {
							id: 'create',
						}
					},
					'delete': {
						method: "DELETE",
						params: {
							id: 'delete',
							controller: '@id'
						}
					},
					'getById': {
						method: "GET",
						params: {
							id: 'getById',
							controller: '@id'
						}
					},
					'getChapterByClasses': {
						method: "POST",
						params: {
							id: 'getChapterByClasses',
							controller: '@id'
						}
					}
				}
			);
			loadData.unit = $resource(rootpath + '/api/unit/getUnit', null,
				{
					'getUnit': { method: "POST" },
					'getUnitbytopics': { method: "POST" },
					'update': { method: "PUT" }
				}
			);

			loadData.manageunit = $resource(rootpath + '/api/unit/:id', null,
				{
					'getUnitbytopics': {
						method: "POST",
						params: {
							id: 'getUnitbytopics',
						}
					},
					'getStudentUnit': {
						method: "POST",
						params: {
							id: 'getStudentUnit',
						}
					}
				}
			);
			loadData.unithome = $resource(rootpath + '/api/unit/studenthome', null,
				{
					'studenthome': { method: "POST" },
				}
			);
			loadData.chapter = $resource(rootpath + '/api/chapter/getChapter', null,
				{
					'getChapter': { method: "POST" },
					'update': { method: "PUT" }
				}
			);

			loadData.topic = $resource(rootpath + '/api/topic/:id/:controller', null,
				{
					'getTopic': {
						method: "POST",
						params: {
							id: 'getTopic'
						}
					}, 'getAll': {
						method: "GET",
						params: {
							id: 'getAll'
						}
					},
					'getVideo': {
						method: "GET",
						params: {
							id: 'show',
							controller: '@topicId'
						}
					},
					'update': {
						method: "PUT",
						params: {
							id: 'update'
						}
					},
					'getByClassId': {
						method: "POST",
						params: {
							id: 'getByClassId'
						}
					}
				}
			);
			loadData.classes = $resource(rootpath + '/api/class/:id/:controller/:extend', null,
				{
					'joinClass': {
						method: "PUT",
						params: {
							id: 'joinClass',
							controller: '@joinCode',
							extend: '@studentId'
						}
					},
					'unJoinClass': {
						method: "PUT",
						params: {
							id: 'unJoinClass',
							controller: '@joinCode',
							extend: '@studentId'
						}
					},
					'joinedClass': {
						method: "POST",
						params: {
							id: 'joinedClass'
						}
					},
					'getUserClassById': {
						method: "POST",
						params: {
							id: 'getUserClass',
							controller: '@userID'
						}
					},
					'getStudents': {
						method: "POST",
						params: {
							id: 'students',
							controller: '@classID'
						}
					},
					'myClasses': {
						method: "POST",
						params: {
							id: 'myClasses'
						}
					},
					'createMyClass': { method: "POST" },
					'updateMyClasses': {
						method: "PUT",
						params: {
							id: '@id',
						}
					},
					'assignClass': {
						method: "POST",
						params: {
							id: '@classID',
							controller: '@chapterID'
						}
					},
					'allStudents': {
						method: "POST",
						params: {
							id: 'allstudents',
						}
					},
					'MultiTeacherStudent': {
						method: "POST",
						params: {
							id: 'MultiTeacherStudent'
						}
					},
					'getClass': { method: "GET" },
					'remove': {
						method: "DELETE",
						params: { id: '@id' }
					},
					'update': { method: "PUT" },
					'getDetailById': {
						method: "GET",
						params: {
							id: 'getDetailById',
							controller: '@classId'
						}
					}
				}
			);
			return loadData;
		})
		.factory('SubcribeService', function ($resource, apiDomain) {
			var rootpath = apiDomain;
			return $resource(rootpath + '/api/subscriber', {}, {
				'subcribed': {
					method: "POST",
					isArray: true,
				}
			});
		})

		.factory('StaticContentService', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/content/:id/:type', {
				id: '@_id'
			}, {
				'get': {
					method: "GET",
					params: {
						type: '@type'
					}
				},
				'create': {
					method: "POST",
				},
				'update': {
					method: "PUT",
				}
			});
		})
		.factory('Discussion', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/discussion/:id/:controller', null,
				{
					'getDiscussions': {
						method: "POST"
					},
					'myDiscussions': {
						method: "POST",
						params: { id: 'mydiscussion' }
					},
					'update': {
						method: "PUT",
						params: { id: '@id' }
					},
					'create': {
						method: "POST",
						params: { id: 'create' }
					},
					'addReply': {
						method: "POST",
						params: { id: 'reply', controller: '@id' }
					}
				});
		})
		.factory('FilterOption', function ($resource, config) {
			var filters = function () {
				var filter = {
					where: {},
					limit: 30,
					page: 1,
					total: 0
				};

				return { 'filter': filter }
			}
			return filters;
		})
		.factory('SystemEnum', function ($resource, config) {

			var enums = {};
			var rootpath = config.baseUrl;
			enums = $resource(rootpath + '/api/enums/:id/:controller', null,
				{
					'getParentChild': {
						method: "GET",
					},
					'getEnum': {
						method: 'GET',
						params: { id: 'show', controller: '@controller' }
					},
					'create': {
						method: 'POST',
						params: { id: 'create' }
					},
					'update': {
						method: "PUT",
						params: { id: '@id' }
					},
					'verify': {
						method: "GET",
						params: {
							id: 'verify',
							controller: '@id'
						},
						'delete': {
							method: "DELETE",
							params: { id: '@id' }
						}

					}

				}
			);
			return enums;
		})
		.factory('TestQuesService', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/question/:id/:controller', {
				id: '@id'
			},
				{
					'get': {
						method: "POST",
					},
					'count': {
						method: "GET",
						params: {
							id: 'count'
						}
					},
					'create': {
						method: "POST",
						isArray: false,
						params: {
							id: 'create'
						}
					},
					'update': {
						method: "PUT",
						params: {
							id: '@id'
						}
					},
					'getbyid': {
						method: "GET",
						params: {
							id: '@id'
						}
					},
					'delete': {
						method: "DELETE",
						params: {
							id: '@id'
						}
					},
					'verify': {
						method: "GET",
						isArray: false,
						params: { id: 'verify', controller: '@id' }
					},
					'getByChapetId': {
						method: "GET",
						isArray: false,
						params: { id: 'getByChapetId', controller: '@chapterId' }
					},
					'saveDocument': {
						method: "POST",
						isArray: false,
						params: { id: 'saveDocument' }
					}
				});
		})
		.factory('StoryService', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/story/:id/:controller', {
				id: '@id'
			},
				{
					'getAll': {
						method: "POST",
						params: {
							id: 'getAll'
						}
					},
					'get': {
						method: "POST"
					},
					'count': {
						method: "GET",
						params: {
							id: 'count'
						}
					},
					'create': {
						method: "POST",
						isArray: false,
						params: {
							id: 'create'
						}
					},
					'update': {
						method: "PUT",
						params: {
							id: '@id'
						}
					},
					'myStories': {
						method: "POST",
						isArray: false
					},
					'delete': {
						method: "DELETE",
						params: {
							id: '@id'
						}
					},
					'verify': {
						method: "GET",
						isArray: false,
						params: { id: 'verify', controller: '@id' }
					},
					'Unverify': {
						method: "GET",
						isArray: false,
						params: { id: 'Unverify', controller: '@id' }
					}
				});
		})
		.factory('VideoService', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/video/:id/:controller', {
				id: '@id'
			},
				{
					'getAll': {
						method: "POST",
						params: {
							id: 'getAll'
						}
					},
					'get': {
						method: "POST"
					},
					'count': {
						method: "GET",
						params: {
							id: 'count'
						}
					},
					'create': {
						method: "POST",
						isArray: false,
						params: {
							id: 'create'
						}
					},
					'update': {
						method: "PUT",
						params: {
							id: '@id'
						}
					},
					'myStories': {
						method: "POST",
						isArray: false
					},
					'delete': {
						method: "DELETE",
						params: {
							id: '@id'
						}
					},
					'verify': {
						method: "GET",
						isArray: false,
						params: { id: 'verify', controller: '@id' }
					},
					'Unverify': {
						method: "GET",
						isArray: false,
						params: { id: 'Unverify', controller: '@id' }
					}
				});
		})
		.factory('ExamService', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/exam/:id/:controller', {
				id: '@id'
			},
				{
					'startExam': {
						method: "POST",
						params: {
							id: 'start'
						}
					},
					'getQuestion': {
						method: "POST",
						params: {
							id: 'getQuestion'
						}
					},
					'submitAnswer': {
						method: "POST",
						isArray: false,
						params: {
							id: 'submit',
							controller: '@id'
						}
					},
					'submitAnswers': {
						method: "POST",
						params: {
							id: 'submitAnswers',
						}
					},
					'ExamResult': {
						method: "GET",
						isArray: false,
						params: {
							id: 'show',
							controller: '@controller'
						}
					},
					'myExamsList': {
						method: "POST",
						params: {
							id: 'myExam'
						}
					},
					'myQuizList': {
						method: "POST",
						params: {
							id: 'myQuiz'
						}
					},

					'myChildExamsList': {
						method: "POST",
						params: {
							id: 'myChildExam',
							controller: '@uid'
						}
					},
					'myChildQuizList': {
						method: "POST",
						params: {
							id: 'myChildQuiz',
							controller: '@uid'
						}
					},

					'examList': {
						method: "POST",
						isArray: false,
					}
				});
		})
		.factory('UploadImage', function ($resource, config) {
			var rootpath = config.baseUrl;
			var imageData = {};
			imageData = $resource(rootpath + '/api/gfs/:id', { id: '@id' },
				{
					'get': { method: "GET", },
					'update': { method: "PUT", }
				}
			);
			return imageData;
		})
		.factory('StudentService', function ($resource, config) {
			var rootPath = config.baseUrl;
			var studentsData = {};
			studentsData = $resource(rootPath + '/api/user/students', null, { 'query': { method: 'GET', isArray: true } });
			return studentsData;
		})
		.factory('UserSetting', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/setting/:id', {
				id: '@id'
			},
				{
					'get': {
						method: "GET",
					},
					'update': {
						method: "PUT",
					},
				});
		})
		.factory('ContactInfo', function ($resource, config) {
			var rootpath = config.baseUrl;
			return $resource(rootpath + '/api/contact/:id', {
				id: '@id'
			},
				{
					'get': {
						method: "POST",
						// url: "/api/contact/all"
					},
					'create': {
						method: "POST",
						isArray: false,
						params: { id: 'us' }
					},
					'update': {
						method: "PUT",
						params: {
							id: '@id'
						}
					},
					'delete': {
						method: "DELETE",
					},
					'send': {
						method: "POST",
						isArray: false,
						params: { id: 'career' }
					}
				});
		})


})();

(function () {

    'use strict';

    //Directive used to set metisMenu and minimalize button
    angular.module('kapdec')

        .directive('preLoading', function ($http) {
            return {
                restrict: 'A',
                link: function (scope, elem) {
                    scope.isLoading = isLoading;
                    scope.$watch(scope.isLoading, toggleElement);
                    function toggleElement(loading) {
                        if (loading) {
                            elem.css('display', 'block')
                        } else {
                            elem.css('display', 'none')
                        }
                    }
                    function isLoading() {
                        return $http.pendingRequests.length > 0;
                    }
                }
            };

        })
        .directive('mongooseError', function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    element.on('keydown', function () {
                        return ngModel.$setValidity('mongoose', true);
                    });
                }
            };
        })
        .directive('numbersOnly', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, ngModelCtrl) {
                    function fromUser(text) {
                        if (text) {
                            var transformedInput = text.replace(/[^0-9]/g, '');
                            var transformedInputs = transformedInput.split('.');
                            if (transformedInputs.length > 1) {
                                transformedInput = transformedInputs[0] + '.' + transformedInputs[1];
                            }

                            if (transformedInput !== text) {
                                if (transformedInput == "") {
                                    transformedInput = null;
                                }
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        }
                        return undefined;
                    }
                    ngModelCtrl.$parsers.push(fromUser);
                }
            };
        }).directive('datePicker', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, element, attrs, ngModelController) {
                    // Private variables
                    var datepickerFormat = 'dd/M/yyyy',
                        momentFormat = 'DD/MM/YYYY',
                        datepicker,
                        elPicker;

                    // Init date picker and get objects http://bootstrap-datepicker.readthedocs.org/en/release/index.html
                    datepicker = element.datetimepicker({
                        format: 'DD/MM/YYYY',
                        maxDate: new Date(scope.vm.maxDate)
                    });
                    datepicker.val('');
                    // Only watch and format if ng-model is present https://docs.angularjs.org/api/ng/type/ngModel.NgModelController
                    if (ngModelController) {
                        // So we can maintain time
                        var lastModelValueMoment;

                        ngModelController.$formatters.push(function (modelValue) {
                            var viewValue,
                                m = moment(modelValue).add(1, 'days');
                            if (modelValue && m.isValid()) {
                                lastModelValueMoment = m.clone(); // Save date (so we can restore time later)
                                viewValue = m.format(momentFormat);
                            } else {
                                var r = datepicker.val();
                                lastModelValueMoment = undefined;
                                viewValue = undefined;
                            }
                            return viewValue;
                        });

                        ngModelController.$parsers.push(function (viewValue) {

                            var modelValue,
                                m = moment(viewValue, momentFormat, true).add(1, 'days');
                            if (viewValue && m.isValid()) {
                                // Valid date string in view
                                if (lastModelValueMoment) { // Restore time
                                    m.hour(lastModelValueMoment.hour());
                                    m.minute(lastModelValueMoment.minute());
                                    m.second(lastModelValueMoment.second());
                                    m.millisecond(lastModelValueMoment.millisecond());
                                }
                                modelValue = m;
                            } else {
                                var r = datepicker.val();
                                modelValue = undefined;
                            }
                            return modelValue;
                        });

                        datepicker.on('dp.change', function (evt) {
                            // Only update if it's NOT an <input> (if it's an <input> the datepicker plugin trys to cast the val to a Date)
                            if (evt.target.tagName === 'INPUT') {
                                ngModelController.$setViewValue(moment(evt.date).format(momentFormat)); // $seViewValue basically calls the $parser above so we need to pass a string date value in
                                ngModelController.$render();
                            }
                        });


                    }
                    scope.$watch('vm.maxDate', function () {

                        datepicker = element.datetimepicker({
                            format: 'DD/MM/YYYY',
                            maxDate: new Date(scope.vm.maxDate)
                        });
                        datepicker.val('');

                    });
                }
            };
        }).filter('titleCase', function () {
            return function (input) {
                input = input || '';
                return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
        }).directive('imagePopup', function ($uibModal) {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, elem, attrs, ngModelController) {
                    elem.bind('click', function () {
                        $uibModal.open({
                            template: '<i class="fa fa-times" ng-click="close()" style="cursor: pointer;position:absolute;margin-top:-15px;font-size:19px;right:-15px;"></i><img src="' + elem[0].currentSrc + '" style="width: 100%;">',
                            controller: function ($uibModalInstance, $scope) {
                                $scope.close = function () {
                                    $uibModalInstance.close();
                                }
                            }
                        }).result.then(function () {

                        }, function (reason) {

                        });
                    });
                }

            }
        }).directive('disableRightClick', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    element.bind('contextmenu', function (e) {
                        e.preventDefault();
                    })
                }
            }
        }).directive('stopccp', function () {
            return {
                scope: {},
                link: function (scope, element) {
                    element.on('cut copy paste', function (event) {
                        event.preventDefault();
                    });
                }
            };
        });

})();

(function() {

'use strict';

//Directive used to set metisMenu and minimalize button
 angular.module('kapdec')

    .directive("scrollable", function () {
        return {
          link: function (scope, elem) {
            elem.mCustomScrollbar({
              autoHideScrollbar: false,
              theme: 'dark',
              advanced:{
                updateOnContentResize: true
              }
            });
          }
        };
    })

    .directive('asDate', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$formatters.push(function (input) {
                    var transformedInput;
                    if (input) transformedInput = new Date(input);
                    else transformedInput = new Date();
                    if (transformedInput !== input) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };
    })

    .directive("whenScrolled", function () {
        return function (scope, elm, attr) {
            var raw = elm[0];
            elm.bind("scroll", function () {

                if (raw.scrollTop !== 0)
                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight ) {
                        scope.$apply(attr.whenScrolled);
                    }
                return;
            });
        };
    })

    // .directive('trustedUrl', function (urls, $sce) {
    //    return {
    //        restrict: 'A',
    //        require: '?ngModel',
    //        link: function (scope, element, attrs ) {
    //           return $sce.getTrustedResourceUrl(attrs);
    //        }
    //    };
    // })

    .directive('winHeight', ['$window', function($window) {
        return function(scope, element, attrs) {
            function setHeight() {
                element.css('min-height', angular.element($window)[0].innerHeight + 'px');
            };
            setHeight();

            angular.element($window).bind('resize', function() {
                setHeight();
            });
        };
    }])

    .directive('fileModel', ['$parse','$rootScope', function ($parse,$rootScope) {
        return {
          restrict: 'A',
          link: function(scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind('change', function(){
              scope.$apply(function(){
                modelSetter(scope, element[0].files[0]);
                if(element[0].files[0]){
                $rootScope.fileLoaded = true;
                }
              });
            });
          }
        };
    }])

    .directive("loginEnter", function () {

        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which == 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.loginEnter);
                    });
                    event.preventDefault();
                }

            });
        };
    })

    .directive('showMore', [function() {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                text: '=',
                limit:'='
            },
     
            template: '<div><p ng-show="largeText"> {{ text | subString :0 :end }} &nbsp; <a href="javascript:;" class="" style="color: #007bff;font-size: 14px;" ng-click="showMore()" ng-show="isShowMore">...Read More</a>  <a href="javascript:;" class="" ng-click="showLess()"  style="color: #007bff;font-size:14px;" ng-show="!isShowMore">Show Less</a></p> <p ng-hide="largeText">{{ text }}</p></div> ',

            link: function(scope, iElement, iAttrs) {


                scope.end = scope.limit;
                scope.isShowMore = true;
                scope.largeText = true;
                scope.text=String(scope.text).replace(/<[^>]+>/gm, '');
                if (scope.text != undefined &&(scope.text.length <= scope.limit)) {
                    scope.largeText = false;
                };

                scope.showMore = function() {

                    scope.end = scope.text.length;
                    scope.isShowMore = false;
                };

               scope.showLess = function() {

                   scope.end = scope.limit;
                   scope.isShowMore = true;
               };
            }
        };
     }])

     .directive('showMore1', [function () {
         return {
             restrict: 'AE',
             replace: true,
             scope: {
                 text: '=',
                 limit: '='
             },

             template: '<div><p ng-show="largeText"> {{ text | subString :0 :end }} &nbsp; <a href="javascript:;" class="" style="color: #007bff;font-size: 14px;" ng-click="showMore1()" ng-show="isShowMore1">...Read More</a>  <a href="javascript:;" class="" ng-click="showLess1()"  style="color: #007bff;font-size:14px;" ng-show="!isShowMore1">Show Less</a></p> <p ng-hide="largeText">{{ text }}</p></div> ',

             link: function (scope, iElement, iAttrs) {


                 scope.end = scope.limit;
                 scope.isShowMore1 = true;
                 scope.largeText = true;
                 scope.text=String(scope.text).replace(/<[^>]+>/gm, '');
                 if (scope.text != undefined && (scope.text.length <= scope.limit)) {
                     scope.largeText = false;
                 };

                 scope.showMore1 = function () {

                     scope.end = scope.text.length;
                     scope.isShowMore1 = false;
                 };

                 scope.showLess1 = function () {

                     scope.end = scope.limit;
                     scope.isShowMore1 = true;
                 };
             }
         };
     }])

   .filter('subString', function() {
        return function(str, start, end) {
            if (str != undefined) {
                return str.substr(start, end);
            }
        }
    })

    .filter('unique', function() {
        return function(collection, keyname) {
           var output = [],
               keys = [];

           angular.forEach(collection, function(item) {
               var key = item[keyname];
               if(keys.indexOf(key) === -1) {
                   keys.push(key);
                   output.push(item);
               }
           });

           return output;
        };
     });
    

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('TermsCtrl', function (config, ENUMS, LoadPageData, $log) {
        var vm = this;
        // console.log("TermsCtrl");

        vm.init = function(){
          var cId = ENUMS.contentTypeId.termConditions;
          //console.log(cId)
          LoadPageData.contents.getContent({id: 15 } ).$promise.then(function(res){
             console.log(res.data);
            if(res && res.data ){
              vm.content = res.data;
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });


        }
        vm.init();

});

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('TeamCtrl', function ( config, ENUMS, LoadPageData, $log) {
        var vm = this;

        // console.log("AboutCtrl");

        vm.getImageUrl = function(id){
          return config.baseUrl+'/api/gfs/'+id;
        }

        vm.init = function(){
          var cId = ENUMS.contentTypeId.welcomeNote;
          LoadPageData.contents.getContent({id: cId } ).$promise.then(function(res){
            // console.log("about",res);
            if(res && res.data ){
              vm.content = res.data;
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });


          LoadPageData.team.getTeam().$promise.then(function(res){
            // console.log("team",res);
            if(res && res.data && res.data.data ){
              vm.teams = res.data.data;
            }
          },function(err){
          });


        }
        vm.init();

});

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('subscriptionCtrl', function (config,Utility,FilterOption, ENUMS, LoadPageData, $log) {
        var vm = this;
        var cal;
        vm.countryList = Utility.getGeo();
        vm.filterSubsList = [];
        // console.log("PrivacyCtrl");
        vm.filterOptions = FilterOption().filter;
        vm.init = function(){
          vm.filterOptions.where.active = true;
          LoadPageData.subscription.AllSubscriptionData(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.subsList = res.data.data;
            console.log(res.data.data);
            vm.currency="";
            if(vm.countryList.country_code=="IN"){
              vm.currency="IN";
            }
            else{
              vm.currency="US";
            }
            vm.filterOptions.total = res.data.total;
            vm.filterSubList(vm.currency);
           // console.log(vm.subsList)
          //  vm.filterSubList(vm.currency);
          }
        });


        }
        vm.filterSubList = function (subsFilter) {
          //console.log(subsFilter)
          vm.filterSubsList = [];
          angular.forEach(vm.subsList, function (res, key) {
            if (res.currency == subsFilter) {
              vm.filterSubsList.push(res);
            }
          });
        }
        vm.init();


 });

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('SitemapCtrl', function (config, $log) {
        var vm = this;

        console.log("SitemapCtrl");

 });


})();     

(function() {

'use strict';

 angular.module('kapdec')
    .controller('PrivacyCtrl', function (config, ENUMS, LoadPageData, $log) {
        var vm = this;

        // console.log("PrivacyCtrl");

        vm.init = function(){
          var cId = ENUMS.contentTypeId.privacyPolicy;
          console.log(ENUMS.contentTypeId)
          LoadPageData.contents.getContent({id: 16 }).$promise.then(function(res){
            // console.log("privacy",res);
            if(res && res.data ){
              vm.content = res.data;
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });


        }
        vm.init();


 });

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('notFoundCtrl', function (config, $log, Auth, toastr, $state) {
        var vm = this;

        console.log("notFoundCtrl");
        vm.init =function(){
          toastr.info("Oops 404! you may lose path -> go home ");
        }
        vm.init();

        vm.getmeHome = function(){
          // Auth.logout();
          $state.go('index.home');
        };

        vm.getmeContact = function(){
          // Auth.logout();
          $state.go('index.contact');
        }

});

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('howitworksCtrl', function (config, ENUMS, LoadPageData, $log) {
        var vm = this;

        // console.log("howitworksCtrl");

        vm.init = function(){
          var cId = ENUMS.contentTypeId.privacyPolicy;
          LoadPageData.contents.getContent({id: cId } ).$promise.then(function(res){
            // console.log("howitworksCtrl",res);
            if(res && res.data ){
              vm.content = res.data;
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });


        }
        vm.init();


 });

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('ContactCtrl', function (appPattern, config, $log, ContactInfo, toastr, User, Auth) {
        var vm = this;
        vm.pattern = appPattern;
        vm.user = {};

      vm.contactInit = function () {
            if (Auth.isLoggedIn())
              vm.getCurrentUser();
             else
              vm.contact = {};
         };

      vm.getCurrentUser = function () {
            User.get().$promise.then(function (response) {
              vm.user = response.data;
              vm.contact = {
                    firstName: vm.user.name,
                    email: vm.user.email
                };
            }, function (error) {
                console.log(error);
            });
        };

      vm.contactUs = function (form) {
          vm.submitted = true;
            if (form.$valid) {
               console.log(vm.contact);
                ContactInfo.create(vm.contact).$promise.then(function (response) {
                    console.log(response);
                  vm.contact = {};
                  vm.submitted = false;
                    toastr.success(response.message ||'message sent', "Success!")
                }, function (error) {
                    vm.submitted = false;
                    toastr.error("Something Went worng, Please try again", "Error!")
                    console.log(error);
                });
            }
        };
      vm.contactInit();


});

})();

(function () {

  'use strict';

  angular.module('kapdec')
    .filter('trustAsResourceUrl', ['$sce', function ($sce) {
      return function (val) {
        return $sce.trustAsResourceUrl(val);
      };
    }])
    .controller('CareerCtrl', function (appPattern, config, $log, $scope, ContactInfo, toastr, User, Auth) {
      var vm = this;
      vm.pattern = appPattern;
      vm.user = {};

      vm.careerInit = function () {
        if (Auth.isLoggedIn())
          vm.getCurrentUser();
        else
          vm.career = {};
      };

      vm.getCurrentUser = function () {
        User.get().$promise.then(function (response) {
          vm.user = response.data;
          vm.career = {
            firstName: vm.user.name,
            email: vm.user.email
          };
        }, function (error) {
          console.log(error);
        });
      };

      vm.careerInit();

      var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        if (file && !(file.name.indexOf('.pdf') > -1) && !(file.name.indexOf('.doc') > -1) && !(file.name.indexOf('.docx') > -1) && !(file.name.indexOf('.txt') > -1)) {
          $('#uploadTrigger').val(null);
          return false;
        }
        reader.onload = function (evt) {
          $scope.$apply(function ($scope) {
            // console.log("evt.target.result", evt.target.result)
            vm.career.resume = evt.target.result;
            vm.fileName = file.name;
            // console.log("file", file.name);
          });
        };
        reader.readAsDataURL(file);
      };
      angular.element(document.querySelector('#uploadTrigger')).on('change', handleFileSelect);

      vm.careerApply = function (form) {
        // console.log("submitted", form)
        vm.submitted = true;
        if (form.$valid) {
          // if (!vm.career.resume.includes("base64"))
          // return toastr.info("Please attach you resume", "Info!");
          if (!vm.career.resume) return false;
          if (!(vm.fileName.indexOf('.pdf') > -1)) {
            vm.career.resume = false;
            return false;
          }
         
          ContactInfo.send(vm.career).$promise.then(function (resp) {
            // console.log(resp);
            vm.career = {};
            vm.submitted = false;
            $('#uploadTrigger').val(null);

            toastr.success(resp.message || "Our team will get back to you soon", "Application Sent!");
          }, function (error) {
            toastr.error("Something Went worng, Please try again", "Error!");
          });
        }
      };


    });

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('AboutCtrl', function ( config, ENUMS, LoadPageData, $log) {
        var vm = this;

        // console.log("AboutCtrl");

        vm.getImageUrl = function(id){
          return config.baseUrl+'/api/gfs/'+id;
        }

        vm.init = function(){
          var cId = ENUMS.contentTypeId.welcomeNote;
          LoadPageData.contents.getContent({id: cId } ).$promise.then(function(res){
            // console.log("about",res);
            if(res && res.data ){
              vm.content = res.data;
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });


          LoadPageData.team.getTeam().$promise.then(function(res){
            // console.log("team",res);
            if(res && res.data && res.data.data ){
              vm.teams = res.data.data;
            }
          },function(err){
          });


        }
        vm.init();

});

})();

(function() {

'use strict';

 angular.module('kapdec')

    .controller('FaqsCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, $sce, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = '';
        console.log("FaqsCtrl");

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          LoadPageData.faqs.getCategories(vm.filterOptions).$promise.then(function(res){
            
           // if(vm.filterOptions.where.q !="undefined"){
           //   LoadPageData.faqs.getSearchQuestions(vm.filterOptions).$promise.then(function(res1){
            //    if(res1 && res1.data && res1.data.data ){
             //     vm.question = res1.data.data;
                  
             //     if(vm.question.length){
              //      vm.getCategoryById(vm.question[0]);
             //       vm.question.forEach(function(val,i){
              //        vm['active'+i] = false;
              //      });
               //   }  
  
               // }
             // });
           // }
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.category = res.data.data;
              //console.log(vm.category)
              if(vm.category && vm.category.length){
               // console.log(vm.category[0])
               vm.getQuestionById(vm.category[0]);
              }
             
              // console.log(res);
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();

        vm.getQuestionById = function(cat){
          console.log(cat)
          if(cat && cat._id){
            vm.category.forEach(function(val){
              if(cat.displayName == val.displayName){
                vm[val.displayName] = true;
                vm.contentId = val.displayName;
              }else{
                vm[val.displayName] = false;
              }
            })
            var id = cat._id;
            LoadPageData.faqs.getQuestions({ controller: id},vm.filterOptions).$promise.then(function(res){
              if(res && res.data && res.data.data ){
                vm.question = res.data.data;
                // console.log(res);
                if(vm.question.length){
                  vm.question.forEach(function(val,i){
                    vm['active'+i] = false;
                  });
                }  

              }
            },
            function(error){
               toastr.error("something went wrong", "Oops!");
            });
          }
        }
        vm.getCategoryById = function(qua){
          if(qua && qua._id){
            vm.category.forEach(function(val){
              //console.log(qua.type)
             // console.log(val)
              if(qua.type == val._id){
                vm[val.displayName] = true;
                vm.contentId = val.displayName;
              }else{
                vm[val.displayName] = false;
              }
            })
            
          }
        }
        vm.getFilteredCat = function(){
          vm.init();
        }

        vm.toggler = function($index){
          if( vm['active'+$index] ){
            vm['active'+$index] = false;
          }else{
            vm['active'+$index] = true;
          }
        }




 });

})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('TutorialCtrl', function (config, _, $window, $http, Auth,User, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, toastr, $state, $log) {
      var vm = this;
      vm.filterUnit = FilterOption().filter;
      vm.filterChapter = FilterOption().filter;
      vm.filterTopic = FilterOption().filter;
      vm.filterClass = FilterOption().filter;

      vm.tutorial = {};
      vm.classes = [];
      vm.grades = [];
      vm.me = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
            
            vm.init();
            vm.getTopics();
          }
        },
          function (error) {
          });
      }
      /**
        on init functionality
      **/
      vm.init = function () {
       
        vm.tutorial.classid = "";
         LoadPageData.classes.joinedClass(vm.filterClass).$promise.then(function (res) {
            console.log("class",res);
           if (res && res.data && res.data.data) {
            vm.classes = res.data.data;
          }
         });
        LoadPageData.grade.getGrade(FilterOption().filter).$promise.then(function (res) {
          // console.log("grade",res);
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
          }
        });

        vm.filterChapter.type = 'filter';
        vm.filterChapter.where.grade = vm.user.grades;
        LoadPageData.manageChapter.getAll(vm.filterChapter).$promise.then(function (resp) {
          if (resp && resp.data) {
            vm.chapters = resp.data.data;
          }
        });
        // vm.getChapters();

      };
      vm.me();


      /**
       get topic as per course unit chapter functionality
     **/
      vm.getTopics = function () {
        if (vm.user.grades) {
          vm.filterOptions = FilterOption().filter;
          vm.filterOptions.limit = 30;
          vm.filterOptions.where.grade = vm.user.grades;

          LoadPageData.manageTopic.getAll(vm.filterOptions).$promise.then(function (res) {
            if (res && res.data) {
              vm.topics = res.data.data;
              var topic = [];
              angular.forEach(vm.topics, function (value, key) {
                topic.push(value._id);
              });

              // vm.getUnits(topic);
            }
          });
        }
      };

      /**
            get units as per course functionality
          **/
      vm.getUnits = function (topic) {
        if (topic) {
          vm.filterUnit.where.topic = topic;
          LoadPageData.manageUnit.getAll(vm.filterUnit).$promise.then(function (resp) {
            // console.log('units', resp);
            if (resp && resp.data && resp.data.data) {
              vm.units = resp.data.data;
              vm.loader = false;
            }
          });
        }
      }

      vm.getChapters = function () {
        vm.chapters = [];
        vm.filterChapter = FilterOption().filter;
        vm.filterChapter.type = 'filter';
        vm.filterChapter.where.topic = vm.tutorial.topic;
        vm.filterChapter.where.unit = vm.tutorial.unit;
        if (!vm.tutorial.topic && !vm.tutorial.unit) {
          vm.filterChapter.where.grade = vm.user.grades;
        }

        if (vm.tutorial.unit) {
        vm.filterChapter.where.topic = "";
        }

        LoadPageData.manageChapter.getAll(vm.filterChapter).$promise.then(function (resp) {
          if (resp && resp.data && resp.data.data) {
            vm.chapters = resp.data.data;
          }
        });
      };

      vm.viewChapterContent = function (chapterId) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageContentModel.html',
          controller: 'ChapterContentModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          keyboard: false,
          resolve: {
            data: function () {
              return chapterId;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });
      };

      vm.viewChapterVideo = function (chapterId) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/chapterVideoModal.html',
          controller: 'ChapterModalCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          keyboard: false,
          resolve: {
            data: function () {
              return chapterId;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });
      };


    }).controller('ChapterContentModalController', function (config, _, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, toastr, FilterOption) {
      var vm = this;

      vm.chapterId = data;
      vm.loader = true;
      vm.chapter = {};
      vm.filterClass = FilterOption().filter;

      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        LoadPageData.manageChapter.getById({ id: vm.chapterId }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.chapter = res.data;
            vm.content = vm.chapter.content;
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };

      vm.init();

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
    }).controller('ChapterModalCtrl', function (config, $sce, _, $window, data, $http, Auth, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, toastr, $state, $log, $uibModalInstance) {
      var vm = this;
      vm.loader = true;
      vm.chapter = {};
      vm.filterClass = FilterOption().filter;
      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        LoadPageData.manageChapter.getById({ id: data }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.chapter = res.data;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };

      vm.trustUrl = function (url) {
        return $sce.trustAsResourceUrl(url);
      }

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      vm.init();
    });


})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('TestResultCtrl', function (config,  _, ENUMS, SystemEnum, ExamService, $window, $timeout, $localStorage, LoadPageData, FilterOption, toastr, $state, $log) {
        var vm = this;

        console.log("TestResultCtrl");

        var vm = this;
        vm.params = $state.params;
        vm.loader = true;

        /**
          on init check valid url functionality
        **/
       vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
        vm.invalidUrl = function(){
          if(vm.params  && vm.params.examId ){
            return true;
          }else{
            toastr.error("something went wrong! Invalid Url searched", "Oops!");
            $timeout(function(){
              $state.go('index.notFound404');
            },2000);
            return false;
          }
        }

        /**
          on init functionality
        **/
        vm.init = function(){
          if($localStorage.course){
           vm.course = JSON.parse($localStorage.course);
          }
          vm.invalidUrl();
          if(vm.params.examId){

            // if(vm.params.examId){vm.examId = vm.params.examId;}

            ExamService.ExamResult({controller: vm.params.examId }).$promise.then(function(res){
              console.log(res);
              if(res && res.data){
                vm.result = res.data;
                vm.loader = false;

              }
            },
            function(error){
              toastr.error("something went wrong! try later", "Oops!");
              $timeout(function(){
                $state.go('index.notFound404');
              },2000)
            });
          };

        }
        vm.init();







 });

})();

(function () {

  'use strict';

  angular.module('kapdec')

    .controller('TestCtrl', function (config, _, ENUMS, SystemEnum, ExamService, $window, $timeout, $localStorage, LoadPageData, FilterOption, toastr, $state, $log) {
      var vm = this;
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.result = {};
      vm.isExamCompleted = false;
      // console.log("TestCtrl", vm.params);
      // :course/?type&gradeId&unitId&chapterId&topicId&topic&chapter&q

      /**
        on init check valid url functionality
      **/
      vm.invalidUrl = function () {
        if (vm.params && vm.params.chapterId || vm.params.unitid) {
          return true;
        } else {
          toastr.error("something went wrong! Invalid Url searched", "Oops!");
          $timeout(function () {
            $state.go('index.notFound404');
          }, 2000);
          return false;
        }
      }

      /**
        on get start question functionality
      **/
      vm.getQuestion = function () {
        vm.instruction = "";
        vm.selectOption = '';
        vm.loader = true;
        vm.isNext = false;
        if (vm.isExamCompleted) {
          $state.go('dashboard.testresult', { type: vm.params.type, examId: vm.params.examId })
        }
        // console.log('q');
        if (vm.params.examId) {
          
          ExamService.getQuestion({ id: vm.params.examId, nextQuestionLevel: vm.result.nextQuestionLevel }).$promise.then(function (res) {
             //console.log('q',res);
           
            if (res.code == 204) {
              toastr.error(res.message, "Oops!");
            } else if (res && res.data) {
              vm.question = res.data;
              ExamService.ExamResult({ controller: vm.params.examId}).$promise.then(function (res1) {
        if(res1 && res1.data){
         // console.log(res1.data)
          vm.chapterName=res1.data.chapter.name;
          vm.unitName=res1.data.unit.name;
          if(res1.data.isExam==true){
            vm.questionCount=25;
          }
          else{
            vm.questionCount=10;
          }
          //vm.isExam=res1.data.isExam;
          vm.isQuiz=res1.data.isQuiz;
        }
              });
              vm.loader = false;
              // if(vm.examId){
              //  $state.go('dashboard.test',{type: vm.params.type, examId: vm.examId, q: 'start' });
              // }
              vm.result = {};
            }

          },
            function (error) {
              toastr.error(error.data.message + " something wrong! try later", "Oops!");
              $timeout(function () {
                $state.go('index.notFound404');
              }, 2000);
            });
        }

      }

      /**
        on init functionality
      **/
      vm.init = function () {
        if ($localStorage.course) {
          vm.course = JSON.parse($localStorage.course);
          // console.log(vm.course);
        }
        vm.invalidUrl();
        if (!vm.params.q) {
          var sendData = {};
          console.log(vm.params)
          sendData.chapter = vm.params.chapterId;
          sendData.class = vm.params.classid;
          sendData.unit = vm.params.unitid;

          if (vm.params.chapterId) {
            sendData.examType = ENUMS.testExamType['chapter'];
          }

          if (vm.params.unitid) {
            sendData.examType = ENUMS.testExamType['module'];
          }
          // if(vm.params.course){sendData.course = vm.params.course;}
          //  if(vm.params.topicId){sendData.topic = vm.params.topicId;}

          ExamService.startExam(sendData).$promise.then(function (res) {
            console.log(res);
            if (res && res.data) {
              vm.examId = res.data._id;
              vm.loader = false;
              if (vm.examId) {
                $state.go('dashboard.test', { examId: vm.examId, q: 'start' });
              }
            }
            if (res.code == 204) {
              toastr.error(res.message, "Oops!");
              $state.go('dashboard.tutorial');

            }
          },
            function (error) {
              toastr.error("something went wrong! try later", "Oops!");
              $timeout(function () {
                $state.go('dashboard.profile')
              }, 2000)
            });
        };
        if (vm.params.examId && vm.params.q == 'start') {
          if (vm.params.examId && vm.params.q == 'start') {
           
              // console.log(classInfo);
              $state.go('dashboard.test', { type: 'chapter', examId: vm.params.examId, q: 1 });
               
            //$state.go('dashboard.test', { type: 'chapter', examId: vm.params.examId, q: 1 });
          } else {
            toastr.error("something went wrong! Invalid Url searched", "Oops!");
            $timeout(function () {
              $state.go('index.notFound404');
            }, 2000);
          }
          // SystemEnum.getEnum({ controller: ENUMS.testExamType['chapter'] }).$promise.then(function (res) {
          //   // console.log(res);
          //   if (res && res.data) {
          //     vm.instruction = res.data;
          //     vm.loader = false;
          //     // if(res.data){
          //     //  $state.go('dashboard.test',{type: vm.params.type, examId: vm.examId, q: 1 });
          //     // }
          //   }
          // },
          //   function (error) {
          //     toastr.error("something went wrong! try later", "Oops!");
          //   });

        }
        if (vm.params.examId && vm.params.q == '1') {
          vm.getQuestion();
        }

      };
      vm.init();

      /**
        on get start question functionality
      **/
      vm.getStartExam = function () {
        if (vm.params.examId && vm.params.q == 'start') {
          $state.go('dashboard.test', { type: 'chapter', examId: vm.params.examId, q: 1 });
        } else {
          toastr.error("something went wrong! Invalid Url searched", "Oops!");
          $timeout(function () {
            $state.go('index.notFound404');
          }, 2000);
        }
      }

      /**
        on submit answer question functionality
      **/
      vm.submitAnswer = function (qId, answered) {
        vm.isBusy = true;
        vm.result = {};
        if (vm.params.examId && qId && answered) {
          // ExamService.submitAnswers({
          //   examType: 15,
          //   chapter: vm.params.chapterId,
          //   answers: [{ questonID: qId, selectOption: answered }]
          // }).$promise.then(function (res) {

          // });


          ExamService.submitAnswer({
            id: vm.params.examId,
            questonID: qId,
            selectOption: answered,
            chapter: vm.params.chapterId,
            unit: vm.params.unitid
          }).$promise.then(function (res) {
            console.log(res);
            if (res && res.data && res.data.data) {
              vm.isNext = true;
              vm.isBusy = false;
              vm.result = res.data;
              vm.explanation = res.data.data.explaination;
              vm.isExamCompleted = res.data.isExamCompleted;
            }
          },
            function (error) {
              vm.isBusy = false;
              toastr.error("something went wrong! try later", "Oops!");

              if (vm.params.examId) {
                $state.go('dashboard.test', { type: vm.params.type, examId: vm.params.examId, q: 'start' });
              }

            });

        }
      }


    });

})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('SubscriptionCtrl', function (config, _, ENUMS,LoadPageData, User, $location, FilterOption, $sce, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;
      vm.currency = 'IN';
      vm.currencies = [];
      vm.filterSubsList = [];
     // console.log("SubscriptionCtrl", $location.search().course);

      vm.selectCourse = angular.lowercase($location.search().course) || 'math';


      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      /**
        on load functionality
      **/
      vm.myInfo = function () {
        User.get().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
            // console.log(res.data);
            vm.init();
          }
        })
      }
      vm.myInfo();

      /**
        on load functionality
      **/
      vm.init = function () {
        var cId = ENUMS.contentTypeId.welcomeNote;
        LoadPageData.contents.getContent({id: cId } ).$promise.then(function(res){
          // console.log("about",res);
          if(res && res.data ){
            vm.content = res.data;
          }
        },
        function(error){
            if(error && error.status == -1 ){
              toastr.error("we are offline! try later", "Oops!");
            }
        });
        LoadPageData.subscription.getCurrency().$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.currencies = res.data;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
          vm.filterOptions.where.active = true;
        LoadPageData.subscription.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.subsList = res.data.data;
            vm.filterOptions.total = res.data.total;
            //console.log(res)
            vm.filterSubList(vm.currency);
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };

      vm.filterSubList = function (subsFilter) {
        vm.filterSubsList = [];
        angular.forEach(vm.subsList, function (res, key) {
          if (res.currency == subsFilter) {
            vm.filterSubsList.push(res);
          }
        });
      }
      vm.init();

      /**
        on badge pagination functionality
      **/
      // vm.changeFilterOptions = function() {
      //   if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
      //     vm.init();
      //   }
      // }

      // vm.getFilteredSubs = function(){
      //   vm.init();
      // }
      vm.openModal = function (subscription) {
        
        var subscribeId=subscription._id;
        var amount = subscription.amount * subscription.discount / 100;
        amount = subscription.amount - amount;
      var duration=subscription.duration;
        var currency1="";
        if(subscription.currency=="IN"){
          currency1=1;
        }
        else{
          currency1=2;
         }
       // console.log(subscription)
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/makePaymentModal.html',
          controller: 'paymentForSubscriptionCTRL',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            amount: amount,
            duration:duration,
            currency1:currency1,
            subscribeId:{subscribeId:subscribeId}

          }
        }).result.then(function () {
          vm.getClassList();
        }, function () {
          vm.getClassList();
        });
      };


    }).controller('paymentForSubscriptionCTRL', function (config, _, LoadPageData, User, $location, FilterOption, $sce, $uibModal, $timeout, toastr, amount,duration,currency1,subscribeId, $uibModalStack) {
      var vm = this;
         
      vm.loader = true;
      vm.years = [];
      vm.amount = amount;
      vm.duration=duration;
      vm.subscribeId=subscribeId.subscribeId;
      vm.currency1=currency1;
      //console.log(vm.subscribeId)
      for (var index = 0; index < 20; index++) {
        vm.years.push(moment().add(index, 'years').format('YYYY'))
      }

//console.log(vm.amount)
//console.log(parseFloat(vm.amount))
      vm.makePayment = function (form) {
        //console.log(vm.payment)
        vm.submitted = true;
        vm.payment.amount=parseFloat(vm.amount);
        vm.payment.duration=vm.duration;
        vm.payment.currency1=vm.currency1;
        vm.payment.subscribeId=vm.subscribeId;
        // console.log(vm.payment.recurring)
         if(vm.payment.recurring==undefined){
            vm.payment.recurring=false;
         }
        if (form.$valid) {
          User.get().$promise.then(function (res) {
            if (res && res.data) {
              //console.log(res.data)
              vm.isPaid = res.data.isPaidUser;
              console.log(vm.isPaid)
              if(vm.isPaid==false){
                LoadPageData.subscription.payment(vm.payment).$promise.then(function (res) {
                  //console.log(res.data)
                   if(vm.payment.recurring==false){
                     var response = {};
                     if(res.data.status=="succeeded"){
                       response = LoadPageData.transaction.create({
                         childIdSelect:"",
                         charge_Id:res.data.id,
                         amount:vm.payment.amount,
                         balance_transaction:res.data.balance_transaction,
                         bill_Name:res.data.billing_details.name,
                         city:res.data.billing_details.address.city,
                         state:res.data.billing_details.address.state,
                         country:res.data.billing_details.address.country,
                         pincode:res.data.billing_details.address.postal_code,
                         Address:res.data.billing_details.address.line1,
                         currency:res.data.currency,
                         orderId:res.data.metadata.order_id,
                         paymentMethod:res.data.payment_method,
                         reciptURL:res.data.receipt_url,
                         refundsURL:res.data.refunds.url,
                         sourceId:res.data.source.id,
                         status: "approved",
                         subcription: vm.payment.subscribeId,
                         isRecurrence:vm.payment.recurring,
                         duration:vm.payment.duration,
                    });
                    User.get().$promise.then(function (res) {
                     if (res && res.data) {
                       vm.user = res.data;
                       User.approvePaid({ controller: vm.user._id }, { isPaid: true }).$promise.then(function (res) {
                         if (res) {
                           vm.isBusy = false;
                        }
                       }, function (error) {
                         vm.isBusy = false;
                       });
                     }
                   });
                   
       
       
                    toastr.success("Sucessfully payment", "Success");
                     }
                     else{
                       toastr.error("Some Error", "Error!");
                     }
                     
       
                     
                   }
                   else{
                     if(res.data.status=="active"){
                     
                     response = LoadPageData.transaction.create({
                       childIdSelect:"",
                       charge_Id:res.data.latest_invoice.charge,
                       amount:vm.payment.amount,
                       balance_transaction:"",
                       bill_Name:vm.payment.FirstName+" "+vm.payment.LastName,
                       city:vm.payment.City,
                       state:vm.payment.State,
                       country:vm.payment.Country,
                       pincode:vm.payment.Zipcode,
                       Address:vm.payment.Address,
                       currency:res.data.plan.currency,
                       orderId:"",
                       paymentMethod:'card',
                       reciptURL:res.data.latest_invoice.hosted_invoice_url,
                       refundsURL:res.data.latest_invoice.payment_intent.id,
                       sourceId:res.data.latest_invoice.payment_intent.source,
                       status: "approved",
                       subcription: vm.payment.subscribeId,
                       isRecurrence:vm.payment.recurring,
                       duration:vm.payment.duration,
                  });
                  User.get().$promise.then(function (res) {
                   if (res && res.data) {
                     vm.user = res.data;
                     User.approvePaid({ controller: vm.user._id }, { isPaid: true }).$promise.then(function (res) {
                       if (res) {
                         vm.isBusy = false;
                      }
                     }, function (error) {
                       vm.isBusy = false;
                     });
                   }
                 });
                  toastr.success("Sucessfully payment", "Success");
                 }
                 else{
                   toastr.error("Some Error", "Error!");
                 }
                     ///toastr.error("Some Error", "Error!");
                   }
                  
                   vm.cancel();
                 }, function (error) {
                  // console.log(error)
                   vm.loader = false;
                   toastr.error(error.data.message + "  : error", "Error!");
                 });
              }
              else{
                toastr.error("Payment already saved.", "Error");
              }
            }
          });



          
        }
      }
      vm.selectYear = function (year) {
        vm.months = [];
        var start = 1;

        if (moment().format('YYYY') == year) {
          start = parseInt(moment().format('MM'));
        }

        for (var index = start; index <= 12; index++) {
          if (index < 10) {
            vm.months.push('0' + index);
          } else {
            vm.months.push(index);
          }
        }
      }
      vm.cancel = function () {
        $uibModalStack.dismissAll();
      }
    });

})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('SelectByClassCtrl', function (Auth, $uibModal, LoadPageData, $state, FilterOption) {
      var vm = this;
      vm.filterUnit = FilterOption().filter;
      vm.filterChapter = FilterOption().filter;
      vm.filterTopic = FilterOption().filter;
      vm.filterClass = FilterOption().filter;
      vm.classId = $state.params.classid;

      vm.class = {};
      vm.tutorial = {};

      vm.me = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
            vm.init();
          }
        }, function (error) { });
      }
      /**
        on init functionality
      **/
      vm.init = function () {

        vm.tutorial.classid = "";
        LoadPageData.classes.joinedClass(vm.filterClass).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            angular.forEach(res.data.data, function (value) {
              if (value._id == vm.classId) {
                vm.class = value;
                vm.getTopics();
                vm.getChapters();
              }
            });
          }
        });
      };
      vm.me();


      /**
       get topic as per course unit chapter functionality
     **/
      vm.getTopics = function () {
        vm.filterOptions = FilterOption().filter;
        vm.filterOptions.limit = 30;
        vm.filterOptions.where._id = vm.class.topics;

        LoadPageData.manageTopic.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data) {
            vm.topics = res.data.data;
            var topic = [];
            angular.forEach(vm.topics, function (value, key) {
              topic.push(value._id);
            });

            // vm.getUnits();
          }
        });
      };

      /**
            get units as per course functionality
          **/
      vm.getUnits = function (topic) {
        vm.tutorial.unit = "";
        vm.units = [];

        vm.filterUnit.where._id = vm.class.units;
        vm.filterUnit.where.topic = topic;

        LoadPageData.manageUnit.getAll(vm.filterUnit).$promise.then(function (resp) {
          // console.log('units', resp);
          if (resp && resp.data && resp.data.data) {
            vm.units = resp.data.data;
            vm.loader = false;
          }
        });
      }

      vm.getChapters = function () {
        vm.chapters = [];
        vm.filterChapter = FilterOption().filter;
        vm.filterChapter.type = 'filter';
        if (!vm.tutorial.topic && !vm.tutorial.unit) {
          vm.filterChapter.where.unit = vm.class.units;
        }

        if (vm.tutorial.topic) {
          vm.filterChapter.where.unit = "";
          vm.filterChapter.where.topic = vm.tutorial.topic;
        }

        if (vm.tutorial.unit) {
          vm.filterChapter.where.topic = "";
          vm.filterChapter.where.unit = vm.tutorial.unit;
        }

        LoadPageData.manageChapter.getAll(vm.filterChapter).$promise.then(function (resp) {
          if (resp && resp.data && resp.data.data) {
            vm.chapters = [];
            angular.forEach(resp.data.data, function (value) {
              if (vm.class.chapters.indexOf(value._id) > -1) {
                vm.chapters.push(value);
              }
            });
          }
        });
      };

      vm.viewChapterContent = function (chapterId) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageContentModel.html',
          controller: 'ChapterContentModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          keyboard: false,
          resolve: {
            data: function () {
              return chapterId;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });
      };

      vm.viewChapterVideo = function (chapterId) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/chapterVideoModal.html',
          controller: 'ChapterModalCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          keyboard: false,
          resolve: {
            data: function () {
              return chapterId;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });
      };


    }).controller('ChapterContentModalController', function (config, _, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, toastr, FilterOption) {
      var vm = this;

      vm.chapterId = data;
      vm.loader = true;
      vm.chapter = {};
      vm.filterClass = FilterOption().filter;

      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        LoadPageData.manageChapter.getById({ id: vm.chapterId }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.chapter = res.data;
            vm.content = vm.chapter.content;
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };

      vm.init();

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
    }).controller('ChapterModalCtrl', function (config, $sce, _, $window, data, $http, Auth, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, toastr, $state, $log, $uibModalInstance) {
      var vm = this;
      vm.loader = true;
      vm.chapter = {};
      vm.filterClass = FilterOption().filter;
      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        LoadPageData.manageChapter.getById({ id: data }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.chapter = res.data;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };

      vm.trustUrl = function (url) {
        return $sce.trustAsResourceUrl(url);
      }

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      vm.init();
    });


})();

(function() {

'use strict';

angular.module('kapdec')
    .controller('ProfileCtrl', function (config, Auth, $log,User,FilterOption,LoadPageData) {
        var vm = this;
        console.log("ProfileCtrl");
        vm.filterOptions = FilterOption().filter;
        vm.grade=[];
        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        vm.init = function(){
          
        User.get().$promise.then(function (res) {
            if(res && res.data ){
              vm.user = res.data;
            if(vm.user=="US"){
              vm.countryCode="+1";
            }
            else{
              vm.countryCode="+91";
            }
              var log = [];
              angular.forEach(vm.user.grades, function(value, key) {
                 var filter = FilterOption().filter;
                filter.where["_id"] = value;
                LoadPageData.manageGrade.getAll(filter).$promise.then(function (res1) {
                  if (res1 && res1.data && res1.data.data) {
                    var AllData=res1.data.data[0];
                     vm.grade.push(AllData.name)
                  }
                });
               
              }, log);
      
              vm.user.dob = moment(vm.user.dob).add(-1,'days').format('DD/MM/YYYY');
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();

});

})();


(function() {

'use strict';

 angular.module('kapdec')
    .controller('MysubscriptionCtrl', function (config, _, LoadPageData, $location, FilterOption, $sce, moment, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions   = FilterOption().filter;
      vm.filterOptions.limit = 30;

        console.log("MysubscriptionCtrl");

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        /**
          on load functionality
        **/
        vm.init = function(){
          LoadPageData.transaction.getHistory(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.transList = res.data.data;
              vm.filterOptions.total = res.data.total;
              console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();

        /**
          on badge pagination functionality
        **/
        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredTrans = function(){
          vm.init();
        }



 });

})();

(function() {

'use strict';

angular.module('kapdec')
      .controller('MyTestsCtrl', function (config, _,  Auth, ExamService, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

            var vm = this;

            vm.viewBy = [10, 20, 30, 90];
            vm.params = $state.params;
            vm.loader = true;
            vm.loadQuestion = true;
            vm.filterQuestion = FilterOption().filter;
            vm.filterQuiz   = FilterOption().filter;
            vm.filterQuiz.limit = '10';
            vm.filterQuestion.limit = '10';
            console.log("MyTestsCtrl");

            vm.dtOptions = DTOptionsBuilder.newOptions()
              .withDOM('lfrtip')
              .withOption('paging', false)
              .withOption('searching', false)
              .withOption('lengthChange', false)
              .withOption('status', false)
              .withOption('bInfo', false)
                .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [0] }])

            vm.getImageUrl = function(id){
              if(id){
              return config.baseUrl+'/api/gfs/'+id;
              }
            };

            /**
              on load functionality
            **/
           vm.getQuiz = function () {

            ExamService.myQuizList(vm.filterQuiz).$promise.then(function(res){
              if(res && res.data && res.data.data ){
              
                vm.loader = false;
                vm.myQuizList = res.data.data;
                console.log(vm.myQuizList)
                vm.filterQuiz.total = res.data.total;
                // console.log(res)
              }
            },
              function (error) {
              });
          };
    
          vm.getExam = function () {
    
            ExamService.myExamsList(vm.filterQuestion).$promise.then(function(res){
              if(res && res.data && res.data.data ){
              
                vm.loader = false;
                vm.myExamList = res.data.data;
                vm.filterQuestion.total = res.data.total;
                // console.log(res)
              }
            },
              function (error) {
              });
          };

          vm.init = function () {
            vm.getQuiz();
            vm.getExam();
          };

           // vm.init = function(){
          
             // ExamService.myExamsList(vm.filterOptions).$promise.then(function(res){
              //  if(res && res.data && res.data.data ){
                
               //   vm.loader = false;
               //   vm.myExamList = res.data.data;
               //   vm.filterOptions.total = res.data.total;
                  // console.log(res)
               // }
              //},
             // function(error){
              //    if(error && error.status == -1 ){
               ////     toastr.error("we are offline! try later", "Oops!");
               //   }
              //});
            //};
            vm.init();


           // vm.changeFilterOptions = function() {
             // if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
              //  vm.init();
             // }
           // }
            vm.changeFilterOptions = function (type) {
              if ((vm['filter' + type].page - 1) * vm['filter' + type].limit <= vm['filter' + type].total) {
                vm['get' + type]();
              }
            }
            vm.getFilteredTests = function(){
              vm.init();
            }



 });


})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('EditProfileCtrl', function (appPattern, User, toastr, $uibModal, Upload, $state, config, Auth, $log, $scope, $timeout,SweetAlert,$window,FilterOption,LoadPageData) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = {};
      vm.userDOB = "";
      vm.filterOptions = FilterOption().filter;
      vm.grade=[];
      // console.log("EditProfileCtrl");

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.init = function () {
        User.get().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
            if(vm.user=="US"){
              vm.countryCode="+1";
            }
            else{
              vm.countryCode="+91";
            }
            var log = [];
            angular.forEach(vm.user.grades, function(value, key) {
               var filter = FilterOption().filter;
              filter.where["_id"] = value;
              LoadPageData.manageGrade.getAll(filter).$promise.then(function (res1) {
                if (res1 && res1.data && res1.data.data) {
                  var AllData=res1.data.data[0];
                   vm.grade.push(AllData.name)
                }
              });
             
            }, log);
            vm.fullName = vm.user.name;
            vm.userDOB = moment(vm.user.dob).add(-1,'days').format('DD/MM/YYYY');
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();

      vm.upload = function (form) {
        vm.submitted = true;
          if (form.$valid) {
            vm.loader = true;
            if (!vm.fullName) return false;
            vm.user.name = vm.fullName;
            if ((vm.password || vm.confirmPassword) && !(vm.password === vm.confirmPassword)) return false;
            if (vm.password && vm.confirmPassword) vm.user.password = vm.password;

            User.update({ data: vm.user }).$promise.then(function (res) {
              if (res && res.data) {
                vm.loader = false;
                toastr.success("Profile has Updated! " + res.message, "Successful");
                $state.go("dashboard.profile");
              }
            },
              function (error) {
                if (error) {
                  vm.init();
                  vm.loader = false;
                  toastr.error(error.data.message, "Oops!");
                }
              });
          }
      };
      vm.refreshImage = function () {
        $window.location.reload();
      }

      vm.removeImage = function () {

        SweetAlert.swal({
          title: "Are you sure ?",
          text: "Do you want to delete this image",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              User.removeImage({ data: vm.user }).$promise.then(function (res) {
                if (res && res.data) {
                  vm.loader = false;
                  toastr.success("Your profile image has been deleted successfully!");
                  $window.location.reload();
                }
              },
                function (error) {
                  if (error) {
                    vm.loader = false;
                    toastr.error(error.data.message, "Oops!");
                  }
                });
            } else {
              SweetAlert.swal("Cancelled", "You have been cancelled", "error");
            }
          });



      }
      vm.changeImage = function () {

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/editProfileImageModal.html',
          controller: 'EditProfileImageCtrl',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.user;
            }
          }
        }).result.then(function () {
          vm.init();
        }, function () {

        });
      };
      
    }).controller('EditProfileImageCtrl', function (appPattern, $state, data, toastr, $uibModalInstance, Upload, config, Auth, $log, $scope, $timeout) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = data;

      vm.cancelUpload = function () {

        $("#fileInput").val("");
        $scope.myImage = "";
        vm.myCroppedImage = '';
      };
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      $scope.uploadPic = function (file) {
        file.upload = Upload.upload({
          url: 'https://angular-file-upload-cors-srv.appspot.com/upload',
          data: { username: $scope.username, file: file },
        });

        file.upload.then(function (response) {
          $timeout(function () {
            file.result = response.data;
          });
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

      }

      vm.watchUpdateImage = function (isDone) {
        $timeout(function () {
          $scope.$emit("uploaded", { update: isDone });
          location.reload();
        }, 2000);
      }

      vm.upload = function (fileUrl, name) {

        Upload.upload({
          url: config.baseUrl + '/api/users/update',
          data: { data: vm.user, file: Upload.dataUrltoBlob(fileUrl, name) },
          disableProgress: true
        }).then(function (response) {
            $timeout(function () {
              // console.log(response);
              toastr.success("Profile has Updated! " + response.data.message, "Successful");
              vm.watchUpdateImage(true);
              vm.loader = false;
              vm.cancelUpload();
              $scope.result = response.data;
            });
          }, function (err) {
            if (err) {
              toastr.error("something went wrong ! try later  " + err.message, "Oops!");
              vm.init();
              vm.loader = false;
            }
            console.log("err", err);
          })
      }

      $scope.onSelectFile = function (model) {

        var file = model.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
          $scope.$apply(function ($scope) {
            $scope.myImage = evt.target.result;
          });
        };
        reader.readAsDataURL(file);
      }

    });



})();

(function() {

'use strict';

angular.module('kapdec')

      .controller('DiscussionTopicCtrl', function (config, _, $window, SweetAlert, $uibModal, $timeout, $localStorage, Discussion, FilterOption, $uibModalStack, toastr, $state, $log) {

        var vm = this;
        $uibModalStack.dismissAll();
        vm.loader     = true;
        vm.params = $state.params;
        vm.submitted  = false;
        vm.filterQues = FilterOption().filter;
        vm.filterAns  = FilterOption().filter;
        /**
          on get discussion list functionality
        **/
        vm.getList = function(){
          if(vm.params &&vm.params.page){
             vm.filterQues.page = vm.params.page;
          };
          Discussion.getDiscussions(vm.filterQues).$promise.then(function(res){
            console.log("getdiscuss",res);
            if(res && res.data && res.data.data ){
                vm.loader = false;
                vm.getDiscussions = res.data.data;
                vm.filterQues.total = res.data.total;
             }
           }, function(error){
             if(error && error.status == -1 ){
               toastr.error("we are offline! try later", "Oops!");
             }
           });

        };
        vm.getList();

        /**
          on load more question limit+5 functionality
        **/
        vm.loadMore = function(scope){
          if(!vm[scope]){ vm[scope] = 5 };
          vm[scope] += 5;
        }
        vm.loadLess = function(scope){
          if(!vm[scope]){ vm[scope] = 5 };
          vm[scope] -= 5;
        }
        vm.changeDiscussionPage = function(){
          if( vm.filterQues.page ){
            vm.params.page =  vm.filterQues.page;
            $state.go('dashboard.discussiontopic', { page: vm.filterQues.page },{notify: false} );
            vm.getList();
          }
        };

        /**
          on add reply on question functionality
        **/
        vm.postReply = function(form, discussion, index){
          // vm.submitted = true;
          vm['submitted'+index] = true;
          // console.log(form, discussion);
          if (form.$valid ) {
              vm['loadReply'+index] = true;
              Discussion.addReply( { id : discussion._id, answer: discussion.addReply } ).$promise.then(function (response) {
                 vm['loadReply'+index] =false;
                 vm['submitted'+index] = false;
                 vm.getDiscussions[index] = response.data;
                 // vm.init();
              }, function (error) {
                  vm['loadReply'+index] =false;
                  toastr.error(error.data.message+"  :Something Went worng", "Error!");
              });
           }

        }

        /**
          on add/ask question functionality
        **/
        vm.askQuestion = function (form) {

          vm.submitted = true;
          if (form.$valid && vm.question) {
            // console.log(vm.question);
              vm.loader = true;
              Discussion.create( { discussionTitle : vm.question } ).$promise.then(function (response) {

                 vm.loader =false;
                 vm.submitted = false;
                 vm.question = "";
                 vm.getList();
                 $("button[data-dismiss=\"modal\"]").click();
                 toastr.success(response.message+' question added', "Successfully!");

              }, function (error) {
                  vm.loader =false;
                  toastr.error(error.data.message+"  :Something Went worng", "Error!");
              });
          }

        };


  })
  .controller('MyDiscussionCtrl', function (config, _, $window, SweetAlert, $uibModal, $timeout, $localStorage, Discussion, FilterOption, $uibModalStack, toastr, $state, $log) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.loader     = true;
      vm.params = $state.params;
      vm.submitted  = false;
      vm.filterQues = FilterOption().filter;
      vm.filterAns  = FilterOption().filter;
      /**
        on get my-discussion list functionality
      **/
      vm.getList = function(){
        vm.filterQues.limit = 30;
        if(vm.params &&vm.params.page){ vm.filterQues.page = vm.params.page; };

        Discussion.myDiscussions(vm.filterQues).$promise.then(function(res){
          console.log("mydiscuss",res);
          if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.myDiscussions = res.data.data;
              vm.filterQues.total = res.data.total;
           }
         }, function(error){
           if(error && error.status == -1 ){
             toastr.error("we are offline! try later", "Oops!");
           }
         });

      };
      vm.getList();

        /**
          on load more question {limit+5} functionality
        **/
        vm.loadMore = function(scope){
          if(!vm[scope]){ vm[scope] = 5 };
          vm[scope] += 5;
        }

        vm.loadLess = function(scope){
          if(!vm[scope]){ vm[scope] = 5 };
          vm[scope] -= 5;
        }

        vm.changeDiscussionPage = function(){
          if( vm.filterQues.page ){
            $state.go('dashboard.mydiscussion', { page: vm.filterQues.page },{notify: true} );
            // vm.getList();
          }
        };

        /**
          on add reply on question functionality
        **/
        vm.postReply = function(form, discussion, index){
          // vm.submitted = true;
          vm['submitted'+index] = true;
          console.log(form, discussion, index );

          if (form.$valid ) {
              vm['loadReply'+index] = true;
              Discussion.addReply( { id : discussion._id, answer: discussion.addReply } ).$promise.then(function (response) {
                 vm['loadReply'+index] =false;
                 vm['submitted'+index] = true;
                  vm.myDiscussions[index] = response.data;

                 // delete discussion.addReply;
                 // vm.init();
              }, function (error) {
                  vm['loadReply'+index] =false;
                  toastr.error(error.data.message+"  :Something Went worng", "Error!");
              });
           }

        }

        /**
          on add/ask question functionality
        **/
        vm.askQuestion = function (form) {

          vm.submitted = true;
          if (form.$valid && vm.question) {
            // console.log(vm.question);
              vm.loader = true;
              Discussion.create( { discussionTitle : vm.question } ).$promise.then(function (response) {

                 vm.loader =false;
                 vm.submitted = false;
                 vm.question = "";
                 vm.getList();
                 $("button[data-dismiss=\"modal\"]").click();
                 toastr.success(response.message+' question added', "Successfully!");

              }, function (error) {
                  vm.loader =false;
                  toastr.error(error.data.message+"  :Something Went worng", "Error!");
              });
          }

        };



    });


})();



'use strict';

angular.module('kapdec')
  .controller('DashboardViewCtrl', function (config, $log, Auth, FilterOption,ExamService, $uibModal, LoadPageData, $localStorage, $uibModalStack, $state,$scope) {
    var vm = this;
    $uibModalStack.dismissAll();
    vm.filterQuestion = FilterOption().filter;
    vm.filterQuiz   = FilterOption().filter;
    vm.filterQuiz.limit = '100';
    vm.filterQuestion.limit = '100';

    vm.getImageUrl = function (id) {
      return config.baseUrl + '/api/gfs/' + id;
    };
    vm.TotalModule=0;
    vm.TotalBadge=0;
    vm.TotalQuiz=0;
    vm.AverageQuiz=0;

    vm.TotalExam=0;
    vm.AverageExam=0;

    vm.GraphData="";
    var month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    vm.init = function () {

      
        Auth.getCurrentUser().$promise.then(function (res) {
         // console.log('hi')
          //console.log(res)
          if (res && res.data) {
            vm.user = res.data;
            
           // vm.init();
           // console.log(vm.user.grades)
            if (vm.user.grades) {
              vm.filterOptions = FilterOption().filter;
              vm.filterOptions.limit = 200;
              vm.filterOptions.where.grade = vm.user.grades;
        
              LoadPageData.manageTopic.getAll(vm.filterOptions).$promise.then(function (res) {
                if (res && res.data) {
                  vm.topics = res.data.data;
                  var topic = [];
                  angular.forEach(vm.topics, function (value, key) {
                   // topic.push(value._id);
                   vm.getModule(value._id);
                  });
        
                  // vm.getUnits(topic);
                }
              });
            }
          }
        });
      
    };
   
    vm.filterOptions = FilterOption().filter;
    vm.filterOptions.limit = 30;
  LoadPageData.badges.getActive(vm.filterOptions).$promise.then(function (res) {
    if (res && res.data && res.data.data) {
      vm.loader = false;
      vm.badgeList = res.data.data;
      _.map(vm.badgeList, function (value) {
        value.count = 0;
        _.map(res.data.exams, function (exam, key) {
          if (value._id == exam.allocatedBadgeID) {

            value.count = key + 1;
          }
        });
      });
    //  console.log(vm.badgeList);
      vm.badgeList.forEach(function (element, i1) {
        if(i1==0){
            vm.TotalBadge=0;
            vm.TotalBadge=element.count;
        }
        else{
          vm.TotalBadge =vm.TotalBadge+element.count;
        }
        //console.log(element.count);
      });
    }
  },
    function (error) {
      if (error && error.status == -1) {
        toastr.error("we are offline! try later", "Oops!");
      }
    });
    ExamService.myQuizList(vm.filterQuiz).$promise.then(function(res){
      if(res && res.data && res.data.data ){
      
        vm.loader = false;
        vm.myQuizList = res.data.data;
        console.log(vm.myQuizList)
        vm.myQuizList.forEach(function (element, i1) {
          vm.TotalQuiz =vm.TotalQuiz+element.obtainPercentage;

        });
        if(vm.TotalQuiz==0){
          vm.AverageQuiz=0;
        }
        else{
          vm.filterQuiz.total = res.data.total;
          vm.AverageQuiz=vm.TotalQuiz/vm.filterQuiz.total;
        }
      

       for (var index = 5; index >= 0; index--) {
        vm.StudentScore=0;
        vm.Percentage=0;
         var StartMonth = new Date();
         //console.log(StartMonth)
             StartMonth.setMonth(StartMonth.getMonth() - index);
             vm.StudentCount=0;
              vm.myQuizList.forEach(function (element, i1) {
                   if(new Date(element.createdAt).getMonth() == new Date(StartMonth).getMonth() && new Date(element.createdAt).getFullYear() == new Date(StartMonth).getFullYear()){
                   vm.StudentScore=vm.StudentScore+element.obtainPercentage;
                   vm.StudentCount=vm.StudentCount+1;
                 }
               });
               if(vm.StudentScore>0){
                vm.Percentage=(vm.StudentScore/vm.StudentCount).toFixed(2);
               }
               else{
                vm.Percentage=0;
               }
               vm.GraphData +=vm.Percentage+'^'+month[new Date(StartMonth).getMonth()]+" "+new Date(StartMonth).getFullYear()+",";
         
         
       }
       console.log(vm.GraphData)



      }
    });
    ExamService.myExamsList(vm.filterQuestion).$promise.then(function(res){
     
      if(res && res.data && res.data.data ){
      //  console.log(res.data)
        vm.loader = false;
        vm.myExamList = res.data.data;
        vm.myExamList.forEach(function (element, i1) {
          vm.TotalExam =vm.TotalExam+element.obtainPercentage;

        });
        vm.filterQuestion.total = res.data.total;
       // console.log(vm.filterQuestion.total)
       // console.log(vm.TotalExam)
       if(vm.filterQuestion.total==0){
        vm.AverageExam=0;
       }
       else{
        vm.AverageExam=vm.TotalExam/vm.filterQuestion.total;
       }
      
       
       //  console.log(vm.AverageExam)
      }
    });
   
    vm.getModule = function (id) {
      // console.log(id)
     vm.FilterOption = FilterOption().filter;
     vm.FilterOption.limit = 200;
     vm.FilterOption.where.topic = id;
 
      
     LoadPageData.manageUnit.getAll(vm.FilterOption).$promise.then(function (resp) {
       if (resp && resp.data) {
        // console.log(resp.data.total)
         vm.TotalModule = vm.TotalModule+resp.data.total;
        // console.log(vm.TotalModule)
         //console.log( vm.chapters )
         //vm.TotalModule=vm.chapters;
       }
     });

     
    
        
   }


    vm.init();
   
    
  //console.log(vm.TotalBadge)
  
    $scope.label1 = ["Week1"];
    $scope.label2 = ["Week1"];
    // $scope.label2 = [""];
    $scope.series = ['Series A'];
    $scope.data1 = [[65]];
    $scope.data2 = [[0]];
    // $scope.data3 = [[]];
    $scope.onClick = function (points, evt) {
      console.log(points, evt);
    };
    $scope.datasetOverride = [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2' }];
    $scope.options = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-1',
            type: 'linear',
            display: true,
            position: 'left'
          }
        ]
      }
    };
  });

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ClassesCtrl', function (config, _, $window, $http, Auth, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, toastr, $state, $log) {
      var vm = this;


      vm.filterClass = FilterOption().filter;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [0] }, { bSortable: false, aTargets: [5] }])

      // console.log("ClassesCtrl");

      /**
        on get class list
      **/
      vm.getClassList = function () {
        vm.classes = [];
        // LoadPageData.unithome.studenthome(vm.filterClass).$promise.then(function (res) {
        //   console.log(res);
        // });
        LoadPageData.classes.joinedClass(vm.filterClass).$promise.then(function (res) {
          // console.log('class',res);
          if (res && res.data && res.data.data && res.data.data.length) {
            vm.classes = res.data.data;
            console.log(vm.classes)
            vm.loader = false;
            vm.filterClass.total = res.data.total;
            // getunitasd(vm.classes[0]._id, vm.classes[0].units[0]._id)
          }
        }, function (error) {
          if (error && error.status == -1) {
            toastr.error("we are offline! try later", "Oops!");
          }
        });

      }

      function getunitasd(classid, unitId) {
        debugger;
        vm.filterUnit = FilterOption().filter;
        vm.filterUnit.where.classId = classid;
        vm.filterUnit.where.unitId = unitId;
        LoadPageData.manageChapter.getChapterByClasses(vm.filterUnit).$promise.then(function (resp) {
          // console.log('units', resp);
          if (resp && resp.data && resp.data.data) {
            vm.units = resp.data.data;
            vm.loader = false;
          }
        });
      }

      vm.me = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
          }
        },
          function (error) {
          });
      }
      /**
        on init functionality
      **/
      vm.init = function () {
        if ($localStorage.course) {
          vm.course = JSON.parse($localStorage.course);
        }
        vm.getClassList();
        vm.me();

      };
      vm.init();

      /**
        on class table panination functionality
      **/
      vm.changeClassesPagination = function () {
        vm.getClassList();
      }

      /**
        on remove class disjoin class functionality
      **/
      vm.removeClass = function (classInfo) {
        // console.log(classInfo);
        if (classInfo && vm.user) {
          vm.loader = true;

          SweetAlert.swal({
            title: "Are you sure ?",
            text: "Your want to disjoin this class -->  " + classInfo.name,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, remove it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {
                LoadPageData.classes.unJoinClass({ joinCode: classInfo.joinCode, studentId: vm.user._id }).$promise.then(function (response) {
                  vm.loader = false;
                  vm.classCode = "";
                  // toastr.success(response.message+'class disJoined', "Successfully!");
                  SweetAlert.swal("Success", "Your class has been removed", "success");
                  vm.getClassList();

                }, function (error) {
                  vm.loader = false;
                  // toastr.error(error.data.message+"  :Something Went worng", "Error!");
                  SweetAlert.swal("Cancelled", error.data.message + "  ! Something Went worng", "error");
                });
              } else {
                SweetAlert.swal("Cancelled", "You have been cancelled", "error");
              }
            });

        }

      };

      /**
        on join new class with unique class functionality
      **/


      /**
       not inuse##  on open new class functionality
      **/
      vm.openNewClassModal = function () {
        $uibModal.open({
          templateUrl: "app/dashboard/classes/newclass-modal.html",
          // controller: 'ClassesCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
        }).result.then(function () {
          vm.getClassList();
        }, function () {
          vm.getClassList();
        });
      };

      vm.openModal = function () {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/joinClassModel.html',
          controller: 'JoinNewClassCtrl',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm'
        }).result.then(function () {
          vm.getClassList();
        }, function () {
          vm.getClassList();

        });


      };
      /**
             open modal for edit view functionality
           **/
      vm.viewClass = function (details) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/classViewByStudent.html',
          controller: 'classViewModalController',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return details;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };
    }).controller('JoinNewClassCtrl', function (config, _, $window, $http, Auth, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, $uibModalInstance, toastr, $state, $log) {
      var vm = this;
      vm.loader = false;
      vm.submitted = false;

      vm.me = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
          }
        },
          function (error) {
          });
      }
      vm.me();
      vm.joinClassWithCode = function (form) {

        vm.submitted = true;
        if (form.$valid && vm.classCode && vm.user._id) {
          // console.log(vm.classCode);
          vm.loader = true;
          LoadPageData.classes.joinClass({ joinCode: vm.classCode, studentId: vm.user._id }).$promise.then(function (response) {
            vm.loader = false;
            vm.submitted = false;
            vm.classCode = "";
            toastr.success(response.message + ' class Joined', "Successfully!");
            $uibModalInstance.dismiss('Close');

          }, function (error) {
            vm.loader = false;
            toastr.error(error.data.message + "  : error", "Error!");
            // console.log(error);
          });
        }

      };
      vm.cancel = function () {
        $uibModalStack.dismissAll();
      }
    })
    .controller('classViewModalController', function (config,LoadPageData, _, $uibModalStack, data, $uibModalInstance) {
      var vm = this;
      vm.loader = false;
      vm.submitted = false;
      vm.data = data;
      LoadPageData.topic.getByClassId({classid:vm.data._id }).$promise.then(function (res) {});
      LoadPageData.classes.getDetailById({controller:vm.data._id }).$promise.then(function (res) {
        vm.data =res.data;
      });

      vm.cancel = function () {
        $uibModalStack.dismissAll();
      }
    });


})();

(function () {

    'use strict';

    angular.module('kapdec')
        .controller('ChapterCtrl', function (config,$sce, _, $window, $http, Auth, SweetAlert, DTOptionsBuilder, $uibModal, $timeout, $localStorage, LoadPageData, FilterOption, $uibModalStack, toastr, $state, $log) {
            var vm = this;
            vm.params = $state.params;
            vm.loader = true;
            vm.chapter = {};
            vm.filterClass = FilterOption().filter;
            vm.init = function () {
                vm.me = Auth.getCurrentUser();
                LoadPageData.manageChapter.getById({ id: vm.params.id }).$promise.then(function (res) {
                    if (res && res.data) {
                        vm.loader = false;
                        vm.chapter = res.data;
                        // console.log(res)
                    }
                },
                    function (error) {
                        if (error && error.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });

            };

            vm.trustUrl = function(url){
                return $sce.trustAsResourceUrl(url);
              }
            vm.init();
        });

      
})();


(function () {

  'use strict';

  angular.module('kapdec')
    .controller('BadgesCtrl', function (config, _, LoadPageData, FilterOption, $sce, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;
      console.log("BadgesCtrl");
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };


      /**
        on load functionality
      **/
      vm.init = function () {
        LoadPageData.badges.getActive(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.badgeList = res.data.data;
            _.map(vm.badgeList, function (value) {
              value.count = 0;
              _.map(res.data.exams, function (exam, key) {
                if (value._id == exam.allocatedBadgeID) {

                  value.count = key + 1;
                }
              });
            });
            console.log(vm.badgeList);
            vm.badges = _.map(res.data.data, _.partialRight(_.pick, ['name']));
            vm[vm.badges[0].name] = true;  //open first
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();

      /**
        on badge select view functionality
      **/
      vm.openBadge = function (ev, badge) {
        if (vm.badges && vm.badges.length) {
          vm.badges.forEach(function (val) { vm[val.name] = false; })
          vm[badge] = true;
        }
      }

      /**
        on badge pagination functionality
      **/
      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredBadges = function () {
        vm.init();
      }



    });


})();

(function() {

'use strict';

angular.module('kapdec')
    .controller('AdminProfilesCtrl', function (config, $state, User, Auth, $log) {
        var vm = this;
        console.log("adminProfilesCtrl");

        vm.params = $state.params;

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        vm.me = function(){
          User.get().$promise.then(function (res) {
          // Auth.getCurrentUser().$promise.then(function(res){
            if(res && res.data ){

              if( res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin' ) ){
                vm.me = res.data;
              }else{
                // vm.logout();
              }
            }
          },
          function(error){
          });
        }

        vm.init = function(){
          vm.me();
          if(vm.params && vm.params.id){
            User.getByUid({id: vm.params.id }).$promise.then(function(res){
              if(res && res.data && res.data.userDetails){
                  vm.user = res.data.userDetails;
                  vm.userDOB = moment(vm.user.dob).add(-1,'days').format('DD/MM/YYYY')
                 // vm.user.dob = moment(res.data.dob).add(-1,'days').format('DD/MM/YYYY');
                  if (vm.user.role == 'subAdmin') {
                      $("#adminSubmenu").addClass('active')
                  }
                  else {
                      $("#adminmenu").addClass('active')
                  }
              }
            },
            function(error){
                if(error && error.status == -1 ){
                  toastr.error("we are offline! try later", "Oops!");
                }else{
                  $state.go('admin.dashboardpanel');
                  toastr.error("fake url visited! try later", "Oops!");
                }
            });
          }else{
            $state.go('admin.dashboardpanel');
            toastr.error("fake url visited! try later", "Oops!");
          }


        };
       
        vm.init();

});

})();



(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageVideoCtrl', function (config, _,  Auth, VideoService, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageVideoCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [7] },{class: 'manage-story-first', targets: 1},{class: 'manage-story-third', targets: 3},{class: 'manage-story-four', targets: 4},{class: 'manage-story-five', targets: 5},{class: 'manage-story-six', targets: 6}])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        /**
          on load functionality
        **/
        vm.init = function(){
          VideoService.get(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.storyList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredStory = function(){
          vm.init();
        }

        /**
          verify story functionality
        **/
       
        vm.verifyStory = function(storyId){
          vm.isBusy = true;

          VideoService.verify({controller: storyId }).$promise.then(function(res){
            console.log("storyverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Video verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };
        vm.unverifyStory = function(storyId){
          vm.isBusy = true;

          VideoService.Unverify({controller: storyId }).$promise.then(function(res){
            console.log("storyverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Video Unverified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };
        /**
          update story functionality
        **/
        vm.updateStory = function(form){
          vm.submitted = true;
         if (form.$valid) {
          vm.isBusy = true;

          VideoService.update({id: vm.story._id },vm.story).$promise.then(function(res){
            console.log("story",res);
            if(res){
                vm.isBusy = false;
                vm.updatedModal();
                toastr.success(res.message+' video updated', "Successfully!");
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               vm.errors.other = error.data.message;
               $timeout(function(){ vm.errors ={}; },3500);
           });

         }
       };

        /**
          delete confirmation sweetalert
        **/
        vm.deleteStory = function(sid) {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "You want to delete this Video!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = true;
                VideoService.delete({id: sid} ).$promise.then(function(res) {
                  SweetAlert.swal("Success", "Video has been deleted", "success");
                  vm.init();
                  vm.isBusy = false;
                },function() {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }


        /**
          open modal for edit view functionality
        **/
        vm.openModal = function(details, isEditable, size, parentSelector) {

          vm.details = { 'details': details };
          vm.modalValue = isEditable;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/VideoActionModal.html',
            controller: 'VideoModalController',
            controllerAs: 'vm',
            size: size,
            appendTo: parentElem,
            resolve: {
              data: function() {
                return vm.details;
              },
              model: function() {
                return vm.modalValue;
              }
            }
          }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };

        vm.AddModal = function(details, isEditable) {

          vm.details = { 'details': details };
          vm.modalValue = isEditable;
        //  var parentElem = parentSelector ?
         //   angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
         $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/AddVideoActionModal.html',
          controller: 'VideoModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };




})
.controller('VideoModalController', function(config, _, appPattern, model, data,  $sce, Auth, VideoService, LoadPageData,   $uibModalInstance, $localStorage, FilterOption, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
    var vm = this;
    vm.updated = false;
    vm.loader  =  true;
    vm.pattern = appPattern;
    vm.isBusy = false;
    vm.submitted = false;
    vm.errors = {};
    vm.story   = {};

    $timeout(function() {
      vm.isEditable = model || false;
    }, 100);

    vm.trustUrl = function(url){
      return $sce.trustAsResourceUrl(url);
    }

    /**
      open modal closed functionality
    **/
    vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
    };
    vm.updatedModal =function(){
      vm.updated = true;
      $uibModalInstance.close(vm.updated);
    }

   // ##################  view update form binding ###############

     if(data && data.details){
       vm.loader = false;
       vm.story = data.details;
     }

    /**
      update story functionality
    **/
    vm.updateStory = function(form){
      vm.submitted = true;
     if (form.$valid) {
      vm.isBusy = true;
       if(!vm.story._id){
        VideoService.create(vm.story ).$promise.then(function(res){
          console.log("story",res);
          if(res){
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success('Create video updated', "Successfully!");
           }
         });


       }
       else{
        VideoService.update({id: vm.story._id },vm.story ).$promise.then(function(res){
          console.log("story",res);
          if(res){
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success('Update video updated', "Successfully!");
           }
         });
       }
       response.$promise.then(function (resp) {
        // console.log("block user",res);
        if (resp) {
          if (resp && resp.message) {
            //toastr.success("Story Created Successfully!");
          };
          // Account created, redirect to the page with requested a signup
          vm.updatedModal();
          vm.isBusy = false;
        }
      }, function(error){
           vm.isBusy = false;
           vm.errors.other = error.data.message;
           $timeout(function(){ vm.errors ={}; },3500);
       });

     }
   };


});


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageUserCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log,$scope) {

      var vm = this;

      vm.viewBy =[30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;
      

      vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('Blfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('stateSave', true)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [1] },{class: 'manage-user-third', targets: 3},{ bSortable: false, aTargets: [7] }])
          .withOption('buttons', [{
              extend: 'csvHtml5',
              action: function (e, dt, button, config) {
                  config.filename = new Date().valueOf().toString();
                  $.fn.dataTable.ext.buttons.csvHtml5.action(e, dt, button, config);
              },
              exportOptions: {
                  columns: [2, 3, 4, 5, 6]
              }
          },{
                  extend: 'excelHtml5',
                  action: function (e, dt, button, config) {
                      config.filename = new Date().valueOf().toString();
                      $.fn.dataTable.ext.buttons.excelHtml5.action(e, dt, button, config);
                  },
                  exportOptions: {
                      columns: [2, 3, 4, 5, 6]
                  }
              }, {
                  
                  extend: 'pdfHtml5',
                  action: function (e, dt, button, config) {
                      config.filename = new Date().valueOf().toString();
                      $.fn.dataTable.ext.buttons.pdfHtml5.action(e, dt, button, config);
                  },
                  exportOptions: {
                      columns: [2, 3, 4, 5, 6]
                  }, customize: function (doc) {
                      var cols = [];
                      cols[0] = { text: 'Kapdec', alignment: 'right', margin: [0, 0, 25], color: '#0275d8' };
                      var objFooter = {};
                      objFooter['alignment'] = 'center';
                      objFooter['columns'] = cols;
                      doc["footer"] = objFooter;
                      //doc.content.splice(1, 0, {
                      //    margin: [0, 0, 0, 12],
                      //    alignment: 'center',
                      //    image: 'data:image/jpeg;base64,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'
                      //});
                  
              }
              }])
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };
      
      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              vm[res.data.role] = true;
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
       
        vm.me = Auth.getCurrentUser();
        vm.checked();
        User.getAllUser(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.getRoles();
            vm.usersList = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(vm.usersList)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();

      
      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredUsers = function () {
        vm.init();
      }
     
      /**
        blockUser functionality
      **/
      vm.blockUser = function (id, isBlock, user) {
        vm.isBusy = true;

        User.blockUser({ controller: id }, { isBlock: isBlock }).$promise.then(function (res) {
          // console.log("block user",res);
          if (res) {
            vm.isBusy = false;
            vm.texty = isBlock ? "Blocked" : "Unblocked";
            toastr.success(res.message + ': ' + user + ' ' + vm.texty, "Successfully!");
            vm.init();
          }
        }, function (error) {
          console.log(error)
          vm.isBusy = false;
          toastr.error(error.data.message + 'something went wrong', "Error!");
        });
      };
      /**
             Approve User functionality
           **/
      vm.approveUser = function (id, isApprovedByAdmin, user) {
        vm.isBusy = true;

        User.approveUser({ controller: id }, { isApprovedByAdmin: isApprovedByAdmin }).$promise.then(function (res) {
          // console.log("block user",res);
          if (res) {
            vm.isBusy = false;
            vm.texty = isApprovedByAdmin ? "Approved" : "Unapproved";
            toastr.success(res.message + ': ' + user + ' ' + vm.texty, "Successfully!");
            vm.init();
          }
        }, function (error) {
          console.log(error)
          vm.isBusy = false;
          toastr.error(error.data.message + 'something went wrong', "Error!");
        });
      };
      /**
        delete confirmation sweetalert
      **/
      vm.deleteUser = function (id) {
        SweetAlert.swal({
          title: "Are you sure ?",
          text: "You want to delete this User!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              User.deleteUser({ id: id }).$promise.then(function () {
                vm.init();
                SweetAlert.swal("Success", "User has been deleted", "success");
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }
       /**
        open modal for edit view functionality
      **/
     vm.openModal = function (details, isEditable) {

      vm.details = { 'details': details };
      vm.modalValue = isEditable;
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modal/createAdminModal.html',
        controller: 'UserCtrl',
        backdrop: 'static',
        keyboard: false,
        controllerAs: 'vm',
        resolve: {
          data: function () {
            return vm.details;
          },
          model: function () {
            return vm.modalValue;
          }
        }
      }).result.then(function (updated) {
        if (updated) {
          vm.init();
        }
      }, function () {

      });


    };

    vm.openEditModal = function (details, isEditable) {

      vm.details = { 'details': details };
      vm.modalValue = isEditable;

      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modal/editAdminModal.html',
        controller: 'UserCtrl',
        backdrop: 'static',
        keyboard: false,
        controllerAs: 'vm',
        resolve: {
          data: function () {
            console.log(vm.details,"vm.details")
            return vm.details;
          },
          model: function () {
            return vm.modalValue;
          }
        }
      }).result.then(function (updated) {
        if (updated) {
          vm.init();
        }
      }, function () {

      });


    };

    })

    .controller('UserCtrl', function (countrys,config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log,$scope) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;

      vm.country = '';//Utility.getGeo();
      vm.user = {};
      vm.user.role = 'teacher'
      vm.maxDate = moment().add(-1, 'years').format("YYYY-MM-DD");
      $scope.countries = countrys.countries
    LoadPageData.grade.getGrade(FilterOption().filter).$promise.then(function (res) {
        if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
        }
    });
    vm.changerole = function (role) {
      vm.user = {};
      vm.user.role = role;
      vm.bellowAge = false;
      vm.maxDate = moment().add(-2, 'years').format("YYYY-MM-DD");
      vm.submitted = false;
      if (role === 'teacher') {
          vm.user.dob = "";
          vm.maxDate = moment().add(-18, 'years').format("YYYY-MM-DD");
      }
  }

  vm.changeGrades = function () {
      if (vm.user.grades.length > 2) {
          toastr.info("You can select only 2 grades. ", "Information");
          var rr = vm.user.grades.splice(1, 1);
      }
  }
  vm.changecountry = function () {
       var func = JSON.parse(vm.user.countryName)
       vm.user.dialCode = func.dialCode;
       vm.user.emoji = func.emoji;
       console.log(JSON.parse(vm.user.countryName),"vm.user.countryName")
  }
  vm.checkStudentAge = function (date) {
      if (vm.user.role === 'student') {
          vm.bellowAge = false;
          var currentYear = moment().add(-13, 'years');
          var selectedYear = moment(date);
          var diffrentdate = currentYear.diff(selectedYear, 'days')
          if (diffrentdate < 0) {
              vm.bellowAge = true;
          } else {
              vm.bellowAge = false;
          }
      }
  }
        if (data.details) {
            if(data.details._id !=""){
              User.getuserFind({ _id: data.details._id }).$promise.then(function(res){
                if(data.details.role !="parent"){
                     vm.user.grades=res.data[0].grades;
                }
                console.log(res,"resedd")
                vm.user.emoji = res.data[0].emoji;
                vm.user.dialCode = res.data[0].dialCode;
                vm.user.countryName=JSON.stringify(res.data[0].countryName)
                vm.user.phoneNumber=res.data[0].phoneNumber;
                vm.user.degreeName =res.data[0].degreeName;
                vm.user.collegeName =res.data[0].collegeName;
                vm.user.specialization =res.data[0].specialization;
              });
            }
            vm.user = data.details;
            vm.user.fullname = data.details.name;
            vm.user.confirmPassword = data.details.password;
            //var dateTime = new Date(data.details.dob);
            //dateTime = moment(dateTime).format("YYYY-MM-DD")
            vm.user.dob = moment(data.details.dob);
      }
      vm.errors = {};

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.register = function (form) {
        vm.submitted = true;
        // vm.user.role = vm.teacherlogin ? 'teacher' : vm.studentlogin ? 'student' : 'parent';
        var response = {};
        if (form.$valid) {
          if (!vm.user._id){
            var userDetails = {
                name: vm.user.fullname,
                email: vm.user.email,
                password: vm.user.password,
                role: vm.user.role,
                dob: vm.user.dob,
                dialCode : vm.user.dialCode,
                emoji : vm.user.emoji,
                countryName : JSON.parse(vm.user.countryName),
                phoneNumber: vm.user.phoneNumber,
                facebook: {},
                google: {},
                curriculum: vm.country ? vm.country.country_code : '',
                terms: vm.user.terms
            };
                userDetails.grades = vm.user.grades;
                 userDetails.isApprovedByAdmin=true;
                  userDetails.emailVerified=true;
            if (vm.user.role == 'teacher') {
                userDetails.degreeName = vm.user.degreeName;
                userDetails.collegeName = vm.user.collegeName;
                userDetails.specialization = vm.user.specialization;
            }

            if (vm.user.role == 'student' && vm.bellowAge) {
                userDetails.parentEmail = vm.user.parentEmail;
            }

            if (vm.params && vm.params.invite) {
                var pid = window.atob(vm.params.invite);
                if (pid && pid.parent) {
                    userDetails = Object.assign(userDetails, { parent: pid.parent });
                }
            };
            console.log(userDetails)
            Auth.createUser(userDetails)
                .then(function (resp) {
                    if (resp && resp.message) {
                        toastr.success("Registered ! please verify your email ", "Successfully!");

                    };
                    // Account created, redirect to the page with requested a signup
                    if (vm.user.role) {
                        $uibModalInstance.dismiss('cancel');
                        // $state.go('dashboard.profile');
                    } else {
                        $uibModalInstance.dismiss('cancel');
                        // Auth.redirectToAttemptedUrl();
                    }
                })
                .catch(function (err) {
                    err = err.data;
                    vm.errors = {};
                    if (err && err.error) {
                        angular.forEach(err.error.errors, function (error, field) {
                            form[field].$setValidity('mongoose', false);
                            vm.errors[field] = error.message;
                            // console.log(vm.errors[field])
                        });
                        // $timeout(function() { vm.errors = {}; }, 6000);
                    } else {
                        vm.errors = err.message || 'something went wrong';
                        toastr.error(err.message, "Oops!");
                    }
                    if (err && err.status == -1) {
                        toastr.error("we are offline! try later", "Oops!");
                    }
                });
              }
              else{
                
                User.getuserFind({ _id: vm.user._id }).$promise.then(function(res){
                  console.log(data.details.role)
                  if(data.details.role =="student"){
                  response = User.updateDetails({ id: vm.user._id }, {
                    _id: vm.user._id,
                    name: vm.user.fullname,
                    dialCode : vm.user.dialCode,
                    emoji : vm.user.emoji,
                    countryName : JSON.parse(vm.user.countryName),
                   // grade: vm.course.grade,
                    phoneNumber: vm.user.phoneNumber,
                    //country:vm.course.country,
                    grades : vm.user.grades,
                    role:data.details.role

                  })
                }
                else  if(data.details.role =="teacher"){
                  response = User.updateDetails({ id: vm.user._id }, {
                    _id: vm.user._id,
                    name: vm.user.fullname,
                   // grade: vm.course.grade,
                    phoneNumber: vm.user.phoneNumber,
                    dialCode : vm.user.dialCode,
                    emoji : vm.user.emoji,
                    countryName : JSON.parse(vm.user.countryName),
                    //country:vm.course.country,
                    grades : vm.user.grades,
                    degreeName:vm.user.degreeName,
                    specialization:vm.user.specialization,
                    role:data.details.role
                  })
                }
                else{
                  response = User.updateDetails({ id: vm.user._id }, {
                    _id: vm.user._id,
                    name: vm.user.fullname,
                    //grade: vm.course.grade,
                    phoneNumber: vm.user.phoneNumber,
                    dialCode : vm.user.dialCode,
                    emoji : vm.user.emoji,
                    countryName : JSON.parse(vm.user.countryName),
                    role:data.details.role
                    //country:vm.course.country,
                   // grades : vm.user.grades,

                  })
                }
                response.$promise.then(function (resp) {
                  if (resp) {
                    if (resp && resp.message) {
                      toastr.success("User Updated Successfully!");
                    };
                    // Account created, redirect to the page with requested a signup
                    vm.updatedModal();
                    vm.isBusy = false;
                  }
                }, function (err) {
                  err = err.data;
                  vm.errors = {};
                  vm.isBusy = false;
                  if (err && err.error) {
                    angular.forEach(err.error.errors, function (error, field) {
                      form[field].$setValidity('mongoose', false);
                      vm.errors[field] = error.message;
                    });
                  } else {
                    vm.errors = err.message || "something wrong fields !"
                  }
                  if (err && err.status == -1) {
                    toastr.error("we are offline! try later", "Oops!");
                  }
                });
                 
                 
                });
              }
        }
    };


  





    });




})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageUnitCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [7] }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };

      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              vm[res.data.role] = true;
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        vm.checked();
       // console.log(vm.filterOptions)

        LoadPageData.manageUnit.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.units = res.data.data;
            //console.log('rudresh')
           // console.log(vm.units)
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredunits = function () {
        vm.init();
      }


      /**
        delete confirmation sweetalert
      **/
      vm.deleteUnit = function (id) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this Module!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              LoadPageData.manageUnit.delete({ id: id }).$promise.then(function () {
                SweetAlert.swal("Success", "Module has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable) {
            
         



        vm.details = { 'details': details };
        vm.modalValue = isEditable;
     //console.log(vm.details)
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageUnitModal.html',
          controller: 'UnitModalController',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };


    })
    .controller('UnitModalController', function (config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $scope, Upload) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;
      vm.topics = [];
      //vm.grade = '';
      vm.courses = [];
      vm.grades = [];
      vm.country = '';//Utility.getGeo();
      vm.unit = {
        isPaid: false
      };
      //vm.filterTopic = {};
      vm.errors = {};
      if (data && model) {
        vm.unit = data.details;
      }
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      vm.getCurriculum = function () {
        LoadPageData.curriculum.get().$promise.then(function (resp) {
          // console.log('curriculum', resp);
          if (resp && resp.data) {
            vm.curriculum = resp.data;
            if (data.details.country) {
                vm.unit.country = data.details.country + "";
                vm.getGradeByCountry(vm.unit.country);
                vm.unit.grade = data.details.grade._id + "";
                
            }
           if (data.details.grade) {
              vm.unit.course = data.details.course._id+ "";
            }
            if (data.details.course) {
              vm.unit.topic = data.details.topic._id+ "";
            }
          }
        });
      };
      vm.getCurriculum();

      vm.getGradeByCountry = function (countryId) {
        vm.courses =[];
        vm.grades =[];
        vm.topics=[];
        var filter = FilterOption().filter;
        filter.where["country"] = countryId;
        LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
            vm.initLoad();

            if (data.details.grade) {
              vm.getCourse(vm.unit.grade);
            }
           
          }
        });
      }
      vm.getGradeByCountry1 = function (countryId) {
        vm.unit.grade="";
        vm.unit.topic="";
        vm.unit.course="";
        vm.courses =[];
        vm.grades =[];
        vm.topics=[];
        var filter = FilterOption().filter;
        filter.where["country"] = countryId;
        LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
            vm.initLoad();

            if (data.details.grade) {
              vm.getCourse(vm.unit.grade);
            }
           
          }
        });
      }
      vm.getCourse = function (gradeId) {
        //vm.topic.course ="19";
        vm.courses =[];
        vm.topics =[];
        var filter = FilterOption().filter;
        filter.where["grade"] = gradeId;
        LoadPageData.course.getAll(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.courses = res.data.data;
            vm.initLoad();

            if (data.details.course) {
              vm.getTopics(vm.unit.course);
            }
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      }
      vm.getCourse1 = function (gradeId) {
        //vm.topic.course ="19";
        vm.unit.course="";
        vm.unit.topic="";
        vm.courses =[];
        vm.topics =[];
        var filter = FilterOption().filter;
        filter.where["grade"] = gradeId;
        LoadPageData.course.getAll(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.courses = res.data.data;
            vm.initLoad();

            if (data.details.course) {
              vm.getTopics(vm.unit.course);
            }
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      }
      vm.getTopics = function (courseId) {
        vm.topics =[];
        var filter = FilterOption().filter;
        filter.where["course"] = courseId;
          LoadPageData.topic.getTopic(filter).$promise.then(function (res) {
            if (res && res.data && res.data.data && res.data.data.length) {
              vm.topics = res.data.data;
            }
          });
        
      }
      vm.getTopics1 = function (courseId) {
        vm.unit.topic="";
        vm.topics =[];
        var filter = FilterOption().filter;
        filter.where["course"] = courseId;
          LoadPageData.topic.getTopic(filter).$promise.then(function (res) {
            if (res && res.data && res.data.data && res.data.data.length) {
              vm.topics = res.data.data;
            }
          });
        
      }
      vm.initLoad = function () {
        var handleFileSelect = function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.fileUrl = evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
      }

     

     
     
      vm.cancel = function () {
          //$uibModalInstance.dismiss('Close');
          vm.updated = true;
          $uibModalInstance.close(vm.updated);
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.saveUnit = function (form) {
        vm.submitted = true;

        if (form.$valid) {
          vm.isBusy = true;
          var response = {};

          if (!vm.unit._id) {
           // if ($scope.fileUrl) {
             // response = Upload.upload({
               // url: config.baseUrl + '/api/unit/create/',
               // data: { data: vm.unit, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
              //  disableProgress: true
             // });
           // } else {
             // console.log(vm.topic)
            
              var filterData={"name":vm.unit.name,"country":parseInt(vm.unit.country),"grade":parseInt(vm.unit.grade),"course":parseInt(vm.unit.course),"topic":parseInt(vm.unit.topic)};
              LoadPageData.CheckUnit.getCheckUnit(filterData).$promise.then(function (res) {
                if (parseInt(res.data.total)>=1) {
                  toastr.error("Module already exist", "Error");
  
                }
                else{
                  if ($scope.fileUrl) {
                    response = Upload.upload({
                      url: config.baseUrl + '/api/unit/create/',
                      data: { data: vm.unit, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
                      disableProgress: true
                    });
                  }
                  else{
                    response = LoadPageData.manageUnit.create(vm.unit).$promise;
                  }
                 
                  //response = LoadPageData.manageTopic.create(vm.topic).$promise;
                }
                response.then(function (resp) {
                  // console.log("block user",res);
                  if (resp) {
                    if (resp && resp.message) {
                      toastr.success("Module Created Successfully!");
                      //toastr.success("Registered !" + resp.message, "Successfully!");
                    };
                    // Account created, redirect to the page with requested a signup
                    vm.updatedModal();
                    vm.isBusy = false;
                  }
                }, function (err) {
                  err = err.data;
                  vm.errors = {};
                  vm.isBusy = false;
                  if (err && err.error) {
                    angular.forEach(err.error.errors, function (error, field) {
                      form[field].$setValidity('mongoose', false);
                      vm.errors[field] = error.message;
                    });
                  } else {
                    vm.errors = err.message || "something wrong fields !"
                  }
                  if (err && err.status == -1) {
                    toastr.error("we are offline! try later", "Oops!");
                  }
                });
              });
             // 
           // }
          } else {
            //if ($scope.fileUrl) {
             // response = Upload.upload({
               // url: config.baseUrl + '/api/unit/update/' + vm.unit._id,
                //data: { data: vm.unit, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
                //disableProgress: true
              //});
            //} else {
              
              var filterData={"name":vm.unit.name,"country":parseInt(vm.unit.country),"grade":parseInt(vm.unit.grade),"course":parseInt(vm.unit.course),"topic":parseInt(vm.unit.topic)};
              //var filterData={"name":vm.topic.name,"country":parseInt(vm.topic.country),"grade":parseInt(vm.topic.grade),"course":parseInt(vm.topic.course)};
              LoadPageData.CheckUnit.getCheckUnit(filterData).$promise.then(function (res) {
                if (parseInt(res.data.total)>=1) {
                  var filter = FilterOption().filter;
                  filter.where["_id"] = vm.unit._id;
                LoadPageData.unit.getUnit(filter).$promise.then(function (res1) {
                  if (res1 && res1.data && res1.data.data) {
                    var AllData=res1.data.data[0];
                  //  console.log(AllData)
                    var UnitName=AllData.name;

                    var TopicCountryId=AllData.country;
                    var GradeId=AllData.grade;
                    var CourseId=AllData.course;
                    var TopicId=AllData.topic;
                   // console.log(TopicName+","+TopicCountryId+","+GradeId+","+CourseId)
                   // console.log(vm.topic)
                    if(UnitName==vm.unit.name && TopicCountryId==vm.unit.country && GradeId==vm.unit.grade && CourseId==vm.unit.course && TopicId==vm.unit.topic){
                     // response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                     if ($scope.fileUrl) {
                      response = Upload.upload({
                        url: config.baseUrl + '/api/unit/update/' + vm.unit._id,
                        data: { data: vm.unit, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
                        disableProgress: true
                      });
                    }
                    else{
                      response = LoadPageData.manageUnit.update({ controller: vm.unit._id }, vm.unit).$promise
                    }
                   
                      response.then(function (resp) {
                        // console.log("block user",res);
                        if (resp) {
                          if (resp && resp.message) {
                            toastr.success("Module Updated Successfully!");
                            //toastr.success("Registered !" + resp.message, "Successfully!");
                          };
                          // Account created, redirect to the page with requested a signup
                          vm.updatedModal();
                          vm.isBusy = false;
                        }
                      }, function (err) {
                        err = err.data;
                        vm.errors = {};
                        vm.isBusy = false;
                        if (err && err.error) {
                          angular.forEach(err.error.errors, function (error, field) {
                            form[field].$setValidity('mongoose', false);
                            vm.errors[field] = error.message;
                          });
                        } else {
                          vm.errors = err.message || "something wrong fields !"
                        }
                        if (err && err.status == -1) {
                          toastr.error("we are offline! try later", "Oops!");
                        }
                      });
                    }
                    else{
                     // console.log('hi')
                      toastr.error("Module already exist", "Error");
                    }
                    
                  }
                });

                  //
  
                }
                else{
                  response = LoadPageData.manageUnit.update({ controller: vm.unit._id }, vm.unit).$promise
                  //response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                }
                response.then(function (resp) {
                  // console.log("block user",res);
                  if (resp) {
                    if (resp && resp.message) {
                      toastr.success("Module Updated Successfully!");
                     // toastr.success("Registered !" + resp.message, "Successfully!");
                    };
                    // Account created, redirect to the page with requested a signup
                    vm.updatedModal();
                    vm.isBusy = false;
                  }
                }, function (err) {
                  err = err.data;
                  vm.errors = {};
                  vm.isBusy = false;
                  if (err && err.error) {
                    angular.forEach(err.error.errors, function (error, field) {
                      form[field].$setValidity('mongoose', false);
                      vm.errors[field] = error.message;
                    });
                  } else {
                    vm.errors = err.message || "something wrong fields !"
                  }
                  if (err && err.status == -1) {
                    toastr.error("we are offline! try later", "Oops!");
                  }
                });
              });



              //response = LoadPageData.manageUnit.update({ controller: vm.unit._id }, vm.unit).$promise
            //}
          }


          // if (!vm.unit._id) {
          //   response = LoadPageData.manageUnit.create(vm.unit);
          // } else {
          //   response = LoadPageData.manageUnit.update({ id: vm.unit._id }, vm.unit)
          // }

          response.then(function (resp) {
            // console.log("block user",res);
            if (resp) {
              if (resp && resp.message) {
                toastr.success("Registered !" + resp.message, "Successfully!");
              };
              // Account created, redirect to the page with requested a signup
              vm.updatedModal();
              vm.isBusy = false;
            }
          }, function (err) {
            err = err.data;
            vm.errors = {};
            vm.isBusy = false;
            if (err && err.error) {
              angular.forEach(err.error.errors, function (error, field) {
                form[field].$setValidity('mongoose', false);
                vm.errors[field] = error.message;
              });
            } else {
              vm.errors = err.message || "something wrong fields !"
            }
            if (err && err.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

        }
      };

    });


})();


(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageTransactionCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageTransactionCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [10] }])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          LoadPageData.transaction.getAll(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.transactionList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredTrans = function(){
          vm.init();
        }

        /**
          verify Transaction functionality
        **/
        vm.approveTransaction = function(tsId){
          vm.isBusy = true;

          LoadPageData.transaction.allowFree({ id: tsId }).$promise.then(function(res){
            console.log("Transactionverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Transaction verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };
        vm.RefundTransaction = function(tsId){
          SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to transfer this Amount!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
          function(isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              var filter = FilterOption().filter;
               filter.where["_id"] = tsId;
               LoadPageData.transaction.getAll(filter).$promise.then(function(res){
               if(res && res.data && res.data.data){
              vm.loader = false;
              vm.charge = res.data.data[0].charge_Id;
              vm.EmployeeId=res.data.data[0].uid._id;
              vm.refundConfirm(tsId,vm.charge,vm.EmployeeId)
             
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });



          
        };
        vm.refundConfirm=function(id,chargeid,EmployeeId){

          LoadPageData.transaction.refundPay({ id: chargeid }).$promise.then(function(res){
         //   console.log("refundtransaction",res);
            if(res){
                vm.isBusy = false;
                User.approvePaid({ controller: EmployeeId }, { isPaid: false }).$promise.then(function (res) {
                  if (res) {
                    //vm.isBusy = false;
                    LoadPageData.transaction.RefundTractionAdd({ controller: id }, { isPaid: true }).$promise.then(function (res1) {
                     console.log(res1)
                      if (res1) {
                        vm.isBusy = false;
                      }
                    }, function (error) {
                      vm.isBusy = false;
                    });
                  }
                }, function (error) {
                  vm.isBusy = false;
                });
                //console.log("TransId="+id)
                
                toastr.success(res.message+' Transaction refund', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        }
        /**
          delete confirmation sweetalert
        **/
        vm.deleteTransaction = function(id) {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "You want to delete this Transaction!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = false;
                LoadPageData.transaction.remove({id: id}).$promise.then(function() {
                  vm.init();
                  SweetAlert.swal("Success", "Transaction has been deleted", "success");
                },function(err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }





});

})();



(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageTeamCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageUserCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [8] },{
            class: 'manage-team-fifth', targets: 5
        },{class: 'manage-team-second', targets: 2},{class: 'manage-team-six', targets: 6},{class: 'manage-team-seven', targets: 7},{class: 'manage-team-action', targets: 8}])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          LoadPageData.team.getAll(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.teamList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredTeams = function(){
          vm.init();
        }


        /**
          verify teams functionality
        **/
        vm.verifyTeams = function(teamId){
          vm.isBusy = true;

          LoadPageData.team.verify({controller: teamId }).$promise.then(function(res){
            console.log("teamverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Team verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };

        /**
          delete confirmation sweetalert
        **/
        vm.deleteTeams = function(id) {
            vm.isBusy = true;
          SweetAlert.swal({
              title: "Are you sure?",
              text: "You want to delete this Member!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = false;
                LoadPageData.team.remove({id: id}).$promise.then(function() {
                  vm.init();
                  SweetAlert.swal("Success", "Team has been deleted", "success");
                },function(err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }



        /**
          open modal for edit view functionality
        **/
        vm.openModal = function(details, isEditable, size, parentSelector) {

          vm.details = { 'details': details  };
          vm.modalValue = isEditable;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/manageTeamActionModal.html',
            controller: 'TeamModalController',
            controllerAs: 'vm',
            size: size,
            appendTo: parentElem,
            resolve: {
              data: function() {
                return vm.details;
              },
              model: function() {
                return vm.modalValue;
              }
            }
          }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };


  })
  .controller('TeamModalController', function(config, _, Upload, model, data, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, $scope, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
        var vm = this;
        vm.updated = false;
        vm.loader  =  true;
        vm.isBusy = false;
        vm.pattern = appPattern;
        vm.submitted = false;
        vm.errors = {};
        vm.team   = {};

        $timeout(function() {
          vm.isEditable = model || false;
        }, 100);

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        /**
          open modal closed functionality
        **/
        vm.cancel = function () {
            $uibModalInstance.dismiss('Close');
        };
        vm.updatedModal =function(){
          vm.updated = true;
          $uibModalInstance.close(vm.updated);
        }

    // ##################  view update form binding ###############

     if(data){
       vm.team    = data.details;
       vm.loader  =  false;
       console.log(data);

       if(data.details && !(model == 'new') ){
         var badgeData = data.details;

         $timeout(function() {
           // vm.ques = quesData;
           // vm.ques._id = quesData._id;
           // vm.ques.unit = quesData.unit._id;
           // vm.ques.chapter = quesData.chapter._id;
         }, 2000);

       }
     }


// ************** image croping uploading ******************

      vm.cancelUpload = function(form){
          $("#fileInput").val("");
          $scope.myImage= "";
          vm.myCroppedImage="";
      };
      vm.cancelUpload();

     vm.initLoad = function(){

      var handleFileSelect=function(evt) {
         var file=evt.currentTarget.files[0];
         var reader = new FileReader();
         reader.onload = function (evt) {
           $scope.$apply(function($scope){
             $scope.myImage=evt.target.result;
           });
         };
         reader.readAsDataURL(file);
       };
       angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect );
    }

       /**
         update team functionality
       **/
       vm.updateTeams = function(form, fileUrl, name){

           vm.submitted = true;
          // console.log(form)
           if(fileUrl && vm.team._id){

              Upload.upload({
                    url: config.baseUrl+'/api/team/update/'+vm.team._id,
                    data: { data: vm.team, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success("Team has Updated! "+response.data.message, "Successful");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                 }
               // console.log("err",err);
             })

          }else{
           // console.log('hiiii')
             if (form.$valid) {
              vm.isBusy = true;

              LoadPageData.team.update({ controller : vm.team._id },vm.team).$promise.then(function(res){
                // console.log("team",res);
                if(res){
                    vm.isBusy = false;
                    vm.updatedModal();
                    toastr.success(res.message+' team updated', "Successfully!");
                 }
               }, function(error){
                   console.log(error)
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
               });

             }
             else{
              toastr.error("something went wrong ! try later"+error.data.message, "Oops!");
              vm.isBusy = false;
             }
         }

       };

       /**
         add new team functionality
       **/
       vm.addTeams = function(form, fileUrl, name){
         //console.log(fileUrl)
           vm.submitted = true;

           if( form.$valid ){
             if( fileUrl ){

              Upload.upload({
                    url: config.baseUrl+'/api/team/create',
                    data: { data: vm.team, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success(response.message+' Team added', "Successfully!");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
                 }
                console.log("err",err);
             })

           }else{
             toastr.error(' Image file required', "Error!");
           }

          }

       };





});


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageTopicCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [6] },{
            class: 'manage-topic-second', targets: 4
        }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };

      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              vm[res.data.role] = true;
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        vm.checked();
        LoadPageData.manageTopic.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.topics = res.data.data;
            //console.log(vm.topics)
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredtopics = function () {
        vm.init();
      }


      /**
        delete confirmation sweetalert
      **/
      vm.deleteTopic = function (id) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this Topic!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              LoadPageData.manageTopic.deleteSubject({ id: id }).$promise.then(function () {
                SweetAlert.swal("Success", "Topic has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable) {
        
        vm.details = { 'details': details };
        vm.modalValue = isEditable;
        
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageTopicModal.html',
          controller: 'TopicModalController',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };


    })
    .controller('TopicModalController', function (config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, Upload, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log, $scope) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;

      vm.country = '';//Utility.getGeo();
      vm.courses = [];
     
      vm.topic = {
        isPaid: false
      };
      vm.errors = {};
      if (data && model) {
        vm.topic = data.details;
        
      }
     //console.log(vm.topic)

     

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.getCurriculum = function () {
        LoadPageData.curriculum.get().$promise.then(function (resp) {
          // console.log('curriculum', resp);
          if (resp && resp.data) {
            vm.curriculum = resp.data;
           // console.log(vm.topic)
            if (data.details.country) {
             
             vm.topic.country = data.details.country+ "";
             //vm.topic.country = data.details.country._id + "";
             vm.getGradeByCountry(vm.topic.country);
            }
           if (data.details.grade) {
              vm.topic.course = data.details.course._id+ "";
              vm.getCourse(vm.topic.course);
            }
           
          }
        });
      };
      vm.getCurriculum();

      vm.getGradeByCountry = function (countryId) {
        
        //vm.topic.country =countryId;
      //  console.log('CuntryId '+countryId)
        //vm.topic.grade = "";
       //vm.topic.course ="";
        vm.courses =[];
        vm.grades =[];
        var filter = FilterOption().filter;
        filter.where["country"] = countryId;
        LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
          // console.log("grade",res);
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
            vm.initLoad();

            if (data.details.grade) {
              if(data.details.grade._id !=undefined){
                vm.topic.grade = data.details.grade._id + "";
                vm.getCourse(vm.topic.grade);
              }
              else{
                vm.topic.grade = "";
                vm.topic.course="";
              }
             
              
            }
           
          }
        });
      }

      vm.getCourse = function (gradeId) {
        console.log(gradeId)
       // vm.topic.course ="";
        vm.courses =[];
        var filter = FilterOption().filter;
        filter.where["grade"] = gradeId;
        LoadPageData.course.getAll(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
           // vm.course = data.details.course._id + "";
           //console.log(res.data.data)
            vm.courses = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      }
      vm.getCourse1 = function (gradeId) {
        console.log(gradeId)
        vm.topic.course ="";
        vm.courses =[];
        var filter = FilterOption().filter;
        filter.where["grade"] = gradeId;
        LoadPageData.course.getAll(filter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
           // vm.course = data.details.course._id + "";
           //console.log(res.data.data)
            vm.courses = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      }

      vm.initLoad = function () {
        var handleFileSelect = function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.fileUrl = evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
      }


      vm.cancel = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
       // $uibModalInstance.dismiss('Close');
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.saveTopic = function (form) {
        vm.submitted = true;

        if (form.$valid) {
          vm.isBusy = true;
          var response = {};
         

          if (!vm.topic._id) {
           // if ($scope.fileUrl) {
             // response = Upload.upload({
               // url: config.baseUrl + '/api/topic/create/',
               // data: { data: vm.topic, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
              //  disableProgress: true
             // });
            //} else {
              
              var filterData={"name":vm.topic.name,"country":parseInt(vm.topic.country),"grade":parseInt(vm.topic.grade),"course":parseInt(vm.topic.course)};
              LoadPageData.CheckTopic.getCheckTopic(filterData).$promise.then(function (res) {
                if (parseInt(res.data.total)>=1) {
                  toastr.error("Topic already exist", "Error");
  
                }
                else{
                  if ($scope.fileUrl) {
                    response = Upload.upload({
                      url: config.baseUrl + '/api/topic/create/',
                      data: { data: vm.topic, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
                      disableProgress: true
                    });
                  }
                  else{
                    response = LoadPageData.manageTopic.create(vm.topic).$promise;
                  }
                 
                }
                response.then(function (resp) {
                  // console.log("block user",res);
                  if (resp) {
                    if (resp && resp.message) {
                      toastr.success("Topic Created Successfully!");
                    //  toastr.success("Registered !" + resp.message, "Successfully!");
                    };
                    // Account created, redirect to the page with requested a signup
                    vm.updatedModal();
                    vm.isBusy = false;
                  }
                }, function (err) {
                  err = err.data;
                  vm.errors = {};
                  vm.isBusy = false;
                  if (err && err.error) {
                    angular.forEach(err.error.errors, function (error, field) {
                      form[field].$setValidity('mongoose', false);
                      vm.errors[field] = error.message;
                    });
                  } else {
                    vm.errors = err.message || "something wrong fields !"
                  }
                  if (err && err.status == -1) {
                    toastr.error("we are offline! try later", "Oops!");
                  }
                });
              });
              

             
           // }
          } else {
            //if ($scope.fileUrl) {

             // response = Upload.upload({
               // url: config.baseUrl + '/api/topic/update/' + vm.topic._id,
               // data: { data: vm.topic, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
               // disableProgress: true
              //});
           // } else {
              
              var filterData={"name":vm.topic.name,"country":parseInt(vm.topic.country),"grade":parseInt(vm.topic.grade),"course":parseInt(vm.topic.course)};
              LoadPageData.CheckTopic.getCheckTopic(filterData).$promise.then(function (res) {
                if (parseInt(res.data.total)>=1) {
                  var filter = FilterOption().filter;
                  filter.where["_id"] = vm.topic._id;
                LoadPageData.topic.getTopic(filter).$promise.then(function (res1) {
                  if (res1 && res1.data && res1.data.data) {
                    var AllData=res1.data.data[0];
                  //  console.log(AllData)
                    var TopicName=AllData.name;
                    var TopicCountryId=AllData.country;
                    var GradeId=AllData.grade;
                    var CourseId=AllData.course;
                  
                    if(TopicName==vm.topic.name && TopicCountryId==vm.topic.country && GradeId==vm.topic.grade && CourseId==vm.topic.course){
                      if ($scope.fileUrl) {

                        response = Upload.upload({
                          url: config.baseUrl + '/api/topic/update/' + vm.topic._id,
                          data: { data: vm.topic, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
                          disableProgress: true
                        });
                      }
                      else{
                        response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                      }
                      
                      response.then(function (resp) {
                        // console.log("block user",res);
                        if (resp) {
                          if (resp && resp.message) {
                            toastr.success("Topic Updated Successfully!");
                          };
                          // Account created, redirect to the page with requested a signup
                          vm.updatedModal();
                          vm.isBusy = false;
                        }
                      }, function (err) {
                        err = err.data;
                        vm.errors = {};
                        vm.isBusy = false;
                        if (err && err.error) {
                          angular.forEach(err.error.errors, function (error, field) {
                            form[field].$setValidity('mongoose', false);
                            vm.errors[field] = error.message;
                          });
                        } else {
                          vm.errors = err.message || "something wrong fields !"
                        }
                        if (err && err.status == -1) {
                          toastr.error("we are offline! try later", "Oops!");
                        }
                      });
                    }
                    else{
                     // console.log('hi')
                      toastr.error("Topic already exist", "Error");
                    }
                    
                  }
                });

                  //
  
                }
                else{
                  response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                }
                response.then(function (resp) {
                  // console.log("block user",res);
                  if (resp) {
                    if (resp && resp.message) {
                      toastr.success("Topic Updated Successfully!");
                     // toastr.success("Registered !" + resp.message, "Successfully!");
                    };
                    // Account created, redirect to the page with requested a signup
                    vm.updatedModal();
                    vm.isBusy = false;
                  }
                }, function (err) {
                  err = err.data;
                  vm.errors = {};
                  vm.isBusy = false;
                  if (err && err.error) {
                    angular.forEach(err.error.errors, function (error, field) {
                      form[field].$setValidity('mongoose', false);
                      vm.errors[field] = error.message;
                    });
                  } else {
                    vm.errors = err.message || "something wrong fields !"
                  }
                  if (err && err.status == -1) {
                    toastr.error("we are offline! try later", "Oops!");
                  }
                });
              });
              
              
            //}
          }

         

        }
      };





    });


})();


(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageSubscriptionCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.submitted = false;
      vm.filterOptions   = FilterOption().filter;
      vm.filterOptions.limit = 30;
      console.log("ManageBadgesCtrl");

      vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
          .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [9] },{class: 'manage-subscripton-seven', targets: 7},{class: 'manage-subscripton-six', targets: 6},{class: 'manage-subscripton-eight', targets: 8}])

      vm.getImageUrl = function(id){
        if(id){
        return config.baseUrl+'/api/gfs/'+id;
        }
      };


      vm.init = function(){
        LoadPageData.subscription.getAll(vm.filterOptions).$promise.then(function(res){
          if(res && res.data && res.data.data ){
            vm.loader = false;
            vm.subscriptionList = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
        function(error){
            if(error && error.status == -1 ){
              toastr.error("we are offline! try later", "Oops!");
            }
        });
      };
      vm.init();


      vm.changeFilterOptions = function() {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredSubscript = function(){
        vm.init();
      }

      /**
        verify subscription functionality
      **/
      vm.verifySubscription = function(subsId){
        vm.isBusy = true;

        LoadPageData.subscription.verify({controller: subsId }).$promise.then(function(res){
          console.log("subscriptionverify",res);
          if(res){
              vm.isBusy = false;
              toastr.success(res.message+' subscription verified', "Successfully!");
              vm.init();
           }
         }, function(error){
             console.log(error)
             vm.isBusy = false;
             toastr.error(error.data.message+'something went wrong', "Error!");
         });
      };

      /**
        delete confirmation sweetalert
      **/
      vm.deleteSubscription = function(id) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this Plan!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
          function(isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              LoadPageData.subscription.remove({id: id}).$promise.then(function() {
                vm.init();
                SweetAlert.swal("Success", "Subscription has been deleted", "success");
              },function(err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }



      /**
        open modal for edit view functionality
      **/
      vm.openModal = function(details, isEditable, size, parentSelector) {

        vm.details = { 'details': details  };
        vm.modalValue = isEditable;
        var parentElem = parentSelector ?
          angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/subscriptionActionModal.html',
          controller: 'SubscriptionModalController',
          controllerAs: 'vm',
          size: size,
          appendTo: parentElem,
          resolve: {
            data: function() {
              return vm.details;
            },
            model: function() {
              return vm.modalValue;
            }
          }
        }).result.then(function(updated) {
          if (updated) {
            vm.init();
          }
        }, function() {

        });


      };


})
.controller('SubscriptionModalController', function(config, _, Upload, model, data, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, $scope, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
      var vm = this;
      vm.updated = false;
      vm.loader  =  true;
      vm.isBusy = false;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.errors = {};
      vm.subscription   = {};

      $timeout(function() {
        vm.isEditable = model || false;
      }, 100);

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
          $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal =function(){
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

  // ##################  view update form binding ###############

   if(data){
     vm.subscription = data.details;
     vm.loader  =  false;
     console.log(data);

     if(data.details && !(model == 'new') ){
       var subscriptionData = data.details;

       $timeout(function() {
         // vm.ques = quesData;
         // vm.ques._id = quesData._id;
         vm.subscription.purchase = subscriptionData.purchase;
         vm.subscription.course = subscriptionData.course._id;
       }, 1500);

     }else{
       vm.subscription = {};
       vm.subscription.purchase =  [ { currency : '', mrp:''} ];
     }
   }

  // ########################### close #############################


    vm.init = function(){
      LoadPageData.subscription.getCurrency().$promise.then(function(res){
        if(res && res.data ){
          vm.loader = false;
          vm.currency = res.data;
          // console.log(res)
        }
      },
      function(error){
          if(error && error.status == -1 ){
            toastr.error("we are offline! try later", "Oops!");
          }
      });

      LoadPageData.course.getCourse(FilterOption().filter).$promise.then(function(res){
        if(res && res.data && res.data.data ){
          $localStorage.course = JSON.stringify(res.data.data);
          vm.course = res.data.data;
        }
      });

      vm.duration = [{_id: '15 days', name: "15 days"},{_id: '1 month', name: "1 month"},
                     {_id: '2 month', name: "2 month"}, {_id: '3 month', name: "3 month"},
                      {_id: '6 month', name: "6 month"}, {_id: '9 month', name: "9 month"},
                     {_id: '1 year', name: "1 year"}
                   ];


    };
    vm.init();

    /**
      get purchase add remove functionality
    **/

    vm.addOption = function(){
      if (vm.subscription.purchase.length < vm.currency.length ) {
        vm.subscription.purchase.push( { currency : '', mrp:''} );
      }
    }
    vm.delOption = function(i){
      if (vm.subscription.purchase.length ) {
        vm.subscription.purchase.splice(i,1);
      }
    };

  /**
    add new Subscription functionality
  **/
  vm.addSubscription = function(form){
    vm.submitted = true;
   if (form.$valid) {
    vm.isBusy = true;

    LoadPageData.subscription.create( vm.subscription ).$promise.then(function(res){
      // console.log("badge",res);
      if(res){
          vm.isBusy = false;
          vm.updatedModal();
          toastr.success(res.message+' Subscription added', "Successfully!");
       }
     }, function(error){
         console.log(error)
         vm.isBusy = false;
         vm.errors.other = error.data.message;
         $timeout(function(){ vm.errors ={}; },3500);
     });
   }

  };
  /**
    update Subscription functionality
  **/
  vm.updateSubscription = function(form){
    vm.submitted = true;
   if (form.$valid) {
    vm.isBusy = true;

    LoadPageData.subscription.update({id: vm.subscription._id },vm.subscription).$promise.then(function(res){
      console.log("Subscription",res);
      if(res){
          vm.isBusy = false;
          vm.updatedModal();
          toastr.success(res.message+' Subscription updated', "Successfully!");
       }
     }, function(error){
         console.log(error)
         vm.isBusy = false;
         vm.errors.other = error.data.message;
         $timeout(function(){ vm.errors ={}; },3500);
     });

   }
  };


});

})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageSubAdminCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
       /// .withOption('language', [{ZeroRecords:"No records to displays"}])
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [1] },{class: 'manage-user-third', targets: 3},{ bSortable: false, aTargets: [7] }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };

      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              //vm.user.dob= moment(res.data.dob).add(-1,'days').format('DD/MM/YYYY')
              vm[res.data.role] = true;
              //console.log(vm.user)
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        vm.checked();
        User.getSubAdmin(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
           // console.log(res)
            vm.loader = false;
            vm.getRoles();
            vm.usersList = res.data.data;
           
            //vm.user.dob = moment(res.data.dob).add(-1,'days').format('DD/MM/YYYY');
            vm.filterOptions.total = res.data.total;
            
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredUsers = function () {
        vm.init();
      }

      /**
        blockUser functionality
      **/
      vm.blockUser = function (id, isBlock, user) {
        vm.isBusy = true;

        User.blockUser({ controller: id }, { isBlock: isBlock }).$promise.then(function (res) {
          // console.log("block user",res);
          if (res) {
            vm.isBusy = false;
            vm.texty = isBlock ? "Blocked" : "Unblocked";
            toastr.success(res.message + ': ' + user + ' ' + vm.texty, "Successfully!");
            vm.init();
          }
        }, function (error) {
          //console.log(error)
          vm.isBusy = false;
          toastr.error(error.data.message + 'something went wrong', "Error!");
        });
      };

      /**
        delete confirmation sweetalert
      **/
      vm.deleteUser = function (id) {
        SweetAlert.swal({
          title: "Are you sure?",
          text: "You want to delete this sub admin!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              User.deleteUser({ id: id }).$promise.then(function () {
                SweetAlert.swal("Success", "Sub Admin has been deleted successfully.", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable) {

        vm.details = { 'details': details };
        vm.modalValue = isEditable;

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/createSubAdminModal.html',
          controller: 'SubadminModalController',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };


    })
    .controller('SubadminModalController', function (countrys,config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log,$scope) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;

      vm.country = '';//Utility.getGeo();
      vm.user = {};
      if(data.details){
        vm.maxDate=moment(data.details.dob).add(-1,'days').format("YYYY-MM-DD")
      }
      else{
        vm.maxDate = moment().add(-1, 'years').format("YYYY-MM-DD");
      }
      $scope.countries = countrys.countries
     //vm.maxDate=moment().add(-1, 'years').format("YYYY-MM-DD");
     // vm.minDate=moment().add(-100, 'years').format("YYYY-MM-DD");
     //console.log(vm.maxDate)
        if (data.details) {
           
        vm.user = data.details;
        vm.user.fullname = data.details.name;
        vm.user.confirmPassword = data.details.password;
        console.log(data.details,"data.details")
        vm.user.dialCode = data.details.dialCode
        vm.user.emoji = data.details.emoji
        vm.user.countryName = JSON.stringify(data.details.countryName)
            // vm.user.dob=data.details.dob;
            //vm.user.dob = new FormControl(moment([2015, 0, 1]));
             // var dateTime = new Date(data.details.dob);
             // dateTime = moment(dateTime).format("YYYY-MM-DD")
            //m.user.dob = moment(data.details.dob);
            //vm.user.dob = moment(data.details.dob).format('YYYY/MM/DD')
             vm.user.dob = moment(data.details.dob).add(-1,'days').format("DD/MM/YYYY");
          //  console.log(vm.user)
      }
      vm.changecountry = function () {
        var func = JSON.parse(vm.user.countryName)
        vm.user.dialCode = func.dialCode;
        vm.user.emoji = func.emoji;
   }
      vm.errors = {};

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.register = function (form) {
        vm.submitted = true;
        vm.user.role = 'subAdmin';

        if (form.$valid) {

          vm.isBusy = true;
          if (!vm.user._id) {
            User.createSubAdmin({
              name: vm.user.fullname,
              email: vm.user.email,
              dob: new Date(vm.user.dob),
              dialCode : vm.user.dialCode,
              emoji : vm.user.emoji,
              countryName : JSON.parse(vm.user.countryName),
              phoneNumber: vm.user.phoneNumber,
              password: vm.user.password,
              role: vm.user.role,
              facebook: {},
              google: {},
              curriculum: vm.country ? vm.country.country_code : '',
              terms: vm.user.terms
            })
              .$promise.then(function (resp) {
                // console.log("block user",res);
                if (resp) {
                  if (resp && resp.message) {
                    toastr.success("Registered !" + resp.message, "Successfully!");
                  };
                  // Account created, redirect to the page with requested a signup
                  vm.updatedModal();
                  vm.isBusy = false;
                }
              }, function (err) {
                err = err.data;
                vm.errors = {};
                vm.isBusy = false;
                if (err && err.error) {
                  angular.forEach(err.error.errors, function (error, field) {
                    form[field].$setValidity('mongoose', false);
                    vm.errors[field] = error.message;
                    // console.log(vm.errors[field])
                  });
                  // $timeout(function(){ vm.errors ={}; },4000);
                } else {
                  vm.errors = err.message || "something wrong fields !"
                }
                if (err && err.status == -1) {
                  toastr.error("we are offline! try later", "Oops!");
                }
              });
          } else {
            User.update({
              data: {
                _id: vm.user._id,
                name: vm.user.fullname,
                email: vm.user.email,
                password: vm.user.password,
                role: vm.user.role,
                dob: vm.user.dob,
                dialCode : vm.user.dialCode,
                emoji : vm.user.emoji,
                countryName : JSON.parse(vm.user.countryName),
                phoneNumber: vm.user.phoneNumber,
                facebook: {},
                google: {},
                curriculum: vm.country ? vm.country.country_code : '',
                terms: vm.user.terms
              }
            })
              .$promise.then(function (resp) {
                // console.log("block user",res);
                if (resp) {
                  if (resp && resp.message) {
                    toastr.success("Registered !" + resp.message, "Successfully!");
                  };
                  // Account created, redirect to the page with requested a signup
                  vm.updatedModal();
                  vm.isBusy = false;
                }
              }, function (err) {
                err = err.data;
                vm.errors = {};
                vm.isBusy = false;
                if (err && err.error) {
                  angular.forEach(err.error.errors, function (error, field) {
                    form[field].$setValidity('mongoose', false);
                    vm.errors[field] = error.message;
                    // console.log(vm.errors[field])
                  });
                  // $timeout(function(){ vm.errors ={}; },4000);
                } else {
                  vm.errors = err.message || "something wrong fields !"
                }
                if (err && err.status == -1) {
                  toastr.error("we are offline! try later", "Oops!");
                }
              });
          }
        }
      };





    });


})();



(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageStoryCtrl', function (config, _,  Auth, StoryService, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageStoryCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [7] },{class: 'manage-story-first', targets: 1},{class: 'manage-story-third', targets: 3},{class: 'manage-story-four', targets: 4},{class: 'manage-story-five', targets: 5},{class: 'manage-story-six', targets: 6}])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        /**
          on load functionality
        **/
        vm.init = function(){
          StoryService.get(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.storyList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredStory = function(){
          vm.init();
        }

        /**
          verify story functionality
        **/
        vm.verifyStory = function(storyId){
          vm.isBusy = true;

          StoryService.verify({controller: storyId }).$promise.then(function(res){
            console.log("storyverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Story verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };
        vm.UnverifyStory = function(storyId){
          vm.isBusy = true;

          StoryService.Unverify({controller: storyId }).$promise.then(function(res){
            console.log("storyverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Story Unverified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };
        /**
          update story functionality
        **/
        vm.updateStory = function(form){
          vm.submitted = true;
         if (form.$valid) {
          vm.isBusy = true;

          StoryService.update({id: vm.story._id },vm.story).$promise.then(function(res){
            console.log("story",res);
            if(res){
                vm.isBusy = false;
                vm.updatedModal();
                toastr.success(res.message+' story updated', "Successfully!");
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               vm.errors.other = error.data.message;
               $timeout(function(){ vm.errors ={}; },3500);
           });

         }
       };

        /**
          delete confirmation sweetalert
        **/
        vm.deleteStory = function(sid) {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "You want to delete this Story!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = true;
                StoryService.delete({id: sid} ).$promise.then(function(res) {
                  SweetAlert.swal("Success", "story has been deleted", "success");
                  vm.init();
                  vm.isBusy = false;
                },function() {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }


        /**
          open modal for edit view functionality
        **/
        vm.openModal = function(details, isEditable, size, parentSelector) {

          vm.details = { 'details': details };
          vm.modalValue = isEditable;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/StoryActionModal.html',
            controller: 'StoryModalController',
            controllerAs: 'vm',
            size: size,
            appendTo: parentElem,
            resolve: {
              data: function() {
                return vm.details;
              },
              model: function() {
                return vm.modalValue;
              }
            }
          }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };

        vm.AddModal = function(details, isEditable) {

          vm.details = { 'details': details };
          vm.modalValue = isEditable;
        //  var parentElem = parentSelector ?
         //   angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
         $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/AddStoryActionModal.html',
          controller: 'StoryModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };




})
.controller('StoryModalController', function(config, _, appPattern, model, data,  $sce, Auth, StoryService, LoadPageData,   $uibModalInstance, $localStorage, FilterOption, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
    var vm = this;
    vm.updated = false;
    vm.loader  =  true;
    vm.pattern = appPattern;
    vm.isBusy = false;
    vm.submitted = false;
    vm.errors = {};
    vm.story   = {};

    $timeout(function() {
      vm.isEditable = model || false;
    }, 100);

    vm.trustUrl = function(url){
      return $sce.trustAsResourceUrl(url);
    }

    /**
      open modal closed functionality
    **/
    vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
    };
    vm.updatedModal =function(){
      vm.updated = true;
      $uibModalInstance.close(vm.updated);
    }

   // ##################  view update form binding ###############

     if(data && data.details){
       vm.loader = false;
       vm.story = data.details;
     }

    /**
      update story functionality
    **/
    vm.updateStory = function(form){
      vm.submitted = true;
     if (form.$valid) {
      vm.isBusy = true;
       if(!vm.story._id){
        StoryService.create(vm.story ).$promise.then(function(res){
          console.log("story",res);
          if(res){
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success('Create story updated', "Successfully!");
           }
         });


       }
       else{
        StoryService.update({id: vm.story._id },vm.story ).$promise.then(function(res){
          console.log("story",res);
          if(res){
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success('Update story updated', "Successfully!");
           }
         });
       }
       response.$promise.then(function (resp) {
        // console.log("block user",res);
        if (resp) {
          if (resp && resp.message) {
            //toastr.success("Story Created Successfully!");
          };
          // Account created, redirect to the page with requested a signup
          vm.updatedModal();
          vm.isBusy = false;
        }
      }, function(error){
           vm.isBusy = false;
           vm.errors.other = error.data.message;
           $timeout(function(){ vm.errors ={}; },3500);
       });

     }
   };


});


})();


(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageQuestionsCtrl', function (config, ENUMS, _, SystemEnum, Auth, TestQuesService, LoadPageData, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;
      vm.AllQuestion=[];
      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.isBusy = false;

      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;
      console.log("ManageTestQuestionsCtrl");

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [7] }])
      /**
        open get gfs image download src functionality
      **/
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      /**
        get difficulty level functionality for modal
      **/
      vm.getEnum = function () {
        SystemEnum.getParentChild({ id: 2 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.diffLevel = res.data;
          }
        });
      }
      vm.getEnum();

      /**
        total counts in table ques functionality
      **/
      vm.getQuesCounts = function () {
        TestQuesService.count().$promise.then(function (res) {
          if (res && res.data) {
            vm.totalTestQues = res.data;
          }
        },
          function (error) {
          });
      };
      /**
        initial table data functionality
      **/
      vm.init = function () {
        TestQuesService.get(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
             
            vm.testQuestionsList = res.data.data;
            console.log(res.data.data);
            // vm.getQuesCounts();
            vm.loader = false;
            vm.filterOptions.total = res.data.total;
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();


      // vm.testQuestionsList= [{ course : "math", unit:"number system", chapter:"real no", topic: "algebra", level: "hard", question: "what is elementry algebra?" },
      //                { course : "math", unit:"Integers", chapter:"intgers", topic: "geomatry", level: "easy", question: "what is elementry algebra?" }]

      /**
        table filtering functionality
      **/
      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredQuestions = function () {
        vm.init();
      }

      /**
        verify test questions functionality
      **/
     
     vm.selectQuestion = function (quesId) {
    
     if(vm.AllQuestion.length==0){
      vm.AllQuestion.push(quesId)
     }
     else{
       vm.check=true;
      for (var index = 0; index < vm.AllQuestion.length; index++) {
        var element = vm.AllQuestion[index];
        if(element==quesId){
          vm.check=false;
          vm.AllQuestion.splice(index, 1);
        
        }
        
        
      }
      if(vm.check==true){
        vm.AllQuestion.push(quesId)
      }
     // console.log(vm.AllQuestion)
     }
          
     
     }
    // console.log(vm.AllQuestion)
    
    vm.MultipleDelete = function () {
      if(vm.AllQuestion.length>0){
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You want to delete this Question!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "No, cancel it",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            vm.isBusy = true;
            vm.count=0;
            for (var index = 0; index < vm.AllQuestion.length; index++) {
              var element = vm.AllQuestion[index];
              TestQuesService.delete({ id: element }).$promise.then(function (res) {
              });
              vm.count=parseInt(vm.count)+1;
            }
           
           
             if(vm.count==vm.AllQuestion.length)
               {
                vm.isBusy = false;
                SweetAlert.swal("Success", "question has been deleted", "success");
                  vm.AllQuestion=[];
                  vm.count=0;
                  setTimeout(function(){
                    vm.init();
                  },1000)
                  //vm.init();
                   //$window.location.reload();
               }
          
          } else {
            vm.isBusy = false;
            SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
          }
        });
      }
      else{
        toastr.error('Please atleast one select question', "Error!");
      }
    }
      vm.verifyTestQues = function (quesId) {
        vm.isBusy = true;

        TestQuesService.verify({ controller: quesId }).$promise.then(function (res) {
          console.log("quesverify", res);
          if (res) {
            vm.isBusy = false;
            toastr.success(res.message + ' question verified', "Successfully!");
            vm.init();
          }
        }, function (error) {
          console.log(error)
          vm.isBusy = false;
          toastr.error(error.data.message + 'something went wrong', "Error!");
        });
      };

      /**
        delete confirmation sweetalert
      **/
      vm.deleteTestQues = function (quesId) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this Question!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = true;
              TestQuesService.delete({ id: quesId }).$promise.then(function (res) {
                console.log("quesDel", res);
                if (res) {
                  vm.isBusy = false;
                  SweetAlert.swal("Success", "question has been deleted", "success");
                  // toastr.success(res.message+' question deleted', "Successfully!");
                  vm.init();
                }
              }, function (error) {
                vm.isBusy = false;
                // toastr.error(error.data.message+'something went wrong', "Error!");
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              });

            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function () {


        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/testQuesActionModal.html',
          controller: 'DocsQuesModalController',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
        }).result.then(function (updated) {
            vm.init();
        }, function () {
          vm.init();
        });
      };

    }).controller('DocsQuesModalController', function (config, _, Auth, TestQuesService, $scope, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log, Upload) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.isBusy = false;
      vm.submitted = false;
      vm.errors = {};
      vm.ques = {};
      vm.topics = [];
      //vm.grades = [];
     vm.courses = [];
     // vm.grades = [];
      vm.chapters=[];
      vm.units=[];
     vm.country = '';//Utility.getGeo();
      vm.filterUnit = FilterOption().filter;
      vm.filterChapter = FilterOption().filter;
      vm.filterTopic = FilterOption().filter;

      vm.getCurriculum = function () {
        LoadPageData.curriculum.get().$promise.then(function (resp) {
          // console.log('curriculum', resp);
          if (resp && resp.data) {
            vm.curriculum = resp.data;
          }
        });
      };
      vm.getCurriculum();

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        //$uibModalInstance.dismiss('Close');
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      };
      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      /**
        get units as per course functionality
      **/
     vm.getGradeByCountry = function (country) {
      vm.courses =[];
      vm.grades =[];
      vm.chapters=[];
      vm.topics=[];
      vm.units=[];
      var filter = FilterOption().filter;
      filter.where["country"] = country;
      LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
        if (res && res.data && res.data.data) {
          vm.grades = res.data.data;
         // vm.initLoad();

          //if (data.details.grade) {
          //  vm.getCourse(vm.unit.grade);
        //  }
         
        }
      });
    }

    vm.getCourse = function (grade) {
      //vm.topic.course ="19";
      vm.courses =[];
     // vm.grades =[];
      vm.topics=[];
      vm.chapters=[];
      vm.units=[];
      var filter = FilterOption().filter;
      filter.where["grade"] = grade;
      LoadPageData.course.getAll(filter).$promise.then(function (res) {
        if (res && res.data && res.data.data) {
          vm.courses = res.data.data;
         // vm.initLoad();

          //if (data.details.course) {
          //  vm.getTopics(vm.unit.course);
          //}
        }
      },
        function (error) {
          if (error && error.status == -1) {
            toastr.error("we are offline! try later", "Oops!");
          }
        });
    }

      vm.getUnits = function (topic) {
      
        vm.chapters=[];
        vm.units=[];
        if (topic) {
          vm.filterUnit.where.topic = topic;
          vm.filterUnit.type = 'filter';
        };

        LoadPageData.unit.getUnit(vm.filterUnit).$promise.then(function (resp) {
          // console.log('units', resp);
          if (resp && resp.data && resp.data.data) {
            vm.units = resp.data.data;
            vm.loader = false;
          }
        });


      }
      vm.getChapters = function (unitId) {
        
        vm.chapters=[];
        
        if (unitId) {
          vm.filterChapter.type = 'filter';
          vm.filterChapter.where.unit = unitId;

          LoadPageData.chapter.getChapter(vm.filterChapter).$promise.then(function (resp) {
            // console.log('chapter', resp);
            if (resp && resp.data && resp.data.data) {
              vm.chapters = resp.data.data;
              vm.initLoad();

            }
          });
        }

      };
      /**
        get topic as per course unit chapter functionality
      **/
      vm.getTopics = function (course) {
        
        vm.topics=[];
        vm.chapters=[];
        vm.units=[];
        if (course) {
          vm.filterTopic.type = 'filter';
          vm.filterTopic.where.course = course;

          LoadPageData.topic.getTopic(vm.filterTopic).$promise.then(function (res) {
            // console.log("topicres",res);
            if (res && res.data && res.data.data && res.data.data.length) {
              vm.topics = res.data.data;
            }
          });
        }

      };


      // ##################  view update form binding ###############
      vm.initLoad = function () {
        var handleFileSelect = function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.fileUrl = evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#fileInput1')).on('change', handleFileSelect);
      }

      vm.initLoad();

      vm.updateQuestion = function (form) {
        vm.submitted = true;
        if (form.$valid) {
          vm.isBusy = true;
          var service = {};
          if ($scope.fileUrl) {

            service = Upload.upload({
              url: config.baseUrl + '/api/question/saveDocument/',
              data: { data: vm.ques, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
              disableProgress: true
            });

            service.then(function (res) {
              console.log("quest", res);
              if (res) {
                vm.isBusy = false;
                toastr.success(res.message + ' question updated', "Successfully!");
                vm.cancel();
              }
            }, function (error) {
              console.log(error)
              vm.isBusy = false;
              vm.errors.other = error.data.message;
              $timeout(function () { vm.errors = {}; }, 3500);
            });
          }

        }
      };


    });


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageGradeCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [1] }, { bSortable: false, aTargets: [5] }, {
              class: 'manage-grade-second', targets: 3
          }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };

      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              vm[res.data.role] = true;
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        vm.checked();
        LoadPageData.manageGrade.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.grades = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();



      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredGrades = function () {
        vm.init();
      }


      /**
        delete confirmation sweetalert
      **/
      vm.deleteGrade = function (id) {
        SweetAlert.swal({
          title: "Are you sure?",
          text: "You want to delete this Grade!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              LoadPageData.manageGrade.delete({ id: id }).$promise.then(function () {
                  SweetAlert.swal("Success", "Grade has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable) {

        vm.details = { 'details': details };
        //console.log(vm.details)
        vm.modalValue = isEditable;

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageGradeModal.html',
          controller: 'GradeModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };


    })
    .controller('GradeModalController', function (config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;

      vm.country = '';//Utility.getGeo();
      vm.grade = {};
      vm.errors = {};
      vm.courses = [];
      vm.curriculum = [];
      if (data && model) {
        vm.grade = data.details;
        if (data.details.country) {
          vm.grade.country = data.details.country._id + '';
        }
      }
      //console.log(vm.grade)
      LoadPageData.course.getCourses().$promise.then(function (res) {
        if (res && res.data) {
          console.log(res)
          vm.courses = res.data;
        }
      },
        function (error) {
          if (error && error.status == -1) {
            toastr.error("we are offline! try later", "Oops!");
          }
        });

      vm.getCurriculum = function () {
        LoadPageData.curriculum.get().$promise.then(function (resp) {
          // console.log('curriculum', resp);
          if (resp && resp.data) {
            vm.curriculum = resp.data;
          }
        });
      };
      vm.getCurriculum();

      vm.cancel = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
        //$uibModalInstance.dismiss('Close');
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.saveGrade = function (form) {
        vm.submitted = true;
     
        if (form.$valid) {
          vm.isBusy = true;
          var response = {};
          var filterData={"name":vm.grade.name,"country":parseInt(vm.grade.country)};
          LoadPageData.FindGrade.getFindGrade(filterData).$promise.then(function (res) {
        // console.log(res.data.total)
            if (parseInt(res.data.total)>=1) {
              var filter = FilterOption().filter;
                filter.where["_id"] = vm.grade._id;
              LoadPageData.manageGrade.getAll(filter).$promise.then(function (res1) {
                console.log(vm.grade._id)
                if (res1 && res1.data && res1.data.data) {
                  var AllData=res1.data.data[0];
                  var GradeName=AllData.name;
                  var GradeCountryId=AllData.country._id;
                  if(vm.grade._id!=undefined && GradeName ==vm.grade.name && GradeCountryId ==vm.grade.country){
                    //console.log('hi')
                    response = LoadPageData.manageGrade.update({ id: vm.grade._id }, {
                      _id: vm.grade._id,
                      name: vm.grade.name,
                      description: vm.grade.description,
                      country: vm.grade.country
                    })
                    response.$promise.then(function (resp) {
                      // console.log("block user",res);
                      if (resp) {
                        if (resp && resp.message) {
                          toastr.success("Grade Updated Successfully!");
                        };
                        // Account created, redirect to the page with requested a signup
                        vm.updatedModal();
                        vm.isBusy = false;
                      }
                    }, function (err) {
                      err = err.data;
                      vm.errors = {};
                      vm.isBusy = false;
                      if (err && err.error) {
                        angular.forEach(err.error.errors, function (error, field) {
                          form[field].$setValidity('mongoose', false);
                          vm.errors[field] = error.message;
                        });
                      } else {
                        vm.errors = err.message || "something wrong fields !"
                      }
                      if (err && err.status == -1) {
                        toastr.error("we are offline! try later", "Oops!");
                      }
                    });
                  }
                  else{
                    toastr.error("Grade already exist", "Error");
                  }
                }
              });
              
            }
            else{
              if (!vm.grade._id) {
                response = LoadPageData.manageGrade.create({
                  name: vm.grade.name,
                  description: vm.grade.description,
                  country: vm.grade.country
                });
              } else {
                response = LoadPageData.manageGrade.update({ id: vm.grade._id }, {
                  _id: vm.grade._id,
                  name: vm.grade.name,
                  description: vm.grade.description,
                  country: vm.grade.country
                })
              }
              response.$promise.then(function (resp) {
                // console.log("block user",res);
                if (resp) {
                  if (resp && resp.message) {
                    toastr.success("Grade Created Successfully!");
                  };
                  // Account created, redirect to the page with requested a signup
                  vm.updatedModal();
                  vm.isBusy = false;
                }
              }, function (err) {
                err = err.data;
                vm.errors = {};
                vm.isBusy = false;
                if (err && err.error) {
                  angular.forEach(err.error.errors, function (error, field) {
                    form[field].$setValidity('mongoose', false);
                    vm.errors[field] = error.message;
                  });
                } else {
                  vm.errors = err.message || "something wrong fields !"
                }
                if (err && err.status == -1) {
                  toastr.error("we are offline! try later", "Oops!");
                }
              });
                   //  vm.updatedModal();
                    //vm.isBusy = false;
                   // toastr.success("Grade Created Successfully!");
            }
          });


        }
     
      };
    });


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageFaqCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loadCategory = true;
      vm.loadQuestion = true;
      vm.filterCategory = FilterOption().filter;
      vm.filterQuestion = FilterOption().filter;
      vm.filterCategory.limit = 30;
      vm.filterQuestion.limit = 30;
      console.log("ManageFaqsCtrl");

      vm.showTypeList = [{ _id: 'category', name: 'Category List' }, { _id: 'questions', name: 'Questions List' }
      ];
        vm.showType = 'questions';
      
       
        
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfrtip')
                .withOption('paging', false)
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('status', false)
                .withOption('bInfo', false)
                .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [6] }, { bSortable: false, aTargets: [5] }, {
                    class: 'manage-faq', targets: 1
                }, {
                        class: 'manage-faq', targets: 3
                }
                ])

        

     

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.getCategory = function () {

        LoadPageData.faqs.getCategories(vm.filterCategory).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadCategory = false;
            vm.categoryList = res.data.data;
            vm.filterCategory.total = res.data.total;
             // console.log(res);
          }
        },
          function (error) {
          });
      };

      vm.getQuestion = function () {

        LoadPageData.faqs.getAllQuestions(vm.filterQuestion).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadQuestion = false;
            vm.questionList = res.data.data;
            vm.filterQuestion.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });
      };

      // ######################  init and filters paginations ###################

      vm.init = function () {
        vm.getCategory();
        vm.getQuestion();
      };
      vm.init();


      vm.changeFilterOptions = function (type) {
        if ((vm['filter' + type].page - 1) * vm['filter' + type].limit <= vm['filter' + type].total) {
          vm['get' + type]();
        }
      }

      vm.getFiltered = function (type) {
        vm['get' + type]();
      }

      // ######################  init and filters paginations ###################

      /**
        verify all type functionality
      **/
      vm.verifyMe = function (id, type) {
        if (id && type) {
          vm.isBusy = true;

          if (type == 'Question') {

            LoadPageData.faqs.verify({ controller: id }).$promise.then(function (res) {
              // console.log("verify",res);
              if (res) {
                vm.isBusy = false;
                toastr.success(res.message + ' request verified', "Successfully!");
                vm['get' + type]();
              }
            }, function (error) {
              console.log(error)
              vm.isBusy = false;
              toastr.error(error.data.message + 'something went wrong', "Error!");
            });
          };
          if (type == 'Category') {

            SystemEnum.verify({ controller: id }).$promise.then(function (res) {
              // console.log("verify",res);
              if (res) {
                vm.isBusy = false;
                toastr.success(res.message + ' request verified', "Successfully!");
                vm['get' + type]();
              }
            }, function (error) {
              console.log(error)
              vm.isBusy = false;
              toastr.error(error.data.message + 'something went wrong', "Error!");
            });
          };

        }

      };

      /**
        delete confirmation sweetalert
      **/
      vm.deleteMe = function (id, type) {
        if (id && type) {
          SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this " + type+"!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {
                vm.isBusy = true;
                LoadPageData.faqs.remove({ id: id }).$promise.then(function (res) {
                  SweetAlert.swal("Success", type + " has been deleted", "success");
                  vm.isBusy = false;
                  vm['get' + type]();
                }, function (err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });

        }
      };

      vm.deleteCategory = function (id, type) {
        if (id && type) {
          SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this " + type+"!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {
                vm.isBusy = true;
                SystemEnum.delete({ id: id }).$promise.then(function (res) {
                  SweetAlert.swal("Success", type + " has been deleted", "success");
                  vm.isBusy = false;
                  vm['get' + type]();
                }, function (err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });

        }
      };
      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable, type, size, parentSelector) {
        if (type) {
          vm.details = { 'qDetails': details };
          vm.modalValue = isEditable;
          vm.modalType = type;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/faqsActionModal.html',
            controller: 'FaqsModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            size: size,
            appendTo: parentElem,
            resolve: {
              data: function () {
                return vm.details;
              },
              hType: function () {
                return vm.modalType;
              },
              model: function () {
                return vm.modalValue;
              }
            }
          }).result.then(function (type) {
            if (type && typeof type == 'string') {
              type = type.charAt(0).toUpperCase() + type.slice(1);
              // vm.init();
              vm['get' + type]();
            }
          }, function () {

          });


        }
      };




    })
    .controller('FaqsModalController', function (config, _, model, hType, data, SystemEnum, Upload, Auth, LoadPageData, $uibModalInstance, $localStorage, $scope, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.isBusy = false;
      vm.submitted = false;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = '';
      vm.errors = {};
      vm.faq = {};

      $timeout(function () {
        vm.isEditable = model || false;
        vm.type = hType;
      }, 100);

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      vm.trustUrl = function (url) {
        return $sce.trustAsResourceUrl(url);
      }

      vm.init = function () {
        LoadPageData.faqs.getCategories(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.category = res.data.data;
            // console.log(res);
          }
        },
          function (error) {
          });
      };
      vm.init();

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal = function (type) {

        vm.updated = type;
        $uibModalInstance.close(type);
      }


      if (data) {
        var info = data.qDetails;

        if (data.qDetails && !(model == 'new')) {
          // console.log(info);
          var qData = Object.assign({}, info);

          $timeout(function () {
            vm.faq = qData;
            vm.faq._id = qData._id;
            if (qData.type && qData.type._id) vm.faq.type = qData.type._id;

          }, 200);

        }
      }

      // ########################### close #############################

      /**
        add new  functionality
      **/
      vm.addFaqs = function (type, form) {
        vm.submitted = true;

        if (form.$valid && (vm.type == 'Category')) {
          vm.isBusy = true;
          var faq = vm.faq;
          Object.assign(faq, { parent: 21 });
          SystemEnum.create(faq).$promise.then(function (res) {
            // console.log("faq",res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal(vm.type);
              toastr.success(res.message + ' request added', "Successfully!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });
        }

        if (form.$valid && (vm.type == 'Question')) {
          vm.isBusy = true;

          LoadPageData.faqs.create(vm.faq).$promise.then(function (res) {
            console.log("faq", res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal(vm.type);
              toastr.success(res.message + ' request added', "Successfully!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });
        }


      };
      /**
        update functionality
      **/
      vm.updateFaqs = function (type, form) {
        vm.submitted = true;

        if (form.$valid && (vm.type == 'Category')) {
          vm.isBusy = true;
          var faq = vm.faq;
          Object.assign(faq, { parent: 21 });
          SystemEnum.update({ id: vm.faq._id }, faq).$promise.then(function (res) {
            // console.log("faq",res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal(vm.type);
              toastr.success(res.message + ' request updated', "Successfully!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });

        }
        if (form.$valid && (vm.type == 'Question')) {
          vm.isBusy = true;

          LoadPageData.faqs.update({ controller: vm.faq._id }, vm.faq).$promise.then(function (res) {
            // console.log("faq",res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal(vm.type);
              toastr.success(res.message + ' request updated', "Successfully!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });

        }

      };
      // else closed






    });

})();


(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageEnquiryCtrl', function (config, _, Auth, ContactInfo, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.submitted = false;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.where["career"]=false
      vm.filterOptions.limit = 30;
      console.log("ManageEnquiryCtrl");

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [8] },{class: 'manage-enquiry-first', targets: 1},{class: 'manage-enquiry-four', targets: 4},{class: 'manage-enquiry-five', targets: 5},{class: 'manage-enquiry-seven', targets: 7}])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };


      vm.init = function () {
        ContactInfo.get(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.enquiryList = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredEnquiry = function () {
        vm.init();
      }

      /**
        delete confirmation sweetalert
      **/
      vm.deleteEnquiry = function (id) {
        vm.isBusy = true;
        SweetAlert.swal({
          title: "Are you sure?",
          text: "You want to delete this Enquiry!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              ContactInfo.delete({ id: id }).$promise.then(function (res) {
                SweetAlert.swal("Success", "Enquiry has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }

      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable, size, parentSelector) {
        //console.log(isEditable)
        vm.details = { 'details': details };
        vm.modalValue = isEditable;
        var parentElem = parentSelector ?
          angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/contactEnquiryAction.html',
          controller: 'EnquiryModalController',
          controllerAs: 'vm',
          size: size,
          backdrop: 'static',
          keyboard: false,
          appendTo: parentElem,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };
      vm.openViewModal = function (details, isEditable, size, parentSelector) {
        //console.log(isEditable)
        vm.details = { 'details': details };
        vm.modalValue = isEditable;
        var parentElem = parentSelector ?
          angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/contactViewEnquiryAction.html',
          controller: 'EnquiryViewModalController',
          controllerAs: 'vm',
          size: size,
          backdrop: 'static',
          keyboard: false,
          appendTo: parentElem,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };



    })
    .controller('EnquiryModalController', function (config, _, appPattern, model, data, $sce, Auth, ContactInfo, $uibModalInstance, $localStorage, FilterOption, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.pattern = appPattern;
      vm.isBusy = false;
      vm.submitted = false;
      vm.errors = {};
      vm.enquiry = {};

      $timeout(function () {
        vm.isEditable = model || false;
      }, 100);

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      // ##################  view update form binding ###############

      if (data && data.details) {
        vm.loader = false;
        vm.enquiry = data.details;
      }

      /**
        reply Enquiry functionality
      **/
      vm.replyEnquiry = function (form) {
        vm.submitted = true;
        if (form.$valid) {
          vm.isBusy = true;
//console.log( vm.enquiry)
          ContactInfo.update({ id: vm.enquiry._id }, vm.enquiry).$promise.then(function (res) {
            // console.log("enquiry",res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success(res.message || '  Reply Sent', "Successfully!");
            }
          }, function (error) {
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
            toastr.error("Somthing is Wrong", "Error");
          });

        }
      };



    })
    .controller('EnquiryViewModalController', function (config, _, appPattern, model, data, $sce, Auth, ContactInfo, $uibModalInstance, $localStorage, FilterOption, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.pattern = appPattern;
      vm.isBusy = false;
      vm.submitted = false;
      vm.errors = {};
      vm.enquiry = {};

      $timeout(function () {
        vm.isEditable = model || false;
      }, 100);

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      // ##################  view update form binding ###############

      if (data && data.details) {
        vm.loader = false;
        console.log(data.details)
        vm.enquiry = data.details;
      }

      


    });
    
})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageCourseHierarchyCtrl', function (config, _, Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [20, 30, 45, 60];
      vm.params = $state.params;
      vm.loadGrade = true;
      vm.loadCourse = true;
      vm.loadUnit = true;
      vm.loadChapter = true;
      vm.loadTopic = true;
      vm.filterGrade = FilterOption().filter;
      vm.filterCourse = FilterOption().filter;
      vm.filterUnit = FilterOption().filter;
      vm.filterChapter = FilterOption().filter;
      vm.filterTopic = FilterOption().filter;
      vm.filterGrade.limit = 20;
      vm.filterCourse.limit = 20;
      vm.filterUnit.limit = 20;
      vm.filterChapter.limit = 20;
      vm.filterTopic.limit = 20;
      console.log("ManageCourseHierarchyCtrl");

      vm.showTypeList = [{ _id: 'grade', name: 'Grade List' }, { _id: 'course', name: 'Course List' },
      { _id: 'unit', name: 'Unit List' }, { _id: 'chapter', name: 'Chapter List' },
      { _id: 'topic', name: 'Topic List' },
      ];
      vm.showType = 'grade';

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [5] }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.getGrade = function () {

        LoadPageData.hierarchy.getAll({ type: 'grade' }, vm.filterGrade).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadGrade = false;
            vm.gradeList = res.data.data;
            vm.filterGrade.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });

      };
      vm.getCourse = function () {

        LoadPageData.hierarchy.getAll({ type: 'course' }, vm.filterCourse).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadCourse = false;
            vm.courseList = res.data.data;
            vm.filterCourse.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });

      };

      vm.getUnit = function () {

        LoadPageData.hierarchy.getAll({ type: 'unit' }, vm.filterUnit).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadUnit = false;
            vm.unitList = res.data.data;
            vm.filterUnit.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });

      };

      vm.getChapter = function () {

        LoadPageData.hierarchy.getAll({ type: 'chapter' }, vm.filterChapter).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadChapter = false;
            vm.chapterList = res.data.data;
            vm.filterChapter.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });
      };

      vm.getTopic = function () {

        LoadPageData.hierarchy.getAll({ type: 'topic' }, vm.filterTopic).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loadTopic = false;
            vm.topicList = res.data.data;
            vm.filterTopic.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
          });
      };

      // ######################  init and filters paginations ###################

      vm.init = function () {
        vm.getGrade();
        vm.getCourse();
        vm.getUnit();
        vm.getChapter();
        vm.getTopic();
      };
      vm.init();


      vm.changeFilterOptions = function (type) {
        if ((vm['filter' + type].page - 1) * vm['filter' + type].limit <= vm['filter' + type].total) {
          vm['get' + type]();
        }
      }

      vm.getFiltered = function (type) {
        vm['get' + type]();
      }

      // ######################  init and filters paginations ###################

      /**
        verify all type functionality
      **/
      vm.verifyMe = function (id, type) {
        if (id && type) {
          vm.isBusy = true;
          LoadPageData.hierarchy.verify({ type: type.toLowerCase(), controller: id }).$promise.then(function (res) {
            // console.log("verify",res);
            if (res) {
              vm.isBusy = false;
              toastr.success(res.message + ' request verified', "Successfully!");
              vm['get' + type]();
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            toastr.error(error.data.message + 'something went wrong', "Error!");
          });
        }

      };

      /**
        delete confirmation sweetalert
      **/
      vm.deleteMe = function (id, type) {
        if (id && type) {
          SweetAlert.swal({
            title: "? Are you sure",
            text: "!Your want to delete this " + type,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "No, cancel it",
            closeOnConfirm: false,
            closeOnCancel: false
          },
            function (isConfirm) {
              if (isConfirm) {
                vm.isBusy = true;
                LoadPageData.hierarchy.remove({ type: type.toLowerCase(), id: id }).$promise.then(function (res) {
                  SweetAlert.swal("Success", type + " has been deleted", "success");
                  vm.isBusy = false;
                  vm['get' + type]();
                }, function (err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });

        }
      };


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable, type, size, parentSelector) {
        if (type) {
          vm.details = { 'qDetails': details };
          vm.modalValue = isEditable;
          vm.modalType = type;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/hierarchyActionModal.html',
            controller: 'HierarchyModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            size: size,
            appendTo: parentElem,
            resolve: {
              data: function () {
                return vm.details;
              },
              hType: function () {
                return vm.modalType;
              },
              model: function () {
                return vm.modalValue;
              }
            }
          }).result.then(function (type) {
            if (type && typeof type == 'string') {
              type = type.charAt(0).toUpperCase() + type.slice(1);
              // vm.init();
              vm['get' + type]();
            }
          }, function () {

          });


        }
      };



    })
    .controller('HierarchyModalController', function (config, _, model, hType, data, Upload, Auth, LoadPageData, $uibModalInstance, $localStorage, $scope, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.isBusy = false;
      vm.submitted = false;
      vm.errors = {};
      vm.hire = {};

      vm.filterUnit = FilterOption().filter;
      vm.filterChapter = FilterOption().filter;
      vm.filterTopic = FilterOption().filter;
      vm.filterGrade = FilterOption().filter;
      vm.isPaid = [{ name: 'Yes', _id: true }, { name: 'No', _id: false }]
      $timeout(function () {
        vm.isEditable = model || false;
        vm.type = hType.toLowerCase();
      }, 100);

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      vm.trustUrl = function (url) {
        return $sce.trustAsResourceUrl(url);
      }

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal = function (type) {

        vm.updated = type;
        $uibModalInstance.close(type);
      }

      /**
        get units as per course functionality
      **/
      vm.getUnits = function (courseId) {

        if ($localStorage.course) {
          vm.course = JSON.parse($localStorage.course);
        }
        if (vm.course) {
          vm.filterUnit.where.course = courseId || vm.course[0]._id;
          vm.filterUnit.type = 'filter';
        };

        LoadPageData.unit.getUnit(vm.filterUnit).$promise.then(function (resp) {
          // console.log('units', resp);
          if (resp && resp.data && resp.data.data) {
            vm.unit = resp.data.data;
            vm.loader = false;
          }
        });


      }
      vm.getUnits();
      /**
        get grades functionality
      **/
      vm.getGrades = function () {

        vm.filterGrade.type = 'filter';
        LoadPageData.hierarchy.getAll({ type: 'grade' }, vm.filterGrade).$promise.then(function (resp) {
          // console.log('grade', resp);
          if (resp && resp.data && resp.data.data) {
            vm.grade = resp.data.data;
          }
        });
      };
      vm.getGrades();
      /**
        get curriculum functionality
      **/
      vm.getCurriculum = function () {
        LoadPageData.curriculum.get().$promise.then(function (resp) {
          // console.log('curriculum', resp);
          if (resp && resp.data) {
            vm.curriculum = resp.data;
          }
        });
      };
      vm.getCurriculum();
      /**
        get chapters as per course unit functionality
      **/
      vm.getChapters = function (unitId) {

        if (unitId) {
          vm.filterChapter.type = 'filter';
          vm.filterChapter.where.course = vm.hire.course;
          vm.filterChapter.where.unit = unitId;

          LoadPageData.chapter.getChapter(vm.filterChapter).$promise.then(function (resp) {
            // console.log('chapter', resp);
            if (resp && resp.data && resp.data.data) {
              vm.chapter = resp.data.data;
            }
          });
        }

      };

      /**
        get grade add remove functionality
      **/
      // vm.options =  [ {id: 1, name:'option 1'},{ id: 2, name: 'option 2'}];

      vm.addGrade = function () {
        if (vm.hire.grade.length < 4) {
          vm.hire.grade.push({ curriculum: '', gradeType: '' });
        }
      }
      vm.delGrade = function (i) {
        if (vm.hire.grade.length > 1) {
          vm.hire.grade.splice(i, 1);
        }
      };

      // ##################  view update form binding ###############

      if (data) {
        var info = data.qDetails;
        vm.hire.grade = [{ curriculum: '', gradeType: '' }];

        if (data.qDetails && !(model == 'new')) {
          console.log(info);
          var qData = Object.assign({}, info);
          if (qData.course) {
            // vm.hire.course = qData.course._id;
            vm.getUnits(qData.course._id);
          }
          if (qData.course && qData.unit) {
            vm.getChapters(qData.unit._id);
          }
          $timeout(function () {
            vm.hire = qData;
            // vm.hire._id = qData._id;
            if (qData.unit) vm.hire.unit = qData.unit._id;
            if (qData.chapter) vm.hire.chapter = qData.chapter._id;
            if (qData.course) vm.hire.course = qData.course._id;
            if (qData.grade) {
              vm.hire.grade = qData.grade;
              if (qData.grade.length) {
                qData.grade.forEach(function (val, i) {
                  vm.hire.grade[i].gradeType = val.gradeType._id;
                })
              }
            }

          }, 1000);

        }
      }

      // ########################### close #############################

      /**
        add new  functionality
      **/
      vm.addHierarchy = function (type, form, fileUrl, name) {
        vm.submitted = true;

        if (form.$valid && !(vm.type == 'topic')) {
          vm.isBusy = true;

          LoadPageData.hierarchy.create({ type: type }, vm.hire).$promise.then(function (res) {
            console.log("hire", res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal(vm.type);
              toastr.success(res.message + ' request added', "Successfully!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });
        }

        if (fileUrl && vm.type == 'topic') {
          vm.isBusy = true;

          Upload.upload({
            url: config.baseUrl + '/api/topic/create',
            data: { data: vm.hire, file: Upload.dataUrltoBlob(fileUrl, name) },
            disableProgress: true
          })
            .then(function (response) {
              $timeout(function () {
                // console.log(response);
                toastr.success(response.message + ' Topic added', "Successfully!");
                vm.isBusy = false;
                vm.cancelUpload();
                vm.updatedModal(vm.type);
                $scope.result = response.data;
              });

            }, function (err) {
              if (err) {
                toastr.error("something went wrong ! try later" + err.message, "Oops!");
                vm.isBusy = false;
                vm.errors.other = error.data.message;
                $timeout(function () { vm.errors = {}; }, 3500);
              }
              console.log("err", err);
            })

        }
        if (vm.type == 'topic' && !fileUrl) {
          toastr.error(' Image file required', "Error!");
        }

      };
      /**
        update functionality
      **/
      vm.updateHierarchy = function (type, form, fileUrl, name) {
        vm.submitted = true;

        if (fileUrl && vm.hire._id && (vm.type == 'topic')) {
          vm.isBusy = true;
          Upload.upload({
            url: config.baseUrl + '/api/topic/update/' + vm.hire._id,
            data: { data: vm.hire, file: Upload.dataUrltoBlob(fileUrl, name) },
            disableProgress: true
          })
            .then(function (response) {
              $timeout(function () {
                // console.log(response);
                toastr.success("Chapter info has Updated! " + response.data.message, "Successful");
                vm.isBusy = false;
                vm.cancelUpload();
                vm.updatedModal(vm.type);
                $scope.result = response.data;
              });

            }, function (err) {
              if (err) {
                toastr.error("something went wrong ! try later" + err.message, "Oops!");
                vm.isBusy = false;
              }
              console.log("err", err);
            })

        } else {

          if (form.$valid && !(vm.type == 'topic')) {
            vm.isBusy = true;

            LoadPageData.hierarchy.update({ type: type, id: vm.hire._id }, vm.hire).$promise.then(function (res) {
              console.log("hire", res);
              if (res) {
                vm.isBusy = false;
                vm.updatedModal(vm.type);
                toastr.success(res.message + ' request updated', "Successfully!");
              }
            }, function (error) {
              console.log(error)
              vm.isBusy = false;
              vm.errors.other = error.data.message;
              $timeout(function () { vm.errors = {}; }, 3500);
            });

          }
          if (form.$valid && (vm.type == 'topic')) {
            vm.isBusy = true;

            LoadPageData.hierarchy.topicUpdate({ type: type, controller: vm.hire._id }, vm.hire).$promise.then(function (res) {
              console.log("hire", res);
              if (res) {
                vm.isBusy = false;
                vm.updatedModal(vm.type);
                toastr.success(res.message + ' request updated', "Successfully!");
              }
            }, function (error) {
              console.log(error)
              vm.isBusy = false;
              vm.errors.other = error.data.message;
              $timeout(function () { vm.errors = {}; }, 3500);
            });

          }

        };
        // else closed


      };

      // ************** image croping uploading ******************

      vm.cancelUpload = function (form) {
        $("#fileInput").val("");
        $scope.myImage = "";
        vm.myCroppedImage = "";
      };
      vm.cancelUpload();

      vm.initLoad = function () {

        var handleFileSelect = function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.myImage = evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
      }


    });


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageCourseCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;

      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 30;

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [5] }])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      //get roles
      vm.getRoles = function () {

        SystemEnum.getParentChild({ id: 4 }).$promise.then(function (res) {
          if (res && res.data) {
            vm.loader = false;
            vm.role = res.data.filter(function (el) { return el.name !== 'admin' });
          }
        },
          function (error) {
          });
      };

      vm.checked = function () {
        Auth.getCurrentUser().$promise.then(function (res) {
          if (res && res.data) {

            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
              vm.user = res.data;
              vm[res.data.role] = true;
            } else {
              // vm.logout();
            }
          }
        },
          function (error) {
          });
      }


      vm.init = function () {
        vm.me = Auth.getCurrentUser();
        vm.checked();
        LoadPageData.course.getCourse(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.courses = res.data.data;
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });

      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredCourses = function () {
        vm.init();
      }


      /**
        delete confirmation sweetalert
      **/
      vm.deleteCourse = function (id) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You want to delete this Subject!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              LoadPageData.course.deleteSubject({ id: id }).$promise.then(function () {
                  SweetAlert.swal("Success", "Subject has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }


      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable) {

        vm.details = { 'details': details };
        vm.modalValue = isEditable;

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/manageCourseModal.html',
          controller: 'CourseModalController',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };


    })
    .controller('CourseModalController', function (config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log,$scope, Upload) {

      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.isBusy = false;

      vm.country = '';//Utility.getGeo();
      vm.course = {};
      vm.errors = {};
      vm.grades = [];

      if (data && model) {
        vm.course = data.details;
      }
        //console.log(vm.course)
        //if (data.details.country) {
         // vm.course.country = data.details.country._id + '';
         // vm.getGradeByCountry(vm.course.country);
        //}
        vm.getImageUrl = function (id) {
          if (id) {
            return config.baseUrl + '/api/gfs/' + id;
          }
        };
        vm.getCurriculum = function () {
          LoadPageData.curriculum.get().$promise.then(function (resp) {
            // console.log('curriculum', resp);
            if (resp && resp.data) {
              vm.curriculum = resp.data;
              console.log(vm.course)
              if (data.details.country) {
               
               vm.course.country = data.details.country+ "";
               vm.course.grade = data.details.grade._id + "";
               vm.getGradeByCountry(vm.course.country);
              }
            
             
            }
          });
        };
        vm.getCurriculum();

      vm.getGradeByCountry = function (countryId) {
        //vm.course.grade="";
        //vm.topic.country =countryId;
        //console.log('CuntryId '+countryId)
        //vm.topic.grade = "";
       //vm.topic.course ="";
       // vm.courses =[];
        vm.grades =[];
        var filter = FilterOption().filter;
        filter.where["country"] = countryId;
        LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
          // console.log("grade",res);
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
            vm.initLoad();

           
           
          }
        });
      }
      vm.getGradeByCountry1 = function (countryId) {
        vm.course.grade="";
        //vm.topic.country =countryId;
        //console.log('CuntryId '+countryId)
        //vm.topic.grade = "";
       //vm.topic.course ="";
       // vm.courses =[];
        vm.grades =[];
        var filter = FilterOption().filter;
        filter.where["country"] = countryId;
        LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
          // console.log("grade",res);
          if (res && res.data && res.data.data) {
            vm.grades = res.data.data;
            vm.initLoad();

           
           
          }
        });
      }
      vm.initLoad = function () {
        var handleFileSelect = function (evt) {
          var file = evt.currentTarget.files[0];
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
              $scope.fileUrl = evt.target.result;
            });
          };
          reader.readAsDataURL(file);
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
      }

      vm.cancel = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
        //$uibModalInstance.dismiss('Close');
      };

      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      vm.saveCourse = function (form) {
        vm.submitted = true;
        

        if (form.$valid) {
          vm.isBusy = true;
          var response = {};
         // if ($scope.fileUrl) {
           // response = Upload.upload({
             // url: config.baseUrl + '/api/course/create/',
            //  data: { data: vm.unit, file: Upload.dataUrltoBlob($scope.fileUrl, name) },
            //  disableProgress: true
          //  });
        //  }
          var filterData={"name":vm.course.name,"country":parseInt(vm.course.country),"grade":parseInt(vm.course.grade)};
          console.log(filterData)
          LoadPageData.FindCourse.getFindCourse(filterData).$promise.then(function (res) {
             console.log(res.data.total)
                if (parseInt(res.data.total)>=1) {
                  var filter = FilterOption().filter;
                    filter.where["_id"] = vm.course._id;
                  LoadPageData.course.getCourse(filter).$promise.then(function (res1) {
                    if (res1 && res1.data && res1.data.data) {
                      var AllData=res1.data.data[0];
                      console.log(AllData)
                      var GradeId=AllData.grade._id;
                      var GradeCountryId=AllData.country;
                      var CourseName=AllData.name;
                      if(vm.course._id!=undefined && CourseName==vm.course.name && GradeCountryId==vm.course.country && GradeId==vm.course.grade){
                        //console.log('hi')
                        response = LoadPageData.course.update({ id: vm.course._id }, {
                          _id: vm.course._id,
                          name: vm.course.name,
                          grade: vm.course.grade,
                          description: vm.course.description,
                          country:vm.course.country
                        })
                        response.$promise.then(function (resp) {
                          // console.log("block user",res);
                          if (resp) {
                            if (resp && resp.message) {
                              toastr.success("Subject Updated Successfully!");
                            };
                            // Account created, redirect to the page with requested a signup
                            vm.updatedModal();
                            vm.isBusy = false;
                          }
                        }, function (err) {
                          err = err.data;
                          vm.errors = {};
                          vm.isBusy = false;
                          if (err && err.error) {
                            angular.forEach(err.error.errors, function (error, field) {
                              form[field].$setValidity('mongoose', false);
                              vm.errors[field] = error.message;
                            });
                          } else {
                            vm.errors = err.message || "something wrong fields !"
                          }
                          if (err && err.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                          }
                        });
                      }
                      else{
                        toastr.error("Subject already exist", "Error");
                      }
                    }
                  });
                  
                }
                else{
                  if (!vm.course._id) {
                    response = LoadPageData.course.create({
                      name: vm.course.name,
                      description: vm.course.description,
                      grade: vm.course.grade,
                      country:vm.course.country
                    });
                  } else {
                    response = LoadPageData.course.update({ id: vm.course._id }, {
                      _id: vm.course._id,
                      name: vm.course.name,
                      grade: vm.course.grade,
                      description: vm.course.description,
                      country:vm.course.country
                    })
                  }
                  response.$promise.then(function (resp) {
                    // console.log("block user",res);
                    if (resp) {
                      if (resp && resp.message) {
                        toastr.success("Subject Created Successfully!");
                      };
                      // Account created, redirect to the page with requested a signup
                      vm.updatedModal();
                      vm.isBusy = false;
                    }
                  }, function (err) {
                    err = err.data;
                    vm.errors = {};
                    vm.isBusy = false;
                    if (err && err.error) {
                      angular.forEach(err.error.errors, function (error, field) {
                        form[field].$setValidity('mongoose', false);
                        vm.errors[field] = error.message;
                      });
                    } else {
                      vm.errors = err.message || "something wrong fields !"
                    }
                    if (err && err.status == -1) {
                      toastr.error("we are offline! try later", "Oops!");
                    }
                  });
                       //  vm.updatedModal();
                        //vm.isBusy = false;
                       // toastr.success("Grade Created Successfully!");
                }
              });

        }
      };





    });


})();


(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageContentsCtrl', function (config, _,  Auth, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.loadContent = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        vm.content = {};
        console.log("ManageContentsCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [5] }])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          SystemEnum.getParentChild({id: 5}).$promise.then(function(res){
            if(res && res.data ){
              console.log(res.data,"res.data")
              vm.loader = false;
              vm.contentList = res.data;
              vm.contentId = vm.contentList[0]._id;
              vm.getContentInfo(vm.contentId);
              // console.log(res) displayName
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();
        vm.getContentInfo = function(id){
          vm.contentId = id
          console.log(vm.contentId,"contentId")
          vm.loadContent = true;
          LoadPageData.content.get({controller: id }).$promise.then(function(res){
            if(res && res.data ){
              vm.loadContent = false;
              vm.content = res.data;
              console.log(res)
            }
          },
          function(error){
            toastr.error("something went wrong", "Oops!");
          });
        };


        /**
          verify content functionality
        **/
        vm.verifyContent = function(Id){
          console.log(Id,"getContentInfogetContentInfo")
          vm.isBusy = true;
          LoadPageData.content.verify({controller: Id }).$promise.then(function(res){
            // console.log("verify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+'Content verified', "Successfully!");
                vm.getContentInfo(vm.contentId);
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };

        /**
          update content functionality
        **/
        vm.updateContent = function(form){
          vm.submitted = true;
         if (form.$valid) {
          vm.isBusy = true;
          vm.content.type = vm.contentId;
        console.log(vm.content.type,"vm.content.type")
        console.log(vm.contentId,"contentId")
        console.log(vm.content,"contentId")
        LoadPageData.content.update({id: vm.contentId }, vm.content ).$promise.then(function(res){
            console.log("story",res);
            if(res){
                vm.isBusy = false;
                vm.getContentInfo(vm.contentId);
                toastr.success(res.message+'content updated', "Successfully!");
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });

         }
       };


        /**
          delete confirmation sweetalert
        **/
        vm.deleteContent = function(id) {
          vm.isBusy = true;
          SweetAlert.swal({
              title: "? Are you sure",
              text: "!Your want to delete this User",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = false;
                LoadPageData.content.delete({id: id}).$promise.then(function(res) {
                  SweetAlert.swal("Success", "request has been deleted", "success");
                  vm.getContentInfo(vm.contentId);
                },function(err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }




});

})();

(function () {

    'use strict';

    angular.module('kapdec')
        .controller('ManageChapterCtrl', function (config, _, Auth, User, SystemEnum, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

            var vm = this;

            vm.viewBy = [30, 45, 60, 90, 100];
            vm.params = $state.params;
            vm.loader = true;
            vm.filterOptions = FilterOption().filter;
            vm.filterOptions.limit = 30;

            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withDOM('lfrtip')
                .withOption('paging', false)
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('status', false)
                .withOption('bInfo', false)
                .withOption('aoColumnDefs', [{bSortable: false, aTargets: [9]}, {
                    class: 'manage-topic-third', targets: 6
                }, {
                    class: 'manage-topic-third', targets: 7
                }])

            vm.getImageUrl = function (id) {
                if (id) {
                    return config.baseUrl + '/api/gfs/' + id;
                }
            };

            //get roles
            vm.getRoles = function () {

                SystemEnum.getParentChild({id: 4}).$promise.then(function (res) {
                        if (res && res.data) {
                            vm.loader = false;
                            vm.role = res.data.filter(function (el) {
                                return el.name !== 'admin'
                            });
                        }
                    },
                    function (error) {
                    });
            };

            vm.checked = function () {
                Auth.getCurrentUser().$promise.then(function (res) {
                        if (res && res.data) {

                            if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
                                vm.user = res.data;
                                vm[res.data.role] = true;
                            } else {
                                // vm.logout();
                            }
                        }
                    },
                    function (error) {
                    });
            }


            vm.init = function () {
                vm.me = Auth.getCurrentUser();
                vm.checked();
                LoadPageData.manageChapter.getAll(vm.filterOptions).$promise.then(function (res) {
                        if (res && res.data && res.data.data) {
                            vm.loader = false;
                            vm.chapters = res.data.data;
                            vm.filterOptions.total = res.data.total;
                        }
                    },
                    function (error) {
                        if (error && error.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });

            };
            vm.init();


            vm.changeFilterOptions = function () {
                if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
                    vm.init();
                }
            }

            vm.getFilteredchapters = function () {
                vm.init();
            }


            /**
             delete confirmation sweetalert
             **/
            vm.deleteChapter = function (id) {
                SweetAlert.swal({
                        title: "Are you sure?",
                        text: "You want to delete this Chapter!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes, delete it",
                        cancelButtonText: "No, cancel it",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            vm.isBusy = false;
                            LoadPageData.manageChapter.delete({id: id}).$promise.then(function () {
                                SweetAlert.swal("Success", "Chapter has been deleted", "success");
                                vm.init();
                            }, function (err) {
                                vm.isBusy = false;
                                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                            })
                        } else {
                            vm.isBusy = false;
                            SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
                        }
                    });
            }


            /**
             open modal for edit view functionality
             **/
            vm.openModal = function (details, isEditable) {

                vm.details = {'details': details};
                vm.modalValue = isEditable;

                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/components/modal/manageChapterModal.html',
                    controller: 'ChapterModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        data: function () {
                            return vm.details;
                        },
                        model: function () {
                            return vm.modalValue;
                        }
                    }
                }).result.then(function (updated) {
                    if (updated) {
                        vm.init();
                    }
                }, function () {

                });


            };
            /**
             open modal for edit view functionality
             **/
            vm.viewChapterContent = function (content) {
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/components/modal/manageContentModel.html',
                    controller: 'adminChapterContentModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    keyboard: true,
                    resolve: {
                        data: function () {
                            return content;
                        }
                    }
                }).result.then(function (updated) {
                    if (updated) {
                        vm.init();
                    }
                }, function () {

                });
            };

        })
        .controller('ChapterModalController', function (config, _, model, $uibModalStack, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, Upload, SweetAlert, $uibModal, $scope, $timeout, toastr, $state, $log) {

            var vm = this;
            $uibModalStack.dismissAll();
            vm.pattern = appPattern;
            vm.submitted = false;
            vm.isBusy = false;
            vm.units = [];
            vm.chapter = {
                isPaid: false
            };
            vm.topics = [];
            vm.courses = [];
            vm.grades = [];
            //vm.chapters = [];
            vm.filterTopic = {};
            vm.errors = {};
            if (data && model) {
                vm.chapter = data.details;
            }
            vm.getCurriculum = function () {
                LoadPageData.curriculum.get().$promise.then(function (resp) {
                    // console.log('curriculum', resp);
                    if (resp && resp.data) {
                        vm.curriculum = resp.data;
                        if (data.details.country) {
                            vm.chapter.country = data.details.country + "";
                            vm.getGradeByCountry(vm.chapter.country);
                            vm.chapter.grade = data.details.grade._id + "";

                        }
                        if (data.details.grade) {
                            vm.chapter.course = data.details.course._id + "";
                        }
                        if (data.details.course) {
                            vm.chapter.topic = data.details.topic._id + "";
                        }
                        if (data.details.topic) {
                            vm.chapter.unit = data.details.unit._id + "";
                        }
                    }
                });
            };
            vm.getCurriculum();

            vm.getGradeByCountry = function (countryId) {
                vm.courses = [];
                vm.grades = [];
                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["country"] = countryId;
                LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data) {
                        vm.grades = res.data.data;
                        vm.initLoad();

                        if (data.details.grade) {
                            vm.getCourse(vm.chapter.grade);
                        }

                    }
                });
            }
            vm.getGradeByCountry1 = function (countryId) {
                vm.chapter.grade = "";
                vm.chapter.topic = "";
                vm.chapter.course = "";
                vm.chapter.unit = "";
                vm.courses = [];
                vm.grades = [];
                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["country"] = countryId;
                LoadPageData.grade.getGrade(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data) {
                        vm.grades = res.data.data;
                        vm.initLoad();

                        if (data.details.grade) {
                            vm.getCourse(vm.chapter.grade);
                        }

                    }
                });
            }
            vm.getCourse = function (gradeId) {

                //vm.topic.course ="19";
                vm.courses = [];
                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["grade"] = gradeId;
                LoadPageData.course.getAll(filter).$promise.then(function (res) {
                        if (res && res.data && res.data.data) {
                            vm.courses = res.data.data;
                            vm.initLoad();

                            if (data.details.course) {
                                vm.getTopics(vm.chapter.course);
                            }
                        }
                    },
                    function (error) {
                        if (error && error.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });
            }
            vm.getCourse1 = function (gradeId) {
                vm.chapter.topic = "";
                vm.chapter.course = "";
                vm.chapter.unit = "";
                //vm.topic.course ="19";
                vm.courses = [];
                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["grade"] = gradeId;
                LoadPageData.course.getAll(filter).$promise.then(function (res) {
                        if (res && res.data && res.data.data) {
                            vm.courses = res.data.data;
                            vm.initLoad();

                            if (data.details.course) {
                                vm.getTopics(vm.chapter.course);
                            }
                        }
                    },
                    function (error) {
                        if (error && error.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });
            }
            vm.getTopics = function (courseId) {

                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["course"] = courseId;
                LoadPageData.topic.getTopic(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data && res.data.data.length) {
                        vm.topics = res.data.data;
                        vm.initLoad();

                        if (data.details.topic) {
                            console.log(vm.chapter.topic)
                            vm.getChapter(vm.chapter.topic);
                        }
                    }
                });

            }
            vm.getTopics1 = function (courseId) {
                vm.chapter.topic = "";
                vm.chapter.unit = "";
                vm.topics = [];
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["course"] = courseId;
                LoadPageData.topic.getTopic(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data && res.data.data.length) {
                        vm.topics = res.data.data;
                        vm.initLoad();

                        if (data.details.topic) {
                            console.log(vm.chapter.topic)
                            vm.getChapter(vm.chapter.topic);
                        }
                    }
                });

            }

            vm.getChapter = function (topicId) {
                console.log(topicId)
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["topic"] = topicId;
                LoadPageData.unit.getUnit(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data && res.data.data.length) {
                        vm.units = res.data.data;
                    }
                });

            }
            vm.getChapter1 = function (topicId) {
                vm.chapter.unit = "";
                vm.units = [];
                var filter = FilterOption().filter;
                filter.where["topic"] = topicId;
                LoadPageData.unit.getUnit(filter).$promise.then(function (res) {
                    if (res && res.data && res.data.data && res.data.data.length) {
                        vm.units = res.data.data;
                    }
                });

            }
            vm.initLoad = function () {
                var handleFileSelect = function (evt) {
                    var file = evt.currentTarget.files[0];
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        $scope.$apply(function ($scope) {
                            $scope.fileUrl = evt.target.result;
                        });
                    };
                    reader.readAsDataURL(file);
                };
                angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
            }

            vm.initLoad();
            vm.getImageUrl = function (id) {
                if (id) {
                    return config.baseUrl + '/api/gfs/' + id;
                }
            };

            //function init() {
            //  vm.filterTopic.type = 'filter';
            //  vm.filterTopic.where = {};
            //  LoadPageData.manageUnit.getAll(FilterOption().filter).$promise.then(function (res) {
            //    if (res && res.data) {
            //      console.log(res)
            //      vm.units = res.data.data;
            //      if (data && model) {
            //        if (data.details.unit) {
            //          vm.chapter.unit = data.details.unit._id + "";
            //        }
            //      }
            //    }
            //  },
            //    function (error) {
            //      if (error && error.status == -1) {
            //        toastr.error("we are offline! try later", "Oops!");
            //      }
            //    });


            //}

            //init();

            vm.cancel = function () {
                // $uibModalInstance.dismiss('Close');
                vm.updated = true;
                $uibModalInstance.close(vm.updated);
            };

            vm.updatedModal = function () {
                vm.updated = true;
                $uibModalInstance.close(vm.updated);
            }

            vm.saveChapter = function (form) {
                vm.submitted = true;

                if (form.$valid) {
                    vm.isBusy = true;
                    var response = {};
                    if (!vm.chapter._id) {

                        //} else {
                        var filterData = {
                            "name": vm.chapter.name,
                            "country": parseInt(vm.chapter.country),
                            "grade": parseInt(vm.chapter.grade),
                            "course": parseInt(vm.chapter.course),
                            "topic": parseInt(vm.chapter.topic),
                            "unit": parseInt(vm.chapter.unit)
                        };
                        LoadPageData.CheckChapter.getCheckChapter(filterData).$promise.then(function (res) {
                            if (parseInt(res.data.total) >= 1) {
                                toastr.error("Chapter already exist", "Error");

                            } else {
                                if ($scope.fileUrl) {

                                    response = Upload.upload({
                                        url: config.baseUrl + '/api/chapter/create/',
                                        data: {data: vm.chapter, file: Upload.dataUrltoBlob($scope.fileUrl, name)},
                                        disableProgress: true
                                    });
                                } else {
                                    response = LoadPageData.manageChapter.create(vm.chapter).$promise;
                                }

                                //response = LoadPageData.manageTopic.create(vm.topic).$promise;
                            }
                            response.then(function (resp) {
                                console.log("block user",resp);
                                if (resp) {
                                    if (resp && resp.message) {
                                        toastr.success("Chapter Created Successfully!");
                                        //toastr.success("Registered !" + resp.message, "Successfully!");
                                    }
                                    vm.updatedModal();
                                    vm.isBusy = false;
                                    // Account created, redirect to the page with requested a signup
                                }
                            }, function (err) {
                                err = err.data;
                                vm.errors = {};
                                vm.isBusy = false;
                                if (err && err.error) {
                                    angular.forEach(err.error.errors, function (error, field) {
                                        form[field].$setValidity('mongoose', false);
                                        vm.errors[field] = error.message;
                                    });
                                } else {
                                    vm.errors = err.message || "something wrong fields !"
                                }
                                if (err && err.status == -1) {
                                    toastr.error("we are offline! try later", "Oops!");
                                }
                            });
                        });
                        //response = LoadPageData.manageChapter.create(vm.chapter).$promise;
                        // }

                    } else {

                        //} else {
                        var filterData = {
                            "name": vm.chapter.name,
                            "country": parseInt(vm.chapter.country),
                            "grade": parseInt(vm.chapter.grade),
                            "course": parseInt(vm.chapter.course),
                            "topic": parseInt(vm.chapter.topic),
                            "unit": parseInt(vm.chapter.unit)
                        };
                        LoadPageData.CheckChapter.getCheckChapter(filterData).$promise.then(function (res) {
                            if (parseInt(res.data.total) >= 1) {
                                var filter = FilterOption().filter;
                                filter.where["_id"] = vm.chapter._id;
                                LoadPageData.chapter.getChapter(filter).$promise.then(function (res1) {
                                    if (res1 && res1.data && res1.data.data) {
                                        var AllData = res1.data.data[0];
                                        console.log(AllData)
                                        var chapterName = AllData.name;

                                        var TopicCountryId = AllData.country;
                                        var GradeId = AllData.grade;
                                        var CourseId = AllData.course;
                                        var TopicId = AllData.topic;
                                        var UnitId = AllData.unit;
                                        // console.log(chapterName+","+TopicCountryId+","+GradeId+","+CourseId+","+TopicId+","+UnitId)
                                        // console.log(vm.topic)
                                        if (chapterName == vm.chapter.name && TopicCountryId == vm.chapter.country && CourseId == vm.chapter.course && TopicId == vm.chapter.topic) {
                                            // response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                                            if ($scope.fileUrl) {

                                                response = Upload.upload({
                                                    url: config.baseUrl + '/api/chapter/update/' + vm.chapter._id,
                                                    data: {
                                                        data: vm.chapter,
                                                        file: Upload.dataUrltoBlob($scope.fileUrl, name)
                                                    },
                                                    disableProgress: true
                                                });
                                            } else {
                                                response = LoadPageData.manageChapter.update({controller: vm.chapter._id}, vm.chapter).$promise
                                            }

                                            response.then(function (resp) {
                                                // console.log("block user",res);
                                                if (resp) {
                                                    if (resp && resp.message) {
                                                        toastr.success("Chapter Updated Successfully!");
                                                        //toastr.success("Registered !" + resp.message, "Successfully!");
                                                    }
                                                    ;
                                                    // Account created, redirect to the page with requested a signup
                                                    vm.updatedModal();
                                                    vm.isBusy = false;
                                                }
                                            }, function (err) {
                                                err = err.data;
                                                vm.errors = {};
                                                vm.isBusy = false;
                                                if (err && err.error) {
                                                    angular.forEach(err.error.errors, function (error, field) {
                                                        form[field].$setValidity('mongoose', false);
                                                        vm.errors[field] = error.message;
                                                    });
                                                } else {
                                                    vm.errors = err.message || "something wrong fields !"
                                                }
                                                if (err && err.status == -1) {
                                                    toastr.error("we are offline! try later", "Oops!");
                                                }
                                            });
                                        } else {
                                            // console.log('hi')
                                            toastr.error("Chapter already exist", "Error");
                                        }

                                    }
                                });

                                //

                            } else {
                                response = LoadPageData.manageChapter.update({controller: vm.chapter._id}, vm.chapter).$promise
                                //response = LoadPageData.manageTopic.update({ controller: vm.topic._id }, vm.topic).$promise
                            }
                            response.then(function (resp) {
                                // console.log("block user",res);
                                if (resp) {
                                    if (resp && resp.message) {
                                        toastr.success("Chapter Updated Successfully!");
                                        //toastr.success("Registered !" + resp.message, "Successfully!");
                                    }
                                    ;
                                    // Account created, redirect to the page with requested a signup
                                    vm.updatedModal();
                                    vm.isBusy = false;
                                }
                            }, function (err) {
                                err = err.data;
                                vm.errors = {};
                                vm.isBusy = false;
                                if (err && err.error) {
                                    angular.forEach(err.error.errors, function (error, field) {
                                        form[field].$setValidity('mongoose', false);
                                        vm.errors[field] = error.message;
                                    });
                                } else {
                                    vm.errors = err.message || "something wrong fields !"
                                }
                                if (err && err.status == -1) {
                                    toastr.error("we are offline! try later", "Oops!");
                                }
                            });
                        });
                        // response = LoadPageData.manageChapter.update({ controller: vm.chapter._id }, vm.chapter).$promise;
                        //}
                    }

                    response.then(function (resp) {
                        // console.log("block user",res);
                        if (resp) {
                            if (resp && resp.message) {
                                toastr.success("Chapter Updated Successfully!");
                                //toastr.success("Registered !" + resp.message, "Successfully!");
                            }
                            ;
                            // Account created, redirect to the page with requested a signup
                            vm.updatedModal();
                            vm.isBusy = false;
                        }
                    }, function (err) {
                        err = err.data;
                        vm.errors = {};
                        vm.isBusy = false;
                        if (err && err.error) {
                            angular.forEach(err.error.errors, function (error, field) {
                                form[field].$setValidity('mongoose', false);
                                vm.errors[field] = error.message;
                            });
                        } else {
                            vm.errors = err.message || "something wrong fields !"
                        }
                        if (err && err.status == -1) {
                            toastr.error("we are offline! try later", "Oops!");
                        }
                    });

                }
            };

        })
        .controller('adminChapterContentModalController', function (config, _, data, User, Utility, Auth, appPattern, LoadPageData, $uibModalInstance, toastr) {
            var vm = this;

            vm.cancel = function () {
                $uibModalInstance.dismiss('Close');
            };
            vm.content = data;
            $uibModalInstance.rendered.then(function(){
                matchEqRender();
            });
        });


})();


(function () {

  'use strict';

  angular.module('kapdec')
    .controller('ManageCareerCtrl', function (config, _, Auth, ContactInfo, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

      var vm = this;
     
      vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.submitted = false;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.where["career"]=true
      vm.filterOptions.limit = 30;
      console.log("ManageEnquiryCtrl");

      vm.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('lfrtip')
        .withOption('paging', false)
        .withOption('searching', false)
        .withOption('lengthChange', false)
        .withOption('status', false)
        .withOption('bInfo', false)
        .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [8] },{class: 'manage-enquiry-first', targets: 1},{class: 'manage-enquiry-four', targets: 4},{class: 'manage-enquiry-five', targets: 5},{class: 'manage-enquiry-seven', targets: 7}])

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };


      vm.init = function () {
        ContactInfo.get(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.enquiryList = res.data.data;
            
            vm.filterOptions.total = res.data.total;
            // console.log(res)
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();


      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
        }
      }

      vm.getFilteredEnquiry = function () {
        vm.init();
      }

      /**
        delete confirmation sweetalert
      **/
      vm.deleteEnquiry = function (id) {
        vm.isBusy = true;
        SweetAlert.swal({
          title: "Are you sure?",
          text: "You want to delete this career!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it",
          cancelButtonText: "No, cancel it",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              vm.isBusy = false;
              ContactInfo.delete({ id: id }).$promise.then(function (res) {
                SweetAlert.swal("Success", "Career has been deleted", "success");
                vm.init();
              }, function (err) {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
              })
            } else {
              vm.isBusy = false;
              SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
            }
          });
      }

      /**
        open modal for edit view functionality
      **/
      vm.openModal = function (details, isEditable, size, parentSelector) {

        vm.details = { 'details': details };
        vm.modalValue = isEditable;
        var parentElem = parentSelector ?
          angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/contactEnquiryAction.html',
          controller: 'EnquiryModalController',
          controllerAs: 'vm',
          size: size,
          backdrop: 'static',
          keyboard: false,
          appendTo: parentElem,
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
            vm.init();
          }
        }, function () {

        });


      };

      vm.viewChapterContent = function (content) {
        
        //console.log(content)
       // window.open(content)
       window.open("data:application/octet-stream;charset=utf-16le;base64,"+content);
       // window.open("data:application/pdf," + escape(content));
      };


    })
    .controller('CareerModalController', function (config, _, appPattern, model, data, $sce, Auth, ContactInfo, $uibModalInstance, $localStorage, FilterOption, DTOptionsBuilder, SweetAlert, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;
      vm.updated = false;
      vm.loader = true;
      vm.pattern = appPattern;
      vm.isBusy = false;
      vm.submitted = false;
      vm.errors = {};
      vm.enquiry = {};

      $timeout(function () {
        vm.isEditable = model || false;
      }, 100);

      /**
        open modal closed functionality
      **/
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };
      vm.updatedModal = function () {
        vm.updated = true;
        $uibModalInstance.close(vm.updated);
      }

      // ##################  view update form binding ###############

      if (data && data.details) {
        vm.loader = false;
        vm.enquiry = data.details;
      }

      /**
        reply Enquiry functionality
      **/
      vm.replyEnquiry = function (form) {
        vm.submitted = true;
        if (form.$valid) {
          vm.isBusy = true;

          ContactInfo.update({ id: vm.enquiry._id }, vm.enquiry).$promise.then(function (res) {
            // console.log("enquiry",res);
            if (res) {
              vm.isBusy = false;
              vm.updatedModal();
              toastr.success(res.message || '  Reply Sent', "Successfully!");
            }
          }, function (error) {
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
            toastr.error("Somthing is Wrong", "Error");
          });

        }
      };



    });

})();



(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageBannerCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageUserCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
          .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [7] }])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          LoadPageData.banner.getAll(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.bannerList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredBanners = function(){
          vm.init();
        }


        /**
          verify banners functionality
        **/
        vm.verifyBanners = function(bannerId){
          vm.isBusy = true;

          LoadPageData.banner.verify({controller: bannerId }).$promise.then(function(res){
            console.log("bannerverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Banner verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };

        /**
          delete confirmation sweetalert
        **/
        vm.deleteBanners = function(id) {
            vm.isBusy = true;
          SweetAlert.swal({
              title: "? Are you sure",
              text: "!Your want to delete this User",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = false;
                LoadPageData.banner.remove({id: id}).$promise.then(function(res) {
                  vm.init();
                  SweetAlert.swal("Success", "Banner has been deleted", "success");
                },function(err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }



        /**
          open modal for edit view functionality
        **/
        vm.openModal = function(details, isEditable, size, parentSelector) {

          vm.details = { 'details': details  };
          vm.modalValue = isEditable;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/manageBannerAction.html',
            controller: 'BannerModalController',
            controllerAs: 'vm',
            size: size,
            appendTo: parentElem,
            backdrop: 'static',
            keyboard: false,
             resolve: {
              data: function() {
                return vm.details;
              },
              model: function() {
                return vm.modalValue;
              }
            }
          }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };


  })
  .controller('BannerModalController', function(config, _, Upload, model, data, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, $scope, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
        var vm = this;
        vm.updated = false;
        vm.loader  =  true;
        vm.isBusy = false;
        vm.pattern = appPattern;
        vm.submitted = false;
        vm.errors = {};
        vm.banner   = {};

        $timeout(function() {
          vm.isEditable = model || false;
        }, 100);

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        /**
          open modal closed functionality
        **/
        vm.cancel = function () {
            $uibModalInstance.dismiss('Close');
        };
        vm.updatedModal =function(){
          vm.updated = true;
          $uibModalInstance.close(vm.updated);
        }

    // ##################  view update form binding ###############

     if(data){
       vm.banner    = data.details;
       vm.loader  =  false;
       console.log(data);

       if(data.details && !(model == 'new') ){
         var badgeData = data.details;

         $timeout(function() {
           // vm.ques = quesData;
           // vm.ques._id = quesData._id;
           // vm.ques.unit = quesData.unit._id;
           // vm.ques.chapter = quesData.chapter._id;
         }, 2000);

       }
     }


// ************** image croping uploading ******************

      vm.cancelUpload = function(form){
          $("#fileInput").val("");
          $scope.myImage= "";
          vm.myCroppedImage="";
      };
      vm.cancelUpload();

     vm.initLoad = function(){

      var handleFileSelect=function(evt) {
         var file=evt.currentTarget.files[0];
         var reader = new FileReader();
         reader.onload = function (evt) {
           $scope.$apply(function($scope){
             $scope.myImage=evt.target.result;
           });
         };
         reader.readAsDataURL(file);
       };
       angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect );
    }

       /**
         update banner functionality
       **/
       vm.updateBanners = function(form, fileUrl, name){

           vm.submitted = true;

           if(fileUrl && vm.banner._id){

              Upload.upload({
                    url: config.baseUrl+'/api/banner/update/'+vm.banner._id,
                    data: { data: vm.banner, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success("Banner has Updated! "+response.data.message, "Successful");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                 }
                console.log("err",err);
             })

          }else{
             if (form.$valid) {
              vm.isBusy = true;

              LoadPageData.banner.update({ controller : vm.banner._id },vm.banner).$promise.then(function(res){
                // console.log("badge",res);
                if(res){
                    vm.isBusy = false;
                    vm.updatedModal();
                    toastr.success(res.message+' banner updated', "Successfully!");
                 }
               }, function(error){
                   console.log(error)
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
               });

             }
         }

       };

       /**
         add new banner functionality
       **/
       vm.addBanners = function(form, fileUrl, name){
           vm.submitted = true;

           if( form.$valid ){
             if( fileUrl ){

              Upload.upload({
                    url: config.baseUrl+'/api/banner/create',
                    data: { data: vm.banner, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success(response.message+' Banner added', "Successfully!");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
                 }
                console.log("err",err);
             })

           }else{
             toastr.error(' Image file required', "Error!");
           }

          }

       };





});


})();


(function() {

'use strict';

angular.module('kapdec')
    .controller('ManageBadgesCtrl', function (config, _,  Auth, User, LoadPageData, FilterOption, SweetAlert, $sce, DTOptionsBuilder, $uibModal, $timeout, toastr, $state, $log) {

        var vm = this;

        vm.viewBy = [30, 45, 60, 90, 100];
        vm.params = $state.params;
        vm.loader = true;
        vm.filterOptions   = FilterOption().filter;
        vm.filterOptions.limit = 30;
        console.log("ManageBadgesCtrl");

        vm.dtOptions = DTOptionsBuilder.newOptions()
          .withDOM('lfrtip')
          .withOption('paging', false)
          .withOption('searching', false)
          .withOption('lengthChange', false)
          .withOption('status', false)
          .withOption('bInfo', false)
            .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [1] },{ bSortable: false, aTargets: [8] }])

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };


        vm.init = function(){
          LoadPageData.badges.getAll(vm.filterOptions).$promise.then(function(res){
            if(res && res.data && res.data.data ){
              vm.loader = false;
              vm.badgeList = res.data.data;
              vm.filterOptions.total = res.data.total;
              // console.log(res)
            }
          },
          function(error){
              if(error && error.status == -1 ){
                toastr.error("we are offline! try later", "Oops!");
              }
          });
        };
        vm.init();


        vm.changeFilterOptions = function() {
          if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
            vm.init();
          }
        }

        vm.getFilteredBadges = function(){
          vm.init();
        }

        /**
          verify badges functionality
        **/
        vm.verifyBadges = function(badgeId){
          vm.isBusy = true;

          LoadPageData.badges.verify({controller: badgeId }).$promise.then(function(res){
            console.log("badgeverify",res);
            if(res){
                vm.isBusy = false;
                toastr.success(res.message+' Badge verified', "Successfully!");
                vm.init();
             }
           }, function(error){
               console.log(error)
               vm.isBusy = false;
               toastr.error(error.data.message+'something went wrong', "Error!");
           });
        };

        /**
          delete confirmation sweetalert
        **/
        vm.deleteBadge = function(id) {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "You want to delete this Badge!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "No, cancel it",
              closeOnConfirm: false,
              closeOnCancel: false
            },
            function(isConfirm) {
              if (isConfirm) {
                vm.isBusy = false;
                LoadPageData.badges.remove({id: id}).$promise.then(function() {
                  vm.init();
                  SweetAlert.swal("Success", "Badge has been deleted", "success");
                },function(err) {
                  vm.isBusy = false;
                  SweetAlert.swal("Cancelled", "something went wrong! request has been cancelled", "error");
                })
              } else {
                vm.isBusy = false;
                SweetAlert.swal("Cancelled", "Your request has been cancelled", "error");
              }
            });
        }



        /**
          open modal for edit view functionality
        **/
        vm.openModal = function(details, isEditable, size, parentSelector) {

          vm.details = { 'details': details  };
          vm.modalValue = isEditable;
          var parentElem = parentSelector ?
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
          $uibModal.open({
            animation: true,
            templateUrl: 'app/components/modal/badgeActionModal.html',
            controller: 'BadgeModalController',
            controllerAs: 'vm',
            size: size,
            appendTo: parentElem,
            backdrop: 'static',
            keyboard: false,
              resolve: {
              data: function() {
                return vm.details;
              },
              model: function() {
                return vm.modalValue;
              }
            }
          }).result.then(function(updated) {
            if (updated) {
              vm.init();
            }
          }, function() {

          });


        };


  })
  .controller('BadgeModalController', function(config, _, Upload, model, data, Auth, appPattern, LoadPageData, $uibModalInstance, $localStorage, FilterOption, $sce, $scope, SweetAlert, $uibModal, $timeout, toastr, $state, $log ) {
        var vm = this;
        vm.updated = false;
        vm.loader  =  true;
        vm.isBusy = false;
        vm.pattern = appPattern;
        vm.submitted = false;
        vm.errors = {};
        vm.badge   = {};

        $timeout(function() {
          vm.isEditable = model || false;
        }, 100);

        vm.getImageUrl = function(id){
          if(id){
          return config.baseUrl+'/api/gfs/'+id;
          }
        };

        /**
          open modal closed functionality
        **/
        vm.cancel = function () {
            $uibModalInstance.dismiss('Close');
        };
        vm.updatedModal =function(){
          vm.updated = true;
          $uibModalInstance.close(vm.updated);
        }

    // ##################  view update form binding ###############

     if(data){
       vm.badge = data.details;
       vm.loader  =  false;
       console.log(data);

       if(data.details && !(model == 'new') ){
         var badgeData = data.details;

         $timeout(function() {
           // vm.ques = quesData;
           // vm.ques._id = quesData._id;
           // vm.ques.unit = quesData.unit._id;
           // vm.ques.chapter = quesData.chapter._id;
         }, 2000);

       }
     }

    // ########################### close #############################

    /**
      add new badge functionality
    **/
    vm.addBadgesx = function(form){
      vm.submitted = true;
     if (form.$valid) {
      vm.isBusy = true;

      LoadPageData.badges.create( vm.badge ).$promise.then(function(res){
        console.log("badge",res);
        if(res){
            vm.isBusy = false;
            vm.updatedModal();
            toastr.success(res.message+' badge added', "Successfully!");
         }
       }, function(error){
           console.log(error)
           vm.isBusy = false;
           vm.errors.other = error.data.message;
           $timeout(function(){ vm.errors ={}; },3500);
       });
     }

    };
    /**
      update badge functionality
    **/
    vm.updateBadgesX = function(form){
      vm.submitted = true;
     if (form.$valid) {
      vm.isBusy = true;

      LoadPageData.badges.update({id: vm.badge._id },vm.badge).$promise.then(function(res){
        console.log("badge",res);
        if(res){
            vm.isBusy = false;
            vm.updatedModal();
            toastr.success(res.message+' badge updated', "Successfully!");
         }
       }, function(error){
           console.log(error)
           vm.isBusy = false;
           vm.errors.other = error.data.message;
           $timeout(function(){ vm.errors ={}; },3500);
       });

     }
    };


// ************** image croping uploading ******************

      vm.cancelUpload = function(form){
          $("#fileInput").val("");
          $scope.myImage= "";
          vm.myCroppedImage="";
      };
      vm.cancelUpload();

     vm.initLoad = function(){

      var handleFileSelect=function(evt) {
         var file=evt.currentTarget.files[0];
         var reader = new FileReader();
         reader.onload = function (evt) {
           $scope.$apply(function($scope){
             $scope.myImage=evt.target.result;
           });
         };
         reader.readAsDataURL(file);
       };
       angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect );
    }

       /**
         update badge functionality
       **/
       vm.updateBadges = function(form, fileUrl, name){

           vm.submitted = true;

           if(fileUrl && vm.badge._id){

              Upload.upload({
                    url: config.baseUrl+'/api/badge/update/'+vm.badge._id,
                    data: { data: vm.badge, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success("Badge has Updated! "+response.data.message, "Successful");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                 }
                console.log("err",err);
             })

          }else{
             if (form.$valid) {
              vm.isBusy = true;

              LoadPageData.badges.update({ controller : vm.badge._id },vm.badge).$promise.then(function(res){
                // console.log("badge",res);
                if(res){
                    vm.isBusy = false;
                    vm.updatedModal();
                    toastr.success(res.message+' badge updated', "Successfully!");
                 }
               }, function(error){
                   console.log(error)
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
               });

             }
         }

       };

       /**
         add new badge functionality
       **/
       vm.addBadges = function(form, fileUrl, name){
           vm.submitted = true;

           if( form.$valid ){
             if( fileUrl ){

              Upload.upload({
                    url: config.baseUrl+'/api/badge',
                    data: { data: vm.badge, file: Upload.dataUrltoBlob(fileUrl, name) },
                    disableProgress: true
              })
              .then(function (response) {
                    $timeout(function () {
                        // console.log(response);
                        toastr.success(response.message+' badge added', "Successfully!");
                        vm.isBusy = false;
                        vm.cancelUpload();
                        vm.updatedModal();
                        $scope.result = response.data;
                    });

             }, function(err){
                 if(err){
                   toastr.error("something went wrong ! try later"+err.message, "Oops!");
                   vm.isBusy = false;
                   vm.errors.other = error.data.message;
                   $timeout(function(){ vm.errors ={}; },3500);
                 }
                console.log("err",err);
             })

           }else{
             toastr.error(' Image file required', "Error!");
           }

          }

       };












});


})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('EditAdminProfileCtrl', function (appPattern, User, toastr, $uibModal, Upload, config, Auth, $log, $scope, $timeout) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = {};

      // console.log("EditProfileCtrl");

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.init = function () {
        vm.submitted = false;
        User.get().$promise.then(function (res) {
          if (res && res.data) {
            vm.user = res.data;
            
            //vm.user.dob = moment(res.data.dob).add(-1,'days').format('MM/dd/YYYY');
            // console.log(res.data.profilePicture);
            vm.fullName = vm.user.name;
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
      };
      vm.init();

      vm.upload = function (form) {

        vm.submitted = true;
        if (!vm.fullName) return false;
        vm.user.name = vm.fullName;
        if ((vm.password || vm.confirmPassword) && !(vm.password === vm.confirmPassword)) return false;
        if (vm.password && vm.confirmPassword) vm.user.password = vm.password;

        vm.loader = true;

        if (form.$valid) {
          User.update({ data: vm.user }).$promise.then(function (res) {
            if (res && res.data) {
              vm.init();
              vm.loader = false;
              toastr.success("Profile has Updated! " + res.message, "Successful");
            }
          },
            function (error) {
              if (error) {
                vm.init();
                vm.loader = false;
                toastr.error(error.data.message, "Oops!");
              }
            });
        }

      };

      vm.changeImage = function () {

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/editProfileImageModal.html',
          controller: 'EditProfileImageCtrl',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.user;
            }
          }
        }).result.then(function () {
            vm.init();
        }, function () {

        });


      };
    }).controller('EditProfileImageCtrl', function (appPattern, $state, data, toastr, $uibModalInstance, Upload, config, Auth, $log, $scope, $timeout) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = data;

      vm.cancelUpload = function () {

        $("#fileInput").val("");
        $scope.myImage = "";
        vm.myCroppedImage = '';
      };
      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };
      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      $scope.uploadPic = function (file) {
        file.upload = Upload.upload({
          url: 'https://angular-file-upload-cors-srv.appspot.com/upload',
          data: { username: $scope.username, file: file },
        });

        file.upload.then(function (response) {
          $timeout(function () {
            file.result = response.data;
          });
        }, function (response) {
          if (response.status > 0)
            $scope.errorMsg = response.status + ': ' + response.data;
        }, function (evt) {
          // Math.min is to fix IE which reports 200% sometimes
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

      }

      vm.watchUpdateImage = function (isDone) {
        $timeout(function () {
          $scope.$emit("uploaded", { update: isDone });
          location.reload();
        }, 2000);
      }

      vm.upload = function (fileUrl, name) {

        Upload.upload({
          url: config.baseUrl + '/api/users/update',
          data: { data: vm.user, file: Upload.dataUrltoBlob(fileUrl, name) },
          disableProgress: true
        })
          .then(function (response) {
            $timeout(function () {
              // console.log(response);
              toastr.success("Profile has Updated! " + response.data.message, "Successful");
              vm.watchUpdateImage(true);
              vm.loader = false;
              vm.cancelUpload();
              $scope.result = response.data;
            });
          }, function (err) {
            if (err) {
              toastr.error("something went wrong ! try later  " + err.message, "Oops!");
              vm.init();
              vm.loader = false;
            }
            console.log("err", err);
          })
      }

      $scope.onSelectFile = function (model) {

        var file = model.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
          $scope.$apply(function ($scope) {
            $scope.myImage = evt.target.result;
          });
        };
        reader.readAsDataURL(file);
      }

    });



})();



'use strict';

angular.module('kapdec')
    .controller('AdminDashboardCtrl', function (config, $log, Auth, $uibModalStack, $state ) {
        var vm = this;
        $uibModalStack.dismissAll();

        vm.getImageUrl = function(id){
          return config.baseUrl+'/api/gfs/'+id;
        };

        /**
          on init functionality
        **/
        vm.init = function(){
          try{

            Auth.getCurrentUser().$promise.then(function(res){
              if(res && res.data ){
                vm.user = res.data;
              }
            },
            function(error){
                if(error && error.status == -1 ){
                  toastr.error("we are offline! try later", "Oops!");
                }
            });

          }
          catch(err){
            // vm.logout();
             // $state.go('index.home');
          }

        };
        vm.init();



        console.log("Dashboard-admin-Ctrl");

});

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('PartialCtrl', function (config, appPattern, $log, LoadPageData, toastr, $uibModal) {
      var vm = this;
      vm.pattern = appPattern;

      // console.log("partialCtrl");

      // ####### footer newsletter #########################
      vm.submit = false;
      vm.subscriber = {};
      vm.subscribe = function (form) {
        console.log(form,"index.privacy")
        vm.submit = true;
        if (form.$valid) {
          // console.log(vm.subscriber);
          LoadPageData.subscriber.add(vm.subscriber).$promise.then(function (response) {

            vm.subscriber = {};
            vm.submit = false;
            toastr.success(response.message , "Information!");

          }, function (error) {
            toastr.error("Something Went worng, Please try again", "Error!");
            vm.submit = false;
            console.log(error);
          });
        }
      };
      vm.items = ['item1', 'item2', 'item3'];
      vm.login = function () {
        var modalInstance = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/accounts/login/login.html',
          controller: 'LoginCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {

          }
        });
      }

      vm.signup = function () {
        var modalInstance = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/accounts/signup/signup.html',
          controller: 'SignupCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          keyboard: false,
          resolve: {

          }
        });
      }
    });

})();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('VerifyCtrl', function ($uibModalStack, User, Auth, verifyEmail, $location, toastr, $state) {
      var vm = this;
      $uibModalStack.dismissAll();
      vm.isVerifySuccess = false;

      vm.invalid = function () {
        toastr.error("Oops! Invalid form");
        $state.go('index.notFound404');
      };
      // vm.newUser = $location.search().u;
      vm.initial = function () {
        Auth.logout();

        if ($state.params.token) {

          try {
            var params = JSON.parse(Base64.decode($state.params.token));

            if (params && params.token && params.type && params.type.name) {
              vm.token = params.token;
              vm.type = params.type.name;
              if (vm.type == 'v_signup') {
                vm.verifyType = "SignUp Email";

                verifyEmail.send({ token: $state.params.token }).$promise.then(function (response) {
                  //console.log(response);
                  if(response.data){
                    vm.AllData=response.data;
                  }
                 
                  if (response.data.role == 'student') {
                    toastr.success("Your free Subscription is activated", "Successfully!");
                  }
                  vm.isVerifySuccess = true;
                }, function (error) {
                  if (error) {
                    vm.invalid();
                  }
                });
              }
              if (vm.type == 'v_password') {
                vm.verifyType = "Reset Password";
                Auth.logout();
                $state.go('index.reset', { token: $state.params.token });
              }
            } else {
              vm.invalid();
            }
          } catch (err) {
            vm.invalid();
          }

        } else {
          vm.invalid();
        }


      };
      vm.initial();



    });

})(); 

(function () {

    'use strict';

    angular.module('kapdec')
        .controller('signupinviteCtrl', function ($scope, Auth, appPattern, Utility,User, config, $state, $timeout, $window, $location, FilterOption, LoadPageData, $stateParams, toastr, Facebook,addChildrenAddTeacher) {

            var vm = this;
           // $uibModalStack.dismissAll();
            vm.pattern = appPattern;
            vm.submitted = false;
            vm.params = $state.params;
            vm.bellowAge = false;
            vm.teacherlogin = true;
            vm.grades = [];
            vm.country = Utility.getGeo();
            vm.user = {};
            vm.user.role = 'student';
            vm.errors = {};
            vm.user.rolename="";
            //vm.user.dob=moment().add(-1, 'years').format("YYYY-MM-DD");
             vm.maxDate = moment().add(-1, 'years').format("YYYY-MM-DD");
             //console.log(vm.maxDate)
           //vm.maxDate="";
            vm.initial = function () {
                if (Auth.isLoggedIn()) {
                    $state.go('dashboard.view');
                }
               
               
                if (vm.params && vm.params.token) {
                    User.getByUid({id:vm.params.token}).$promise.then(function (response1) {
                        console.log(response1.data.userDetails)
                        if(response1.data.userDetails){
                           if(response1.data.userDetails.role=="parent")
                           {
                           //console.log(response1.data)
                           vm.user.parentEmail=response1.data.userDetails.email;
                           //console.log(vm.user.parentEmail)
                           }
                        }
                        
                    });
                    vm[vm.params.type + 'login'] = true;
                    window.document.title = 'Kapdec | Signup';
                }
                else{
                    $state.go('index.home');
                }
                if(vm.country.country_code=="IN"){
                    vm.filter = FilterOption().filter;
                    // local
                   // vm.filter.where.country = "3";
                    //online
                   vm.filter.where.country = "63";
                   vm.CountryCode="+91";
                  }
                  else{
                   // vm.filter = FilterOption().filter;
                    //local
                   // vm.filter.where.country = "209";
                    // Online
                     vm.filter.where.country = "229";
                     vm.CountryCode="+1";
                  }
             
                LoadPageData.grade.getGrade(vm.filter).$promise.then(function (res) {
                    // console.log("grade",res);
                    if (res && res.data && res.data.data) {
                        vm.grades = res.data.data;
                    }
                });
            }
            vm.initial();

            vm.cancel = function () {
                $uibModalInstance.dismiss('Close');
                $state.go('index.home');
            };

            vm.changerole = function (role) {
                vm.user = {};
                vm.user.role = role;
                vm.bellowAge = false;
                vm.maxDate = moment().add(-2, 'years').format("YYYY-MM-DD");
                vm.submitted = false;
                if (role === 'teacher') {
                    vm.user.dob = "";
                    vm.maxDate = moment().add(-18, 'years').format("YYYY-MM-DD");
                }
            }

            vm.changeGrades = function () {
                if (vm.user.grades.length > 2) {
                    toastr.info("You can select only 2 grades. ", "Information");
                    var rr = vm.user.grades.splice(1, 1);
                }
            }
            
            vm.checkStudentAge = function (date) {
               
                if (vm.user.role === 'student') {
                    vm.bellowAge = false;
                    var currentYear = moment().add(-1,'days').add(-13, 'years');
                    var selectedYear = moment(date);
                    console.log(currentYear+","+selectedYear)
                    var diffrentdate = currentYear.diff(selectedYear, 'days')
                   // console.log(diffrentdate)
                    if (diffrentdate < 0) {
                        vm.bellowAge = true;
                    } else {
                        vm.bellowAge = false;
                    }
                }
            }

            // vm.selectLoginType = function(loginType) {
            //     vm[loginType] = true;
            //     vm.submitted = false;
            //     vm.user ={};
            //     if (loginType == 'teacherlogin') {
            //         vm.studentlogin = false;
            //         vm.parentlogin = false;
            //         window.document.title = 'Kapdec | Signup for teacher';
            //     }
            //     if (loginType == 'studentlogin') {
            //         vm.teacherlogin = false;
            //         vm.parentlogin = false;
            //         window.document.title = 'Kapdec | Signup for student';
            //         vm.user.terms  = true;
            //     }
            //     if (loginType == 'parentlogin') {
            //         vm.teacherlogin = false;
            //         vm.studentlogin = false;
            //         window.document.title = 'Kapdec | Signup for parent';
            //         vm.user.terms  = true;
            //     }
            // }


            vm.register = function (form) {
                vm.submitted = true;
                // vm.user.role = vm.teacherlogin ? 'teacher' : vm.studentlogin ? 'student' : 'parent';
                if (vm.params && vm.params.token) {
                   // vm[vm.params.type + 'login'] = true;
                   // window.document.title = 'Kapdec | Signup for ' + vm.params.type;
                }
                else{
                    $state.go('index.home');
                }

                if (form.$valid) {
                    var userDetails = {
                        name: vm.user.fullname,
                        email: vm.user.email,
                        password: vm.user.password,
                        role: vm.user.role,
                        dob: vm.user.dob,
                        phoneNumber: vm.user.phoneNumber,
                        facebook: {},
                        google: {},
                        curriculum: vm.country ? vm.country.country_code : '',
                        terms: vm.user.terms
                    };
                    userDetails.grades = vm.user.grades;

                    

                    if (vm.user.role == 'student' && vm.bellowAge) {
                        userDetails.parentEmail = vm.user.parentEmail;
                    }

                    
                    Auth.createUser(userDetails)
                        .then(function (resp) {
                            if (resp && resp.message) {
                               if(vm.user.rolename !="parent"){
                                addChildrenAddTeacher.send({ email: vm.user.email,teacherId:vm.params.token }).$promise.then(function (response) {

                                });
                               }
                                
                                toastr.success("Registered ! please verify your email ", "Successfully!");

                            };
                            // Account created, redirect to the page with requested a signup
                           
                        })
                        .catch(function (err) {
                            err = err.data;
                            vm.errors = {};
                            if (err && err.error) {
                                angular.forEach(err.error.errors, function (error, field) {
                                    form[field].$setValidity('mongoose', false);
                                    vm.errors[field] = error.message;
                                    // console.log(vm.errors[field])
                                });
                                // $timeout(function() { vm.errors = {}; }, 6000);
                            } else {
                                vm.errors = err.message || 'something went wrong';
                                toastr.error(err.message, "Oops!");
                            }
                            if (err && err.status == -1) {
                                toastr.error("we are offline! try later", "Oops!");
                            }
                        });
                }
            };


            $scope.dobOnChange = function (val) {
                // vm.user.dob = val;
                console.log(val);
            }
            $scope.me = function () {
                Facebook.api('/me', function (response) {
                    $scope.user = response;
                });
            };


        });

})();

(function () {

    'use strict';

    angular.module('kapdec')
        .controller('SignupCtrl', function (countrys,$scope, Auth, appPattern, Utility, config, $state, $timeout, $uibModalStack, $uibModalInstance, $window, $location, FilterOption, LoadPageData, $stateParams, toastr,Facebook) {

            var vm = this;
            $uibModalStack.dismissAll();
            vm.pattern = appPattern;
            vm.submitted = false;
            vm.params = $state.params;
            vm.bellowAge = false;
            vm.teacherlogin = true;
            vm.grades = [];
            vm.country = Utility.getGeo();
            vm.user = {};
            vm.user.role = 'teacher';
            vm.errors = {};
            $scope.countries = countrys.countries
            //vm.user.dob=moment().add(-1, 'years').format("YYYY-MM-DD");
             vm.maxDate = moment().add(-1, 'years').format("YYYY-MM-DD");
             //console.log(vm.maxDate)
           //vm.maxDate="";
            vm.initial = function () {
                if (Auth.isLoggedIn()) {
                    $state.go('dashboard.view');
                }
                if (vm.params && vm.params.invite) {
                    vm.parentlogin = false;
                    vm.teacherlogin = false;
                    vm.studentlogin = true;
                    window.document.title = 'Kapdec | Signup for student';
                }
                if (vm.params && vm.params.type) {
                    vm.parentlogin = false;
                    vm.teacherlogin = false;
                    vm.studentlogin = false;
                    vm[vm.params.type + 'login'] = true;
                    window.document.title = 'Kapdec | Signup for ' + vm.params.type;
                }
                if(vm.country.country_code=="IN"){
                    vm.filter = FilterOption().filter;
                    // local
                   // vm.filter.where.country = "3";
                    //online
                   vm.filter.where.country = "63";
                   vm.CountryCode="+91";
                  
                  }
                  else{
                    vm.filter = FilterOption().filter;
                    //local
                   // vm.filter.where.country = "209";
                    // Online
                     vm.filter.where.country = "229";
                     vm.CountryCode="+1";
                  }
            // console.log(vm.country)
                LoadPageData.grade.getGrade(FilterOption().filter).$promise.then(function (res) {
                    // console.log("grade",res);
                    if (res && res.data && res.data.data) {
                        vm.grades = res.data.data;
                    }
                });
            }
            vm.initial();
            vm.changecountry = function () {
                var func = JSON.parse(vm.user.countryName)
                vm.user.dialCode = func.dialCode;
                vm.user.emoji = func.emoji;
                console.log(JSON.parse(vm.user.countryName),"vm.user.countryName")
           }
            vm.cancel = function () {
                $uibModalInstance.dismiss('Close');
                $state.go('index.home');
            };

            vm.changerole = function (role) {
                vm.user = {};
                vm.user.role = role;
                vm.bellowAge = false;
                vm.maxDate = moment().add(-2, 'years').format("YYYY-MM-DD");
                vm.submitted = false;
                if (role === 'teacher') {
                    vm.user.dob = "";
                    vm.maxDate = moment().add(-18, 'years').format("YYYY-MM-DD");
                }
            }

            vm.changeGrades = function () {
                if (vm.user.grades.length > 2) {
                    toastr.info("You can select only 2 grades. ", "Information");
                    var rr = vm.user.grades.splice(1, 1);
                }
            }
            
            vm.checkStudentAge = function (date) {
               
                if (vm.user.role === 'student') {
                    vm.bellowAge = false;
                    var currentYear = moment().add(-1,'days').add(-13, 'years');
                    var selectedYear = moment(date);
                    console.log(currentYear+","+selectedYear)
                    var diffrentdate = currentYear.diff(selectedYear, 'days')
                   // console.log(diffrentdate)
                    if (diffrentdate < 0) {
                        vm.bellowAge = true;
                    } else {
                        vm.bellowAge = false;
                    }
                }
            }

            // vm.selectLoginType = function(loginType) {
            //     vm[loginType] = true;
            //     vm.submitted = false;
            //     vm.user ={};
            //     if (loginType == 'teacherlogin') {
            //         vm.studentlogin = false;
            //         vm.parentlogin = false;
            //         window.document.title = 'Kapdec | Signup for teacher';
            //     }
            //     if (loginType == 'studentlogin') {
            //         vm.teacherlogin = false;
            //         vm.parentlogin = false;
            //         window.document.title = 'Kapdec | Signup for student';
            //         vm.user.terms  = true;
            //     }
            //     if (loginType == 'parentlogin') {
            //         vm.teacherlogin = false;
            //         vm.studentlogin = false;
            //         window.document.title = 'Kapdec | Signup for parent';
            //         vm.user.terms  = true;
            //     }
            // }


            vm.register = function (form) {
                vm.submitted = true;
                // vm.user.role = vm.teacherlogin ? 'teacher' : vm.studentlogin ? 'student' : 'parent';

                if (form.$valid) {
                    var userDetails = {
                        name: vm.user.fullname,
                        email: vm.user.email,
                        password: vm.user.password,
                        role: vm.user.role,
                        dob: vm.user.dob,
                        dialCode : vm.user.dialCode,
                        emoji : vm.user.emoji,
                        countryName : JSON.parse(vm.user.countryName),
                        phoneNumber: vm.user.phoneNumber,
                        facebook: {},
                        google: {},
                        curriculum: vm.country ? vm.country.country_code : '',
                        terms: vm.user.terms
                    };
                    userDetails.grades = vm.user.grades;

                    if (vm.user.role == 'teacher') {
                        userDetails.degreeName = vm.user.degreeName;
                        userDetails.collegeName = vm.user.collegeName;
                        userDetails.specialization = vm.user.specialization;
                    }

                    if (vm.user.role == 'student' && vm.bellowAge) {
                        userDetails.parentEmail = vm.user.parentEmail;
                    }

                    if (vm.params && vm.params.invite) {
                        var pid = window.atob(vm.params.invite);
                        if (pid && pid.parent) {
                            userDetails = Object.assign(userDetails, { parent: pid.parent });
                        }
                    };
                   // console.log(userDetails)
                    Auth.createUser(userDetails)
                        .then(function (resp) {
                            if (resp && resp.message) {
                                toastr.success("Registered ! please verify your email ", "Successfully!");

                            };
                            // Account created, redirect to the page with requested a signup
                            if (vm.user.role) {
                                $uibModalInstance.dismiss('cancel');
                                // $state.go('dashboard.profile');
                            } else {
                                $uibModalInstance.dismiss('cancel');
                                // Auth.redirectToAttemptedUrl();
                            }
                        })
                        .catch(function (err) {
                            err = err.data;
                            vm.errors = {};
                            if (err && err.error) {
                                angular.forEach(err.error.errors, function (error, field) {
                                    form[field].$setValidity('mongoose', false);
                                    vm.errors[field] = error.message;
                                    // console.log(vm.errors[field])
                                });
                                // $timeout(function() { vm.errors = {}; }, 6000);
                            } else {
                                vm.errors = err.message || 'something went wrong';
                                toastr.error(err.message, "Oops!");
                            }
                            if (err && err.status == -1) {
                                toastr.error("we are offline! try later", "Oops!");
                            }
                        });
                }
            };


            $scope.dobOnChange = function (val) {
                // vm.user.dob = val;
                console.log(val);
            }


            vm.loginOauth = function (provider,RoleName) {
                //var role = vm.teacherlogin ? 'teacher' : vm.studentlogin ? 'student' : 'parent';
                var role=RoleName;
                var curriculum = vm.country ? vm.country.country_code : '';
                //var password="google@123";
                // Facebook.login(function (response) {
                //     Do something with response.
                // });
                console.log(role)
                if (curriculum && role) {
                    $window.open(config.baseUrl + '/auth/' + provider + '/' + role + '/' + curriculum, "_self");
                }
            };

            $scope.getLoginStatus = function () {
                Facebook.getLoginStatus(function (response) {
                    if (response.status === 'connected') {
                        $scope.loggedIn = true;
                    } else {
                        $scope.loggedIn = false;
                    }
                });
            };

            $scope.me = function () {
                Facebook.api('/me', function (response) {
                    $scope.user = response;
                });
            };


        });

})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('ResetCtrl', function(appPattern, $uibModalStack, Auth, $location, toastr, $state) {
      var vm = this;
      $uibModalStack.dismissAll();
      vm.pattern = appPattern;

      vm.invalid = function(){
        toastr.error("Oops! Invalid form");
        $state.go('index.notFound404');
      };

      vm.initial = function(){

          Auth.logout();

          if($state.params.token){

          try{
            var params = JSON.parse( Base64.decode( $state.params.token ) );

            if(params && params.token && params.type && params.type.name){
              vm.token = params.token;
              vm.type = params.type.name;

              if(vm.type == 'v_password'){
                vm.verifyType = "reset";
              }
            }else{
              vm.invalid();
            }
          } catch(err){
             vm.invalid();
          }

         }else{
           vm.invalid();
         }

      };
      vm.initial();

      vm.user = {
          password: "",
          confirmPassword: "",
      };

      var queryString = $location.search();

      vm.isResetSuccess = false;
      vm.resetPassword = function(form) {
         vm.submitted = true;

          if (form.$valid && $state.params.token) {
              if (vm.user.password === vm.user.confirmPassword) {
                  var param = JSON.parse( Base64.decode( $state.params.token ) );
                  param.password = vm.user.password;
                  var data = Base64.encode( JSON.stringify(param) );

                  Auth.ResetPassword({'data': data}).then(function(res) {
                      toastr.success("Your Password has been changed successfully.");
                       $state.go('index.home')
                      vm.isResetSuccess = true;
                  }).catch(function(err) {
                      toastr.error(err.data);
                  })
              } else {
                  toastr.error("Oops! Passwords don't match");
              }
          } else {
            //   toastr.error("Oops! Invalid form");
          }
      }

  });


})();

(function () {

	'use strict';

	angular.module('kapdec')
		.controller('LoginCtrl', function (appPattern, User, Auth, $state, toastr, $uibModalStack, $uibModalInstance, $localStorage, $location, $timeout, $window, $rootScope, $stateParams, $uibModal) {
			var vm = this;
			$uibModalStack.dismissAll();
			vm.pattern = appPattern;

			vm.user = {};
			vm.forgot = {};
			vm.errors = {};
			vm.error = {};
			//console.log(localStorage.chkbx)
			if (localStorage.chkbx && localStorage.chkbx != '') {
				vm.user.email = localStorage.usrname;
				vm.user.password = localStorage.pass;
				vm.user.check = true;
			} else {
				vm.user.email = "";
				vm.user.password = "";
				vm.user.check = false;
			}

			vm.initial = function () {
				if (Auth.isLoggedIn()) {

					$state.go('dashboard.view');
				}
			}
			vm.initial();

			vm.cancel = function () {
				$uibModalInstance.dismiss('Close');
				$state.go('index.home');
			};

			vm.logindiv = true;
			vm.toggleForgetLogin = function (division) {
				if (!vm[division]) {
					vm.forgetpass = !vm.forgetpass;
					vm.logindiv = !vm.logindiv;
				}
			}

			vm.login = function (form) {
				vm.submitted = true;
				//  vm.uInfo = JSON.stringify( { email: vm.user.email, password: vm.user.password } );
				vm.uInfo = { email: vm.user.email, password: vm.user.password };
				if (form.$valid) {
					//  Auth.login( Base64.encode(vm.uInfo) )
					console.log(vm.user.check)
					if (vm.user.check == true) {
						localStorage.usrname = vm.user.email;
						localStorage.pass = vm.user.password;
						localStorage.chkbx = true;
					}
					else {
						localStorage.usrname = "";
						localStorage.pass = "";
						localStorage.chkbx = false;
					}
					Auth.login(vm.uInfo)
						.then(function (data) {
							//$uibModalInstance.dismiss('Close');
							// console.log("success login data from LoginCtrl>>", data)
							// User.get(function (resp) {
							if (data && data.user) {
								var res = data.user;
								//if ((res.role == "student" || res.role == "parent" || res.role == "teacher") && res.firstime) {
								//  if (res.role == "student") $state.go('dashboard.tutorial');
								//  if (res.role == "parent") $state.go('parent.dashboardpanel');
								//  if (res.role == "teacher") $state.go('teacher.dashboardpanel');
								// } else if ((res.role == "student" || res.role == "parent" || res.role == "teacher")) {
								//   if (res.role == "student") $state.go('dashboard.tutorial');
								//   if (res.role == "parent") $state.go('parent.dashboardpanel');
								//   if (res.role == "teacher") $state.go('teacher.dashboardpanel');
								// } else if ((res.role == "admin" || res.role == "subAdmin")) {
								//   $state.go('admin.manageuser');
								// } else {
								//  $uibModalInstance.dismiss('Close');
								//  Auth.redirectToAttemptedUrl();
								//}
								$rootScope.userParent = false;
								$rootScope.userTeacher = false;
								$rootScope.userStudent = false;
								$rootScope.userAdmin = false;

								if ((res.role == "student" || res.role == "parent" || res.role == "teacher")) {
									console.log(res.role, "res.role")
									if ((res.role == "student")) {
										$rootScope.userStudent = true;
										$state.go('dashboard.tutorial');
									} else if ((res.role == "parent")) {
										$rootScope.userParent = true;
										$state.go('dashboard.view');
									} else if ((res.role == "teacher")) {
										$rootScope.userTeacher = true;
										$state.go('dashboard.view');
									}
								} else if ((res.role == "admin" || res.role == "subAdmin")) {
									$rootScope.userAdmin = true;
									console.log(res.role, "res.role")
									$state.go('admin.manageuser');
								} else {
									$uibModalInstance.dismiss('Close');
									Auth.redirectToAttemptedUrl();
								}
							}

							// });

						})
						.catch(function (err) {
							if (err) {
								vm.errors.other = err.message;
								console.log(vm.errors.other)
								// $timeout(function(){ vm.errors ={}; },6000);
								if (err && err.status == -1) {
									toastr.error("we are offline! try later", "Oops!");
								}
								// toastr.error("oops! error", "Something went wrong"+err.message );
							}
						});
				}
			};

			vm.forgotPassword = function (resetform) {
				vm.submittedEmail = true;
				vm.error = {};
				if (resetform.$valid) {
					Auth.ForgotPassword({ email: vm.forgot.email }).then(function (res) {

						if (res && res.$resolved) {
							toastr.success(res.message);
							$uibModalInstance.dismiss('Close');
						}

					}).catch(function (err) {
						if (err) {
							vm.error = err.data || "something went wrong: try later";
							// toastr.error( err.data.message+" error: Please try again");
						}
					})
				}
			};
			vm.signup = function () {
				var modalInstance = $uibModal.open({
					animation: true,
					ariaLabelledBy: 'modal-title',
					ariaDescribedBy: 'modal-body',
					templateUrl: 'app/accounts/signup/signup.html',
					controller: 'SignupCtrl',
					controllerAs: 'vm',
					backdrop: 'static',
					keyboard: false,
					resolve: {

					}
				});
			}
		});

})();


(function() {

  'use strict';

 angular.module('kapdec')
 .controller('SubscribeRequiredCtrl', function (appPattern, User, Auth, $state, toastr, $uibModalStack, $uibModalInstance, $localStorage, $location, $timeout, $window, $rootScope, $stateParams) {
     var vm = this;
     $uibModalStack.dismissAll();

     vm.message = "Subscription Required: please purchase the required subscription ! ";

     vm.cancel = function () {
         $uibModalInstance.dismiss('Close');
         // $state.go('/subscription');
         $location.path('/subscription/').search();
     };


   });

 })();

(function () {

  'use strict';

  angular.module('kapdec')
    .controller('StoriesCtrl', function (config, appPattern, ENUMS, _, $sce, Auth, StoryService, LoadPageData, $localStorage, FilterOption, $uibModal, $timeout, toastr, $state, $log) {
      var vm = this;

      // vm.viewBy = [30, 45, 60, 90, 100];
      vm.params = $state.params;
      vm.loader = true;
      vm.pattern = appPattern;
      vm.filterOptions = FilterOption().filter;
      vm.filterOptions.limit = 10;
      vm.story = {};
      vm.story.description = '';
      console.log("StoriesCtrl");
      vm.trustUrl = function (url) {
        return $sce.trustAsResourceUrl(url);
      }
      
      /**
        onload list story functionality
      **/
      vm.init = function () {

        if (vm.params && vm.params.page) { vm.filterOptions.page = vm.params.page; }
        StoryService.getAll(vm.filterOptions).$promise.then(function (res) {
          if (res && res.data && res.data.data) {
            vm.loader = false;
            vm.storyList = res.data.data;
            vm.filterOptions.total = res.data.total;
          
          }
        },
          function (error) {
            if (error && error.status == -1) {
              toastr.error("we are offline! try later", "Oops!");
            }
          });
          
      };
      vm.init();

      
      vm.changeFilterOptions = function () {
        if ((vm.filterOptions.page - 1) * vm.filterOptions.limit <= vm.filterOptions.total) {
          vm.init();
          // $state.go('index.stories',{ page: vm.filterOptions.page })
        }
      }

      vm.getFilteredStory = function () {
        vm.init();
      }

      var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        if (file && !(file.name.indexOf('.xls') > -1) && !(file.name.indexOf('.xlsx') > -1) && !(file.name.indexOf('.pdf') > -1) && !(file.name.indexOf('.doc') > -1) && !(file.name.indexOf('.docx') > -1) && !(file.name.indexOf('.txt') > -1)) {
          $('#uploadTrigger').val(null);
          return false;
        }
        reader.onload = function (evt) {
          $scope.$apply(function ($scope) {
            // console.log("evt.target.result", evt.target.result)
            vm.story.document = evt.target.result;
            vm.fileName = file.name;
            // console.log("file", file.name);
          });
        };
        reader.readAsDataURL(file);
      };
      angular.element(document.querySelector('#uploadTrigger')).on('change', handleFileSelect);

      /**
        add new story functionality
      **/
      vm.addStory = function (form) {
        vm.submitted = true;
        if (form.$valid) {
          vm.isBusy = true;
          if (vm.story.description.length < 15) {
            vm.descriptionminlength = true;
            return false;
          }
          StoryService.create(vm.story).$promise.then(function (res) {
            console.log("story", res);
            if (res) {
              vm.isBusy = false;
              vm.story = '';
              vm.submitted = false;
              vm.init();
              $('#uploadTrigger').val(null);

              toastr.success("Your story has been submitted successfully.", "Success!");
            }
          }, function (error) {
            console.log(error)
            vm.isBusy = false;
            vm.errors.other = error.data.message;
            $timeout(function () { vm.errors = {}; }, 3500);
          });
        }

      };

      vm.descriptionlength = 0;
      vm.countdescriptionlength = function () {
        vm.descriptionlength = 0;
        if (vm.story.description.length > 15) {
          vm.descriptionminlength = false;
        }

        if (vm.story.description)
          vm.descriptionlength = vm.story.description.length;
      }


    });


})();

(function() {

'use strict';
      /**  static :: states :: info
       * /about ::about us page
       * /404 :: notfound404 page
       * /terms-and-conditions  ::terms&conditions page
       * /contact ::contact us page
       * /privacy-and-policy ::privacy page
       * /career ::career page
       * /FAQs  ::FAQs page
       * /sitemap ::sitemap page
       * /howItWorks ::howItWorks page
      */

angular.module('kapdec')

 /** @ngInject */

    .config(function($stateProvider, $ocLazyLoadProvider) {
        $stateProvider
            .state("index.about", {
                title: 'about us',
                url: '/about',
                templateUrl: 'app/static/aboutUs/about.html',
                controller: 'AboutCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.notFound404", {
                title: 'not found 404',
                url: '/404',
                templateUrl: 'app/static/notFound404/notFound.html',
                controller: 'notFoundCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.terms", {
                title: 'Terms service',
                url: '/terms-and-conditions',
                templateUrl: 'app/static/termsCondition/tc.html',
                controller: 'TermsCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.contact", {
                title: 'contact us',
                url: '/contact',
                templateUrl: 'app/static/contactUs/contact.html',
                controller: 'ContactCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.privacy", {
                title: 'privacy and policy',
                url: '/privacy-and-policy',
                templateUrl: 'app/static/privacy/privacy.html',
                controller: 'PrivacyCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.career", {
                title: 'career',
                url: '/career',
                templateUrl: 'app/static/career/career.html',
                controller: 'CareerCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.FAQs", {
                title: 'FAQs',
                url: '/FAQs',
                templateUrl: 'app/static/FAQs/FAQs.html',
                controller: 'FaqsCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.howItWorks", {
                title: 'how it works',
                url: '/how-it-works',
                templateUrl: 'app/static/howitworks/howitworks.html',
                controller: 'howitworksCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.subscription", {
                title: 'subscription',
                url: '/subscription',
                templateUrl: 'app/static/subscription/subscription.html',
                controller: 'subscriptionCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.team", {
                title: 'team',
                url: '/team',
                templateUrl: 'app/static/team/team.html',
                controller: 'TeamCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })
            .state("index.sitemap", {
                title: 'sitemap',
                url: '/sitemap',
                templateUrl: 'app/static/sitemap/sitemap.html',
                controller: 'SitemapCtrl',
                controllerAs: 'vm',
                showHeader: true,
                showFooter: true,
                ensureAuthenticate: false
            })


    })


})();

(function() {

'use strict';

 angular.module('kapdec')
    .controller('SelectTopicCtrl', function (config, _, $sce, $window, $timeout, $scope, $localStorage, LoadPageData, FilterOption, toastr, $state, $log) {
        var vm = this;
        vm.params = $state.params;
        vm.loader =true;
        vm.filterChapter = FilterOption().filter;
        vm.filterTopic   = FilterOption().filter;
        vm.chapters = [];
        // console.log("SelectTopicsCtrl", vm.params);

        vm.getImageUrl = function(id){
          return config.baseUrl+'/api/gfs/'+id;
        }

        vm.trustUrl = function(url){
          return $sce.trustAsResourceUrl(url+'?autoplay=1&loop=1&autopause=0');
        }


        /**
          topics by chapter functionality
        **/
        vm.getChapterTopics = function(chapterId){
          // console.log(chapterId);
           if(chapterId){
            vm.filterTopic.where.chapter = chapterId;
            vm.filterTopic.limit = 30;
            // if(vm.params &&vm.params.page){ vm.filterTopic.page = vm.params.page; };
            // if(vm.params &&vm.params.gradeId){ vm.filterTopic.where.grade = vm.params.gradeId; };
            if(vm.params &&vm.params.unitId){ vm.filterTopic.where.unit = vm.params.unitId; };
            if(vm.course){ vm.filterTopic.where.course = vm.course[0]._id; };
            LoadPageData.topic.getTopic(vm.filterTopic).$promise.then(function(res){
              // console.log("topicres",res);
              if(res && res.data && res.data.data && res.data.data.length){
                  vm['topics'+chapterId] = res.data.data;
                  // console.log("topics"+chapterId,vm['topics'+chapterId]);
                  vm.loader = false;
                  vm.filterTopic.total = res.data.total;
               }
             });
          }
        };

        /**
          chapters by unit functionality
        **/
        vm.getUnitChapterList = function(){

          vm.filterChapter.limit = 30;
          if(vm.params &&vm.params.page){ vm.filterChapter.page = vm.params.page; };
          if(vm.params &&vm.params.gradeId){ vm.filterChapter.where.grade = vm.params.gradeId; }
          if(vm.params &&vm.params.unitId){ vm.filterChapter.where.unit = vm.params.unitId; }
          if(vm.course){ vm.filterChapter.where.course = vm.course[0]._id; };
          // LoadPageData.chapter.getChapter(vm.filterChapter).$promise.then(function(res){
          //   // console.log('chapterres',res);
          //   if(res && res.data && res.data.data){
          //     vm.loader = false;
          //   }
          //   if(res && res.data && res.data.data && res.data.data.length){
          //       vm.chapters = res.data.data;
          //       // console.log(vm.chapters);
          //       vm.loader = false;
          //       vm.getChapterTopics(vm.chapters[0]._id);
          //       vm.statusOpen0 = true;
          //       vm.filterChapter.total = res.data.total;
          //    }
          //  }, function(error){
          //    if(error && error.status == -1 ){
          //      toastr.error("we are offline! try later", "Oops!");
          //    }
          //  });
        }
        /**
          on init functionality
        **/
        vm.init = function(){
          if($localStorage.course){
           vm.course = JSON.parse($localStorage.course);
          }
          if(vm.params && vm.params.unitId && vm.params.course){
            vm.getUnitChapterList();
          }else{
            toastr.error("invalid url !", "Oops!");
            $state.go("index.home");
          }
        };
        vm.init();
        /**
          suggestion description toggle functionality
        **/
        vm.toggler = function(toggleProp,i,j){
          var index = i.toString()+j.toString();
          if( toggleProp == 'suggest' ){
            vm['descript'+index] = false;
            vm[toggleProp+index] =! vm[toggleProp+index];
          };
          if( toggleProp == 'descript' ){
            vm['suggest'+index] = false;
            vm[toggleProp+index] =! vm[toggleProp+index];
          };

        }
        /**
        get video url from topic thumnail id
        **/
        vm.getVideo = function(topicId, scopeName){

          LoadPageData.topic.getVideo( {controller: topicId } ).$promise.then(function(res){
             if(res && res.data && res.data.vidURL ){
                // console.log(res);
                vm[scopeName] = res.data.vidURL;
                $timeout(function(){
                  var iframe = document.getElementById(scopeName);
                  var player = new Vimeo.Player(iframe);
                  player.play();
                },1500);
             }
           }, function(error){
             if(error.status !== 402){
               toastr.error("something wrong! try later", "Oops!");
             }
           });
        };


 });

})();

(function() {

 'use strict';

 angular.module('kapdec')
    .controller('SelectGradeTopicCtrl', function (config, _, $window, $localStorage, LoadPageData, FilterOption, toastr, $state, $log) {
        var vm = this;
        vm.params = $state.params;
        vm.loader =true;
        vm.filterTopic = FilterOption().filter;
        vm.filterUnit = FilterOption().filter;
        vm.filterTopic.limit = 30;
        // console.log("SelectGradeCtrl",vm.params );
        // SelectGradeCtrl {course: "Math", type: "grade", gradeId: "8", unitId: undefined}

      /**
        topic unitlist functionality
      **/
        vm.getTopicUnitList = function(){

          if(vm.params &&vm.params.page){ vm.filterTopic.page = vm.params.page; }
          if(vm.course){ vm.filterTopic.where.course = vm.course[0]._id; };
          LoadPageData.unit.getUnit(vm.filterTopic).$promise.then(function(res){
            if(res && res.data && res.data.data && res.data.data.length){
                vm.units = res.data.data;
                vm.loader = false;
                vm.filterTopic.total = res.data.total;
             }
           }, function(error){
             if(error && error.status == -1 ){
               toastr.error("we are offline! try later", "Oops!");
             }
           });
        }

        /**
          grade unitlist functionality
        **/

        vm.getGradeUnitList = function(){

          LoadPageData.grade.getGrade( FilterOption().filter ).$promise.then(function(res){
            // console.log("grade",res);
            if(res && res.data && res.data.data ){
              vm.grade = res.data.data;
              if(vm.grade && vm.grade.length){
                 vm.grades = _.map(vm.grade, _.partialRight(_.pick, ['_id', 'name']));
                 // console.log(vm.grades);
                 if(vm.params&&vm.params.gradeId){
                   var gid = vm.grades.find(function(item){ return item._id == vm.params.gradeId });
                   if(gid) vm[gid.name]= true; vm.filterUnit.where.grade = gid._id;
                 }else{
                   vm[ vm.grades[1].name ] = true; //default opened 1, below call for grade-list
                   vm.filterUnit.where.grade = vm.grade[1]._id;
                 }

                  if(vm.course){ vm.filterUnit.where.course = vm.course[0]._id; };
                  LoadPageData.unit.getUnit( vm.filterUnit ).$promise.then(function(resp){
                     // console.log('units', resp);
                     if(resp && resp.data && resp.data.data ){
                       vm.unit = resp.data.data;
                       vm.loader = false;
                     }
                  });
              }

            }
          }, function(error){
            if(error && error.status == -1 ){
              toastr.error("we are offline! try later", "Oops!");
            }
          });

        }

      /**
        state initialize functionality
      **/
      vm.init = function(){

          if($localStorage.course){
           vm.course = JSON.parse($localStorage.course);
          }
          if(vm.params && vm.params.type == 'unit'){
            vm.showTopic = true; vm.showGrade = false;
          }else if(vm.params && vm.params.type == 'grade'){
            vm.showGrade = true; vm.showTopic = false;
          }else{
            $state.go("index.home");
          }

        if(vm.showGrade){
         vm.getGradeUnitList();
        }
        if(vm.showTopic){
          vm.getTopicUnitList();
        }

      };
      vm.init();

            /**
              grade topic functionality
            **/
            vm.openGrade = function(grade, gradeId ){

              if(gradeId && vm.showGrade ){
                $state.go('index.select-grade', { course: vm.course[0].name, type: 'grade' , gradeId: gradeId  } ,{notify: true} );
                // vm.getGradeUnitList();
              }
            }
            /**
              top grade/topic tab functionality
            **/
            vm.openGradeTopic = function( evt, opentype) {
                   if(! vm[opentype] && opentype == 'showGrade'){
                     $state.go('index.select-grade', { course: vm.course[0].name, type: 'grade' , gradeId: vm.params.gradeId  } ,{notify: true} );
                     // vm.showGrade = true; vm.showTopic =false;
                     // vm.getGradeUnitList();
                   }
                   if(! vm[opentype] && opentype == 'showTopic'){
                     $state.go('index.select-grade', { course: vm.course[0].name, type: 'unit', page: vm.params.page || 1, unitId: vm.params.unitId },{notify: true} );
                     // vm.showGrade = false; vm.showTopic =true;
                     // vm.getTopicUnitList();
                   }
            };

            vm.changeTopicPageOptions = function(){
              // console.log(vm.filterTopic.page);
              if(vm.filterTopic.page && vm.showTopic ){
                $state.go('index.select-grade', { course: vm.course[0].name, type: 'unit', page: vm.filterTopic.page, unitId: vm.params.unitId },{notify: true} );
                vm.getTopicUnitList();
              }
            }

 });

})();

(function() {

  'use strict';

  angular.module('kapdec')
    .controller('DashboardCtrl',function(config,$log,Auth,User,$scope,$localStorage,$uibModalStack,toastr,$timeout,$uibModal,$state,$window) {
      var vm = this;

      $uibModalStack.dismissAll();
      vm.sidebarUrl = 'app/dashboard/navbar-sidebar/sidebar.html';
      vm.topNavbarUrl = 'app/dashboard/navbar-sidebar/top-navbar.html';
      vm.updateImg = true;


      vm.logout = function() {
        User.logOut().$promise.then(function(res) {
          Auth.logout();
          $state.go('index.home');
        });
      };

      vm.getImageUrl = function(id) {
        if(id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      /**
        on init functionality
      **/
      vm.init = function() {

        try {
          $timeout(function() {
            if($localStorage.course) {
              vm.course = JSON.parse($localStorage.course);
            }
          },200);

          User.get().$promise.then(function(res) {
            if(res && res.data) {
              vm.user = res.data;
              if(vm.user.isBlock == true) {
                User.logOut().$promise.then(function(res) {
                  Auth.logout();
                  $state.go('index.home');
                });
              }
            }
          },
            function(error) {
              if(error && error.status == -1) {
                toastr.error("we are offline! try later","Oops!");
              }
            });

        }
        catch(err) {
          // $state.go('index.home');
        }

      };
      vm.init();

      /**
        on user profile info update watcher
      **/
      $scope.$on("uploaded",function(evt,data) {
        if(data && data.update) {
          vm.updateImg = false;
          vm.init();
          $timeout(function() {
            vm.updateImg = true;
          },200);
        }
      });

      vm.openChangePasswordModal = function(details,isEditable) {

        vm.details = { 'details': details };
        vm.modalValue = isEditable;

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/changePasswordModal.html',
          controller: 'studentChangePasswordCtrl',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function() {
              return vm.details;
            },
            model: function() {
              return vm.modalValue;
            }
          }
        }).result.then(function(updated) {
          if(updated) {
          }
        },function() {
        });


      };

    }).controller('studentChangePasswordCtrl',function(appPattern,$state,User,toastr,$uibModalInstance,Upload,config,Auth,$log,$scope,$timeout,$window) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = {};

      vm.cancel = function() {
        $uibModalInstance.dismiss('Close');
      };

      vm.upload = function(form) {

        vm.submitted = true;
        // if (!vm.fullName) return false;
        // vm.user.name = vm.fullName;
        if((vm.password && vm.confirmPassword) && !(vm.password === vm.confirmPassword)) return false;
        if(vm.password && vm.confirmPassword) vm.user.password = vm.password;
        vm.loader = true;

        if(form) {
          User.update({ data: vm.user }).$promise.then(function(res) {
            if(res && res.data) {
              vm.loader = false;
              toastr.success("Your Password has been updated successfully!");
              $uibModalInstance.dismiss('Close');
            }
          },
            function(error) {
              if(error) {
                vm.loader = false;
                toastr.error(error.data.message,"Oops!");
              }
            });
        } else {
          vm.loader = false;

        }
      }
    });

})();

(function() {

	'use strict';
	/**  dashboard :: states :: info
	 * dashboard ::dashboard page
	   * profile ::profile page
	   * edit-profile :: editProfile page
	   * discussion-topic :: discussionTopic page
	   * classes  ::classes page
	   * mysubscription :: mysubscription page
	   * subscription :: subscription page
	   * select-by-grade :: selectByGrade page
	   * select-by-topic :: selectByTopic page
	   * badges  :: badges page
	   * test :: test page
	   * test-paper-result :: testResult page
	  */

	angular.module('kapdec')

		/** @ngInject */

		.config(function($stateProvider,$ocLazyLoadProvider) {
			$stateProvider
				.state("dashboard",{
					title: 'dashboard',
					abstract: true,
					url: "",
					templateUrl: 'app/dashboard/dashboard.html',
					controller: 'DashboardCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true,
					resolve: {
						loadPlugin: function($ocLazyLoad) {
							// $('link[href="assets/css/style.css"]').remove();
							return $ocLazyLoad.load([
								{
									serie: true,
									files: [
										// 'assets/js/datatables.min.js',
										'assets/js/sweetalert.min.js',
										'assets/css/datatables.min.css',
										'assets/css/sweetalert.css',
										'assets/css/bootstrap-chosen.css',
										'assets/css/chosen.css',
										// 'assets/js/quill.js',
										'assets/js/ng-quill.js',
										'assets/css/quill.snow.css',
										'assets/css/dataTables.bootstrap4.min.css',
										// 'assets/css/paper-dashboard.css',
										// 'assets/performancegraph/fusioncharts.js',
										// 'assets/performancegraph/themes/fusioncharts.theme.zune.js',
									]
								},
								{
									serie: true,
									name: 'oitozero.ngSweetAlert',
									files: ['assets/js/angular-sweetalert.min.js']
								},
								{
									serie: true,
									name: 'datatables',
									files: ['assets/js/angular-datatables.min.js']
								},
								{
									serie: true,
									name: 'datatables.buttons',
									files: ['assets/js/angular-datatables.buttons.min.js']
								},
								{
									serie: true,
									files: ['assets/js/chosen.js','assets/js/chosen.jquery.js']
								},
								{
									serie: true,
									files: ['assets/js/lodash.min.js','assets/js/highstock-all.js','https://player.vimeo.com/api/player.js']
								}
							]);
						},
						// checkUserRole: function (Auth, $state) {
						// 	Auth.isAdmin(function (res) {
						// 		if (res) {
						// 			$state.go('admin.dashboardpanel');
						// 		}
						// 		return true;
						// 	});
						// 	Auth.isTeacher(function (res) {
						// 		if (res) {
						// 			$state.go('teacher.dashboardpanel');
						// 		}
						// 	})
						// 	Auth.isParent(function (res) {
						// 		if (res) {
						// 			$state.go('dashboard.view');
						// 		}
						// 	})
						// },
						courses: function(LoadPageData,$localStorage,FilterOption) {
							LoadPageData.course.getCourse(FilterOption().filter).$promise.then(function(res) {
								if(res && res.data && res.data.data) {
									$localStorage.course = JSON.stringify(res.data.data);
								}
								return true;
							});
						}

					}
				})
				.state("dashboard.view",{
					title: 'dashboard',
					url: '/dashboard',
					templateUrl: 'app/dashboard/dashboard-view/dashboard-view.html',
					controller: 'DashboardViewCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.profile",{
					title: 'profile',
					url: '/profile',
					templateUrl: 'app/dashboard/profile/profile.html',
					controller: 'ProfileCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true,
					resolve: {
						loadPlugin: function($ocLazyLoad) {
							return $ocLazyLoad.load([
								{
									serie: true,
									files: ['assets/js/sweetalert.min.js',
										'assets/css/sweetalert.css'
									]
								},
								{
									serie: true,
									name: 'oitozero.ngSweetAlert',
									files: ['assets/js/angular-sweetalert.min.js']
								}
							]);
						}
					}
				})
				.state("dashboard.editprofile",{
					title: 'edit profile',
					url: '/edit-profile',
					templateUrl: 'app/dashboard/edit-profile/editProfile.html',
					controller: 'EditProfileCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.discussiontopic",{
					title: 'discussion Topic',
					url: '/discussion-topic/?page',
					templateUrl: 'app/dashboard/discussion-topic/discussionTopic.html',
					controller: 'DiscussionTopicCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.mydiscussion",{
					title: 'my discussion',
					url: '/my-discussion/?page',
					templateUrl: 'app/dashboard/discussion-topic/my-discussion/myDiscussion.html',
					controller: 'MyDiscussionCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.classes",{
					title: 'classes',
					url: '/classes',
					templateUrl: 'app/dashboard/classes/classes.html',
					controller: 'ClassesCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.mysubscription",{
					title: 'mysubscription',
					url: '/mysubscription',
					templateUrl: 'app/dashboard/mysubscription/mysubscription.html',
					controller: 'MysubscriptionCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.subscription",{
					title: 'subscription',
					url: '/subscription/',
					templateUrl: 'app/dashboard/subscription/subscription.html',
					controller: 'SubscriptionCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.selectbystudentclass",{
					title: 'Select By Class',
					url: '/selectbyclass/:classid',
					templateUrl: 'app/dashboard/select-by-class/selectByClass.html',
					controller: 'SelectByClassCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				// .state("dashboard.selectbytopic", {
				//   title: 'select By Topic',
				//   url: '/select-by-topic/:course/?unitId&gradeId&unit&classId&page',
				//   templateUrl: 'app/dashboard/select-by-topic/selectByTopic.html',
				//   controller: 'SelectByTopicCtrl',
				//   controllerAs: 'vm',
				//   showHeader: false,
				//   showFooter: false,
				//   ensureAuthenticate: true
				// })
				.state("dashboard.badges",{
					title: 'badges',
					url: '/badges',
					templateUrl: 'app/dashboard/badges/badges.html',
					controller: 'BadgesCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})

				.state("dashboard.tutorial",{
					title: 'tutorial',
					url: '/tutorials',
					templateUrl: 'app/dashboard/tutorial/tutorial.html',
					controller: 'TutorialCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.chapter",{
					title: 'chapter',
					url: '/chapters/:id',
					templateUrl: 'app/dashboard/chapter/chapter.html',
					controller: 'ChapterCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.test",{
					title: 'test',
					// url: '/test/:course/?type&examId&gradeId&unitId&chapterId&topicId&topic&chapter&q',
					url: '/test/:chapterId/:unitid/?q&examId&classid',
					templateUrl: 'app/dashboard/test/test.html',
					controller: 'TestCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.mytests",{
					title: 'Exam History',
					url: '/my-quizzes/?page',
					templateUrl: 'app/dashboard/my-tests/myTests.html',
					controller: 'MyTestsCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})
				.state("dashboard.testresult",{
					title: 'test result',
					url: '/test-result/?type&examId',
					templateUrl: 'app/dashboard/test-paper-result/testResult.html',
					controller: 'TestResultCtrl',
					controllerAs: 'vm',
					showHeader: false,
					showFooter: false,
					ensureAuthenticate: true
				})


		})


})();




(function () {

	'use strict';

	angular.module('kapdec')
		.controller('HomeController', function (appPattern, _, $sce, Utility, FilterOption, LoadPageData, User, $state, $localStorage, $uibModalStack, Auth, $sessionStorage, $document, $window, $uibModal, Idle, $rootScope, config, toastr, $scope, $timeout, $filter, $log) {
			var vm = this;
			try {
				$uibModalStack.dismissAll();
				vm.params = $state.params;
				vm.pattern = appPattern;
				vm.submitted = false;
				vm.filterOptions = FilterOption().filter;
				vm.filterOptions.limit = 30;
				vm.country = Utility.getGeo();
				//vm.country.country_code
				vm.user = {};
				vm.errors = {};
				vm.showGrade = true; vm.showTopic = false;
				vm.grades = []; //default grade from getGrade()
				vm.topics = [];
				vm.allUnits = [];
				vm.allTopics = [];
				// vm.allUnits = [];
				vm.chapter = [];
				vm.trustUrl = function (url) {
					return $sce.trustAsResourceUrl(url);
				}

				// ********** idle session *******************************************************
				//Idle.watch();   // closed
				$scope.$on('IdleStart', function (ev, elem, obj) {
					$rootScope.lockedScreen = true;
					// toastr.warning("warning", "Session Timeout Warning");
				})
				$scope.$on('IdleTimeout', function () {
					Auth.logout();
					$localStorage.access_token = "";

				});
				$scope.$on('IdleEnd', function () {
					$("#toast-container").remove();
				});

				// console.log(Utility.getGeo())

				$document.on('scroll', function () {
					var top = $window.scrollY;
					if (top > 200) {
						$('.filterby-tags').addClass('filterTopFixed fadeInLeft');
					} else {
						$('.filterby-tags').removeClass('filterTopFixed fadeInLeft');
					}
				});

				//***************************************************************************
				vm.getImageUrl = function (id) {
					return config.baseUrl + '/api/gfs/' + id;
				}

				vm.init = function () {
					if (vm.country.country_code == "IN") {
						vm.filterTopic = FilterOption().filter;
						//local
						// vm.filterTopic.where.country = "3";
						//online
						vm.filterTopic.where.country = "91";

					}
					else {
						vm.filterTopic = FilterOption().filter;
						//local
						//vm.filterTopic.where.country = "209";
						//online
						vm.filterTopic.where.country = "229";

					}
					LoadPageData.grade.getGrade(vm.filterTopic).$promise.then(function (res) {
						vm.courses = [];
						vm.topics = [];
						vm.units = [];
						vm.chapters = [];
						//console.log("grade",res);
						if (res && res.data && res.data.data) {
							vm.grade = res.data.data;
							if (vm.grade.length > 0) {
								vm.getCourses(vm.grade[0]._id)
							}
						}
					}, function (err) {
					});

					LoadPageData.topic.getTopic(vm.filterTopic).$promise.then(function (res) {
						// vm.topics=[];
						vm.units = [];
						vm.chapters = [];
						if (res && res.data && res.data.data && res.data.data.length) {
							vm.allTopics = res.data.data;
							vm.loader = false;
						}
					});

					LoadPageData.course.getAll(vm.filterTopic).$promise.then(function (resp) {
						// debugger;
						// vm.courses=[];
						vm.topics = [];
						vm.units = [];
						vm.chapters = [];
						if (resp && resp.data && resp.data.data) {
							vm.allUnits = resp.data.data;
							vm.loader = false;
						}
					});

					if (vm.params && vm.params.page) { vm.filterOptions.page = vm.params.page; }
					LoadPageData.video.getvideo(vm.filterOptions).$promise.then(function (res) {
						console.log(res.data)
						if (res && res.data && res.data.data) {
							vm.loader = false;
							vm.storyList = res.data.data;
							vm.filterOptions.total = res.data.total;

						}
					},
						function (error) {
							if (error && error.status == -1) {
								toastr.error("we are offline! try later", "Oops!");
							}
						});

				}

				vm.getModules = function (topicId) {
					//vm.units=[];
					vm.chapters = [];
					LoadPageData.topic.getTopic(FilterOption().filter).$promise.then(function (res) {
						if (res && res.data && res.data.data && res.data.data.length) {
							vm.allTopics = res.data.data;
							vm.loader = false;
						}
					});
				}

				vm.getCourses = function (gradeId) {
					// console.log(gradeId);
					if (gradeId) {
						vm.topics = [];
						vm.courses = [];
						vm.units = [];
						vm.chapters = [];
						vm.loader = true;
						vm.filterTopic = FilterOption().filter;
						vm.filterTopic.where.grade = gradeId;
						LoadPageData.course.getAll(vm.filterTopic).$promise.then(function (res) {
							console.log(res);
							if (res && res.data && res.data.data && res.data.data.length) {
								vm.courses = res.data.data;
								vm.loader = false;
							}
						});
					}
				};

				vm.getTopics = function (course) {
					vm.topics = [];
					// vm.courses=[];
					vm.units = [];
					vm.chapters = [];
					vm.loader1 = true;
					if (course) {
						vm.filterTopic = FilterOption().filter;
						vm.filterTopic.where.course = course;

					};

					LoadPageData.topic.getTopic(vm.filterTopic).$promise.then(function (res) {
						console.log(res);
						if (res && res.data && res.data.data && res.data.data.length) {
							vm.topics = res.data.data;
							vm.loader1 = false;
						}
					});
				}

				vm.getUnits = function (topic) {
					vm.units = [];
					vm.chapters = [];
					vm.loader2 = true;
					if (topic) {
						vm.filterTopic = FilterOption().filter;
						vm.filterTopic.where.topic = topic;

					};

					LoadPageData.unit.getUnit(vm.filterTopic).$promise.then(function (resp) {
						console.log(resp);
						if (resp && resp.data && resp.data.data) {
							vm.units = resp.data.data;
							vm.loader2 = false;
						}
					});
				}
				vm.getChapters = function (unit) {
					vm.chapters = [];
					vm.loader3 = true;
					if (unit) {
						vm.filterTopic = FilterOption().filter;
						vm.filterTopic.where.unit = unit;

					};

					LoadPageData.chapter.getChapter(vm.filterTopic).$promise.then(function (resp) {
						console.log(resp);
						if (resp && resp.data && resp.data.data) {
							vm.chapters = resp.data.data;
							vm.loader3 = false;
						}
					});
				}

				vm.init(); //initialize data function


				// ########### signup ###################################

				vm.userType = 'student';
				vm.loginOauth = function (provider) {
					var role = vm.userType;
					var curriculum = vm.country ? vm.country.country_code : '';
					console.log(role + curriculum)
					if (role && curriculum) {
						$window.open(config.baseUrl + '/auth/' + provider + '/' + role + '/' + curriculum, "_self");
					};
				};




			}
			catch (err) {
				console.log(err);
			}
			vm.signup = function () {
				var modalInstance = $uibModal.open({
					animation: true,
					ariaLabelledBy: 'modal-title',
					ariaDescribedBy: 'modal-body',
					templateUrl: 'app/accounts/signup/signup.html',
					controller: 'SignupCtrl',
					controllerAs: 'vm',
					backdrop: 'static',
					keyboard: false,
					resolve: {

					}
				});
			}

		});


})();



(function () {

  'use strict';

  angular.module('kapdec')
    .controller('AdminPanelCtrl', function (config, $log, Auth, $scope, $rootScope, $localStorage, $uibModalStack,$uibModal, $timeout, $state) {
      var vm = this;

      $uibModalStack.dismissAll();
      vm.sidebarUrl = 'app/admin-panel/navbar-sidebar/sidebar.html';
      vm.topNavbarUrl = 'app/admin-panel/navbar-sidebar/top-navbar.html';
      vm.updateImg = true;
      vm.state = $state;


      vm.logout = function () {
        Auth.logout();
        $state.go('index.home');
      };

      vm.getImageUrl = function (id) {
        if (id) {
          return config.baseUrl + '/api/gfs/' + id;
        }
      };

      vm.init = function () {
        try {
          /**
            on init functionality
          **/

          Auth.getCurrentUser().$promise.then(function (res) {
            if (res && res.data) {

              if (res.data.role && (res.data.role == 'admin' || res.data.role == 'subAdmin')) {
                vm.user = res.data;
                $rootScope[res.data.role] = true;
              } else {
                // vm.logout();
              }
            }
          },
            function (error) {
              if (error && error.status == -1) {
                toastr.error("we are offline! try later", "Oops!");
              }
            });

        }
        catch (err) {
          // vm.logout();
          // $state.go('index.home');
        }

      };
      vm.init();

      /**
        on user profile info update watcher
      **/
      $scope.$on("uploaded", function (evt, data) {
        if (data && data.update) {
          vm.updateImg = false;
          $timeout(function () {
            vm.init();
            vm.updateImg = true;
          }, 800);
        }
      });

      vm.openChangePasswordModal = function (details, isEditable) {

        vm.details = { 'details': details };
        vm.modalValue = isEditable;

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modal/changePasswordModal.html',
          controller: 'adminChangePasswordCtrl',
          backdrop: 'static',
          keyboard: false,
          controllerAs: 'vm',
          resolve: {
            data: function () {
              return vm.details;
            },
            model: function () {
              return vm.modalValue;
            }
          }
        }).result.then(function (updated) {
          if (updated) {
          }
        }, function () {
        });


      };

    }).controller('adminChangePasswordCtrl', function (appPattern, $state, User, toastr, $uibModalInstance, Upload, config, Auth, $log, $scope, $timeout, $window) {
      var vm = this;
      vm.pattern = appPattern;
      vm.submitted = false;
      vm.loader = false;
      vm.user = {};

      vm.cancel = function () {
        $uibModalInstance.dismiss('Close');
      };

      vm.upload = function (form) {

        vm.submitted = true;
        // if (!vm.fullName) return false;
        // vm.user.name = vm.fullName;
        if ((vm.password && vm.confirmPassword) && !(vm.password === vm.confirmPassword)) return false;
        if (vm.password && vm.confirmPassword) vm.user.password = vm.password;
        vm.loader = true;

        if (form) {
          User.update({ data: vm.user }).$promise.then(function (res) {
            if (res && res.data) {
              vm.loader = false;
              toastr.success("Your Password has been updated successfully!");
              $uibModalInstance.dismiss('Close');
            }
          },
            function (error) {
              if (error) {
                vm.loader = false;
                toastr.error(error.data.message, "Oops!");
              }
            });
        } else {
          vm.loader = false;

        }
      }
    });


})();

(function () {

    'use strict';
    /**  admin :: states :: info
     * /admin :: admin-view page
       * /mangeuser ::manage-user page
       * /tests ::tests page
      */

    angular.module('kapdec')

        /** @ngInject */

        .config(function ($stateProvider, $ocLazyLoadProvider) {
            $stateProvider
                .state("admin", {
                    title: 'admin',
                    abstract: true,
                    url: "",
                    templateUrl: 'app/admin-panel/admin-panel.html',
                    controller: 'AdminPanelCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true,
                    resolve: {
                        checkUserRole: function (Auth, $location) {
                            Auth.isAdmin(function (res) {
                                if (!res) {
                                    $location.path('/dashboard');
                                }
                            })
                        },
                        loadPlugin: function ($ocLazyLoad) {
                            return $ocLazyLoad.load([
                                {
                                    serie: true,
                                    files: ['assets/js/datatables.min.js',
                                        'assets/js/sweetalert.min.js',
                                        'assets/css/datatables.min.css',
                                        'assets/css/sweetalert.css',
                                        'assets/css/bootstrap-chosen.css',
                                        'assets/css/chosen.css',
                                        'assets/js/quill.js',
                                        'assets/js/ng-quill.js',
                                        'assets/css/quill.snow.css',
                                        'assets/js/bootstrap-datetimepicker.min.js',
                                        '//nightly.datatables.net/css/dataTables.bootstrap4.min.css',
                                        'assets/css/select.min.css',
                                        'assets/css/paper-dashboard.css?v=2.0.0',
                                        'assets/css/responsive.css',

                                    ]
                                },
                                {
                                    serie: true,
                                    name: 'oitozero.ngSweetAlert',
                                    files: ['assets/js/angular-sweetalert.min.js']
                                },
                                {
                                    serie: true,
                                    name: 'datatables',
                                    files: ['assets/js/angular-datatables.min.js']
                                },
                                {
                                    serie: true,
                                    name: 'datatables.buttons',
                                    files: ['assets/js/angular-datatables.buttons.min.js']
                                },
                                {
                                    serie: true,
                                    files: ['assets/js/chosen.js', 'assets/js/chosen.jquery.js']
                                },
                                {
                                    serie: true,
                                    files: ['assets/js/lodash.min.js', 'assets/js/highstock-all.js', 'https://player.vimeo.com/api/player.js']
                                }

                            ]);
                        }

                    }
                })
                .state("admin.dashboardpanel", {
                    title: 'Admin Panel',
                    url: '/admin/dashboard-panel',
                    templateUrl: 'app/admin-panel/admin-dashboard/admin-dashboard.html',
                    controller: 'AdminDashboardCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.profiles", {
                    title: 'profile info',
                    url: '/profiles/:id',
                    templateUrl: 'app/admin-panel/profile/profile.html',
                    controller: 'AdminProfilesCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true,
                })
                .state("admin.editprofile", {
                    title: 'edit profile',
                    url: '/edit-admin-profile',
                    templateUrl: 'app/admin-panel/edit-profile/editProfile.html',
                    controller: 'EditAdminProfileCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.manageuser", {
                    title: 'Manange user',
                    url: '/admin/manage-user',
                    templateUrl: 'app/admin-panel/manage-user/manage-user.html',
                    controller: 'ManageUserCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managesubadmin", {
                    title: 'Manange Sub Admin',
                    url: '/admin/manage-subadmin',
                    templateUrl: 'app/admin-panel/manage-subadmin/manage-subadmin.html',
                    controller: 'ManageSubAdminCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managecourse", {
                    title: 'Manange Course',
                    url: '/admin/manage-course',
                    templateUrl: 'app/admin-panel/manage-course/manage-course.html',
                    controller: 'ManageCourseCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managetopic", {
                    title: 'Manange Topic',
                    url: '/admin/manage-topic',
                    templateUrl: 'app/admin-panel/manage-topic/manage-topic.html',
                    controller: 'ManageTopicCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.manageunit", {
                    title: 'Manange Module',
                    url: '/admin/manage-unit',
                    templateUrl: 'app/admin-panel/manage-unit/manage-unit.html',
                    controller: 'ManageUnitCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managechapter", {
                    title: 'Manange Chapter',
                    url: '/admin/manage-chapter',
                    templateUrl: 'app/admin-panel/manage-chapter/manage-chapter.html',
                    controller: 'ManageChapterCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.editsubscription", {
                    title: 'Manange Subscription',
                    url: '/admin/edit-subscription/?id',
                    templateUrl: 'app/admin-panel/manage-subscription/edit-subscription/edit-subscription.html',
                    controller: 'editSubscriptionController',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managestory", {
                    title: 'Manange Story',
                    url: '/admin/manage-story',
                    templateUrl: 'app/admin-panel/manage-story/manage-story.html',
                    controller: 'ManageStoryCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managevideo", {
                    title: 'Manange Video',
                    url: '/admin/manage-video',
                    templateUrl: 'app/admin-panel/manage-video/manage-video.html',
                    controller: 'ManageVideoCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managequestion", {
                    title: 'Manange Test Questions',
                    url: '/admin/manage-question',
                    templateUrl: 'app/admin-panel/manage-question/manage-question.html',
                    controller: 'ManageQuestionsCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.addquestion", {
                    title: 'Manange Test Questions',
                    url: '/admin/add-question/?questionId',
                    templateUrl: 'app/admin-panel/manage-question/add-question/add-question.html',
                    controller: 'TestQuesModalController',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managefaqs", {
                    title: 'Manange FAQs',
                    url: '/admin/manage-faqs',
                    templateUrl: 'app/admin-panel/manage-faq/manage-faq.html',
                    controller: 'ManageFaqCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.manageenquiry", {
                    title: 'manage enquiry',
                    url: '/admin/manage-enquiry',
                    templateUrl: 'app/admin-panel/manage-enquiry/manage-enquiry.html',
                    controller: 'ManageEnquiryCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managecareer", {
                    title: 'manage career',
                    url: '/admin/manage-career',
                    templateUrl: 'app/admin-panel/manage-career/manage-career.html',
                    controller: 'ManageCareerCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managesubscription", {
                    title: 'Manange Subscription',
                    url: '/admin/manage-subscription',
                    templateUrl: 'app/admin-panel/manage-subscription/manage-subscription.html',
                    controller: 'ManageSubscriptionCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managetransaction", {
                    title: 'Manange Transaction',
                    url: '/admin/manage-transaction',
                    templateUrl: 'app/admin-panel/manage-transaction/manage-transaction.html',
                    controller: 'ManageTransactionCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managecontents", {
                    title: 'Manange Contents',
                    url: '/admin/manage-contents',
                    templateUrl: 'app/admin-panel/manage-contents/manage-contents.html',
                    controller: 'ManageContentsCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.manageteams", {
                    title: 'Manange Teams',
                    url: '/admin/manage-teams',
                    templateUrl: 'app/admin-panel/manage-team/manage-team.html',
                    controller: 'ManageTeamCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managebanners", {
                    title: 'Manange Banners',
                    url: '/admin/manage-banners',
                    templateUrl: 'app/admin-panel/manage-banner/manage-banner.html',
                    controller: 'ManageBannerCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.managebadges", {
                    title: 'Manange Badges',
                    url: '/admin/manage-badges',
                    templateUrl: 'app/admin-panel/manage-badges/manage-badges.html',
                    controller: 'ManageBadgesCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.coursehierarchy", {
                    title: 'Manange Course-Hierarchy',
                    url: '/admin/manage-course-hierarchy',
                    templateUrl: 'app/admin-panel/manage-course-hierarchy/manage-course-hierarchy.html',
                    controller: 'ManageCourseHierarchyCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })
                .state("admin.grade", {
                    title: 'Manange Grade',
                    url: '/admin/manage-grade',
                    templateUrl: 'app/admin-panel/manage-grade/manage-grade.html',
                    controller: 'ManageGradeCtrl',
                    controllerAs: 'vm',
                    showHeader: false,
                    showFooter: false,
                    ensureAuthenticate: true
                })


        })


})();


(function () {
	'use strict';

	angular
		.module('kapdec')
		.constant('config', {
			appName: 'kapdec',
			version: 1.5,
			appVersion: 1.0,

			// baseUrl        : 'http://18.223.167.111',
			// baseUrl: 'http://3.15.5.6:4000',
			// baseUrl: 'http://108.175.15.221:3001',
			baseUrl: 'http://localhost:3001',
			logOutTimerByMinutes: 1,
			warningTimerByMinutes: 50


		});

	/** @ngInject */


})();

(function () {
	'use strict';

	angular
		.module('kapdec')
		.constant('countrys', {
			appName: 'kapdec',
			version: 1.5,
            appVersion: 1.0,
            countries : [
                {
                    "code": "AD",
                    "emoji": "🇦🇩",
                    "unicode": "U+1F1E6 U+1F1E9",
                    "name": "Andorra",
                    "title": "flag for Andorra",
                    "dialCode": "+376"
                },
                {
                    "code": "AE",
                    "emoji": "🇦🇪",
                    "unicode": "U+1F1E6 U+1F1EA",
                    "name": "United Arab Emirates",
                    "title": "flag for United Arab Emirates",
                    "dialCode": "+971"
                },
                {
                    "code": "AF",
                    "emoji": "🇦🇫",
                    "unicode": "U+1F1E6 U+1F1EB",
                    "name": "Afghanistan",
                    "title": "flag for Afghanistan",
                    "dialCode": "+93"
                },
                {
                    "code": "AG",
                    "emoji": "🇦🇬",
                    "unicode": "U+1F1E6 U+1F1EC",
                    "name": "Antigua and Barbuda",
                    "title": "flag for Antigua and Barbuda",
                    "dialCode": "+1268"
                },
                {
                    "code": "AI",
                    "emoji": "🇦🇮",
                    "unicode": "U+1F1E6 U+1F1EE",
                    "name": "Anguilla",
                    "title": "flag for Anguilla",
                    "dialCode": "+1 264"
                },
                {
                    "code": "AL",
                    "emoji": "🇦🇱",
                    "unicode": "U+1F1E6 U+1F1F1",
                    "name": "Albania",
                    "title": "flag for Albania",
                    "dialCode": "+355"
                },
                {
                    "code": "AM",
                    "emoji": "🇦🇲",
                    "unicode": "U+1F1E6 U+1F1F2",
                    "name": "Armenia",
                    "title": "flag for Armenia",
                    "dialCode": "+374"
                },
                {
                    "code": "AO",
                    "emoji": "🇦🇴",
                    "unicode": "U+1F1E6 U+1F1F4",
                    "name": "Angola",
                    "title": "flag for Angola",
                    "dialCode": "+244"
                },
                {
                    "code": "AQ",
                    "emoji": "🇦🇶",
                    "unicode": "U+1F1E6 U+1F1F6",
                    "name": "Antarctica",
                    "title": "flag for Antarctica",
                    "dialCode": null
                },
                {
                    "code": "AR",
                    "emoji": "🇦🇷",
                    "unicode": "U+1F1E6 U+1F1F7",
                    "name": "Argentina",
                    "title": "flag for Argentina",
                    "dialCode": "+54"
                },
                {
                    "code": "AS",
                    "emoji": "🇦🇸",
                    "unicode": "U+1F1E6 U+1F1F8",
                    "name": "American Samoa",
                    "title": "flag for American Samoa",
                    "dialCode": "+1 684"
                },
                {
                    "code": "AT",
                    "emoji": "🇦🇹",
                    "unicode": "U+1F1E6 U+1F1F9",
                    "name": "Austria",
                    "title": "flag for Austria",
                    "dialCode": "+43"
                },
                {
                    "code": "AU",
                    "emoji": "🇦🇺",
                    "unicode": "U+1F1E6 U+1F1FA",
                    "name": "Australia",
                    "title": "flag for Australia",
                    "dialCode": "+61"
                },
                {
                    "code": "AW",
                    "emoji": "🇦🇼",
                    "unicode": "U+1F1E6 U+1F1FC",
                    "name": "Aruba",
                    "title": "flag for Aruba",
                    "dialCode": "+297"
                },
                {
                    "code": "AX",
                    "emoji": "🇦🇽",
                    "unicode": "U+1F1E6 U+1F1FD",
                    "name": "Åland Islands",
                    "title": "flag for Åland Islands",
                    "dialCode": ""
                },
                {
                    "code": "AZ",
                    "emoji": "🇦🇿",
                    "unicode": "U+1F1E6 U+1F1FF",
                    "name": "Azerbaijan",
                    "title": "flag for Azerbaijan",
                    "dialCode": "+994"
                },
                {
                    "code": "BA",
                    "emoji": "🇧🇦",
                    "unicode": "U+1F1E7 U+1F1E6",
                    "name": "Bosnia and Herzegovina",
                    "title": "flag for Bosnia and Herzegovina",
                    "dialCode": "+387"
                },
                {
                    "code": "BB",
                    "emoji": "🇧🇧",
                    "unicode": "U+1F1E7 U+1F1E7",
                    "name": "Barbados",
                    "title": "flag for Barbados",
                    "dialCode": "+1 246"
                },
                {
                    "code": "BD",
                    "emoji": "🇧🇩",
                    "unicode": "U+1F1E7 U+1F1E9",
                    "name": "Bangladesh",
                    "title": "flag for Bangladesh",
                    "dialCode": "+880"
                },
                {
                    "code": "BE",
                    "emoji": "🇧🇪",
                    "unicode": "U+1F1E7 U+1F1EA",
                    "name": "Belgium",
                    "title": "flag for Belgium",
                    "dialCode": "+32"
                },
                {
                    "code": "BF",
                    "emoji": "🇧🇫",
                    "unicode": "U+1F1E7 U+1F1EB",
                    "name": "Burkina Faso",
                    "title": "flag for Burkina Faso",
                    "dialCode": "+226"
                },
                {
                    "code": "BG",
                    "emoji": "🇧🇬",
                    "unicode": "U+1F1E7 U+1F1EC",
                    "name": "Bulgaria",
                    "title": "flag for Bulgaria",
                    "dialCode": "+359"
                },
                {
                    "code": "BH",
                    "emoji": "🇧🇭",
                    "unicode": "U+1F1E7 U+1F1ED",
                    "name": "Bahrain",
                    "title": "flag for Bahrain",
                    "dialCode": "+973"
                },
                {
                    "code": "BI",
                    "emoji": "🇧🇮",
                    "unicode": "U+1F1E7 U+1F1EE",
                    "name": "Burundi",
                    "title": "flag for Burundi",
                    "dialCode": "+257"
                },
                {
                    "code": "BJ",
                    "emoji": "🇧🇯",
                    "unicode": "U+1F1E7 U+1F1EF",
                    "name": "Benin",
                    "title": "flag for Benin",
                    "dialCode": "+229"
                },
                {
                    "code": "BL",
                    "emoji": "🇧🇱",
                    "unicode": "U+1F1E7 U+1F1F1",
                    "name": "Saint Barthélemy",
                    "title": "flag for Saint Barthélemy",
                    "dialCode": "+590"
                },
                {
                    "code": "BM",
                    "emoji": "🇧🇲",
                    "unicode": "U+1F1E7 U+1F1F2",
                    "name": "Bermuda",
                    "title": "flag for Bermuda",
                    "dialCode": "+1 441"
                },
                {
                    "code": "BN",
                    "emoji": "🇧🇳",
                    "unicode": "U+1F1E7 U+1F1F3",
                    "name": "Brunei Darussalam",
                    "title": "flag for Brunei Darussalam",
                    "dialCode": "+673"
                },
                {
                    "code": "BO",
                    "emoji": "🇧🇴",
                    "unicode": "U+1F1E7 U+1F1F4",
                    "name": "Bolivia",
                    "title": "flag for Bolivia",
                    "dialCode": "+591"
                },
                {
                    "code": "BQ",
                    "emoji": "🇧🇶",
                    "unicode": "U+1F1E7 U+1F1F6",
                    "name": "Bonaire, Sint Eustatius and Saba",
                    "title": "flag for Bonaire, Sint Eustatius and Saba"
                },
                {
                    "code": "BR",
                    "emoji": "🇧🇷",
                    "unicode": "U+1F1E7 U+1F1F7",
                    "name": "Brazil",
                    "title": "flag for Brazil",
                    "dialCode": "+55"
                },
                {
                    "code": "BS",
                    "emoji": "🇧🇸",
                    "unicode": "U+1F1E7 U+1F1F8",
                    "name": "Bahamas",
                    "title": "flag for Bahamas",
                    "dialCode": "+1 242"
                },
                {
                    "code": "BT",
                    "emoji": "🇧🇹",
                    "unicode": "U+1F1E7 U+1F1F9",
                    "name": "Bhutan",
                    "title": "flag for Bhutan",
                    "dialCode": "+975"
                },
                {
                    "code": "BV",
                    "emoji": "🇧🇻",
                    "unicode": "U+1F1E7 U+1F1FB",
                    "name": "Bouvet Island",
                    "title": "flag for Bouvet Island"
                },
                {
                    "code": "BW",
                    "emoji": "🇧🇼",
                    "unicode": "U+1F1E7 U+1F1FC",
                    "name": "Botswana",
                    "title": "flag for Botswana",
                    "dialCode": "+267"
                },
                {
                    "code": "BY",
                    "emoji": "🇧🇾",
                    "unicode": "U+1F1E7 U+1F1FE",
                    "name": "Belarus",
                    "title": "flag for Belarus",
                    "dialCode": "+375"
                },
                {
                    "code": "BZ",
                    "emoji": "🇧🇿",
                    "unicode": "U+1F1E7 U+1F1FF",
                    "name": "Belize",
                    "title": "flag for Belize",
                    "dialCode": "+501"
                },
                {
                    "code": "CA",
                    "emoji": "🇨🇦",
                    "unicode": "U+1F1E8 U+1F1E6",
                    "name": "Canada",
                    "title": "flag for Canada",
                    "dialCode": "+1"
                },
                {
                    "code": "CC",
                    "emoji": "🇨🇨",
                    "unicode": "U+1F1E8 U+1F1E8",
                    "name": "Cocos (Keeling) Islands",
                    "title": "flag for Cocos (Keeling) Islands",
                    "dialCode": "+61"
                },
                {
                    "code": "CD",
                    "emoji": "🇨🇩",
                    "unicode": "U+1F1E8 U+1F1E9",
                    "name": "Congo",
                    "title": "flag for Congo",
                    "dialCode": "+243"
                },
                {
                    "code": "CF",
                    "emoji": "🇨🇫",
                    "unicode": "U+1F1E8 U+1F1EB",
                    "name": "Central African Republic",
                    "title": "flag for Central African Republic",
                    "dialCode": "+236"
                },
                {
                    "code": "CG",
                    "emoji": "🇨🇬",
                    "unicode": "U+1F1E8 U+1F1EC",
                    "name": "Congo",
                    "title": "flag for Congo",
                    "dialCode": "+242"
                },
                {
                    "code": "CH",
                    "emoji": "🇨🇭",
                    "unicode": "U+1F1E8 U+1F1ED",
                    "name": "Switzerland",
                    "title": "flag for Switzerland",
                    "dialCode": "+41"
                },
                {
                    "code": "CI",
                    "emoji": "🇨🇮",
                    "unicode": "U+1F1E8 U+1F1EE",
                    "name": "Côte D'Ivoire",
                    "title": "flag for Côte D'Ivoire",
                    "dialCode": "+225"
                },
                {
                    "code": "CK",
                    "emoji": "🇨🇰",
                    "unicode": "U+1F1E8 U+1F1F0",
                    "name": "Cook Islands",
                    "title": "flag for Cook Islands",
                    "dialCode": "+682"
                },
                {
                    "code": "CL",
                    "emoji": "🇨🇱",
                    "unicode": "U+1F1E8 U+1F1F1",
                    "name": "Chile",
                    "title": "flag for Chile",
                    "dialCode": "+56"
                },
                {
                    "code": "CM",
                    "emoji": "🇨🇲",
                    "unicode": "U+1F1E8 U+1F1F2",
                    "name": "Cameroon",
                    "title": "flag for Cameroon",
                    "dialCode": "+237"
                },
                {
                    "code": "CN",
                    "emoji": "🇨🇳",
                    "unicode": "U+1F1E8 U+1F1F3",
                    "name": "China",
                    "title": "flag for China",
                    "dialCode": "+86"
                },
                {
                    "code": "CO",
                    "emoji": "🇨🇴",
                    "unicode": "U+1F1E8 U+1F1F4",
                    "name": "Colombia",
                    "title": "flag for Colombia",
                    "dialCode": "+57"
                },
                {
                    "code": "CR",
                    "emoji": "🇨🇷",
                    "unicode": "U+1F1E8 U+1F1F7",
                    "name": "Costa Rica",
                    "title": "flag for Costa Rica",
                    "dialCode": "+506"
                },
                {
                    "code": "CU",
                    "emoji": "🇨🇺",
                    "unicode": "U+1F1E8 U+1F1FA",
                    "name": "Cuba",
                    "title": "flag for Cuba",
                    "dialCode": "+53"
                },
                {
                    "code": "CV",
                    "emoji": "🇨🇻",
                    "unicode": "U+1F1E8 U+1F1FB",
                    "name": "Cape Verde",
                    "title": "flag for Cape Verde",
                    "dialCode": "+238"
                },
                {
                    "code": "CW",
                    "emoji": "🇨🇼",
                    "unicode": "U+1F1E8 U+1F1FC",
                    "name": "Curaçao",
                    "title": "flag for Curaçao"
                },
                {
                    "code": "CX",
                    "emoji": "🇨🇽",
                    "unicode": "U+1F1E8 U+1F1FD",
                    "name": "Christmas Island",
                    "title": "flag for Christmas Island",
                    "dialCode": "+61"
                },
                {
                    "code": "CY",
                    "emoji": "🇨🇾",
                    "unicode": "U+1F1E8 U+1F1FE",
                    "name": "Cyprus",
                    "title": "flag for Cyprus",
                    "dialCode": "+537"
                },
                {
                    "code": "CZ",
                    "emoji": "🇨🇿",
                    "unicode": "U+1F1E8 U+1F1FF",
                    "name": "Czech Republic",
                    "title": "flag for Czech Republic",
                    "dialCode": "+420"
                },
                {
                    "code": "DE",
                    "emoji": "🇩🇪",
                    "unicode": "U+1F1E9 U+1F1EA",
                    "name": "Germany",
                    "title": "flag for Germany",
                    "dialCode": "+49"
                },
                {
                    "code": "DJ",
                    "emoji": "🇩🇯",
                    "unicode": "U+1F1E9 U+1F1EF",
                    "name": "Djibouti",
                    "title": "flag for Djibouti",
                    "dialCode": "+253"
                },
                {
                    "code": "DK",
                    "emoji": "🇩🇰",
                    "unicode": "U+1F1E9 U+1F1F0",
                    "name": "Denmark",
                    "title": "flag for Denmark",
                    "dialCode": "+45"
                },
                {
                    "code": "DM",
                    "emoji": "🇩🇲",
                    "unicode": "U+1F1E9 U+1F1F2",
                    "name": "Dominica",
                    "title": "flag for Dominica",
                    "dialCode": "+1 767"
                },
                {
                    "code": "DO",
                    "emoji": "🇩🇴",
                    "unicode": "U+1F1E9 U+1F1F4",
                    "name": "Dominican Republic",
                    "title": "flag for Dominican Republic",
                    "dialCode": "+1 849"
                },
                {
                    "code": "DZ",
                    "emoji": "🇩🇿",
                    "unicode": "U+1F1E9 U+1F1FF",
                    "name": "Algeria",
                    "title": "flag for Algeria",
                    "dialCode": "+213"
                },
                {
                    "code": "EC",
                    "emoji": "🇪🇨",
                    "unicode": "U+1F1EA U+1F1E8",
                    "name": "Ecuador",
                    "title": "flag for Ecuador",
                    "dialCode": "+593"
                },
                {
                    "code": "EE",
                    "emoji": "🇪🇪",
                    "unicode": "U+1F1EA U+1F1EA",
                    "name": "Estonia",
                    "title": "flag for Estonia",
                    "dialCode": "+372"
                },
                {
                    "code": "EG",
                    "emoji": "🇪🇬",
                    "unicode": "U+1F1EA U+1F1EC",
                    "name": "Egypt",
                    "title": "flag for Egypt",
                    "dialCode": "+20"
                },
                {
                    "code": "EH",
                    "emoji": "🇪🇭",
                    "unicode": "U+1F1EA U+1F1ED",
                    "name": "Western Sahara",
                    "title": "flag for Western Sahara"
                },
                {
                    "code": "ER",
                    "emoji": "🇪🇷",
                    "unicode": "U+1F1EA U+1F1F7",
                    "name": "Eritrea",
                    "title": "flag for Eritrea",
                    "dialCode": "+291"
                },
                {
                    "code": "ES",
                    "emoji": "🇪🇸",
                    "unicode": "U+1F1EA U+1F1F8",
                    "name": "Spain",
                    "title": "flag for Spain",
                    "dialCode": "+34"
                },
                {
                    "code": "ET",
                    "emoji": "🇪🇹",
                    "unicode": "U+1F1EA U+1F1F9",
                    "name": "Ethiopia",
                    "title": "flag for Ethiopia",
                    "dialCode": "+251"
                },
                {
                    "code": "EU",
                    "emoji": "🇪🇺",
                    "unicode": "U+1F1EA U+1F1FA",
                    "name": "European Union",
                    "title": "flag for European Union"
                },
                {
                    "code": "FI",
                    "emoji": "🇫🇮",
                    "unicode": "U+1F1EB U+1F1EE",
                    "name": "Finland",
                    "title": "flag for Finland",
                    "dialCode": "+358"
                },
                {
                    "code": "FJ",
                    "emoji": "🇫🇯",
                    "unicode": "U+1F1EB U+1F1EF",
                    "name": "Fiji",
                    "title": "flag for Fiji",
                    "dialCode": "+679"
                },
                {
                    "code": "FK",
                    "emoji": "🇫🇰",
                    "unicode": "U+1F1EB U+1F1F0",
                    "name": "Falkland Islands (Malvinas)",
                    "title": "flag for Falkland Islands (Malvinas)",
                    "dialCode": "+500"
                },
                {
                    "code": "FM",
                    "emoji": "🇫🇲",
                    "unicode": "U+1F1EB U+1F1F2",
                    "name": "Micronesia",
                    "title": "flag for Micronesia",
                    "dialCode": "+691"
                },
                {
                    "code": "FO",
                    "emoji": "🇫🇴",
                    "unicode": "U+1F1EB U+1F1F4",
                    "name": "Faroe Islands",
                    "title": "flag for Faroe Islands",
                    "dialCode": "+298"
                },
                {
                    "code": "FR",
                    "emoji": "🇫🇷",
                    "unicode": "U+1F1EB U+1F1F7",
                    "name": "France",
                    "title": "flag for France",
                    "dialCode": "+33"
                },
                {
                    "code": "GA",
                    "emoji": "🇬🇦",
                    "unicode": "U+1F1EC U+1F1E6",
                    "name": "Gabon",
                    "title": "flag for Gabon",
                    "dialCode": "+241"
                },
                {
                    "code": "GB",
                    "emoji": "🇬🇧",
                    "unicode": "U+1F1EC U+1F1E7",
                    "name": "United Kingdom",
                    "title": "flag for United Kingdom",
                    "dialCode": "+44"
                },
                {
                    "code": "GD",
                    "emoji": "🇬🇩",
                    "unicode": "U+1F1EC U+1F1E9",
                    "name": "Grenada",
                    "title": "flag for Grenada",
                    "dialCode": "+1 473"
                },
                {
                    "code": "GE",
                    "emoji": "🇬🇪",
                    "unicode": "U+1F1EC U+1F1EA",
                    "name": "Georgia",
                    "title": "flag for Georgia",
                    "dialCode": "+995"
                },
                {
                    "code": "GF",
                    "emoji": "🇬🇫",
                    "unicode": "U+1F1EC U+1F1EB",
                    "name": "French Guiana",
                    "title": "flag for French Guiana",
                    "dialCode": "+594"
                },
                {
                    "code": "GG",
                    "emoji": "🇬🇬",
                    "unicode": "U+1F1EC U+1F1EC",
                    "name": "Guernsey",
                    "title": "flag for Guernsey",
                    "dialCode": "+44"
                },
                {
                    "code": "GH",
                    "emoji": "🇬🇭",
                    "unicode": "U+1F1EC U+1F1ED",
                    "name": "Ghana",
                    "title": "flag for Ghana",
                    "dialCode": "+233"
                },
                {
                    "code": "GI",
                    "emoji": "🇬🇮",
                    "unicode": "U+1F1EC U+1F1EE",
                    "name": "Gibraltar",
                    "title": "flag for Gibraltar",
                    "dialCode": "+350"
                },
                {
                    "code": "GL",
                    "emoji": "🇬🇱",
                    "unicode": "U+1F1EC U+1F1F1",
                    "name": "Greenland",
                    "title": "flag for Greenland",
                    "dialCode": "+299"
                },
                {
                    "code": "GM",
                    "emoji": "🇬🇲",
                    "unicode": "U+1F1EC U+1F1F2",
                    "name": "Gambia",
                    "title": "flag for Gambia",
                    "dialCode": "+220"
                },
                {
                    "code": "GN",
                    "emoji": "🇬🇳",
                    "unicode": "U+1F1EC U+1F1F3",
                    "name": "Guinea",
                    "title": "flag for Guinea",
                    "dialCode": "+224"
                },
                {
                    "code": "GP",
                    "emoji": "🇬🇵",
                    "unicode": "U+1F1EC U+1F1F5",
                    "name": "Guadeloupe",
                    "title": "flag for Guadeloupe",
                    "dialCode": "+590"
                },
                {
                    "code": "GQ",
                    "emoji": "🇬🇶",
                    "unicode": "U+1F1EC U+1F1F6",
                    "name": "Equatorial Guinea",
                    "title": "flag for Equatorial Guinea",
                    "dialCode": "+240"
                },
                {
                    "code": "GR",
                    "emoji": "🇬🇷",
                    "unicode": "U+1F1EC U+1F1F7",
                    "name": "Greece",
                    "title": "flag for Greece",
                    "dialCode": "+30"
                },
                {
                    "code": "GS",
                    "emoji": "🇬🇸",
                    "unicode": "U+1F1EC U+1F1F8",
                    "name": "South Georgia",
                    "title": "flag for South Georgia",
                    "dialCode": "+500"
                },
                {
                    "code": "GT",
                    "emoji": "🇬🇹",
                    "unicode": "U+1F1EC U+1F1F9",
                    "name": "Guatemala",
                    "title": "flag for Guatemala",
                    "dialCode": "+502"
                },
                {
                    "code": "GU",
                    "emoji": "🇬🇺",
                    "unicode": "U+1F1EC U+1F1FA",
                    "name": "Guam",
                    "title": "flag for Guam",
                    "dialCode": "+1 671"
                },
                {
                    "code": "GW",
                    "emoji": "🇬🇼",
                    "unicode": "U+1F1EC U+1F1FC",
                    "name": "Guinea-Bissau",
                    "title": "flag for Guinea-Bissau",
                    "dialCode": "+245"
                },
                {
                    "code": "GY",
                    "emoji": "🇬🇾",
                    "unicode": "U+1F1EC U+1F1FE",
                    "name": "Guyana",
                    "title": "flag for Guyana",
                    "dialCode": "+595"
                },
                {
                    "code": "HK",
                    "emoji": "🇭🇰",
                    "unicode": "U+1F1ED U+1F1F0",
                    "name": "Hong Kong",
                    "title": "flag for Hong Kong",
                    "dialCode": "+852"
                },
                {
                    "code": "HM",
                    "emoji": "🇭🇲",
                    "unicode": "U+1F1ED U+1F1F2",
                    "name": "Heard Island and Mcdonald Islands",
                    "title": "flag for Heard Island and Mcdonald Islands"
                },
                {
                    "code": "HN",
                    "emoji": "🇭🇳",
                    "unicode": "U+1F1ED U+1F1F3",
                    "name": "Honduras",
                    "title": "flag for Honduras",
                    "dialCode": "+504"
                },
                {
                    "code": "HR",
                    "emoji": "🇭🇷",
                    "unicode": "U+1F1ED U+1F1F7",
                    "name": "Croatia",
                    "title": "flag for Croatia",
                    "dialCode": "+385"
                },
                {
                    "code": "HT",
                    "emoji": "🇭🇹",
                    "unicode": "U+1F1ED U+1F1F9",
                    "name": "Haiti",
                    "title": "flag for Haiti",
                    "dialCode": "+509"
                },
                {
                    "code": "HU",
                    "emoji": "🇭🇺",
                    "unicode": "U+1F1ED U+1F1FA",
                    "name": "Hungary",
                    "title": "flag for Hungary",
                    "dialCode": "+36"
                },
                {
                    "code": "ID",
                    "emoji": "🇮🇩",
                    "unicode": "U+1F1EE U+1F1E9",
                    "name": "Indonesia",
                    "title": "flag for Indonesia",
                    "dialCode": "+62"
                },
                {
                    "code": "IE",
                    "emoji": "🇮🇪",
                    "unicode": "U+1F1EE U+1F1EA",
                    "name": "Ireland",
                    "title": "flag for Ireland",
                    "dialCode": "+353"
                },
                {
                    "code": "IL",
                    "emoji": "🇮🇱",
                    "unicode": "U+1F1EE U+1F1F1",
                    "name": "Israel",
                    "title": "flag for Israel",
                    "dialCode": "+972"
                },
                {
                    "code": "IM",
                    "emoji": "🇮🇲",
                    "unicode": "U+1F1EE U+1F1F2",
                    "name": "Isle of Man",
                    "title": "flag for Isle of Man",
                    "dialCode": "+44"
                },
                {
                    "code": "IN",
                    "emoji": "🇮🇳",
                    "unicode": "U+1F1EE U+1F1F3",
                    "name": "India",
                    "title": "flag for India",
                    "dialCode": "+91"
                },
                {
                    "code": "IO",
                    "emoji": "🇮🇴",
                    "unicode": "U+1F1EE U+1F1F4",
                    "name": "British Indian Ocean Territory",
                    "title": "flag for British Indian Ocean Territory",
                    "dialCode": "+246"
                },
                {
                    "code": "IQ",
                    "emoji": "🇮🇶",
                    "unicode": "U+1F1EE U+1F1F6",
                    "name": "Iraq",
                    "title": "flag for Iraq",
                    "dialCode": "+964"
                },
                {
                    "code": "IR",
                    "emoji": "🇮🇷",
                    "unicode": "U+1F1EE U+1F1F7",
                    "name": "Iran",
                    "title": "flag for Iran",
                    "dialCode": "+98"
                },
                {
                    "code": "IS",
                    "emoji": "🇮🇸",
                    "unicode": "U+1F1EE U+1F1F8",
                    "name": "Iceland",
                    "title": "flag for Iceland",
                    "dialCode": "+354"
                },
                {
                    "code": "IT",
                    "emoji": "🇮🇹",
                    "unicode": "U+1F1EE U+1F1F9",
                    "name": "Italy",
                    "title": "flag for Italy",
                    "dialCode": "+39"
                },
                {
                    "code": "JE",
                    "emoji": "🇯🇪",
                    "unicode": "U+1F1EF U+1F1EA",
                    "name": "Jersey",
                    "title": "flag for Jersey",
                    "dialCode": "+44"
                },
                {
                    "code": "JM",
                    "emoji": "🇯🇲",
                    "unicode": "U+1F1EF U+1F1F2",
                    "name": "Jamaica",
                    "title": "flag for Jamaica",
                    "dialCode": "+1 876"
                },
                {
                    "code": "JO",
                    "emoji": "🇯🇴",
                    "unicode": "U+1F1EF U+1F1F4",
                    "name": "Jordan",
                    "title": "flag for Jordan",
                    "dialCode": "+962"
                },
                {
                    "code": "JP",
                    "emoji": "🇯🇵",
                    "unicode": "U+1F1EF U+1F1F5",
                    "name": "Japan",
                    "title": "flag for Japan",
                    "dialCode": "+81"
                },
                {
                    "code": "KE",
                    "emoji": "🇰🇪",
                    "unicode": "U+1F1F0 U+1F1EA",
                    "name": "Kenya",
                    "title": "flag for Kenya",
                    "dialCode": "+254"
                },
                {
                    "code": "KG",
                    "emoji": "🇰🇬",
                    "unicode": "U+1F1F0 U+1F1EC",
                    "name": "Kyrgyzstan",
                    "title": "flag for Kyrgyzstan",
                    "dialCode": "+996"
                },
                {
                    "code": "KH",
                    "emoji": "🇰🇭",
                    "unicode": "U+1F1F0 U+1F1ED",
                    "name": "Cambodia",
                    "title": "flag for Cambodia",
                    "dialCode": "+855"
                },
                {
                    "code": "KI",
                    "emoji": "🇰🇮",
                    "unicode": "U+1F1F0 U+1F1EE",
                    "name": "Kiribati",
                    "title": "flag for Kiribati",
                    "dialCode": "+686"
                },
                {
                    "code": "KM",
                    "emoji": "🇰🇲",
                    "unicode": "U+1F1F0 U+1F1F2",
                    "name": "Comoros",
                    "title": "flag for Comoros",
                    "dialCode": "+269"
                },
                {
                    "code": "KN",
                    "emoji": "🇰🇳",
                    "unicode": "U+1F1F0 U+1F1F3",
                    "name": "Saint Kitts and Nevis",
                    "title": "flag for Saint Kitts and Nevis",
                    "dialCode": "+1 869"
                },
                {
                    "code": "KP",
                    "emoji": "🇰🇵",
                    "unicode": "U+1F1F0 U+1F1F5",
                    "name": "North Korea",
                    "title": "flag for North Korea",
                    "dialCode": "+850"
                },
                {
                    "code": "KR",
                    "emoji": "🇰🇷",
                    "unicode": "U+1F1F0 U+1F1F7",
                    "name": "South Korea",
                    "title": "flag for South Korea",
                    "dialCode": "+82"
                },
                {
                    "code": "KW",
                    "emoji": "🇰🇼",
                    "unicode": "U+1F1F0 U+1F1FC",
                    "name": "Kuwait",
                    "title": "flag for Kuwait",
                    "dialCode": "+965"
                },
                {
                    "code": "KY",
                    "emoji": "🇰🇾",
                    "unicode": "U+1F1F0 U+1F1FE",
                    "name": "Cayman Islands",
                    "title": "flag for Cayman Islands",
                    "dialCode": "+ 345"
                },
                {
                    "code": "KZ",
                    "emoji": "🇰🇿",
                    "unicode": "U+1F1F0 U+1F1FF",
                    "name": "Kazakhstan",
                    "title": "flag for Kazakhstan",
                    "dialCode": "+7 7"
                },
                {
                    "code": "LA",
                    "emoji": "🇱🇦",
                    "unicode": "U+1F1F1 U+1F1E6",
                    "name": "Lao People's Democratic Republic",
                    "title": "flag for Lao People's Democratic Republic",
                    "dialCode": "+856"
                },
                {
                    "code": "LB",
                    "emoji": "🇱🇧",
                    "unicode": "U+1F1F1 U+1F1E7",
                    "name": "Lebanon",
                    "title": "flag for Lebanon",
                    "dialCode": "+961"
                },
                {
                    "code": "LC",
                    "emoji": "🇱🇨",
                    "unicode": "U+1F1F1 U+1F1E8",
                    "name": "Saint Lucia",
                    "title": "flag for Saint Lucia",
                    "dialCode": "+1 758"
                },
                {
                    "code": "LI",
                    "emoji": "🇱🇮",
                    "unicode": "U+1F1F1 U+1F1EE",
                    "name": "Liechtenstein",
                    "title": "flag for Liechtenstein",
                    "dialCode": "+423"
                },
                {
                    "code": "LK",
                    "emoji": "🇱🇰",
                    "unicode": "U+1F1F1 U+1F1F0",
                    "name": "Sri Lanka",
                    "title": "flag for Sri Lanka",
                    "dialCode": "+94"
                },
                {
                    "code": "LR",
                    "emoji": "🇱🇷",
                    "unicode": "U+1F1F1 U+1F1F7",
                    "name": "Liberia",
                    "title": "flag for Liberia",
                    "dialCode": "+231"
                },
                {
                    "code": "LS",
                    "emoji": "🇱🇸",
                    "unicode": "U+1F1F1 U+1F1F8",
                    "name": "Lesotho",
                    "title": "flag for Lesotho",
                    "dialCode": "+266"
                },
                {
                    "code": "LT",
                    "emoji": "🇱🇹",
                    "unicode": "U+1F1F1 U+1F1F9",
                    "name": "Lithuania",
                    "title": "flag for Lithuania",
                    "dialCode": "+370"
                },
                {
                    "code": "LU",
                    "emoji": "🇱🇺",
                    "unicode": "U+1F1F1 U+1F1FA",
                    "name": "Luxembourg",
                    "title": "flag for Luxembourg",
                    "dialCode": "+352"
                },
                {
                    "code": "LV",
                    "emoji": "🇱🇻",
                    "unicode": "U+1F1F1 U+1F1FB",
                    "name": "Latvia",
                    "title": "flag for Latvia",
                    "dialCode": "+371"
                },
                {
                    "code": "LY",
                    "emoji": "🇱🇾",
                    "unicode": "U+1F1F1 U+1F1FE",
                    "name": "Libya",
                    "title": "flag for Libya",
                    "dialCode": "+218"
                },
                {
                    "code": "MA",
                    "emoji": "🇲🇦",
                    "unicode": "U+1F1F2 U+1F1E6",
                    "name": "Morocco",
                    "title": "flag for Morocco",
                    "dialCode": "+212"
                },
                {
                    "code": "MC",
                    "emoji": "🇲🇨",
                    "unicode": "U+1F1F2 U+1F1E8",
                    "name": "Monaco",
                    "title": "flag for Monaco",
                    "dialCode": "+377"
                },
                {
                    "code": "MD",
                    "emoji": "🇲🇩",
                    "unicode": "U+1F1F2 U+1F1E9",
                    "name": "Moldova",
                    "title": "flag for Moldova",
                    "dialCode": "+373"
                },
                {
                    "code": "ME",
                    "emoji": "🇲🇪",
                    "unicode": "U+1F1F2 U+1F1EA",
                    "name": "Montenegro",
                    "title": "flag for Montenegro",
                    "dialCode": "+382"
                },
                {
                    "code": "MF",
                    "emoji": "🇲🇫",
                    "unicode": "U+1F1F2 U+1F1EB",
                    "name": "Saint Martin (French Part)",
                    "title": "flag for Saint Martin (French Part)",
                    "dialCode": "+590"
                },
                {
                    "code": "MG",
                    "emoji": "🇲🇬",
                    "unicode": "U+1F1F2 U+1F1EC",
                    "name": "Madagascar",
                    "title": "flag for Madagascar",
                    "dialCode": "+261"
                },
                {
                    "code": "MH",
                    "emoji": "🇲🇭",
                    "unicode": "U+1F1F2 U+1F1ED",
                    "name": "Marshall Islands",
                    "title": "flag for Marshall Islands",
                    "dialCode": "+692"
                },
                {
                    "code": "MK",
                    "emoji": "🇲🇰",
                    "unicode": "U+1F1F2 U+1F1F0",
                    "name": "Macedonia",
                    "title": "flag for Macedonia",
                    "dialCode": "+389"
                },
                {
                    "code": "ML",
                    "emoji": "🇲🇱",
                    "unicode": "U+1F1F2 U+1F1F1",
                    "name": "Mali",
                    "title": "flag for Mali",
                    "dialCode": "+223"
                },
                {
                    "code": "MM",
                    "emoji": "🇲🇲",
                    "unicode": "U+1F1F2 U+1F1F2",
                    "name": "Myanmar",
                    "title": "flag for Myanmar",
                    "dialCode": "+95"
                },
                {
                    "code": "MN",
                    "emoji": "🇲🇳",
                    "unicode": "U+1F1F2 U+1F1F3",
                    "name": "Mongolia",
                    "title": "flag for Mongolia",
                    "dialCode": "+976"
                },
                {
                    "code": "MO",
                    "emoji": "🇲🇴",
                    "unicode": "U+1F1F2 U+1F1F4",
                    "name": "Macao",
                    "title": "flag for Macao",
                    "dialCode": "+853"
                },
                {
                    "code": "MP",
                    "emoji": "🇲🇵",
                    "unicode": "U+1F1F2 U+1F1F5",
                    "name": "Northern Mariana Islands",
                    "title": "flag for Northern Mariana Islands",
                    "dialCode": "+1 670"
                },
                {
                    "code": "MQ",
                    "emoji": "🇲🇶",
                    "unicode": "U+1F1F2 U+1F1F6",
                    "name": "Martinique",
                    "title": "flag for Martinique",
                    "dialCode": "+596"
                },
                {
                    "code": "MR",
                    "emoji": "🇲🇷",
                    "unicode": "U+1F1F2 U+1F1F7",
                    "name": "Mauritania",
                    "title": "flag for Mauritania",
                    "dialCode": "+222"
                },
                {
                    "code": "MS",
                    "emoji": "🇲🇸",
                    "unicode": "U+1F1F2 U+1F1F8",
                    "name": "Montserrat",
                    "title": "flag for Montserrat",
                    "dialCode": "+1664"
                },
                {
                    "code": "MT",
                    "emoji": "🇲🇹",
                    "unicode": "U+1F1F2 U+1F1F9",
                    "name": "Malta",
                    "title": "flag for Malta",
                    "dialCode": "+356"
                },
                {
                    "code": "MU",
                    "emoji": "🇲🇺",
                    "unicode": "U+1F1F2 U+1F1FA",
                    "name": "Mauritius",
                    "title": "flag for Mauritius",
                    "dialCode": "+230"
                },
                {
                    "code": "MV",
                    "emoji": "🇲🇻",
                    "unicode": "U+1F1F2 U+1F1FB",
                    "name": "Maldives",
                    "title": "flag for Maldives",
                    "dialCode": "+960"
                },
                {
                    "code": "MW",
                    "emoji": "🇲🇼",
                    "unicode": "U+1F1F2 U+1F1FC",
                    "name": "Malawi",
                    "title": "flag for Malawi",
                    "dialCode": "+265"
                },
                {
                    "code": "MX",
                    "emoji": "🇲🇽",
                    "unicode": "U+1F1F2 U+1F1FD",
                    "name": "Mexico",
                    "title": "flag for Mexico",
                    "dialCode": "+52"
                },
                {
                    "code": "MY",
                    "emoji": "🇲🇾",
                    "unicode": "U+1F1F2 U+1F1FE",
                    "name": "Malaysia",
                    "title": "flag for Malaysia",
                    "dialCode": "+60"
                },
                {
                    "code": "MZ",
                    "emoji": "🇲🇿",
                    "unicode": "U+1F1F2 U+1F1FF",
                    "name": "Mozambique",
                    "title": "flag for Mozambique",
                    "dialCode": "+258"
                },
                {
                    "code": "NA",
                    "emoji": "🇳🇦",
                    "unicode": "U+1F1F3 U+1F1E6",
                    "name": "Namibia",
                    "title": "flag for Namibia",
                    "dialCode": "+264"
                },
                {
                    "code": "NC",
                    "emoji": "🇳🇨",
                    "unicode": "U+1F1F3 U+1F1E8",
                    "name": "New Caledonia",
                    "title": "flag for New Caledonia",
                    "dialCode": "+687"
                },
                {
                    "code": "NE",
                    "emoji": "🇳🇪",
                    "unicode": "U+1F1F3 U+1F1EA",
                    "name": "Niger",
                    "title": "flag for Niger",
                    "dialCode": "+227"
                },
                {
                    "code": "NF",
                    "emoji": "🇳🇫",
                    "unicode": "U+1F1F3 U+1F1EB",
                    "name": "Norfolk Island",
                    "title": "flag for Norfolk Island",
                    "dialCode": "+672"
                },
                {
                    "code": "NG",
                    "emoji": "🇳🇬",
                    "unicode": "U+1F1F3 U+1F1EC",
                    "name": "Nigeria",
                    "title": "flag for Nigeria",
                    "dialCode": "+234"
                },
                {
                    "code": "NI",
                    "emoji": "🇳🇮",
                    "unicode": "U+1F1F3 U+1F1EE",
                    "name": "Nicaragua",
                    "title": "flag for Nicaragua",
                    "dialCode": "+505"
                },
                {
                    "code": "NL",
                    "emoji": "🇳🇱",
                    "unicode": "U+1F1F3 U+1F1F1",
                    "name": "Netherlands",
                    "title": "flag for Netherlands",
                    "dialCode": "+31"
                },
                {
                    "code": "NO",
                    "emoji": "🇳🇴",
                    "unicode": "U+1F1F3 U+1F1F4",
                    "name": "Norway",
                    "title": "flag for Norway",
                    "dialCode": "+47"
                },
                {
                    "code": "NP",
                    "emoji": "🇳🇵",
                    "unicode": "U+1F1F3 U+1F1F5",
                    "name": "Nepal",
                    "title": "flag for Nepal",
                    "dialCode": "+977"
                },
                {
                    "code": "NR",
                    "emoji": "🇳🇷",
                    "unicode": "U+1F1F3 U+1F1F7",
                    "name": "Nauru",
                    "title": "flag for Nauru",
                    "dialCode": "+674"
                },
                {
                    "code": "NU",
                    "emoji": "🇳🇺",
                    "unicode": "U+1F1F3 U+1F1FA",
                    "name": "Niue",
                    "title": "flag for Niue",
                    "dialCode": "+683"
                },
                {
                    "code": "NZ",
                    "emoji": "🇳🇿",
                    "unicode": "U+1F1F3 U+1F1FF",
                    "name": "New Zealand",
                    "title": "flag for New Zealand",
                    "dialCode": "+64"
                },
                {
                    "code": "OM",
                    "emoji": "🇴🇲",
                    "unicode": "U+1F1F4 U+1F1F2",
                    "name": "Oman",
                    "title": "flag for Oman",
                    "dialCode": "+968"
                },
                {
                    "code": "PA",
                    "emoji": "🇵🇦",
                    "unicode": "U+1F1F5 U+1F1E6",
                    "name": "Panama",
                    "title": "flag for Panama",
                    "dialCode": "+507"
                },
                {
                    "code": "PE",
                    "emoji": "🇵🇪",
                    "unicode": "U+1F1F5 U+1F1EA",
                    "name": "Peru",
                    "title": "flag for Peru",
                    "dialCode": "+51"
                },
                {
                    "code": "PF",
                    "emoji": "🇵🇫",
                    "unicode": "U+1F1F5 U+1F1EB",
                    "name": "French Polynesia",
                    "title": "flag for French Polynesia",
                    "dialCode": "+689"
                },
                {
                    "code": "PG",
                    "emoji": "🇵🇬",
                    "unicode": "U+1F1F5 U+1F1EC",
                    "name": "Papua New Guinea",
                    "title": "flag for Papua New Guinea",
                    "dialCode": "+675"
                },
                {
                    "code": "PH",
                    "emoji": "🇵🇭",
                    "unicode": "U+1F1F5 U+1F1ED",
                    "name": "Philippines",
                    "title": "flag for Philippines",
                    "dialCode": "+63"
                },
                {
                    "code": "PK",
                    "emoji": "🇵🇰",
                    "unicode": "U+1F1F5 U+1F1F0",
                    "name": "Pakistan",
                    "title": "flag for Pakistan",
                    "dialCode": "+92"
                },
                {
                    "code": "PL",
                    "emoji": "🇵🇱",
                    "unicode": "U+1F1F5 U+1F1F1",
                    "name": "Poland",
                    "title": "flag for Poland",
                    "dialCode": "+48"
                },
                {
                    "code": "PM",
                    "emoji": "🇵🇲",
                    "unicode": "U+1F1F5 U+1F1F2",
                    "name": "Saint Pierre and Miquelon",
                    "title": "flag for Saint Pierre and Miquelon",
                    "dialCode": "+508"
                },
                {
                    "code": "PN",
                    "emoji": "🇵🇳",
                    "unicode": "U+1F1F5 U+1F1F3",
                    "name": "Pitcairn",
                    "title": "flag for Pitcairn",
                    "dialCode": "+872"
                },
                {
                    "code": "PR",
                    "emoji": "🇵🇷",
                    "unicode": "U+1F1F5 U+1F1F7",
                    "name": "Puerto Rico",
                    "title": "flag for Puerto Rico",
                    "dialCode": "+1 939"
                },
                {
                    "code": "PS",
                    "emoji": "🇵🇸",
                    "unicode": "U+1F1F5 U+1F1F8",
                    "name": "Palestinian Territory",
                    "title": "flag for Palestinian Territory",
                    "dialCode": "+970"
                },
                {
                    "code": "PT",
                    "emoji": "🇵🇹",
                    "unicode": "U+1F1F5 U+1F1F9",
                    "name": "Portugal",
                    "title": "flag for Portugal",
                    "dialCode": "+351"
                },
                {
                    "code": "PW",
                    "emoji": "🇵🇼",
                    "unicode": "U+1F1F5 U+1F1FC",
                    "name": "Palau",
                    "title": "flag for Palau",
                    "dialCode": "+680"
                },
                {
                    "code": "PY",
                    "emoji": "🇵🇾",
                    "unicode": "U+1F1F5 U+1F1FE",
                    "name": "Paraguay",
                    "title": "flag for Paraguay",
                    "dialCode": "+595"
                },
                {
                    "code": "QA",
                    "emoji": "🇶🇦",
                    "unicode": "U+1F1F6 U+1F1E6",
                    "name": "Qatar",
                    "title": "flag for Qatar",
                    "dialCode": "+974"
                },
                {
                    "code": "RE",
                    "emoji": "🇷🇪",
                    "unicode": "U+1F1F7 U+1F1EA",
                    "name": "Réunion",
                    "title": "flag for Réunion",
                    "dialCode": "+262"
                },
                {
                    "code": "RO",
                    "emoji": "🇷🇴",
                    "unicode": "U+1F1F7 U+1F1F4",
                    "name": "Romania",
                    "title": "flag for Romania",
                    "dialCode": "+40"
                },
                {
                    "code": "RS",
                    "emoji": "🇷🇸",
                    "unicode": "U+1F1F7 U+1F1F8",
                    "name": "Serbia",
                    "title": "flag for Serbia",
                    "dialCode": "+381"
                },
                {
                    "code": "RU",
                    "emoji": "🇷🇺",
                    "unicode": "U+1F1F7 U+1F1FA",
                    "name": "Russia",
                    "title": "flag for Russia",
                    "dialCode": "+7"
                },
                {
                    "code": "RW",
                    "emoji": "🇷🇼",
                    "unicode": "U+1F1F7 U+1F1FC",
                    "name": "Rwanda",
                    "title": "flag for Rwanda",
                    "dialCode": "+250"
                },
                {
                    "code": "SA",
                    "emoji": "🇸🇦",
                    "unicode": "U+1F1F8 U+1F1E6",
                    "name": "Saudi Arabia",
                    "title": "flag for Saudi Arabia",
                    "dialCode": "+966"
                },
                {
                    "code": "SB",
                    "emoji": "🇸🇧",
                    "unicode": "U+1F1F8 U+1F1E7",
                    "name": "Solomon Islands",
                    "title": "flag for Solomon Islands",
                    "dialCode": "+677"
                },
                {
                    "code": "SC",
                    "emoji": "🇸🇨",
                    "unicode": "U+1F1F8 U+1F1E8",
                    "name": "Seychelles",
                    "title": "flag for Seychelles",
                    "dialCode": "+248"
                },
                {
                    "code": "SD",
                    "emoji": "🇸🇩",
                    "unicode": "U+1F1F8 U+1F1E9",
                    "name": "Sudan",
                    "title": "flag for Sudan",
                    "dialCode": "+249"
                },
                {
                    "code": "SE",
                    "emoji": "🇸🇪",
                    "unicode": "U+1F1F8 U+1F1EA",
                    "name": "Sweden",
                    "title": "flag for Sweden",
                    "dialCode": "+46"
                },
                {
                    "code": "SG",
                    "emoji": "🇸🇬",
                    "unicode": "U+1F1F8 U+1F1EC",
                    "name": "Singapore",
                    "title": "flag for Singapore",
                    "dialCode": "+65"
                },
                {
                    "code": "SH",
                    "emoji": "🇸🇭",
                    "unicode": "U+1F1F8 U+1F1ED",
                    "name": "Saint Helena, Ascension and Tristan Da Cunha",
                    "title": "flag for Saint Helena, Ascension and Tristan Da Cunha",
                    "dialCode": "+290"
                },
                {
                    "code": "SI",
                    "emoji": "🇸🇮",
                    "unicode": "U+1F1F8 U+1F1EE",
                    "name": "Slovenia",
                    "title": "flag for Slovenia",
                    "dialCode": "+386"
                },
                {
                    "code": "SJ",
                    "emoji": "🇸🇯",
                    "unicode": "U+1F1F8 U+1F1EF",
                    "name": "Svalbard and Jan Mayen",
                    "title": "flag for Svalbard and Jan Mayen",
                    "dialCode": "+47"
                },
                {
                    "code": "SK",
                    "emoji": "🇸🇰",
                    "unicode": "U+1F1F8 U+1F1F0",
                    "name": "Slovakia",
                    "title": "flag for Slovakia",
                    "dialCode": "+421"
                },
                {
                    "code": "SL",
                    "emoji": "🇸🇱",
                    "unicode": "U+1F1F8 U+1F1F1",
                    "name": "Sierra Leone",
                    "title": "flag for Sierra Leone",
                    "dialCode": "+232"
                },
                {
                    "code": "SM",
                    "emoji": "🇸🇲",
                    "unicode": "U+1F1F8 U+1F1F2",
                    "name": "San Marino",
                    "title": "flag for San Marino",
                    "dialCode": "+378"
                },
                {
                    "code": "SN",
                    "emoji": "🇸🇳",
                    "unicode": "U+1F1F8 U+1F1F3",
                    "name": "Senegal",
                    "title": "flag for Senegal",
                    "dialCode": "+221"
                },
                {
                    "code": "SO",
                    "emoji": "🇸🇴",
                    "unicode": "U+1F1F8 U+1F1F4",
                    "name": "Somalia",
                    "title": "flag for Somalia",
                    "dialCode": "+252"
                },
                {
                    "code": "SR",
                    "emoji": "🇸🇷",
                    "unicode": "U+1F1F8 U+1F1F7",
                    "name": "Suriname",
                    "title": "flag for Suriname",
                    "dialCode": "+597"
                },
                {
                    "code": "SS",
                    "emoji": "🇸🇸",
                    "unicode": "U+1F1F8 U+1F1F8",
                    "name": "South Sudan",
                    "title": "flag for South Sudan"
                },
                {
                    "code": "ST",
                    "emoji": "🇸🇹",
                    "unicode": "U+1F1F8 U+1F1F9",
                    "name": "Sao Tome and Principe",
                    "title": "flag for Sao Tome and Principe",
                    "dialCode": "+239"
                },
                {
                    "code": "SV",
                    "emoji": "🇸🇻",
                    "unicode": "U+1F1F8 U+1F1FB",
                    "name": "El Salvador",
                    "title": "flag for El Salvador",
                    "dialCode": "+503"
                },
                {
                    "code": "SX",
                    "emoji": "🇸🇽",
                    "unicode": "U+1F1F8 U+1F1FD",
                    "name": "Sint Maarten (Dutch Part)",
                    "title": "flag for Sint Maarten (Dutch Part)"
                },
                {
                    "code": "SY",
                    "emoji": "🇸🇾",
                    "unicode": "U+1F1F8 U+1F1FE",
                    "name": "Syrian Arab Republic",
                    "title": "flag for Syrian Arab Republic",
                    "dialCode": "+963"
                },
                {
                    "code": "SZ",
                    "emoji": "🇸🇿",
                    "unicode": "U+1F1F8 U+1F1FF",
                    "name": "Swaziland",
                    "title": "flag for Swaziland",
                    "dialCode": "+268"
                },
                {
                    "code": "TC",
                    "emoji": "🇹🇨",
                    "unicode": "U+1F1F9 U+1F1E8",
                    "name": "Turks and Caicos Islands",
                    "title": "flag for Turks and Caicos Islands",
                    "dialCode": "+1 649"
                },
                {
                    "code": "TD",
                    "emoji": "🇹🇩",
                    "unicode": "U+1F1F9 U+1F1E9",
                    "name": "Chad",
                    "title": "flag for Chad",
                    "dialCode": "+235"
                },
                {
                    "code": "TF",
                    "emoji": "🇹🇫",
                    "unicode": "U+1F1F9 U+1F1EB",
                    "name": "French Southern Territories",
                    "title": "flag for French Southern Territories"
                },
                {
                    "code": "TG",
                    "emoji": "🇹🇬",
                    "unicode": "U+1F1F9 U+1F1EC",
                    "name": "Togo",
                    "title": "flag for Togo",
                    "dialCode": "+228"
                },
                {
                    "code": "TH",
                    "emoji": "🇹🇭",
                    "unicode": "U+1F1F9 U+1F1ED",
                    "name": "Thailand",
                    "title": "flag for Thailand",
                    "dialCode": "+66"
                },
                {
                    "code": "TJ",
                    "emoji": "🇹🇯",
                    "unicode": "U+1F1F9 U+1F1EF",
                    "name": "Tajikistan",
                    "title": "flag for Tajikistan",
                    "dialCode": "+992"
                },
                {
                    "code": "TK",
                    "emoji": "🇹🇰",
                    "unicode": "U+1F1F9 U+1F1F0",
                    "name": "Tokelau",
                    "title": "flag for Tokelau",
                    "dialCode": "+690"
                },
                {
                    "code": "TL",
                    "emoji": "🇹🇱",
                    "unicode": "U+1F1F9 U+1F1F1",
                    "name": "Timor-Leste",
                    "title": "flag for Timor-Leste",
                    "dialCode": "+670"
                },
                {
                    "code": "TM",
                    "emoji": "🇹🇲",
                    "unicode": "U+1F1F9 U+1F1F2",
                    "name": "Turkmenistan",
                    "title": "flag for Turkmenistan",
                    "dialCode": "+993"
                },
                {
                    "code": "TN",
                    "emoji": "🇹🇳",
                    "unicode": "U+1F1F9 U+1F1F3",
                    "name": "Tunisia",
                    "title": "flag for Tunisia",
                    "dialCode": "+216"
                },
                {
                    "code": "TO",
                    "emoji": "🇹🇴",
                    "unicode": "U+1F1F9 U+1F1F4",
                    "name": "Tonga",
                    "title": "flag for Tonga",
                    "dialCode": "+676"
                },
                {
                    "code": "TR",
                    "emoji": "🇹🇷",
                    "unicode": "U+1F1F9 U+1F1F7",
                    "name": "Turkey",
                    "title": "flag for Turkey",
                    "dialCode": "+90"
                },
                {
                    "code": "TT",
                    "emoji": "🇹🇹",
                    "unicode": "U+1F1F9 U+1F1F9",
                    "name": "Trinidad and Tobago",
                    "title": "flag for Trinidad and Tobago",
                    "dialCode": "+1 868"
                },
                {
                    "code": "TV",
                    "emoji": "🇹🇻",
                    "unicode": "U+1F1F9 U+1F1FB",
                    "name": "Tuvalu",
                    "title": "flag for Tuvalu",
                    "dialCode": "+688"
                },
                {
                    "code": "TW",
                    "emoji": "🇹🇼",
                    "unicode": "U+1F1F9 U+1F1FC",
                    "name": "Taiwan",
                    "title": "flag for Taiwan",
                    "dialCode": "+886"
                },
                {
                    "code": "TZ",
                    "emoji": "🇹🇿",
                    "unicode": "U+1F1F9 U+1F1FF",
                    "name": "Tanzania",
                    "title": "flag for Tanzania",
                    "dialCode": "+255"
                },
                {
                    "code": "UA",
                    "emoji": "🇺🇦",
                    "unicode": "U+1F1FA U+1F1E6",
                    "name": "Ukraine",
                    "title": "flag for Ukraine",
                    "dialCode": "+380"
                },
                {
                    "code": "UG",
                    "emoji": "🇺🇬",
                    "unicode": "U+1F1FA U+1F1EC",
                    "name": "Uganda",
                    "title": "flag for Uganda",
                    "dialCode": "+256"
                },
                {
                    "code": "UM",
                    "emoji": "🇺🇲",
                    "unicode": "U+1F1FA U+1F1F2",
                    "name": "United States Minor Outlying Islands",
                    "title": "flag for United States Minor Outlying Islands"
                },
                {
                    "code": "US",
                    "emoji": "🇺🇸",
                    "unicode": "U+1F1FA U+1F1F8",
                    "name": "United States",
                    "title": "flag for United States",
                    "dialCode": "+1"
                },
                {
                    "code": "UY",
                    "emoji": "🇺🇾",
                    "unicode": "U+1F1FA U+1F1FE",
                    "name": "Uruguay",
                    "title": "flag for Uruguay",
                    "dialCode": "+598"
                },
                {
                    "code": "UZ",
                    "emoji": "🇺🇿",
                    "unicode": "U+1F1FA U+1F1FF",
                    "name": "Uzbekistan",
                    "title": "flag for Uzbekistan",
                    "dialCode": "+998"
                },
                {
                    "code": "VA",
                    "emoji": "🇻🇦",
                    "unicode": "U+1F1FB U+1F1E6",
                    "name": "Vatican City",
                    "title": "flag for Vatican City",
                    "dialCode": "+379"
                },
                {
                    "code": "VC",
                    "emoji": "🇻🇨",
                    "unicode": "U+1F1FB U+1F1E8",
                    "name": "Saint Vincent and The Grenadines",
                    "title": "flag for Saint Vincent and The Grenadines",
                    "dialCode": "+1 784"
                },
                {
                    "code": "VE",
                    "emoji": "🇻🇪",
                    "unicode": "U+1F1FB U+1F1EA",
                    "name": "Venezuela",
                    "title": "flag for Venezuela",
                    "dialCode": "+58"
                },
                {
                    "code": "VG",
                    "emoji": "🇻🇬",
                    "unicode": "U+1F1FB U+1F1EC",
                    "name": "Virgin Islands, British",
                    "title": "flag for Virgin Islands, British",
                    "dialCode": "+1 284"
                },
                {
                    "code": "VI",
                    "emoji": "🇻🇮",
                    "unicode": "U+1F1FB U+1F1EE",
                    "name": "Virgin Islands, U.S.",
                    "title": "flag for Virgin Islands, U.S.",
                    "dialCode": "+1 340"
                },
                {
                    "code": "VN",
                    "emoji": "🇻🇳",
                    "unicode": "U+1F1FB U+1F1F3",
                    "name": "Viet Nam",
                    "title": "flag for Viet Nam",
                    "dialCode": "+84"
                },
                {
                    "code": "VU",
                    "emoji": "🇻🇺",
                    "unicode": "U+1F1FB U+1F1FA",
                    "name": "Vanuatu",
                    "title": "flag for Vanuatu",
                    "dialCode": "+678"
                },
                {
                    "code": "WF",
                    "emoji": "🇼🇫",
                    "unicode": "U+1F1FC U+1F1EB",
                    "name": "Wallis and Futuna",
                    "title": "flag for Wallis and Futuna",
                    "dialCode": "+681"
                },
                {
                    "code": "WS",
                    "emoji": "🇼🇸",
                    "unicode": "U+1F1FC U+1F1F8",
                    "name": "Samoa",
                    "title": "flag for Samoa",
                    "dialCode": "+685"
                },
                {
                    "code": "XK",
                    "emoji": "🇽🇰",
                    "unicode": "U+1F1FD U+1F1F0",
                    "name": "Kosovo",
                    "title": "flag for Kosovo",
                    "dialCode": "+383"
                },
                {
                    "code": "YE",
                    "emoji": "🇾🇪",
                    "unicode": "U+1F1FE U+1F1EA",
                    "name": "Yemen",
                    "title": "flag for Yemen",
                    "dialCode": "+967"
                },
                {
                    "code": "YT",
                    "emoji": "🇾🇹",
                    "unicode": "U+1F1FE U+1F1F9",
                    "name": "Mayotte",
                    "title": "flag for Mayotte",
                    "dialCode": "+262"
                },
                {
                    "code": "ZA",
                    "emoji": "🇿🇦",
                    "unicode": "U+1F1FF U+1F1E6",
                    "name": "South Africa",
                    "title": "flag for South Africa",
                    "dialCode": "+27"
                },
                {
                    "code": "ZM",
                    "emoji": "🇿🇲",
                    "unicode": "U+1F1FF U+1F1F2",
                    "name": "Zambia",
                    "title": "flag for Zambia",
                    "dialCode": "+260"
                },
                {
                    "code": "ZW",
                    "emoji": "🇿🇼",
                    "unicode": "U+1F1FF U+1F1FC",
                    "name": "Zimbabwe",
                    "title": "flag for Zimbabwe",
                    "dialCode": "+263"
                }
            ]

 
		});

	/** @ngInject */


})();
(function () {
    'use strict';
    angular.module('kapdec')
        .config(function ($stateProvider) {
            $stateProvider
                // .state("index.home.login", {
                //     title: 'Login to ',
                //     url: "/login",
                //     showHeader: true,
                //     showFooter: true,
                //     ensureAuthenticate: false,
                //     onEnter: ['$stateParams', '$state', '$uibModal', '$resource',
                //         function ($stateParams, $state, $uibModal, $resource) {
                //             $uibModal.open({
                //                 templateUrl: "app/accounts/login/login.html",
                //                 controller: 'LoginCtrl',
                //                 controllerAs: 'vm',
                //                 // backdrop: 'static',
                //                 // keyboard: false
                //             }).result.finally(function () {
                //                 $state.go('^');
                //             });
                //         }
                //     ]
                // })
                // .state("index.home.signup", {
                //     title: 'Sign Up',
                //     url: "/signup/?invite&type",
                //     showHeader: true,
                //     showFooter: true,
                //     ensureAuthenticate: false,
                //     onEnter: ['$stateParams', '$state', '$uibModal', '$resource',
                //         function ($stateParams, $state, $uibModal, $resource) {
                //             $uibModal.open({
                //                 templateUrl: "app/accounts/signup/signup.html",
                //                 controller: 'SignupCtrl',
                //                 controllerAs: 'vm',
                //                 // backdrop: 'static',
                //                 // keyboard: false
                //             }).result.finally(function () {
                //                 $state.go('^');
                //             });
                //         }
                //     ]
                // })
                .state("index.verifyx", {
                    title: 'Signup for ',
                    url: "/verify-successfully",
                    showHeader: true,
                    showFooter: true,
                    ensureAuthenticate: false,
                    onEnter: ['$location', '$state', '$uibModal', '$resource',
                        function ($location, $state, $uibModal, $resource) {

                            var obj = {
                                ensureAuthenticate: true,
                                message: "Welcome " + $location.search().u + " You account is successfully verified"
                            }

                        }
                    ]
                })
                .state('index.verify', {
                    title: 'Verify ',
                    url: '/verify/:token',
                    showHeader: true,
                    showFooter: true,
                    ensureAuthenticate: false,
                    templateUrl: 'app/accounts/verify/verify.html',
                    controller: 'VerifyCtrl',
                    controllerAs: 'vm'
                })
                .state('index.signupinvite', {
                    title: 'signup Invite ',
                    url: '/signupinvite/:token',
                    showHeader: true,
                    showFooter: true,
                    ensureAuthenticate: false,
                    templateUrl: 'app/accounts/signupinvite/signupinvite.html',
                    controller: 'signupinviteCtrl',
                    controllerAs: 'vm'
                })
                .state('index.reset', {
                    title: 'Reset Password ',
                    url: '/reset-password/:token',
                    showHeader: true,
                    showFooter: true,
                    ensureAuthenticate: false,
                    templateUrl: 'app/accounts/reset/reset.html',
                    controller: 'ResetCtrl',
                    controllerAs: 'vm'
                })
        });
})();

(function () {
	'use strict';

	angular
		.module('kapdec')
		.run(runBlock)

	/** @ngInject */
	function runBlock(amMoment, $log, $rootScope, Auth, $localStorage, $location, $state, $document) {
		//moment local
		amMoment.changeLocale('de');

		$rootScope.$on('$locationChangeStart', function (event) {
			if (!$localStorage.access_token) {
				$location.path('/home'); //login
			}
		});
		$rootScope.$on('$stateChangeStart', function (event, next, toState) {

			$rootScope.showHeader = next.showHeader;
			$rootScope.showFooter = next.showFooter;




			// Auth.isLoggedInAsync(function (loggedIn) {
			// 	if (next.ensureAuthenticate && !loggedIn) {
			// 		event.preventDefault();
			// 		Auth.saveAttemptUrl();
			// 		$state.go('index.home.login');
			// 	}
			// 	if (loggedIn) {
			// 		$rootScope.logSignupDiv = false;
			// 	} else { $rootScope.logSignupDiv = true; };

			// 	if (next.name && (next.name.indexOf('home') > -1) && loggedIn) {

			// 		Auth.isAdmin(function (res) {
			// 			if (res) {
			// 				$rootScope.userAdmin = true;
			// 				$state.go('admin.manageuser');
			// 			} else {
			// 				Auth.isTeacher(function (res) {
			// 					if (res) {
			// 						$rootScope.userTeacher = true;
			// 						$state.go('teacher.dashboardpanel');
			// 					} else {
			// 						Auth.isParent(function (res) {
			// 							debugger;
			// 							if (res) {
			// 								$rootScope.userParent = true;
			// 								$state.go('dashboard.view');
			// 							} else {
			// 								$rootScope.userStudent = true;
			// 								$state.go('dashboard.view');
			// 							}
			// 						});
			// 					}
			// 				});

			// 			}
			// 		});

			// 	}
			// });



			// Auth.isStudent(function (res) {
			// 	if (res) {
			// 		$rootScope.userStudent = true;
			// 	} else { $rootScope.userStudent = false; }
			// });
			// Auth.isTeacher(function (res) {
			// 	if (res) {
			// 		$rootScope.userTeacher = true;
			// 	} else { $rootScope.userTeacher = false; }
			// });
			// Auth.isParent(function (res) {
			// 	if (res) {
			// 		$rootScope.userParent = true;
			// 	} else { $rootScope.userParent = false; }
			// });
			// Auth.isAdmin(function (res) {
			// 	if (res) {
			// 		$rootScope.userAdmin = true;
			// 	} else { $rootScope.userAdmin = false; }
			// });

		});

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			// if(toState.name == 'login'){ };
			window.document.title = 'Kapdec | ' + toState.title;
			var body = $("html, body");
			body.stop().animate({ scrollTop: 0 }, 600, 'swing', function () { });
		});

	}


})();

(function () {
	'use strict';

	angular
		.module('kapdec')
		.config(routerConfig)

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider

			.state('index', {
				abstract: true,
				title: "main",
				url: "",
				templateUrl: "app/components/common/content.html",
				ensureAuthenticate: false,
				resolve: {
					loadPlugin: function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							{
								files: ['assets/js/lodash.min.js',
									'https://player.vimeo.com/api/player.js',
									'assets/css/responsive.css',
									'assets/css/select.min.css',
									'assets/js/bootstrap-datetimepicker.min.js',
									'assets/js/main.js']
							}
						]);
					}
				}
			})
			.state('index.home', {
				url: "/home",
				title: "home",
				templateUrl: "app/home/home.html",
				controller: 'HomeController',
				controllerAs: 'vm',
				data: { pageTitle: 'home view' },
				showHeader: true,
				showFooter: true,
				ensureAuthenticate: false,
				resolve: {
					loadPlugin: function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							{
								serie: true,
								files: ['assets/js/sweetalert.min.js',
									'assets/css/sweetalert.css'
								]
							},
							{
								serie: true,
								name: 'oitozero.ngSweetAlert',
								files: ['assets/js/angular-sweetalert.min.js']
							},
							{
								serie: true,
								files: ['assets/js/lodash.min.js']
							}
						]);
					},
					curriculum: function (Utility) {
						var curr = Utility.setGeo();
						return curr;
					},
					courses: function (LoadPageData, $localStorage, FilterOption) {
						LoadPageData.course.getCourse(FilterOption().filter).$promise.then(function (res) {
							if (res && res.data && res.data.data) {
								$localStorage.course = JSON.stringify(res.data.data);
							}
							return true;
						});
					}

				}
			})
			.state("index.stories", {
				title: 'stories',
				url: '/stories/?page',
				templateUrl: 'app/stories/stories.html',
				controller: 'StoriesCtrl',
				controllerAs: 'vm',
				showHeader: true,
				showFooter: true,
				ensureAuthenticate: false
			})
			.state("index.subscribe-required", {
				title: 'subscription-error',
				url: "/subscribe-required",
				showHeader: true,
				showFooter: true,
				ensureAuthenticate: false,
				onEnter: ['$stateParams', '$state', '$uibModal', '$resource',
					function ($stateParams, $state, $uibModal, $resource) {
						$uibModal.open({
							templateUrl: "app/subscribe-required/subscribe-required.html",
							controller: 'SubscribeRequiredCtrl',
							controllerAs: 'vm',
							backdrop: 'static',
							keyboard: false
						}).result.finally(function () {
							// $state.go('^');
						});
					}
				]
			})
			.state("index.select-grade", {
				title: 'select grade | topic',
				url: '/select-grade/:course/?type&gradeId&unitId&unit&page',
				templateUrl: 'app/select-grade-topic/selectGradeTopic.html',
				controller: 'SelectGradeTopicCtrl',
				controllerAs: 'vm',
				showHeader: true,
				showFooter: true,
				ensureAuthenticate: false,
				resolve: {
					loadPlugin: function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							{
								serie: true,
								files: ['assets/js/lodash.min.js']
							}
						]);
					}
				}
			})
			.state("index.select-topic", {
				title: 'topics',
				url: '/select-topic/:course/?gradeId&unitId&unit&page',
				templateUrl: 'app/select-topic/selectTopic.html',
				controller: 'SelectTopicCtrl',
				controllerAs: 'vm',
				showHeader: true,
				showFooter: true,
				ensureAuthenticate: false,
				resolve: {
					loadPlugin: function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							{
								serie: true,
								files: ['assets/js/lodash.min.js']
							}
						]);
					}
				}
			})

		// $urlRouterProvider.otherwise('/home');
	}

})();

angular.module("kapdec").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin-panel/admin-panel.html","<style>\r\n    .check.students_page {\r\n        padding: 0px 0px !important;\r\n    }\r\n\r\n    .help-block {\r\n        color: #dc3545 ;\r\n    }\r\n</style><div class=\"overlay\" pre-loading=\"\"><span class=\"pre-loading\"><img src=\"assets/image/spinner.gif\"></span></div><div class=\"sidebar\" data-color=\"white\" data-active-color=\"danger\" ng-include=\"vm.sidebarUrl\"></div><div class=\"main-panel\"><nav class=\"navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent\" ng-include=\"vm.topNavbarUrl\"></nav><div class=\"content\" ui-view=\"\"></div></div><button onclick=\"topFunction()\" id=\"topbtn\" title=\"\"><i class=\"fa fa-angle-up\" aria-hidden=\"true\"></i></button>");
$templateCache.put("app/dashboard/dashboard.html","<style>\r\n  .help-block {\r\n    color: #dc3545;\r\n  }\r\n</style><div class=\"overlay\" pre-loading=\"\"><span class=\"pre-loading\"><img src=\"assets/image/spinner.gif\"></span></div><div class=\"wrapper\"><div ng-include=\"vm.sidebarUrl\"></div><div class=\"main-panel\"><div ng-include=\"vm.topNavbarUrl\"></div><div class=\"content\"><div ui-view=\"\"></div></div></div></div><button onclick=\"topFunction()\" id=\"topbtn\" title=\"\"><i class=\"fa fa-angle-up\" aria-hidden=\"true\"></i></button><script>\r\n  window.onscroll = function () { scrollFunction() };\r\n\r\n  function scrollFunction() {\r\n    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {\r\n      document.getElementById(\"topbtn\").style.display = \"block\";\r\n    } else {\r\n      document.getElementById(\"topbtn\").style.display = \"none\";\r\n    }\r\n  }\r\n  function topFunction() {\r\n    var body = $(\"html, body\");\r\n    body.stop().animate({ scrollTop: 0 }, 600, \'swing\', function () {\r\n    });\r\n  }\r\n\r\n  document.addEventListener(\'gesturestart\', function (e) {\r\n    e.preventDefault();\r\n  });\r\n  \r\n  \r\n</script>");
$templateCache.put("app/home/home.html","<style>\r\n.Course-Panel {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.Course-Panel .col-md-4.tab_content.ng-scope {\r\n    float: left;\r\n}\r\n.topics-Panel .col-md-4 {\r\n    float: left;\r\n    /* height: 65px; */\r\n}\r\n.topics-Panel {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.unit-Panel {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.unit-Panel .col-md-4 {\r\n    float: left;\r\n}\r\n.chapter-Panel {\r\n    float: left;\r\n    width: 100%;\r\n}\r\n.chapter-Panel .col-md-4 {\r\n    float: left;\r\n}\r\n.active-panel {\r\n    display: block;\r\n}\r\n.disable-panel {\r\n    display: none;\r\n}\r\n.col-md-4.tab_content span {\r\n    outline: none;\r\n}\r\n.Course-Panel h3, .topics-Panel h3, .unit-Panel h3, .chapter-Panel h3 {\r\n    font-size: 26px;margin-bottom: 15px;padding: 0 15px;\r\n}\r\n.col-md-4.tab_content p {\r\n    float: left;\r\n    width: 50px !important;\r\n    margin-bottom: 0;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n}\r\n.col-md-4.tab_content p img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n.home_page .vertical-tabs{\r\n    margin-top: 0;\r\n}\r\n.help_text_box p{    \r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 3;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    height: 72px;\r\n}\r\n.text_box p strong {\r\n    color: #5bc236;\r\n}\r\n.home_page .vertical-tabs .tab-content {\r\n    display: grid;\r\n}\r\n.education-center{clear: both;}\r\n</style><div class=\"banner-container pb-md-5\"><div class=\"container\"><div class=\"row align-items-center\"><div class=\"col-md-5 pr-md-0\"><h1>Kapdec,</h1><h1>An Academy for e-Learning</h1><p>Your personal coach with you, when you want it, where you want it.</p><p class=\"pt-md-4 pt-2\"><a href=\"javascript:void(0);\" class=\"btn-pink\" ng-click=\"vm.signup()\">Register for Free</a></p></div><div class=\"col-md-7\"><img src=\"assets/img/banner.png\" class=\"img-fluid\" alt=\"banner\"></div></div><div class=\"row align-items-center\"><div class=\"col-md-12\"><a href=\"javascript:void(0)\" class=\"scrolldown d-flex align-items-center\"><img src=\"assets/img/icn_scrol.png\" class=\"img-fluid\" alt=\"scroll down\">&nbsp;&nbsp;Scroll Down</a></div></div></div></div><div class=\"platform-container py-lg-5\" id=\"world-class-platform\"><div class=\"container\"><div class=\"row pt-lg-5 pb-lg-3 py-4\"><div class=\"col-md-12 col-lg-4\"><div class=\"platform-left\"><h1 class=\"text-capitalize pr-lg-5\">World class platform</h1><ul><li>Discover Your Need</li><li>Develop Your Expertise</li><li>Explore Your Opportunities</li></ul></div></div><div class=\"col-md-12 col-lg-8 text-center\"><div class=\"row align-items-center\"><div class=\"col-md-4\"><div class=\"platform-list\"><h1 class=\"platform-top mb-0 d-flex align-items-center justify-content-center\">500+</h1><div class=\"platform-bottom d-flex align-items-center justify-content-center\">Math Topics<br>Discussed</div></div></div><div class=\"col-md-4\"><div class=\"platform-list\"><h1 class=\"platform-top mb-0 d-flex align-items-center justify-content-center\">50,000+</h1><div class=\"platform-bottom d-flex align-items-center justify-content-center\">Math<br>Questions</div></div></div><div class=\"col-md-4\"><div class=\"platform-list\"><h1 class=\"platform-top mb-0 d-flex align-items-center justify-content-center\">0</h1><div class=\"platform-bottom d-flex align-items-center justify-content-center\">Cost to<br>Try</div></div></div></div></div></div></div></div><section id=\"tabs-st\" class=\"py-lg-4\"><div class=\"container\"><h1 class=\"head-title pb-5\">Select Your Grade and Topic</h1><div class=\"accordion py-lg-5 py-0\" id=\"accordionExample\"><div class=\"card\" ng-repeat=\"grade in vm.grade\"><div class=\"card-header\" id=\"heading{{$index+1}}\"><h2 class=\"mb-0\"><button class=\"btn btn-link collapsed\" ng-click=\"vm.getCourses(grade._id)\" type=\"button\" data-toggle=\"collapse\" data-target=\"#collapse{{$index+1}}\" aria-expanded=\"true\" aria-controls=\"collapse{{$index+1}}\">{{grade.name}}</button></h2></div><div id=\"collapse{{$index+1}}\" class=\"collapse\" aria-labelledby=\"heading{{$index+1}}\" data-parent=\"#accordionExample\"><div class=\"card-body\"><div class=\"row\"><div class=\"Course-Panel col-lg-3 col-md-6\" id=\"course-content\"><div class=\"card-choose-list\"><h3>Subject<i class=\"fa fa-angle-right\"></i></h3><div ng-if=\"vm.loader\" class=\"more_loader loader-home\"><h3>Loading subject.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div class=\"collapse-accordion\"><div class=\"tab_content\" ng-repeat=\"course in vm.courses\"><p><img ng-if=\"course.thumbnail\" ng-src=\"{{vm.getImageUrl(course.thumbnail || course._id)}}\" alt=\"\"> <img ng-if=\"!course.thumbnail\" src=\"assets/img/circle.png\"> <span class=\"tab_text course\" ng-click=\"vm.getTopics(course._id)\">{{course.name}}</span></p></div></div></div></div><div class=\"topics-Panel col-lg-3 col-md-6\"><div ng-if=\"vm.loader1\" class=\"more_loader loader-home\"><h3>Loading topic.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div ng-if=\"vm.topics.length > 0\"><div class=\"card-choose-list mCustomScrollbar\"><h3>Topics<i class=\"fa fa-angle-right\"></i></h3><div class=\"collapse-accordion\"><div class=\"tab_content\" ng-repeat=\"topic in vm.topics\"><p><img ng-if=\"topic.thumbnail\" ng-src=\"{{vm.getImageUrl(topic.thumbnail || topic._id)}}\" alt=\"\"> <img ng-if=\"!topic.thumbnail\" src=\"assets/img/circle.png\"> <span class=\"tab_text topic\" ng-click=\"vm.getUnits(topic._id)\">{{topic.name}}</span></p></div></div></div></div></div><div class=\"unit-Panel col-lg-3 col-md-6\"><div ng-if=\"vm.loader2\" class=\"more_loader loader-home\"><h3>Loading module.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div ng-if=\"vm.units.length > 0\"><div class=\"card-choose-list mCustomScrollbar\"><h3>Module<i class=\"fa fa-angle-right\"></i></h3><div class=\"collapse-accordion\"><div class=\"tab_content\" ng-repeat=\"unit in vm.units\"><p><img ng-if=\"unit.thumbnail\" ng-src=\"{{vm.getImageUrl(unit.thumbnail || unit._id)}}\" alt=\"\"> <img ng-if=\"!unit.thumbnail\" src=\"assets/img/circle.png\"> <span class=\"tab_text unit\" ng-click=\"vm.getChapters(unit._id)\">{{unit.name}}</span></p></div></div></div></div></div><div class=\"chapter-Panel col-lg-3 col-md-6\"><div ng-if=\"vm.loader3\" class=\"more_loader loader-home\"><h3>Loading chapter.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div ng-if=\"vm.chapters.length > 0\"><div class=\"card-choose-list mCustomScrollbar\"><h3>Chapter<i class=\"fa fa-angle-right\"></i></h3><div class=\"collapse-accordion\"><div class=\"tab_content\" ng-repeat=\"chapter in vm.chapters\"><p><img src=\"assets/img/circle.png\"> <span class=\"tab_text chapter\">{{chapter.name}}</span></p></div></div></div></div></div></div></div></div></div></div></div></section><div class=\"education-center pb-5 text-center\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"head-title pb-5 text-capitalize\">Kapdec education center</h1><h5 class=\"py-4 col-md-10 offset-md-1 col-12\">Making quality education affordable and accessible to all students is what we actively strive for. Our effective combination of global methods and superior technology prepares students to compete at a world-class level.</h5></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"education-list\"><img src=\"assets/img/abutusimg_1.png\" class=\"img-fluid my-5\" alt=\"education\"><h5 class=\"text-capitalize pb-lg-4\">Designed by Engineers & Powered by Educators</h5><p class=\"px-md-3\">Our global team of experts brings global methods and expertise and a world-class education at your fingertips.</p></div></div><div class=\"col-md-6\"><div class=\"education-list\"><img src=\"assets/img/abutusimg_2.png\" class=\"img-fluid my-5\" alt=\"education\"><h5 class=\"text-capitalize pb-lg-4\">Unique Digital Library</h5><p class=\"px-md-3\">We proudly bring to you the largest most unique database of content and questions at your disposal. Learn, practice, and scale up.</p></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"education-list\"><img src=\"assets/img/abutusimg_3.png\" class=\"img-fluid my-5\" alt=\"education\"><h5 class=\"text-capitalize pb-lg-4\">Adaptive Learning</h5><p class=\"px-md-3\">Our unique algorithm is designed to meet students at the level they are and help them improve continuously to accomplish their full potential.</p></div></div><div class=\"col-md-6\"><div class=\"education-list\"><img src=\"assets/img/abutusimg_4.png\" class=\"img-fluid my-5\" alt=\"education\"><h5 class=\"text-capitalize pb-lg-4\">Portal for Teachers</h5><p class=\"px-md-3\">A unique feature to supplement classroom learning by enabling teachers to create a class, track, monitor and guide students.</p></div></div></div></div></div><div class=\"help_section\"><div class=\"container\"><div class=\"video_head\"><h1 class=\"head-title pb-5 text-white\">We Can Help You</h1></div><div class=\"row\"><div class=\"owl-carousel\" id=\"owl-example\"><div class=\"item\" ng-repeat=\"story in vm.storyList\"><div class=\"help_Box\"><span><iframe width=\"100%\" height=\"250\" ng-src=\"{{vm.trustUrl(story.videoURL)}}\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe></span><div class=\"help_text_box\"><span>{{story.chapter}}</span><h2>{{story.name}}</h2><p>{{story.description}}</p></div></div></div></div></div></div></div><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(0)\").addClass(\'active\');\r\n\r\n        setTimeout(function(){\r\n            $(\"#owl-example\").owlCarousel({\r\n                    items: 3,\r\n                    navigation: true,\r\n                    loop: true,\r\n                    dots: true,\r\n                    margin: 10,\r\n                    autoplay: true,\r\n                    autoplayTimeout: \'3000\',\r\n                    navContainer: \'#nav\',\r\n                    navigationText: [\r\n                        \'<i class=\"fa fa-angle-left\"></i>\',\r\n                        \'<i class=\"fa fa-angle-right\"></i>\'\r\n                    ],\r\n                    itemsDesktop : [1199,3],\r\n                    itemsDesktopSmall : [980,2],\r\n                    itemsTablet: [768,2],\r\n                    itemsMobile : [579,1]\r\n                });\r\n        },3000)\r\n\r\n    $(\'.scrolldown\').click(function () {\r\n        $(\'html, body\').animate({\r\n			scrollTop: $(\'#world-class-platform\').offset().top\r\n		}, 1000);\r\n    });\r\n\r\n    });\r\n\r\n</script>");
$templateCache.put("app/select-grade-topic/selectGradeTopic.html","<div class=\"breadcrumb\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"breadcrum_links\"><a ui-sref=\"index.home\">Home</a> <span>/</span> <a>Select Grade</a></div></div></div></div></div><section><div class=\"page_section\"><div class=\"select_container\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"select_btn\"><a href=\"\" id=\"grade_option\" ng-class=\"{\'active_option\':vm.showGrade }\" ng-click=\"vm.openGradeTopic($event, \'showGrade\')\">Select by Grade</a> <a href=\"\" id=\"topic_options\" ng-class=\"{\'active_option\':vm.showTopic }\" ng-click=\"vm.openGradeTopic($event, \'showTopic\')\">Select by Topic</a></div><div class=\"grade_option\" ng-if=\"vm.showGrade\"><div class=\"tab\"><div class=\"row\"><div ng-repeat=\"grade in vm.grade\" class=\"col-md-2 col-sm-2 col-xs-6\"><button class=\"tablinks\" ng-class=\"{\'active show\': vm[grade.name] }\" ng-click=\"!vm[grade.name] && vm.openGrade( grade.name, grade._id )\">{{grade.name}}</button></div></div></div><div class=\"tabcontent\" ng-if=\"vm[grade.name]\" id=\"{{grade.name}}\" ng-repeat=\"grade in vm.grade\" ng-class=\"{\'active\': vm[grade.name] }\"><div class=\"row\"><div ng-repeat=\"unit in vm.unit\" class=\"col-md-4 col-sm-4 col-xs-12\"><div class=\"grade_topics\"><h3>{{unit.name}}</h3><p>{{unit.description}}</p><a ui-sref=\"index.select-topic({ course:vm.course[0].name, gradeId: vm.params.gradeId, unitId:unit._id, unit: unit.slug })\">Read More</a></div></div></div></div><div ng-if=\"!vm.loader && vm.unit && vm.unit.length < 1\"><h1><i class=\"fa fa-4x fa-padd text-muted fa-exclamation-triangle\"></i> No Tutorial Available !!</h1></div></div><div class=\"topic_options\" ng-if=\"vm.showTopic\"><div ng-if=\"!vm.loader\" class=\"topic_row\"><div class=\"row\"><div ng-repeat=\"units in vm.units\" class=\"col-md-4 col-sm-4 col-xs-12\"><div class=\"grade_topics\"><h3>{{units.name}}</h3><p>{{units.description}}</p><a ui-sref=\"index.select-topic({ course:vm.course[0].name, unitId:units._id, unit: units.slug })\">Read More</a></div></div></div></div><div ng-if=\"vm.loader\" class=\"main-page more_loader\"><h3>Loading.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div ng-if=\"!vm.loader && vm.units && vm.units.length < 1\"><h1><i class=\"fa fa-4x fa-padd text-muted fa-exclamation-triangle\"></i> No Tutorial Available !!</h1></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.units.length\" items-per-page=\"vm.filterTopic.limit\" ng-model=\"vm.filterTopic.page\" total-items=\"vm.filterTopic.total\" ng-change=\"vm.changeTopicPageOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div></section><script>\r\n    $(document).ready(function(){\r\n      $(\".topic_detail_description\").hide();\r\n      $(\".topic_detail_suggetions\").hide();\r\n      $(\".topic_row > .suggetionsbtn\").click(function(){\r\n        $(this).find(\"div > .topic_detail_description\").show();\r\n      });\r\n    });\r\n</script><script>\r\n  function openCity(evt, cityName) {\r\n    var i, tabcontent, tablinks;\r\n    tabcontent = document.getElementsByClassName(\"tabcontent\");\r\n    for (i = 0; i < tabcontent.length; i++) {\r\n      tabcontent[i].style.display = \"none\";\r\n    }\r\n    tablinks = document.getElementsByClassName(\"tablinks\");\r\n    for (i = 0; i < tablinks.length; i++) {\r\n      tablinks[i].className = tablinks[i].className.replace(\" active\", \"\");\r\n    }\r\n    document.getElementById(cityName).style.display = \"block\";\r\n    evt.currentTarget.className += \" active\";\r\n  }\r\n\r\n  // Get the element with id=\"defaultOpen\" and click on it\r\n  // document.getElementById(\"defaultOpen\").click();\r\n</script><script>\r\n  (function($){\r\n    $(window).on(\"load\",function(){\r\n      // $(\".topic_description\").mCustomScrollbar();\r\n    });\r\n  })(jQuery);\r\n</script>");
$templateCache.put("app/select-topic/selectTopic.html","<div class=\"breadcrumb\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"breadcrum_links\"><a ui-sref=\"index.home\">Home</a> <span>/</span> <a href=\"\">Topics</a></div></div></div></div></div><section><div class=\"page_section select-topic\"><div class=\"select_container\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"panel-group chapters\" id=\"accordion\"><div ng-if=\"vm.loader\" class=\"more_loader\"><h3>Loading.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div ng-if=\"!vm.loader && vm.chapters && vm.chapters.length < 1\"><h1><i class=\"fa fa-4x fa-padd text-muted fa-exclamation-triangle\"></i> No Tutorial Available !!</h1></div><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" ng-repeat=\"chapter in vm.chapters\" ng-click=\"vm[\'statusOpen\'+$index] && vm.getChapterTopics(chapter._id)\" class=\"mt-1\" is-open=\"vm[\'statusOpen\'+$index]\"><uib-accordion-heading>{{chapter.name}} <i class=\"float-right fa\" ng-class=\"{\'fa-chevron-down\': status.open, \'fa-chevron-right\': !status.open}\"></i></uib-accordion-heading><div class=\"panel-body\" ng-click=\"$event.stopPropagation();\"><div class=\"topic_row\" ng-repeat=\"topic in vm[\'topics\'+chapter._id]\"><div class=\"row\"><div class=\"col-md-4 col-sm-4 col-xs-12\"><div class=\"topic_video video-thumbnail\" ng-click=\"vm.getVideo(topic._id,\'video\'+chapter._id+\'Url\'+$index)\" ng-if=\"!vm[\'video\'+chapter._id+\'Url\'+$index]\" ng-show=\"topic.thumbnail\"><img ng-src=\"{{vm.getImageUrl(topic.thumbnail) }}\"></div><div class=\"topic_video\"><iframe ng-if=\"vm[\'video\'+chapter._id+\'Url\'+$index]\" data-ready=\"true\" id=\"{{\'video\'+chapter._id+\'Url\'+$index}}\" ng-src=\"{{ vm.trustUrl( vm[\'video\'+chapter._id+\'Url\'+$index] ) }}\" width=\"310\" height=\"225\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-md-8 col-sm-8 col-xs-12\"><div class=\"topic_description\"><h4>{{topic.name}}</h4><p ng-bind-html=\"topic.summary\"></p></div><div class=\"discription_btn\"><a class=\"suggetions-btn\" ng-class=\"{\'active\': vm[\'suggest\'+chapter._id+$index] }\" ng-click=\"vm.toggler(\'suggest\', chapter._id ,$index );\">Suggestion</a> <a class=\"description-btn\" ng-class=\"{\'active\': vm[\'descript\'+chapter._id+$index] }\" ng-click=\"vm.toggler(\'descript\', chapter._id, $index);\">Description</a></div></div><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"t-suggetions animatedx fadeInRight\" ng-if=\"vm[\'suggest\'+chapter._id+$index]\"><p ng-bind-html=\"topic.suggestion\"></p></div><div class=\"t-discription animatedx fadeInRight\" ng-if=\"vm[\'descript\'+chapter._id+$index]\"><p ng-bind-html=\"topic.description\"></p></div></div></div></div></div></div></uib-accordion></div></div></div></div></div></div></section>");
$templateCache.put("app/stories/stories.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><style>\r\n.videoWrap .infoWrap {\r\n    padding: 10px;\r\n    display: block;\r\n}\r\n.videoItem .description {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 3;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n}\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Stories</strong></li></ul></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text\"><h1 class=\"head-title pb-5\">What is your success story?</h1></div></div></div><div class=\"education_center\"><div class=\"container videoWrap\"><div class=\"videoItem py-4\" ng-repeat=\"story in vm.storyList\"><div class=\"row align-items-center\"><div class=\"col-lg-8\"><div class=\"video-iframe\"><iframe width=\"100%\" height=\"350\" ng-src=\"{{vm.trustUrl(story.videoURL)}}\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-lg-4\"><div class=\"videoItemInfo\"><span class=\"infoWrap\"><h5 class=\"mb-1 text-capitalize\">{{story.name}}</h5><p class=\"pb-lg-3\">{{story.email}}</p><p class=\"description\">{{story.description}}</p></span></div></div></div></div><div class=\"row mt-lg-5 pt-4\"><div class=\"col-md-12 stories\"><h1 class=\"head-title pb-5\">Share your story here...</h1><p class=\"head-text text-center my-4\">Share with us about your learning journey and experiences. By sharing your success story, you will inspire and motivate others who are struggling and aspiring to achieve a similar goal</p></div></div><div class=\"row\"><div class=\"col-lg-8 offset-lg-2 contact-info\"><div class=\"stories_form\" style=\"float:left\"><form id=\"contact\" ng-submit=\"vm.addStory(form)\" name=\"form\" novalidate=\"\" class=\"form contact-form\" role=\"form\"><div class=\"row justify-content-center\"><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control form-box\" ng-model=\"vm.story.name\" ng-pattern=\"vm.pattern.fullname\" name=\"name\" placeholder=\"Full Name*\" autofocus=\"\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter Full Name.</span></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control form-box\" name=\"email\" ng-model=\"vm.story.email\" ng-pattern=\"vm.pattern.email\" placeholder=\"Email*\" autocomplete=\"off\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Please enter valid email address.</span> <span class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</span></div><div class=\"col-lg-10 col-md-12 form-group\" ng-class=\"{ \'has-success\': form.videoUrl.$valid , \'has-error\': form.videoUrl.$invalid && vm.submitted }\"><input type=\"url\" class=\"form-control form-box\" name=\"videoUrl\" ng-model=\"vm.story.videoURL\" placeholder=\"Youtube Link\" autocomplete=\"off\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"form.videoUrl.$error.required && vm.submitted\">Please enter valid URL.</span> <span class=\"help-block text-danger\" ng-show=\"form.videoUrl.$error.url && vm.submitted\">Please enter valid URL.</span></div><div class=\"col-lg-10 col-md-12 form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:120px;resize:none;\" name=\"description\" ng-model=\"vm.story.description\" maxlength=\"500\" class=\"form-control contact-msg\" placeholder=\"Your Message...\" ng-keypress=\"vm.countdescriptionlength()\" ng-keydown=\"vm.countdescriptionlength()\" ng-keyup=\"vm.countdescriptionlength()\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea> <span class=\"help-block text-danger\" ng-show=\"vm.descriptionminlength && vm.submitted\">A proper description is required (min 15 character).</span><div class=\"text-right text-muted\"><span class=\"text-left help-block text-danger\" style=\"float: left;\" ng-show=\"form.description.$error.required && vm.submitted\">Please enter message.</span> <span>{{vm.descriptionlength }}/500</span></div></div><div class=\"col-md-12 form-group text-center\"><input type=\"submit\" name=\"submit\" class=\"btn btn-pink\" value=\"Submit\"></div></div></form></div></div></div></div></div><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(3)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/subscribe-required/subscribe-required.html","<div class=\"modal-header\"><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button></div><div class=\"modal-body\" id=\"modal-body\" style=\"font-size:23px;font-weight:bold;\"><div class=\"icon text-center\"><p><span><i class=\"fa fa-2x fa-chevron-circle-right text-info\" style=\"vertical-align: middle;\"></i></span> <span class=\"clr-active text-muted\">{{vm.message}}</span></p></div><div class=\"cross_icon text-center animated infinite pulse\"><button class=\"btn btn-lg\" href=\"javascript:void(0);\" ng-click=\"vm.cancel()\">OK <i class=\"fa fa-external-link text-danger\"></i></button></div></div>");
$templateCache.put("app/accounts/login/login.html","<div class=\"modal-header\"><button type=\"button\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\" class=\"close_btn close\">&times;</button><h4 ng-if=\"vm.logindiv\" class=\"modal-title\" id=\"myModalLabel\">Kapdec Login</h4><h4 ng-if=\"vm.forgetpass\" class=\"modal-title\" id=\"myModalLabel\">Forgot Your Password</h4></div><div class=\"modal-body\"><div ng-if=\"vm.logindiv\"><form ng-submit=\"vm.login(form, \'local\')\" name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input id=\"uLogin\" type=\"email\" ng-model=\"vm.user.email\" name=\"email\" ng-pattern=\"vm.pattern.email\" class=\"form-control form-box\" placeholder=\"Email Id\" autocomplete=\"off\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" id=\"uPassword\" ng-model=\"vm.user.password\" name=\"password\" ng-minlength=\"4\" class=\"form-control form-box\" placeholder=\"Password\" autocomplete=\"off\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter password.</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.minlength && vm.submitted\">Password must be at least 4 characters.</p></div><div class=\"form-group has-error\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"row forgot-password-block\"><div class=\"col-md-6 col-sm-6\"><div class=\"custom-control custom-checkbox mb-3\"><input type=\"checkbox\" class=\"custom-control-input\" id=\"remember_me\" name=\"example1\" ng-model=\"vm.user.check\"> <label class=\"custom-control-label\" for=\"remember_me\">Remember me</label></div></div><div class=\"col-md-6 col-sm-6 d-flex justify-content-sm-end\"><a href=\"\" ng-click=\"vm.toggleForgetLogin(\'forgetpass\')\" id=\"forgotpass\">Forgot Password</a></div></div><div class=\"modal-footer col-md-12 justify-content-center\" style=\"margin-top: 10px;\"><button type=\"submit\" class=\"btn btn-pink\">Login</button></div></form></div><div class=\"forgotpass\" ng-if=\"vm.forgetpass\"><form ng-submit=\"vm.forgotPassword(resetform)\" name=\"resetform\" novalidate=\"\"><p>Please fill out the following field to reset password:</p><br><div class=\"form-group\" ng-class=\"{ \'has-success\': resetform.email.$valid && vm.submittedEmail, \'has-error\': resetform.email.$invalid && vm.submittedEmail }\"><input type=\"email\" ng-model=\"vm.forgot.email\" name=\"email\" ng-pattern=\"vm.pattern.email\" class=\"form-control form-box\" placeholder=\"Enter registered email address...\" autocomplete=\"off\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"resetform.email.$error.pattern && vm.submittedEmail\">Please enter valid email address.</p><p class=\"help-block text-danger\" ng-show=\"resetform.email.$error.required && vm.submittedEmail\">Please enter registered email address.</p><p class=\"help-block text-danger\" ng-show=\"vm.error && vm.error.message && vm.submittedEmail\">{{vm.error.message}}</p></div><div class=\"modal-footer col-md-12 justify-content-center\" style=\"margin-top: 5px;width: 100%;\"><button type=\"submit\" class=\"btn btn-pink\">Reset Password</button></div></form></div></div><div class=\"footer_sign\"><span ng-if=\"!vm.forgetpass\">New User? <a href=\"javascript:void(0)\" ng-click=\"vm.signup()\">Sign Up</a></span> <span ng-if=\"vm.forgetpass\"><a href=\"javascript:void(0)\" ng-click=\"vm.toggleForgetLogin(\'logindiv\')\" id=\"backtologin\">Back to Login</a></span></div>");
$templateCache.put("app/accounts/reset/reset.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><div class=\"about_banner\"><div class=\"container\"><div class=\"row\"><div class=\"breadcrumb\"><div class=\"col-md-8\"><h1>Reset Your Password</h1></div><div class=\"col-md-4 pull-right\"><ul><li><a ui-sref=\"index.home\">Home</a></li><li>/</li><li><a>Reset Password</a></li></ul></div></div></div></div></div><div class=\"education_center\"><div class=\"container\"><div class=\"row\"></div><div class=\"stories_form\" style=\"float:left\"><form id=\"contact\" name=\"form\" ng-submit=\"vm.resetPassword(form)\" novalidate=\"\"><div class=\"col-md-8 form-group\"><h2>Enter your password here...</h2></div><div style=\"padding-top:10px;\" class=\"col-md-6 form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'New Password\'\" placeholder=\"New Password\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">New password is required</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div><div class=\"col-md-6 form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" ng-pattern=\"vm.user.password\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Confirm Password\'\" placeholder=\"Confirm Password\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">confirm password is required</p><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.pattern && vm.submitted\">Confirm password must be matched.</p></div><div class=\"col-md-12 form-group\"><input type=\"submit\" name=\"submit\" class=\"btn btn-info btn-md\" value=\"Submit\"></div></form></div></div></div>");
$templateCache.put("app/accounts/verify/verify.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><div class=\"about_banner\"><div class=\"container\"><div class=\"row\"><div class=\"breadcrumb\"><div class=\"col-md-8\"><h1>Account Activated</h1></div><div class=\"col-md-4 pull-right\"><ul><li><a ui-sref=\"index.home\">Home</a></li><li>/</li><li><a>Account Activated</a></li></ul></div></div></div></div></div><div class=\"education_center\"><div style=\"background: #f0f0f0;width: 776px; margin: auto;padding: 45px 40px;\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"100%\" style=\"max-width: 750px;width:100%;margin:0 auto;background: #f0f0f0;padding: 40px 40px;\"><tbody><tr><td><table style=\"width: 100%;margin:0px;padding: 10px;font-family: \'Roboto\', sans-serif; background: #ffffff; font-size: 12px;text-align: center;\"><tbody><tr><td style=\"position: relative;\"><h1 style=\"margin-top: 25px;\">Account Activated</h1><i class=\"fa fa-envelope\" style=\"font-size: 60px;color: #f3772e;margin-top: 20px;\"></i> <i class=\"fa fa-check-circle\" style=\"position: absolute;font-size: 35px;bottom: -8px;margin-left: -15px;color: #f3772e;background: #fff;border-radius: 50%;width: 40px;height: 40px;LINE-HEIGHT: 40PX;\"></i></td></tr></tbody></table></td></tr><tr><td><table style=\"width: 100%;margin:0px;padding: 10px;font-family: \'Roboto\', sans-serif; background: #ffffff; font-size: 17px;text-align: center;\"><tbody><tr><td><p style=\"font-weight: 500;margin-top: 30px;\">Hello {{vm.AllData.name}},</p><p style=\"margin: 0;\">Thank you, your email has been verified. Your account is now active.</p><p style=\"margin-top: 5px;\">Please use the link below to login your account.</p><a ui-sref=\"index.home\" style=\"outline: none;background: #f3772e;color: #fff;padding: 8px 15px;display: block;width: 220px;margin: auto;text-decoration: none;margin-top: 20px;margin-bottom: 35px;\">LOGIN TO YOUR ACCOUNT</a></td></tr></tbody></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/accounts/signup/signup.html","<style>\r\n     .formLablePhone {\r\n    margin-bottom: 0;\r\n    background: #dadada;\r\n    padding: 11px 7px;\r\n    color: #9ea4a9;\r\n    letter-spacing: 1px;\r\n    line-height: 35px;\r\n    border-radius: 5px;\r\n    padding-left: 10px;\r\n}\r\n      </style><div class=\"modal-header\"><button type=\"button\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\" class=\"close_btn close\">&times;</button><h4 class=\"modal-title\" id=\"myModalLabel\">Kapdec Sign Up</h4></div><div class=\"modal-body\" id=\"joinClass\"><div class=\"teacher\"><div class=\"panel panel-login\"><div class=\"panel-heading\"><ul class=\"pl-0 text-center\"><li><label ng-class=\"{\'sign-label\':vm.user.role==\'teacher\'}\"><input type=\"radio\" name=\"role\" value=\"teacher\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" tabindex=\"1\" autocomplete=\"off\"> Teacher</label></li><li><label ng-class=\"{\'sign-label\':vm.user.role==\'student\'}\"><input type=\"radio\" name=\"role\" value=\"student\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" autocomplete=\"off\"> Student</label></li><li><label ng-class=\"{\'sign-label\':vm.user.role==\'parent\'}\"><input type=\"radio\" name=\"role\" value=\"parent\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" autocomplete=\"off\" checked=\"\"> Parent</label></li></ul></div><div class=\"panel-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\" id=\"teacher-form\" role=\"form\" style=\"display: block;\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" id=\"username\" tabindex=\"1\" name=\"name\" ng-model=\"vm.user.fullname\" ng-minlength=\"3\" maxlength=\"35\" ng-pattern=\"vm.pattern.name\" class=\"form-control form-box\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter full Name</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Full Name must be atleast 3 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.name.$error.pattern && vm.submitted\">Please enter a valid full name.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email Id\" tabindex=\"2\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control form-box\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group dobDate\" ng-class=\"{ \'has-success\': form.dateofBirth.$valid && vm.submitted, \'has-error\': form.dateofBirth.$invalid && vm.submitted }\"><input type=\"text\" date-picker=\"\" class=\"form-control form-box\" tabindex=\"3\" placeholder=\"Date Of Birth\" name=\"dateofBirth\" id=\"dateofBirth\" ng-model=\"vm.user.dob\" ng-selected=\"vm.checkStudentAge(vm.user.dob)\" ng-change=\"vm.checkStudentAge(vm.user.dob)\" maxdate=\"vm.maxDate\" autocomplete=\"off\" mongoose-error=\"\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.required && vm.submitted\">Please enter Date Of Birth.</p><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.mongoose\">{{ vm.errors.dateofBirth }}</p><p ng-show=\"form.dateofBirth.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Student age must be greter than 13</p></div><div ng-if=\"vm.bellowAge && vm.user.role==\'student\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.parentEmail.$valid && vm.submitted, \'has-error\': form.parentEmail.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Parent Email Id\" tabindex=\"2\" name=\"parentEmail\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.parentEmail\" class=\"form-control form-box\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.required && vm.submitted\">Please enter parent email address.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group row country-code\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><div class=\"col-md-4 pr-md-1\"><input type=\"text\" name=\"Countryemoji\" tabindex=\"7\" id=\"Countryemoji\" placeholder=\"Countryemoji\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.emoji\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"> <input type=\"text\" name=\"CountrydialCode\" tabindex=\"7\" id=\"CountrydialCode\" placeholder=\"CountryCode\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.dialCode\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><select ng-model=\"vm.user.countryName\" ng-change=\"vm.changecountry()\" class=\"\"><option value=\"\">-- Select a Country --</option><option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country.name}}</option></select></div><div class=\"input-group col-md-8 pl-md-1\"><input type=\"text\" class=\"form-control form-box\" numbers-only=\"\" tabindex=\"4\" placeholder=\"Phone Number\" name=\"phoneNumber\" ng-model=\"vm.user.phoneNumber\" aria-describedby=\"basic-addon1\" required=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" autocomplete=\"off\"></div><p class=\"help-block text-danger col-md-12\" ng-show=\"form.phoneNumber.$error.required && vm.submitted\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger col-md-12\">Phone Number must be atleast 8 characters.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger col-md-12\">Phone Number must be atleast 8 characters.</p><p class=\"help-block text-danger col-md-12\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div><p ng-if=\"vm.user.role==\'teacher\'\" class=\"formLable\" style=\"margin-bottom:15px\">Qualification</p><div ng-if=\"vm.user.role!=\'parent\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.user.grades\" theme=\"bootstrap\" name=\"grade\" id=\"grade\" close-on-select=\"false\" ng-change=\"vm.changeGrades()\" title=\"Choose a topic\" required=\"\"><ui-select-match placeholder=\"Select Grades...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"grade._id as grade in vm.grades | filter:$select.search\">{{grade.name}}</ui-select-choices></ui-select></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><input type=\"text\" name=\"degree_name\" tabindex=\"5\" id=\"degree_name\" class=\"form-control form-box\" placeholder=\"Degree Name\" value=\"\" ng-model=\"vm.user.degreeName\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.required && vm.submitted\">Please enter Degree Name.</p><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.mongoose\">{{ vm.errors.degreeName }}</p></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.specialization.$valid && vm.submitted, \'has-error\': form.specialization.$invalid && vm.submitted }\"><input type=\"text\" name=\"specialization\" tabindex=\"7\" id=\"specialization\" class=\"form-control form-box\" placeholder=\"Specialization\" value=\"\" ng-model=\"vm.user.specialization\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.required && vm.submitted\">Please enter Specialization.</p><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.mongoose\">{{ vm.errors.specialization }}</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" tabindex=\"8\" ng-model=\"vm.user.password\" id=\"password\" class=\"form-control form-box\" ng-pattern=\"vm.pattern.password\" maxlength=\"25\" placeholder=\"Password\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter password</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" id=\"confirm-password\" tabindex=\"9\" name=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" ng-pattern=\"vm.user.password\" class=\"form-control form-box\" placeholder=\"Confirm Password\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">Confirm password is required</p><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.pattern && vm.submitted\">Confirm password must be matched.</p></div><div class=\"form-group check_box\" ng-show=\"vm.teacherlogin\"><input type=\"checkbox\" tabindex=\"10\" name=\"terms\" ng-model=\"vm.user.terms\" required=\"\" id=\"remember\"> <label for=\"remember\">I agree to <a ui-sref=\"index.terms\" target=\"_blank\"><u>Terms and Conditions</u></a> & <a ui-sref=\"index.privacy\" target=\"_blank\"><u>Privacy Policy</u></a>.</label><p class=\"help-block text-danger\" ng-show=\"form.terms.$error.required && vm.submitted\">Are you agree with terms?</p></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12 text-center\"><input type=\"submit\" name=\"login-submit\" id=\"login-submit\" class=\"btn btn-pink\" value=\"Create My Account\"></div></div></div><div class=\"form-group social_img\"><ul><li ng-if=\"vm.user.role==\'teacher\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'facebook\',\'teacher\')\"><img src=\"assets/img/facebook.jpg\" alt=\"\"></a></li><li ng-if=\"vm.user.role==\'student\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'facebook\',\'student\')\"><img src=\"assets/img/facebook.jpg\" alt=\"\"></a></li><li ng-if=\"vm.user.role==\'parent\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'facebook\',\'parent\')\"><img src=\"assets/img/facebook.jpg\" alt=\"\"></a></li><li ng-if=\"vm.user.role==\'teacher\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'google\',\'teacher\')\"><img src=\"assets/img/googleplus.jpg\" alt=\"\"></a></li><li ng-if=\"vm.user.role==\'student\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'google\',\'student\')\"><img src=\"assets/img/googleplus.jpg\" alt=\"\"></a></li><li ng-if=\"vm.user.role==\'parent\'\"><a href=\"\" ng-click=\"vm.loginOauth(\'google\',\'parent\')\"><img src=\"assets/img/googleplus.jpg\" alt=\"\"></a></li></ul></div></form></div></div></div></div><style>\r\n    .ui-select-choices {\r\n        visibility: visible !important;\r\n        transform: inherit !important;\r\n        border-radius: 0px !important;\r\n    }\r\n\r\n    .btn-xs {\r\n        padding: 1px 5px;\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        border-radius: 3px;\r\n        background-color: white;\r\n    }\r\n\r\n    .ui-select-search::placeholder {\r\n        color: #7d858c !important;\r\n        margin-left: 4px !important;\r\n    }\r\n\r\n    ul.ui-select-choices.ui-select-choices-content.ui-select-dropdown.dropdown-menu {\r\n        display: block;\r\n    }\r\n</style>");
$templateCache.put("app/accounts/signupinvite/signupinvite.html","<style>\r\n	.box {\r\n    position: absolute;\r\n    transform: translate(-50%, -50%);\r\n    top: 45%;\r\n    left: 50%;\r\n    width: 90%;\r\n}\r\n.Our-Value h3 {\r\n    font-size: 40px !important;\r\n    color: #495057 !important;\r\n    position: unset !important;\r\n    transform: none !important;\r\n    margin-bottom: 15px;\r\n}\r\n.Our-Value p {\r\n    font-size: 18px !important;\r\n    font-style: normal !important;\r\n    line-height: 30px;\r\n}\r\n.Our-Value {\r\n    margin-top: 0px !important;\r\n    margin-bottom: 30px;\r\n    text-align: center !important;\r\n}\r\n.formLablePhone {\r\n    margin-bottom: 0;\r\n    background: #dadada;\r\n    padding: 8px 8px;\r\n    color: #9ea4a9;\r\n    letter-spacing: 1px;\r\n    line-height: 35px;\r\n    border-radius: 5px;\r\n    padding-left: 10px;\r\n    padding-bottom: 21px\r\n</style><div class=\"about_banner\"><div class=\"container\"><div class=\"row\"><div class=\"breadcrumb\"><div class=\"col-md-6\"><h1>Sign Up</h1></div><div class=\"col-md-6 pull-right\"><ul><li><a ui-sref=\"index.home\">Home</a></li><li>/</li><li>Sign Up</li></ul></div></div></div></div></div><div class=\"education_center\"><div class=\"container\"><div class=\"row\"><div class=\"teacher\"><div class=\"panel panel-login\"><div class=\"panel-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\" id=\"teacher-form\" role=\"form\" style=\"display: block;\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" id=\"username\" tabindex=\"1\" name=\"name\" ng-model=\"vm.user.fullname\" ng-minlength=\"3\" maxlength=\"35\" ng-pattern=\"vm.pattern.name\" class=\"form-control\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter full Name</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Full Name must be atleast 3 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.name.$error.pattern && vm.submitted\">Please enter a valid full name.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email Id\" tabindex=\"2\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group dobDate\" ng-class=\"{ \'has-success\': form.dateofBirth.$valid && vm.submitted, \'has-error\': form.dateofBirth.$invalid && vm.submitted }\"><input type=\"text\" date-picker=\"\" class=\"form-control\" tabindex=\"3\" placeholder=\"Date Of Birth\" name=\"dateofBirth\" id=\"dateofBirth\" ng-model=\"vm.user.dob\" ng-selected=\"vm.checkStudentAge(vm.user.dob)\" ng-change=\"vm.checkStudentAge(vm.user.dob)\" maxdate=\"vm.maxDate\" autocomplete=\"off\" mongoose-error=\"\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.required && vm.submitted\">Please enter Date Of Birth.</p><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.mongoose\">{{ vm.errors.dateofBirth }}</p><p ng-show=\"form.dateofBirth.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Student age must be greter than 13</p></div><div ng-if=\"vm.bellowAge && vm.user.role==\'student\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.parentEmail.$valid && vm.submitted, \'has-error\': form.parentEmail.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Parent Email Id\" tabindex=\"2\" name=\"parentEmail\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.parentEmail\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.required && vm.submitted\">Please enter parent email address.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><span class=\"formLablePhone\">{{vm.CountryCode}}</span> <input type=\"text\" style=\"margin-left: 47px;margin-top: -34px;width: 85%;\" numbers-only=\"\" tabindex=\"4\" placeholder=\"Phone Number\" name=\"phoneNumber\" ng-model=\"vm.user.phoneNumber\" class=\"form-control\" required=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.required && vm.submitted\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div><div ng-if=\"vm.user.role!=\'parent\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.user.grades\" theme=\"bootstrap\" name=\"grade\" id=\"grade\" close-on-select=\"false\" ng-change=\"vm.changeGrades()\" style=\"border: 1px solid #dddddd;\" title=\"Choose a topic\" required=\"\"><ui-select-match placeholder=\"Select Grades...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"grade._id as grade in vm.grades | filter:$select.search\">{{grade.name}}</ui-select-choices></ui-select></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" tabindex=\"8\" ng-model=\"vm.user.password\" id=\"password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" maxlength=\"25\" placeholder=\"Password\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter password</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" id=\"confirm-password\" tabindex=\"9\" name=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" ng-pattern=\"vm.user.password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">Confirm password is required</p><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.pattern && vm.submitted\">Confirm password must be matched.</p></div><div class=\"form-group check_box\" ng-show=\"vm.teacherlogin\"><input type=\"checkbox\" tabindex=\"10\" name=\"terms\" ng-model=\"vm.user.terms\" required=\"\" id=\"remember\"> <label for=\"remember\">I agree to <a ui-sref=\"index.terms\" target=\"_blank\"><u>Terms and Conditions</u></a> & <a ui-sref=\"index.privacy\" target=\"_blank\"><u>Privacy Policy</u></a>.</label><p class=\"help-block text-danger\" ng-show=\"form.terms.$error.required && vm.submitted\">Are you agree with terms?</p></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><input type=\"submit\" name=\"login-submit\" id=\"login-submit\" class=\"btn btn-info btn-md\" value=\"Create My Account\"></div></div></div></form></div></div></div></div></div></div><style>\r\n    .ui-select-choices {\r\n        visibility: visible !important;\r\n        transform: inherit !important;\r\n        border-radius: 0px !important;\r\n    }\r\n\r\n    .btn-xs {\r\n        padding: 1px 5px;\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        border-radius: 3px;\r\n        background-color: white;\r\n    }\r\n\r\n    .ui-select-search::placeholder {\r\n        color: #7d858c !important;\r\n        margin-left: 4px !important;\r\n    }\r\n\r\n    ul.ui-select-choices.ui-select-choices-content.ui-select-dropdown.dropdown-menu {\r\n        display: block;\r\n    }\r\n .btn-info {\r\n    color: #fff;\r\n    background-color: #f3772e;\r\n    border-color: #f3772e;\r\n    border-radius: 25px;\r\n    padding: 10px 40px;\r\n    font-weight: 500;\r\n    outline: none;\r\n    margin-top: 15px;\r\n    box-shadow: none;\r\n    font-size: 20px!important;\r\n}\r\n.teacher {\r\n    margin: auto;\r\n}\r\n</style><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(1)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/components/common/content.html","<div class=\"overlay\" pre-loading=\"\"><span class=\"pre-loading\"><img src=\"assets/image/spinner.gif\"></span></div><header ng-if=\"showHeader\" ng-include=\"\'app/components/partials/header/header.html\'\"></header><div class=\"main-view\" ui-view=\"\"></div><div class=\"main\" ng-if=\"showFooter\" ng-include=\"\'app/components/partials/footer/footer.html\'\"></div><script>\r\n   window.onscroll = function() {scrollFunction()};\r\n\r\n   function scrollFunction() {\r\n       //if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {\r\n       //    document.getElementById(\"topbtn\").style.display = \"block\";\r\n       //} else {\r\n       //    document.getElementById(\"topbtn\").style.display = \"none\";\r\n       //}\r\n   }\r\n   function topFunction() {\r\n       var body = $(\"html, body\");\r\n       body.stop().animate({scrollTop:0}, 600, \'swing\', function() {\r\n       });\r\n   }\r\n\r\n    document.addEventListener(\'gesturestart\', function (e) {\r\n        e.preventDefault();\r\n    });\r\n\r\n\r\n    // Create Base64 Object @ lib used in utility factory\r\n    var Base64 ={_keyStr:\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\",encode:function(e){var t=\"\";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t=\"\";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9+/=]/g,\"\");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/rn/g,\"n\");var t=\"\";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t=\"\";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}\r\n\r\n\r\n</script>");
$templateCache.put("app/components/partials/sidebar-footer.html","<footer class=\"footer footer-black footer-white\" style=\"padding:15px!important;margin:0!important\"><div class=\"container\"><div class=\"row\"><nav class=\"footer-nav\"><ul><li>Copyright © 2019. Kapdec. All Rights Reserved.</li><li><a ui-sref=\"index.terms\" target=\"_blank\">Terms & Condition</a></li><li><a ui-sref=\"index.privacy\" target=\"_blank\">Privacy Policy</a></li><li><a ui-sref=\"index.sitemap\" target=\"_blank\">Sitemap</a></li></ul></nav></div></div></footer>");
$templateCache.put("app/components/modal/AddStoryActionModal.html","<div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">{{ vm.isEditable === true ? \'Add Story\': vm.isEditable === false ? \'Story details\': \'Add Story\'}}</h3><div class=\"modal-body\"><div ng-if=\"vm.isEditable\"><form name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Full Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A full name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">full name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.story.email\" ng-pattern=\"vm.pattern.email\" placeholder=\"Email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">What\'s your email address?</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.videoUrl.$valid , \'has-error\': form.videoUrl.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" name=\"videoUrl\" ng-model=\"vm.story.videoURL\" placeholder=\"Youtube Video Link ex:https://www.youtube.com/embed/4Wf-PsSn_rA\" ng-minlength=\"10\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Youtube Video Link: https://www.youtube.com/embed/4Wf-PsSn_rA \'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"(form.videoUrl.$error.required || form.videoUrl.$error.minlength) && vm.submitted\">A valid videoURL is required.</p><div><p>Kapdec will not share your personal data with anyone.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:120px;resize:none;\" name=\"description\" ng-model=\"vm.story.description\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateStory(form )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Submit</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div></form></div><div ng-if=\"!vm.isEditable\" class=\"video_container\"><div class=\"row\" style=\"padding:0 30px\"><div class=\"col-xs-12\"><div class=\"videos\"><iframe ng-if=\"vm.story.videoURL\" ng-src=\"{{ vm.trustUrl(vm.story.videoURL) }}\" height=\"260\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-xs-12\"><div class=\"video_description\"><h2><b>{{vm.story.name}}</b></h2><h5>{{vm.story.email}}</h5><h5><b>{{vm.story.createdAt | date: \'mediumDate\' }}</b></h5><p ng-bind-html=\"vm.story.description\"></p></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/AddVideoActionModal.html","<div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">{{ vm.isEditable === true ? \'Add Video\': vm.isEditable === false ? \'Video details\': \'Add Video\'}}</h3><div class=\"modal-body\"><div ng-if=\"vm.isEditable\"><form name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Title\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Title\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">Title is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">Title must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.chapter.$valid && vm.submitted, \'has-error\': form.chapter.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.chapter\" ng-minlength=\"3\" name=\"chapter\" placeholder=\"chapter\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'chapter\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.chapter.$error.required && vm.submitted\">A chapter is required.</p><p ng-show=\"form.chapter.$error.minlength && vm.submitted\" class=\"help-block\">Chapter must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.videoUrl.$valid , \'has-error\': form.videoUrl.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" name=\"videoUrl\" ng-model=\"vm.story.videoURL\" placeholder=\"Youtube Video Link ex:https://www.youtube.com/embed/4Wf-PsSn_rA\" ng-minlength=\"10\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Youtube Video Link: https://www.youtube.com/embed/4Wf-PsSn_rA \'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"(form.videoUrl.$error.required || form.videoUrl.$error.minlength) && vm.submitted\">A valid videoURL is required.</p><div><p>Kapdec will not share your personal data with anyone.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:120px;resize:none;\" name=\"description\" ng-model=\"vm.story.description\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateStory(form )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Submit</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div></form></div><div ng-if=\"!vm.isEditable\" class=\"video_container\"><div class=\"row\" style=\"padding:0 30px\"><div class=\"col-xs-12\"><div class=\"videos\"><iframe ng-if=\"vm.story.videoURL\" ng-src=\"{{ vm.trustUrl(vm.story.videoURL) }}\" height=\"260\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-xs-12\"><div class=\"video_description\"><h2><b>{{vm.story.name}}</b></h2><h5>{{vm.story.email}}</h5><h5><b>{{vm.story.createdAt | date: \'mediumDate\' }}</b></h5><p ng-bind-html=\"vm.story.description\"></p></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/StoryActionModal.html","<div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">{{ vm.isEditable === true ? \'Edit Story\': vm.isEditable === false ? \'Story details\': \'Add Story\'}}</h3><div class=\"modal-body\"><div ng-if=\"vm.isEditable\"><form name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Full Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A full name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">full name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.story.email\" ng-pattern=\"vm.pattern.email\" placeholder=\"Email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">What\'s your email address?</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.videoUrl.$valid , \'has-error\': form.videoUrl.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" name=\"videoUrl\" ng-model=\"vm.story.videoURL\" placeholder=\"Youtube Video Link ex:https://www.youtube.com/embed/4Wf-PsSn_rA\" ng-minlength=\"10\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Youtube Video Link: https://www.youtube.com/embed/4Wf-PsSn_rA \'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"(form.videoUrl.$error.required || form.videoUrl.$error.minlength) && vm.submitted\">A valid videoURL is required.</p><div><p>Kapdec will not share your personal data with anyone.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:120px;resize:none;\" name=\"description\" ng-model=\"vm.story.description\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateStory(form )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Update</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div></form></div><div ng-if=\"!vm.isEditable\" class=\"video_container\"><div class=\"row\" style=\"padding:0 30px\"><div class=\"col-xs-12\"><div class=\"videos\"><iframe ng-if=\"vm.story.videoURL\" ng-src=\"{{ vm.trustUrl(vm.story.videoURL) }}\" height=\"260\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-xs-12\"><div class=\"video_description\"><h2><b>{{vm.story.name}}</b></h2><h5>{{vm.story.email}}</h5><h5><b>{{vm.story.createdAt | date: \'mediumDate\' }}</b></h5><p ng-bind-html=\"vm.story.description\"></p></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/VideoActionModal.html","<div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">{{ vm.isEditable === true ? \'Edit Video\': vm.isEditable === false ? \'Video details\': \'Add Video\'}}</h3><div class=\"modal-body\"><div ng-if=\"vm.isEditable\"><form name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Title\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Title\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">Title is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">Title must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.chapter.$valid && vm.submitted, \'has-error\': form.chapter.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.story.chapter\" ng-minlength=\"3\" name=\"chapter\" placeholder=\"chapter\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'chapter\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.chapter.$error.required && vm.submitted\">A chapter is required.</p><p ng-show=\"form.chapter.$error.minlength && vm.submitted\" class=\"help-block\">Chapter must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.videoUrl.$valid , \'has-error\': form.videoUrl.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" name=\"videoUrl\" ng-model=\"vm.story.videoURL\" placeholder=\"Youtube Video Link ex:https://www.youtube.com/embed/4Wf-PsSn_rA\" ng-minlength=\"10\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Youtube Video Link: https://www.youtube.com/embed/4Wf-PsSn_rA \'\" autocomplete=\"off\" required=\"\"><p class=\"help-block\" ng-show=\"(form.videoUrl.$error.required || form.videoUrl.$error.minlength) && vm.submitted\">A valid videoURL is required.</p><div><p>Kapdec will not share your personal data with anyone.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:120px;resize:none;\" name=\"description\" ng-model=\"vm.story.description\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateStory(form )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Update</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div></form></div><div ng-if=\"!vm.isEditable\" class=\"video_container\"><div class=\"row\" style=\"padding:0 30px\"><div class=\"col-xs-12\"><div class=\"videos\"><iframe ng-if=\"vm.story.videoURL\" ng-src=\"{{ vm.trustUrl(vm.story.videoURL) }}\" height=\"260\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allow=\"autoplay; encrypted-media\" allowfullscreen=\"\"></iframe></div></div><div class=\"col-xs-12\"><div class=\"video_description\"><h2><b>{{vm.story.name}}</b></h2><h5>{{vm.story.email}}</h5><h5><b>{{vm.story.createdAt | date: \'mediumDate\' }}</b></h5><p ng-bind-html=\"vm.story.description\"></p></div></div></div></div></div></div>");
$templateCache.put("app/components/modal/addChildModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Add New Child</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">What\'s your email address?</p><p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/addStudentModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Add New Student</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.addStudentByEmail(formv)\" novalidate=\"\" name=\"formv\"><div class=\"form-group\" ng-class=\"{ \'has-success\': formv.email.$valid && vm.submitted, \'has-error\': formv.email.$invalid && vm.submitted }\"><input class=\"form-control\" rows=\"5\" id=\"comment\" type=\"email\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.studentEmail\" autocomplete=\"off\" placeholder=\"Enter Student Email Id...\" required=\"\"><p class=\"help-block\" style=\"color:red;font-size:16px\" ng-show=\"formv.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" style=\"color:red;font-size:16px\" ng-show=\"formv.email.$error.required && vm.submitted\">Please enter email address.</p></div><div class=\"form-group\"><div ng-class=\"{\'close-event\': vm.isBusy }\" class=\"edit_profile submit\"><a href=\"\" ng-click=\"vm.addStudentByEmail(formv)\" class=\"btn\">Add Student</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/badgeActionModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.isEditable === false?\'Badge Details\':\'Manage Badge\'}}</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"form\" novalidate=\"\"><div ng-class=\"{\'close-event-light\': vm.isEditable === false }\" class=\"form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.badge.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Badge Name\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">name must be atleast 3 characters.</p></div><div ng-class=\"{\'close-event-light\': vm.isEditable === false }\" class=\"form-group\"><input type=\"text\" numbers-only=\"\" class=\"form-control\" ng-model=\"vm.badge.minAllocatePercntageCriteria\" ng-pattern=\"vm.pattern.number\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" onkeyup=\"if(this.value>100){this.value=\'100\';}else if(this.value<0){this.value=\'0\';}\" maxlength=\"3\" name=\"min\" placeholder=\"Min % Criteria\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.min.$error.required && vm.submitted\">Min Allocate % Criteria is required.</p><p ng-show=\"form.min.$error.pattern && vm.submitted\" class=\"help-block text-danger\">Proper Min Allocate % Criteria is required.</p></div><div ng-class=\"{\'close-event-light\': vm.isEditable === false }\" class=\"form-group\"><input type=\"text\" class=\"form-control\" numbers-only=\"\" ng-model=\"vm.badge.maxAllocatePercntageCriteria\" ng-pattern=\"vm.pattern.number\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" onkeyup=\"if(this.value>100){this.value=\'100\';}else if(this.value<0){this.value=\'0\';}\" maxlength=\"3\" name=\"max\" placeholder=\"Max % Criteria\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.max.$error.required && vm.submitted\">Max Allocate % Criteria is required.</p><p ng-show=\"form.max.$error.pattern && vm.submitted\" class=\"help-block text-danger\">Proper Max Allocate % Criteria is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea class=\"form-control\" maxlength=\"250\" name=\"description\" ng-model=\"vm.badge.description\" ng-minlength=\"15\" placeholder=\"Your badge description...\" autocomplete=\"off\" style=\"height: 100px; max-height: 100px;\" required=\"\">  </textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div><div class=\"form-group has-error\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div ng-class=\"{\'close-event-light\': vm.isEditable === false }\" class=\"form-group\" ng-init=\"vm.initLoad()\"><label ng-hide=\"vm.isEditable === false\">Upload Image</label> <input type=\"file\" id=\"fileInput\" size=\"80\" accept=\"image/*\"></div><div class=\"form-group\"><figure class=\"admin-upload-img\"><img ng-src=\"{{ vm.myCroppedImage || vm.getImageUrl(vm.badge.logo ) }}\" alt=\"badge\" class=\"img-fluid\"></figure><div class=\"col-md-12\" style=\"display:none\"><ui-cropper image=\"myImage\" init-max-area=\"true\" area-type=\"circle\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" canvas-scalemode=\"true\"></ui-cropper><div ng-if=\"vm.myCroppedImage\"><span><button ng-disabled=\"vm.isBusy\" ng-click=\"vm.cancelUpload(form);\" class=\"btn btn-default\">Cancel</button></span></div></div></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateBadges(form, vm.myCroppedImage, myImage.name )\" class=\"btn\" type=\"submit\" value=\"Save\">Update</button> <button ng-if=\"vm.isEditable == \'new\'\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addBadges(form, vm.myCroppedImage, myImage.name )\" class=\"btn\" type=\"submit\" value=\"Save\">Save</button></div><div class=\"edit_profile close_btn\"><button ng-if=\"!vm.isEditable === false\" ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn\" style=\"background-color:#18244a !important\" ng-click=\"vm.cancel()\">Cancel</button></div></div></form></div></div></div></div>");
$templateCache.put("app/components/modal/changePasswordModal.html","<div class=\"classes_popup\"><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><h4 class=\"modal-title\">Change Password</h4><div class=\"modal-body\"><form ng-submit=\"vm.joinClassWithCode(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"password\" name=\"password\" ng-model=\"vm.password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" placeholder=\"New Password\" autocomplete=\"off\" required=\"\" id=\"Password\"><i class=\"fa fa-eye-slash form-control-feedback\"></i></div><div class=\"col-md-12\"><span class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter new password</span> <span class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</span></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" ng-pattern=\"vm.password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\" id=\"ConfirmPassword\"><i class=\"fa fa-eye-slash form-control-feedback\"></i></div><div class=\"col-md-12\"><span class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">Please enter confirm password</span> <span class=\"help-block text-danger\" ng-show=\"(form.confirmPassword.$error.pattern || !(vm.confirmPassword === vm.password)) && vm.submitted\">Confirm password must be matched.</span></div></div><div class=\"form-group\"><div class=\"edit_profile submit\"><a href=\"javascript:void(0)\" ng-click=\"vm.upload(form.$valid)\" ng-class=\"{\'close-event\': vm.loader}\" ng-disabled=\"vm.loader\" class=\"btn\">Update Password</a></div></div></form></div></div><script>\r\n    $(document).ready(function () {\r\n        \r\n        $(\'#Password + .fa\').on(\'click\', function () {\r\n            $(this).toggleClass(\'fa-eye-slash\').toggleClass(\'fa-eye\'); // toggle our classes for the eye icon\r\n\r\n            var type = $(\"#Password\").attr(\"type\");\r\n\r\n            if (type === \'password\') {\r\n                $(\"#Password\").attr(\"type\", \"text\");\r\n            } else {\r\n                $(\"#Password\").attr(\"type\", \"password\");\r\n            }\r\n        });\r\n        $(\'#ConfirmPassword + .fa\').on(\'click\', function () {\r\n            $(this).toggleClass(\'fa-eye-slash\').toggleClass(\'fa-eye\'); // toggle our classes for the eye icon\r\n\r\n            var type = $(\"#ConfirmPassword\").attr(\"type\");\r\n\r\n            if (type === \'password\') {\r\n                $(\"#ConfirmPassword\").attr(\"type\", \"text\");\r\n            } else {\r\n                $(\"#ConfirmPassword\").attr(\"type\", \"password\");\r\n            }\r\n        });\r\n    });\r\n\r\n</script>");
$templateCache.put("app/components/modal/chapterVideoModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.chapter.name}}</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><iframe ng-src=\"{{ vm.trustUrl( vm.chapter.vidURL ) }}\" style=\"width: 100%;height: 334px;\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen=\"\"></iframe></div></div>");
$templateCache.put("app/components/modal/classActionByTeacherModal.html","<div class=\"classes_popup\"><button type=\"button\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\" class=\"close\">&times;</button><h4 class=\"modal-title\" ng-if=\"!vm.class._id\">Create New Class</h4><h4 class=\"modal-title\" ng-if=\"vm.class._id\">{{vm.isEditable === true?\'Edit Class\':\'View Class\'}}</h4><div class=\"modal-body\"><form ng-submit=\"vm.manageClass(form)\" name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input id=\"uLogin\" type=\"text\" ng-model=\"vm.class.name\" name=\"name\" class=\"form-control\" placeholder=\"Class Name\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter Class Name.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.class.grade\" ng-change=\"vm.getCourse(vm.class.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">Please select grade.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.course.$valid && vm.submitted, \'has-error\': form.course.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"course\" id=\"course\" ng-model=\"vm.class.course\" ng-change=\"vm.getTopic(vm.class.course)\" required=\"\"><option value=\"\">Select Subject</option><option ng-repeat=\"option in vm.courses track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">Please select Subject.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.topic.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.class.topics\" theme=\"bootstrap\" name=\"topic\" id=\"topic\" close-on-select=\"false\" ng-change=\"vm.getUnits(vm.class.topics)\" style=\"border: 1px solid #dddddd;\" title=\"Choose a topic\" required=\"\"><ui-select-match placeholder=\"Select Topics\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"topic._id as topic in vm.topics | filter:$select.search\">{{topic.name}}</ui-select-choices></ui-select><p class=\"help-block text-danger\" ng-show=\"form.topic.$error.required && vm.submitted\">Please select topic.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.units.$valid && vm.submitted, \'has-error\': form.units.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.class.units\" ng-change=\"vm.getChapters(vm.class.units)\" theme=\"bootstrap\" name=\"units\" id=\"units\" close-on-select=\"false\" style=\"border: 1px solid #dddddd;\" title=\"Choose a Module\" required=\"\"><ui-select-match placeholder=\"Select Modules\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"unit._id as unit in vm.units | filter:$select.search\">{{unit.name}}</ui-select-choices></ui-select><p class=\"help-block text-danger\" ng-show=\"form.units.$error.required && vm.submitted\">Please select Module.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.chapters.$valid && vm.submitted, \'has-error\': form.chapters.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.class.chapters\" name=\"chapters\" id=\"chapters\" theme=\"bootstrap\" close-on-select=\"false\" style=\"border: 1px solid #dddddd;\" title=\"Choose a chapter\" required=\"\"><ui-select-match placeholder=\"Select Chapters\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"chapter._id as chapter in vm.chapters | filter:$select.search\">{{chapter.name}}</ui-select-choices></ui-select><p class=\"help-block text-danger\" ng-show=\"form.chapters.$error.required && vm.submitted\">Please select chapters.</p></div><div class=\"form-group\"><textarea class=\"form-control\" style=\"height: 100px;max-height: 100px;\" placeholder=\"Description\" ng-model=\"vm.class.description\"></textarea></div><div class=\"form-group\"><div ng-if=\"vm.isEditable === true\" class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Submit</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div><style>\r\n  .ui-select-choices {\r\n    visibility: visible !important;\r\n    transform: inherit !important;\r\n    border-radius: 0px !important;\r\n  }\r\n\r\n  .btn-xs {\r\n    padding: 1px 5px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    border-radius: 3px;\r\n    background-color: white;\r\n  }\r\n\r\n  .ui-select-search::placeholder {\r\n    color: #7d858c !important;\r\n    margin-left: 4px !important;\r\n  }\r\n</style>");
$templateCache.put("app/components/modal/classViewByStudent.html","<div class=\"classes_popup\"><button type=\"button\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\" class=\"close\">&times;</button><h4 class=\"modal-title\">Class Detail</h4><div class=\"modal-body\"><div class=\"form-group\"><label class=\"control-label\">Class Name :-</label> {{vm.data.name}}</div><div class=\"form-group\"><label class=\"control-label\">Subject :-</label> {{vm.data.course.name}}</div><div class=\"form-group\"><label class=\"control-label\">Topic :-</label> <span ng-repeat=\"topic in vm.data.topics\">{{topic.name}},</span></div><div class=\"form-group\"><label class=\"control-label\">Module :-</label> <span ng-repeat=\"unit in vm.data.units\">{{unit.name}},</span></div><div class=\"form-group\"><label class=\"control-label\">Chapters :-</label> <span ng-repeat=\"chapter in vm.data.chapters\">{{chapter.name}},</span></div><div class=\"form-group\"><label class=\"control-label\">Description :-</label> {{vm.data.description}}</div><div class=\"form-group\"><label class=\"control-label\">Created By:-</label> {{vm.data.createdBy.name}}</div></div></div>");
$templateCache.put("app/components/modal/contactEnquiryAction.html","<div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">Reply Message</h3><div class=\"modal-body\"><form name=\"form\" ng-if=\"vm.isEditable\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.enquiry.firstName\" ng-minlength=\"3\" name=\"name\" placeholder=\"Full Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.enquiry.email\" ng-pattern=\"vm.pattern.email\" placeholder=\"Email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" autocomplete=\"off\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">What\'s your email address?</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:220px;resize:vertical;\" name=\"description\" ng-model=\"vm.enquiry.replyMessage\" ng-minlength=\"12\" maxlength=\"500\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper reply message is required.</p><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">Please enter reply message!</p></div><br><div class=\"form-group has-error\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><br><div class=\"form-group edit_profile submit\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.replyEnquiry(form )\" class=\"btn\" type=\"submit\" value=\"Save\">Send</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn\" ng-click=\"vm.cancel()\">Cancel</button></div><br></form></div></div>");
$templateCache.put("app/components/modal/contactViewEnquiryAction.html","<style>\r\n    textarea.form-control{\r\n        max-height: 125px !important;\r\n    }\r\n</style><div class=\"classes_popup\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">View Message</h3><div class=\"modal-body\"><form name=\"form\" ng-if=\"vm.isEditable\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.enquiry.firstName\" ng-minlength=\"3\" name=\"name\" placeholder=\"Full Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.enquiry.email\" ng-pattern=\"vm.pattern.email\" placeholder=\"Email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" autocomplete=\"off\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea style=\"height:500px;resize:vertical;\" name=\"description\" ng-model=\"vm.enquiry.message\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea ng-if=\"vm.enquiry.replyMessage\" style=\"height:500px;resize:vertical;\" name=\"description\" ng-model=\"vm.enquiry.replyMessage\" class=\"form-control\" placeholder=\"Your Message...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Your Message\'\" autocomplete=\"off\" required=\"\">  </textarea></div><br><div class=\"form-group edit_profile submit\"><button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn\" ng-click=\"vm.cancel()\">Cancel</button></div><br></form></div></div>");
$templateCache.put("app/components/modal/createAdminModal.html","<style>\r\n     div#joinClass .panel-heading label {\r\n    padding: 10px;\r\n    background: #b0aeae;\r\n    width: 100%;\r\n    display: block;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    cursor: pointer;\r\n}\r\ndiv#joinClass .panel-heading input[type=\"radio\"] {\r\n    position: absolute;\r\n    clip: rect(0px, 0px, 0px, 0px);\r\n    pointer-events: none;\r\n}\r\ndiv#joinClass input {\r\n    padding: 10px;\r\n    border-bottom: 1px solid#ddd;\r\n    border: none;\r\n    vertical-align: middle;\r\n}\r\n.modal-body input {\r\n    border-bottom: 1px solid #ddd!important;\r\n    \r\n}\r\n    .modal-header {\r\n    border-bottom: none;\r\n    text-align: center;\r\n    display: block;\r\n    font-weight: 600;\r\n}\r\n.close:not(:disabled):not(.disabled) {\r\n    outline: none;\r\n}\r\n\r\nul {\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\n.panel-heading li {\r\n    display: inline-block;\r\n    width: 31.33%;\r\n    margin-left: 5px;\r\n}\r\n.sign-label {\r\n    color: #fff!important;\r\n    background: #fc4f4f!important;\r\n}\r\ndiv#joinClass input#login-submit {\r\n    background: #f3772e;\r\n    color: #fff;\r\n    font-size: 18px!important;\r\n    font-weight: 500;\r\n    letter-spacing: 0.5px;\r\n    padding: 12px!important;\r\n    border-radius: 25px;\r\n}\r\n.edit_profile.close_btn a {\r\n    background: #18244a!important;\r\n}\r\n.modal-content {\r\n    padding:0px !important;\r\n}\r\ndiv#joinClass {\r\n    padding: 20px 50px;\r\n}\r\nselect.form-control{-webkit-appearance: none;-webkit-border-radius:0px;}\r\n.form-control {height: auto;}\r\n.ui-select-container.form-control {\r\n    padding: 0;\r\n    border: none;\r\n}\r\n</style><div class=\"modal-header\"><button type=\"button\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\" class=\"close_btn close\">&times;</button><h4 class=\"modal-title\" id=\"myModalLabel\">Add User</h4></div><div class=\"modal-body\" id=\"joinClass\"><div class=\"teacher\"><div class=\"panel panel-login\"><div class=\"panel-heading\"><ul><li><label ng-class=\"{\'sign-label\':vm.user.role==\'teacher\'}\"><input type=\"radio\" name=\"role\" value=\"teacher\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" tabindex=\"1\" autocomplete=\"off\"> Teacher</label></li><li><label ng-class=\"{\'sign-label\':vm.user.role==\'student\'}\"><input type=\"radio\" name=\"role\" value=\"student\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" autocomplete=\"off\"> Student</label></li><li><label ng-class=\"{\'sign-label\':vm.user.role==\'parent\'}\"><input type=\"radio\" name=\"role\" value=\"parent\" ng-model=\"vm.user.role\" ng-change=\"vm.changerole(vm.user.role)\" autocomplete=\"off\" checked=\"\"> Parent</label></li></ul></div><div class=\"panel-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\" id=\"teacher-form\" role=\"form\" style=\"display: block;\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" id=\"username\" tabindex=\"1\" name=\"name\" ng-model=\"vm.user.fullname\" ng-minlength=\"3\" maxlength=\"35\" ng-pattern=\"vm.pattern.name\" class=\"form-control\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter full Name</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Full Name must be atleast 3 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.name.$error.pattern && vm.submitted\">Please enter a valid full name.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email Id\" tabindex=\"2\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group dobDate\" ng-class=\"{ \'has-success\': form.dateofBirth.$valid && vm.submitted, \'has-error\': form.dateofBirth.$invalid && vm.submitted }\"><input type=\"text\" date-picker=\"\" class=\"form-control\" tabindex=\"3\" placeholder=\"Date Of Birth\" name=\"dateofBirth\" id=\"dateofBirth\" ng-model=\"vm.user.dob\" ng-select=\"vm.checkStudentAge(vm.user.dob)\" ng-change=\"vm.checkStudentAge(vm.user.dob)\" maxdate=\"vm.maxDate\" autocomplete=\"off\" mongoose-error=\"\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.required && vm.submitted\">Please enter Date Of Birth.</p><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.mongoose\">{{ vm.errors.dateofBirth }}</p><p ng-show=\"form.dateofBirth.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Student age must be greter than 13</p></div><div ng-if=\"vm.bellowAge && vm.user.role==\'student\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.parentEmail.$valid && vm.submitted, \'has-error\': form.parentEmail.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Parent Email Id\" tabindex=\"2\" name=\"parentEmail\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.parentEmail\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group row country-code\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><div class=\"col-md-4 pr-md-1\"><input type=\"text\" name=\"Countryemoji\" tabindex=\"7\" id=\"Countryemoji\" placeholder=\"Countryemoji\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.emoji\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"> <input type=\"text\" name=\"CountrydialCode\" tabindex=\"7\" id=\"CountrydialCode\" placeholder=\"CountryCode\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.dialCode\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><select ng-model=\"vm.user.countryName\" ng-change=\"vm.changecountry()\" class=\"form-control\"><option value=\"\">-- Select a Country --</option><option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country.name}}</option></select></div><div class=\"col-md-8 pl-md-1\"><input type=\"text\" numbers-only=\"\" tabindex=\"4\" placeholder=\"Phone Number\" name=\"phoneNumber\" ng-model=\"vm.user.phoneNumber\" class=\"form-control\" required=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" autocomplete=\"off\"></div><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.required && vm.submitted\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div><p ng-if=\"vm.user.role==\'teacher\'\" class=\"formLable\" style=\"margin-bottom:15px;padding-left: 10px;\">Qualification</p><div ng-if=\"vm.user.role!=\'parent\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.user.grades\" theme=\"bootstrap\" name=\"grade\" id=\"grade\" close-on-select=\"false\" ng-change=\"vm.changeGrades()\" title=\"Choose a topic\" required=\"\"><ui-select-match placeholder=\"Select Grades...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"grade._id as grade in vm.grades | filter:$select.search\">{{grade.name}}</ui-select-choices></ui-select></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><input type=\"text\" name=\"degree_name\" tabindex=\"5\" id=\"degree_name\" class=\"form-control\" placeholder=\"Degree Name\" value=\"\" ng-model=\"vm.user.degreeName\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.required && vm.submitted\">Please enter Degree Name.</p><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.mongoose\">{{ vm.errors.degreeName }}</p></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.specialization.$valid && vm.submitted, \'has-error\': form.specialization.$invalid && vm.submitted }\"><input type=\"text\" name=\"specialization\" tabindex=\"7\" id=\"specialization\" class=\"form-control\" placeholder=\"Specialization\" value=\"\" ng-model=\"vm.user.specialization\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.required && vm.submitted\">Please enter Specialization.</p><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.mongoose\">{{ vm.errors.specialization }}</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" tabindex=\"8\" ng-model=\"vm.user.password\" id=\"password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" maxlength=\"25\" placeholder=\"Password\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter password</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" id=\"confirm-password\" tabindex=\"9\" name=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" ng-pattern=\"vm.user.password\" class=\"form-control\" placeholder=\"Confirm Password\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">Confirm password is required</p><p class=\"help-block text-danger\" ng-show=\"form.confirmPassword.$error.pattern && vm.submitted\">Confirm password must be matched.</p></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Submit</button></div></div><div class=\"col-md-6\"><div class=\"edit_profile close_btn\" style=\"float:right\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></div></div></form></div></div></div></div><style>\r\n    .ui-select-choices {\r\n        visibility: visible !important;\r\n        transform: inherit !important;\r\n        border-radius: 0px !important;\r\n    }\r\n\r\n    .btn-xs {\r\n        padding: 1px 5px;\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        border-radius: 3px;\r\n        background-color: white;\r\n    }\r\n\r\n    .ui-select-search::placeholder {\r\n        color: #7d858c !important;\r\n        margin-left: 4px !important;\r\n    }\r\n\r\n    ul.ui-select-choices.ui-select-choices-content.ui-select-dropdown.dropdown-menu {\r\n        display: block;\r\n    }\r\n</style>");
$templateCache.put("app/components/modal/createSubAdminModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{!vm.user._id?\'Create\':\'Update\'}} Sub Admin</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\" tabindex=\"-1\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" name=\"name\" ng-model=\"vm.user.fullname\" ng-minlength=\"3\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" placeholder=\"Full Name\" tabindex=\"1\" required=\"\" autocomplete=\"off\" maxlength=\"35\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter full name.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">Name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" tabindex=\"2\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group dobDate\" ng-class=\"{ \'has-success\': form.dateofBirth.$valid && vm.submitted, \'has-error\': form.dateofBirth.$invalid && vm.submitted }\"><input type=\"text\" maxdate=\"vm.maxDate\" class=\"form-control\" autocomplete=\"off\" placeholder=\"{{vm.user.dob}}\" tabindex=\"3\" date-picker=\"vm.user.dob\" name=\"dateofBirth\" id=\"dateofBirth\" ng-model=\"vm.user.dob\" mongoose-error=\"\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.required && vm.submitted\">Please enter Date Of Birth.</p><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.mongoose\">{{ vm.errors.dateofBirth }}</p></div><div class=\"form-group\"><select ng-model=\"vm.user.countryName\" ng-change=\"vm.changecountry()\" class=\"form-control\"><option value=\"\">-- Select a Country --</option><option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country.name}}</option></select></div><div class=\"form-group row\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><div class=\"col-md-2 pr-md-2\"><input type=\"text\" name=\"Countryemoji\" tabindex=\"7\" id=\"Countryemoji\" placeholder=\"Countryemoji\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.emoji\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"></div><div class=\"col-md-2 px-md-2\"><input type=\"text\" name=\"CountrydialCode\" tabindex=\"7\" id=\"CountrydialCode\" placeholder=\"CountryCode\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.dialCode\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"></div><div class=\"col-md-8 pl-md-2\"><input type=\"text\" placeholder=\"Phone Number\" name=\"phoneNumber\" numbers-only=\"\" ng-model=\"vm.user.phoneNumber\" class=\"form-control\" required=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" tabindex=\"4\" autocomplete=\"off\"></div><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.required && vm.submitted\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 10 characters.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 10 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Password\'\" tabindex=\"5\" placeholder=\"Password\" required=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.password.$error.required && vm.submitted\">Please enter password</p><p class=\"help-block\" ng-show=\"form.password.$error.pattern && vm.submitted\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" ng-pattern=\"vm.user.password\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Confirm Password\'\" tabindex=\"6\" placeholder=\"Confirm Password\" required=\"\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required && vm.submitted\">Please enter confirm password</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.pattern && vm.submitted\">Confirm password must be matched.</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div><style>\r\n    select.form-control {\r\n        -webkit-appearance: none;\r\n        -webkit-border-radius: 0px;\r\n    }\r\n\r\n    .form-control {\r\n        height: auto;\r\n    }\r\n\r\n    .ui-select-container.form-control {\r\n        padding: 0;\r\n        border: none;\r\n    }\r\n</style>");
$templateCache.put("app/components/modal/editAdminModal.html","<style>\r\n    div#joinClass .panel-heading label {\r\n        padding: 10px;\r\n        background: #b0aeae;\r\n        width: 100%;\r\n        display: block;\r\n        text-align: center;\r\n        border-radius: 4px;\r\n        color: #fff;\r\n        text-transform: uppercase;\r\n        letter-spacing: 1px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    div#joinClass .panel-heading input[type=\"radio\"] {\r\n        position: absolute;\r\n        clip: rect(0px, 0px, 0px, 0px);\r\n        pointer-events: none;\r\n    }\r\n\r\n    div#joinClass input {\r\n        padding: 15px 0px;\r\n        border-bottom: 1px solid#ddd;\r\n        border: none;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .modal-body input {\r\n        border-bottom: 1px solid #ddd !important;\r\n\r\n    }\r\n\r\n    .modal-header {\r\n        border-bottom: none;\r\n        text-align: center;\r\n        display: block;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .close:not(:disabled):not(.disabled) {\r\n        outline: none;\r\n    }\r\n\r\n    ul {\r\n        margin: 0px;\r\n        padding: 0px;\r\n    }\r\n\r\n    .panel-heading li {\r\n        display: inline-block;\r\n        width: 31.33%;\r\n        margin-left: 5px;\r\n    }\r\n\r\n    .sign-label {\r\n        color: #fff !important;\r\n        background: #fc4f4f !important;\r\n    }\r\n\r\n    div#joinClass input#login-submit {\r\n        background: #f3772e;\r\n        color: #fff;\r\n        font-size: 18px !important;\r\n        font-weight: 500;\r\n        letter-spacing: 0.5px;\r\n        padding: 12px !important;\r\n        border-radius: 25px;\r\n    }\r\n\r\n    .edit_profile.close_btn a {\r\n        background: #18244a !important;\r\n    }\r\n\r\n    .modal-content {\r\n        padding: 0px !important;\r\n    }\r\n\r\n    div#joinClass {\r\n        padding: 20px 50px;\r\n    }\r\n\r\n    .form-control[disabled],\r\n    .form-control[readonly],\r\n    fieldset[disabled] .form-control {\r\n        background-color: #E3E3E3;\r\n        color: #66615B;\r\n        cursor: not-allowed;\r\n    }\r\n</style><div class=\"modal-header\"><button type=\"button\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\" class=\"close_btn close\">&times;</button><h4 class=\"modal-title\" id=\"myModalLabel\">Edit User</h4></div><div class=\"modal-body\" id=\"joinClass\"><div class=\"teacher\"><div class=\"panel panel-login\"><div class=\"panel-body\"><form ng-submit=\"vm.register(form)\" novalidate=\"\" name=\"form\" id=\"teacher-form\" role=\"form\" style=\"display: block;\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" id=\"username\" tabindex=\"1\" name=\"name\" ng-model=\"vm.user.fullname\" ng-minlength=\"3\" maxlength=\"35\" ng-pattern=\"vm.pattern.name\" class=\"form-control\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">Please enter full Name</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Full Name must be atleast 3 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.name.$error.pattern && vm.submitted\">Please enter a valid full name.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Email Id\" tabindex=\"2\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.email\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\" disabled=\"\"><p class=\"help-block text-danger\" ng-show=\"form.email.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.email.$error.mongoose\">{{ vm.errors.email }}</p></div><div ng-if=\"vm.bellowAge && vm.user.role==\'student\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.parentEmail.$valid && vm.submitted, \'has-error\': form.parentEmail.$invalid && vm.submitted }\"><input type=\"email\" placeholder=\"Parent Email Id\" tabindex=\"2\" name=\"parentEmail\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.user.parentEmail\" class=\"form-control\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.pattern && vm.submitted\">Please enter valid email.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.required && vm.submitted\">Please enter email address.</p><p class=\"help-block text-danger\" ng-show=\"form.parentEmail.$error.mongoose\">{{ vm.errors.email }}</p></div><div class=\"form-group\"><select ng-model=\"vm.user.countryName\" ng-change=\"vm.changecountry()\" class=\"form-control\"><option value=\"\">-- Select a Country --</option><option ng-repeat=\"country in countries\" value=\"{{country}}\">{{country.name}}</option></select></div><div class=\"form-group row\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><div class=\"col-md-2 pr-md-2\"><input type=\"text\" name=\"CountryCode\" tabindex=\"7\" id=\"CountryCode\" placeholder=\"CountryCode\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.emoji\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"></div><div class=\"col-md-2 px-md-2\"><input type=\"text\" name=\"CountryCode\" tabindex=\"7\" id=\"CountryCode\" placeholder=\"CountryCode\" ng-readonly=\"vm.user.countryName\" ng-model=\"vm.user.dialCode\" class=\"form-control\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"></div><div class=\"col-md-8 pl-md-2\"><input type=\"text\" numbers-only=\"\" tabindex=\"4\" placeholder=\"Phone Number\" name=\"phoneNumber\" ng-model=\"vm.user.phoneNumber\" class=\"form-control\" required=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" autocomplete=\"off\"></div><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.required && vm.submitted\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 8 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div><p ng-if=\"vm.user.role==\'teacher\'\" class=\"formLable\" style=\"margin-bottom:15px\">Qualification</p><div ng-if=\"vm.user.role!=\'parent\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><ui-select multiple=\"\" ng-model=\"vm.user.grades\" theme=\"bootstrap\" name=\"grade\" id=\"grade\" close-on-select=\"false\" ng-change=\"vm.changeGrades()\" style=\"border: 1px solid #dddddd;\" title=\"Choose a topic\" required=\"\"><ui-select-match placeholder=\"Select Grades...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"grade._id as grade in vm.grades | filter:$select.search\">{{grade.name}}</ui-select-choices></ui-select></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.degree_name.$valid && vm.submitted, \'has-error\': form.degree_name.$invalid && vm.submitted }\"><input type=\"text\" name=\"degree_name\" tabindex=\"5\" id=\"degree_name\" class=\"form-control\" placeholder=\"Degree Name\" value=\"\" ng-model=\"vm.user.degreeName\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.required && vm.submitted\">Please enter Degree Name.</p><p class=\"help-block text-danger\" ng-show=\"form.degree_name.$error.mongoose\">{{ vm.errors.degreeName }}</p></div><div ng-if=\"vm.user.role==\'teacher\'\" class=\"form-group\" ng-class=\"{ \'has-success\': form.specialization.$valid && vm.submitted, \'has-error\': form.specialization.$invalid && vm.submitted }\"><input type=\"text\" name=\"specialization\" tabindex=\"7\" id=\"specialization\" class=\"form-control\" placeholder=\"Specialization\" value=\"\" ng-model=\"vm.user.specialization\" ng-minlength=\"3\" maxlength=\"35\" required=\"\" mongoose-error=\"\"><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.required && vm.submitted\">Please enter Specialization.</p><p class=\"help-block text-danger\" ng-show=\"form.specialization.$error.mongoose\">{{ vm.errors.specialization }}</p></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Update</button></div></div><div class=\"col-md-6\"><div class=\"edit_profile close_btn\" style=\"float:right\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></div></div></form></div></div></div></div><style>\r\n    .ui-select-choices {\r\n        visibility: visible !important;\r\n        transform: inherit !important;\r\n        border-radius: 0px !important;\r\n    }\r\n\r\n    .btn-xs {\r\n        padding: 1px 5px;\r\n        font-size: 12px;\r\n        line-height: 1.5;\r\n        border-radius: 3px;\r\n        background-color: white;\r\n    }\r\n\r\n    .ui-select-search::placeholder {\r\n        color: #7d858c !important;\r\n        margin-left: 4px !important;\r\n    }\r\n\r\n    ul.ui-select-choices.ui-select-choices-content.ui-select-dropdown.dropdown-menu {\r\n        display: block;\r\n    }\r\n</style>");
$templateCache.put("app/components/modal/editProfileImageModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Change Profile Image</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form novalidate=\"\" name=\"askform\" style=\"padding-top:25px\"><figure><img ng-src=\"{{ vm.myCroppedImage || vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" alt=\"user\" src=\"assets/images/profile-image.png\" class=\"img-fluid\"></figure><label ng-show=\"!vm.myCroppedImage\" class=\"edit_profile_picture\"><input type=\"file\" id=\"fileInput\" onchange=\"angular.element(this).scope().onSelectFile(this)\" size=\"60\" accept=\"image/*\"> Change Picture</label><div ng-if=\"vm.myCroppedImage\" ng-class=\"{\'close-event\': vm.loader}\" class=\"text-center\"><span><button ng-disabled=\"vm.loader\" ng-click=\"vm.upload(vm.myCroppedImage, myImage.name);\" class=\"btn\">Save</button></span> <span><button ng-disabled=\"vm.loader\" ng-click=\"vm.cancelUpload(form);\" class=\"btn btn-danger\">cancel</button></span></div><div style=\"margin-top:30px;position:absolute;top:0;right:0\"><ui-cropper image=\"myImage\" area-type=\"circle\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" canvas-scalemode=\"true\"></ui-cropper></div></form></div></div>");
$templateCache.put("app/components/modal/faqsActionModal.html","<div class=\"classes_popup\"><h3 class=\"modal-title\">{{ vm.isEditable === true ? \'Edit \'+vm.type : vm.isEditable === false ? vm.type+\' Details\': \'Add \'+vm.type }}</h3><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\" id=\"modal-body\" style=\"padding:20px;\"><form name=\"form\" novalidate=\"\"><div ng-if=\"vm.type == \'Category\'\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.displayName.$valid && vm.submitted, \'has-error\': form.displayName.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.faq.displayName\" ng-minlength=\"3\" maxlength=\"20\" name=\"displayName\" placeholder=\"Name\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.displayName.$error.required && vm.submitted\">A display Name is required.</p><p ng-show=\"form.displayName.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Display Name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><textarea ng-model=\"vm.faq.description\" name=\"description\" ng-minlength=\"15\" maxlength=\"500\" class=\"form-control\" placeholder=\"Description\" required=\"\">  </textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div></div><div ng-if=\"vm.type == \'Question\'\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : form.category.$invalid && vm.submitted }\"><select ng-model=\"vm.faq.type\" name=\"category\" data-placeholder=\"Course\" class=\"form-control\" required=\"\" ng-options=\"category._id as category.displayName for category in vm.category\"><option value=\"\">Select Category</option></select><p class=\"help-block text-danger\" ng-show=\"form.category.$error.required && vm.submitted\">A category is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.askQuestion.$valid && vm.submitted, \'has-error\': form.askQuestion.$invalid && vm.submitted }\"><textarea name=\"askQuestion\" class=\"form-control\" ng-model=\"vm.faq.askQuestion\" placeholder=\"askQuestion\" required=\"\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.askQuestion.$error.required && vm.submitted\">Please enter askQuestion!</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.answer.$valid && vm.submitted, \'has-error\': form.answer.$invalid && vm.submitted }\"><ng-quill-editor name=\"answer\" ng-model=\"vm.faq.answer\" placeholder=\"answer\" required=\"\"></ng-quill-editor><p class=\"help-block text-danger\" ng-show=\"form.answer.$error.required && vm.submitted\">Please enter answer!</p></div><div class=\"form-grouphas-error\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button ng-if=\"vm.isEditable === true\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateFaqs(vm.type, form )\" class=\"btn\" type=\"submit\" value=\"Save\">Update</button> <button ng-if=\"vm.isEditable == \'new\'\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addFaqs(vm.type, form )\" class=\"btn\" type=\"submit\" value=\"Save\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/hierarchyActionModal.html","<style>\r\n  .modal-dialog {\r\n      max-width: 750px;\r\n      width: 100%;\r\n  }\r\n  .close{\r\n    position: absolute;\r\n    right: 10px;\r\n  }\r\n  .modal-title{\r\n    margin-left: 36%;\r\n    color: black;\r\n  }\r\n  .modal-content{\r\n    padding: 0 !important;\r\n  }\r\n</style><div id=\"login_pop_up\" class=\"\"><div class=\"modal-header theme-clr-theadX\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">&nbsp; &nbsp;<p><b style=\"text-transform: capitalize;\">{{ vm.isEditable === true ? \'Edit \'+vm.type : vm.isEditable === false ? vm.type+\' Details\': \'Add \'+vm.type }}</b></p></h3></div><div class=\"modal-body\" id=\"modal-body\" style=\"padding:20px;\"><div class=\"row\"><div class=\"col-md-12\" ng-show=\"vm.loader\"><div class=\"ibox\"><div class=\"ibox-content\" style=\"height:350px;\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:75px;\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div></div></div><div ng-if=\"!vm.loader\" class=\"col-md-12\" ng-class=\"{\'close-event-light\': vm.isEditable === false }\"><form name=\"form\" novalidate=\"\"><div class=\"common-division\" ng-if=\"[\'grade\',\'course\',\'unit\',\'chapter\',\'topic\'].indexOf(vm.type) > -1\"><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label capitalize\">{{vm.type }} Name</label> <input type=\"text\" class=\"col-sm-10 form-control\" ng-model=\"vm.hire.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A {{vm.type}} Name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">{{vm.type}} Name must be atleast 3 characters.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.description.$valid , \'has-error\': form.description.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\">Description</label><div class=\"col-sm-10 margin-bottom-15\"><textarea style=\"height:180px;resize:vertical;\" ng-model=\"vm.hire.description\" name=\"description\" ng-minlength=\"15\" maxlength=\"250\" class=\"form-control\" placeholder=\"Description...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.description.$error.minlength && vm.submitted\">A proper description is required.</p><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A description is required.</p></div></div></div><div class=\"common-2-division\" ng-if=\"[\'unit\',\'chapter\',\'topic\'].indexOf(vm.type) > -1\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.course.$invalid && vm.submitted }\"><label class=\"col-sm-3 control-label\">Course</label><div class=\"col-sm-9 padd-0\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.course\" ng-change=\"vm.getUnits(vm.hire.course)\" name=\"course\" data-placeholder=\"Course\" class=\"form-control chosen-select\" required=\"\" ng-options=\"course._id as course.name for course in vm.course\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.course.$error.required && vm.submitted\">A course is required.</p></div></div><div ng-if=\"[\'chapter\',\'topic\'].indexOf(vm.type) > -1\" class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.unit.$invalid && vm.submitted }\"><label class=\"col-sm-3 control-label\">Unit</label><div class=\"col-sm-9 padd-0\" ng-class=\"{\'close-eventX\': !vm.hire.course }\" ng-if=\"vm.unit\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.unit\" ng-change=\"vm.getChapters(vm.hire.unit)\" name=\"unit\" data-placeholder=\"Unit\" class=\"form-control chosen-select\" required=\"\" ng-options=\"unit._id as unit.name for unit in vm.unit\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.unit.$error.required && vm.submitted\">A unit is required.</p></div></div><div class=\"col-sm-12\" ng-if=\"vm.type == \'chapter\'\" ng-repeat=\"grade in vm.hire.grade\"><div class=\"form-group col-sm-6 float-none\" ng-class=\"{ \'has-error\' : form.{{\'gradeType\'+$index}}.$invalid && vm.submitted }\"><label class=\"col-sm-3 control-label\">Grade{{$index+1}}</label><div class=\"col-sm-9 padd-0 margin-bottom-15\" ng-if=\"vm.grade\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.grade[$index].gradeType\" name=\"{{\'gradeType\'+$index}}\" data-placeholder=\"select Grade\" class=\"form-control chosen-select\" required=\"\" ng-options=\"grade._id as grade.name for grade in vm.grade\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.{{\'gradeType\'+$index}}.$error.required && vm.submitted\">Grade {{$index+1}} is required.</p></div></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.{{\'curriculum\'+$index}}.$invalid && vm.submitted }\"><label class=\"col-sm-4 control-label\">curriculum{{$index+1}}</label><div class=\"col-sm-6 padd-0 margin-bottom-15\" ng-if=\"vm.curriculum\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.grade[$index].curriculum\" name=\"{{\'curriculum\'+$index}}\" data-placeholder=\"select curriculum\" class=\"form-control chosen-select\" required=\"\" ng-options=\"curri.code as curri.code for curri in vm.curriculum\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.{{\'curriculum\'+$index}}.$error.required && vm.submitted\">curriculum {{$index+1}} is required.</p></div><div ng-if=\"!$index\" class=\"col-sm-2\"><button ng-click=\"vm.addGrade();\"><i class=\"fa fa-plus-circle clr-theme\"></i></button></div><div ng-if=\"$index\" class=\"col-sm-2\"><button ng-click=\"vm.delGrade($index);\"><i class=\"fa fa-minus-circle text-danger\"></i></button></div></div></div></div><div ng-if=\"vm.type == \'topic\'\" class=\"topic-division\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.chapter.$invalid && vm.submitted }\"><label class=\"col-sm-3 control-label\">Chapter</label><div class=\"col-sm-9 padd-0\" ng-class=\"{\'close-eventx\': !vm.hire.unit }\" ng-if=\"vm.chapter\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.chapter\" name=\"chapter\" data-placeholder=\"chapter\" class=\"form-control chosen-select\" required=\"\" ng-options=\"chapter._id as chapter.name for chapter in vm.chapter\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.chapter.$error.required && vm.submitted\">A chapter is required.</p></div></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.summary.$valid , \'has-error\': form.summary.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\">Summary</label><div class=\"col-sm-10 margin-bottom-15\"><textarea style=\"height:120px;resize:vertical;\" ng-model=\"vm.hire.summary\" name=\"summary\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Description...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.summary.$error.minlength && vm.submitted\">A proper summary is required.</p><p class=\"help-block\" ng-show=\"form.summary.$error.required && vm.submitted\">A summary is required.</p></div></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.suggestion.$valid , \'has-error\': form.suggestion.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\">Suggestion</label><div class=\"col-sm-10 margin-bottom-15\"><textarea style=\"height:120px;resize:vertical;\" ng-model=\"vm.hire.suggestion\" name=\"suggestion\" ng-minlength=\"15\" class=\"form-control\" placeholder=\"Description...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.suggestion.$error.minlength && vm.submitted\">A proper suggestion is required.</p><p class=\"help-block\" ng-show=\"form.suggestion.$error.required && vm.submitted\">A suggestion is required.</p></div></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.vidURL.$valid && vm.submitted, \'has-error\': form.vidURL.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\">vidURL</label> <input type=\"text\" class=\"col-sm-10 form-control\" ng-model=\"vm.hire.vidURL\" ng-minlength=\"12\" name=\"vidURL\" placeholder=\"Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.vidURL.$error.required && vm.submitted\">A vidURL is required;.</p><p ng-show=\"form.vidURL.$error.minlength && vm.submitted\" class=\"help-block\">vidURL must be correct.</p></div><div class=\"form-group col-sm-12\" ng-if=\"vm.hire.vidURL\"><div class=\"videos\" style=\"text-align: end;\"><iframe ng-if=\"vm.hire.vidURL\" ng-src=\"{{ vm.trustUrl(vm.hire.vidURL) }}\" width=\"600\" height=\"260\" frameborder=\"0\" webkitallowfullscreen=\"\" mozallowfullscreen=\"\" allowfullscreen=\"\"></iframe></div></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.isPaid.$invalid && vm.submitted }\"><label class=\"col-sm-3 control-label\">Is paid</label><div class=\"col-sm-9 padd-0\" ng-class=\"{\'close-eventx\': !vm.hire.vidURL }\" ng-if=\"vm.isPaid\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.hire.isPaid\" name=\"isPaid\" data-placeholder=\"isPaid\" class=\"form-control chosen-select\" required=\"\" ng-options=\"isPaid._id as isPaid.name for isPaid in vm.isPaid\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.isPaid.$error.required && vm.submitted\">isPaid is required.</p></div></div><div class=\"profile_picture_edit\" ng-class=\"{\'width-full\': !vm.myCroppedImage }\" ng-init=\"vm.initLoad()\"><figure class=\"admin-upload-img\"><img ng-src=\"{{ vm.myCroppedImage || vm.getImageUrl(vm.hire.thumbnail ) }}\" alt=\"thumbnail\" class=\"img-fluid\"></figure><label ng-show=\"!vm.myCroppedImage && !(vm.isEditable === false)\" class=\"edit_profile_picture\"><input type=\"file\" id=\"fileInput\" size=\"80\" accept=\"image/*\"> Add Picture</label><div ng-if=\"vm.myCroppedImage\"><span><button ng-disabled=\"vm.isBusy\" ng-click=\"vm.cancelUpload(form);\" class=\"btn btn-default\">cancel</button></span></div><div style=\"margin-top:15px;position:absolute;z-index: 999;top: 25px;right: 12px;\"><ui-cropper image=\"myImage\" area-type=\"rectangle\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" canvas-scalemode=\"true\"></ui-cropper></div></div></div><br><div class=\"form-group col-sm-12 has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><br><div class=\"margin-top-15\"><div ng-if=\"vm.isEditable === true\" class=\"form-group col-sm-6\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateHierarchy(vm.type, form, vm.myCroppedImage, myImage.name )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Update</button></div><div ng-if=\"vm.isEditable == \'new\'\" class=\"form-group col-sm-6\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addHierarchy(vm.type, form, vm.myCroppedImage, myImage.name )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Save</button></div><div ng-if=\"!vm.isEditable === false\" class=\"form-group col-sm-6\"><button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div></div><br></form></div></div></div></div>");
$templateCache.put("app/components/modal/joinClassModel.html","<div class=\"classes_popup\"><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><h4 class=\"modal-title\">Join New Class</h4><div class=\"modal-body\"><form ng-submit=\"vm.joinClassWithCode(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.classCode.$valid && vm.submitted, \'has-error\': form.classCode.$invalid && vm.submitted }\"><textarea class=\"form-control\" rows=\"5\" type=\"text\" autocomplete=\"off\" name=\"classCode\" ng-model=\"vm.classCode\" id=\"comment\" placeholder=\"Enter URN here...\" required=\"\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.classCode.$error.required && vm.submitted\">Please enter URN.</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><a href=\"javascript:void(0)\" ng-click=\"vm.joinClassWithCode(form)\" ng-class=\"{\'close-event\': vm.loader}\" ng-disabled=\"vm.loader\" class=\"btn\">Join Now</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/joinClasswithMailCodeModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Join New Class</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.joinClassWithCode(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.classCode.$valid && vm.submitted, \'has-error\': form.classCode.$invalid && vm.submitted }\"><input type=\"text\" autocomplete=\"off\" name=\"classCode\" ng-model=\"vm.classCode\" class=\"form-control\" placeholder=\"Enter URN here...\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.classCode.$error.required && vm.submitted\">Please enter URN.</p><p class=\"help-block text-danger\" ng-show=\"vm.error && vm.submitted\">{{vm.errormsg}}</p></div><div ng-if=\"vm.children && vm.children.length\" class=\"form-group\" ng-class=\"{ \'has-error\' : form.children.$invalid && vm.submitted }\"><select ng-model=\"vm.childId\" name=\"children\" data-placeholder=\"Select Child Email ID\" class=\"form-control\" required=\"\" ng-options=\"children._id as children.email for children in vm.children\"><option value=\"\" selected=\"\">Select Your Child</option></select><p class=\"help-block text-danger\" ng-show=\"form.children.$error.required && vm.submitted\">A child email id is required.</p></div><div class=\"form-group\"><div ng-class=\"{\'close-event\':vm.loader}\" class=\"edit_profile submit\"><a ng-click=\"vm.joinClassWithCode(form)\" href=\"\" class=\"btn\">Join Now</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/joinStudentInClass.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Join New Class</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.joinClassWithCode(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.classCode.$valid && vm.submitted, \'has-error\': form.classCode.$invalid && vm.submitted }\"><input type=\"text\" autocomplete=\"off\" name=\"classCode\" ng-model=\"vm.classCode\" class=\"form-control\" placeholder=\"Enter Unique Code\" style=\"padding-left:4px !important\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.classCode.$error.required && vm.submitted\">class code is required.</p><p class=\"help-block text-danger\" ng-show=\"vm.error && vm.submitted\">{{vm.errormsg}}</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-error\' : form.children.$invalid && vm.submitted }\"><div class=\"col-sm-8x row\"><select ng-model=\"vm.childId\" name=\"children\" data-placeholder=\"Select Child Email ID\" class=\"form-control\" required=\"\" ng-options=\"children._id as children.email for children in vm.children\"><option value=\"\" selected=\"\">Select Student Email Id</option></select><p class=\"help-block\" ng-show=\"form.children.$error.required && vm.submitted\">A child email id is required.</p></div></div><div class=\"form-group\"><div ng-class=\"{\'close-event\':vm.loader}\" class=\"edit_profile submit\"><a ng-click=\"vm.joinClassWithCode(form)\" href=\"\" class=\"btn\">Join Now</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/makeParentPaymentModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Payment</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form novalidate=\"\" name=\"form\"><h6 class=\"modal-title text-left\">Please Fill Card Details</h6><div class=\"row\"><input type=\"hidden\" ng-model=\"vm.currency1\"> <input type=\"hidden\" ng-model=\"vm.duration\"><div class=\"form-group col-sm-9\" ng-class=\"{ \'has-success\': form.creditCard.$valid && vm.submitted,\'has-error\': form.creditCard.$invalid && vm.submitted }\"><input type=\"text\" numbers-only=\"\" autocomplete=\"off\" name=\"creditCard\" maxlength=\"16\" minlength=\"16\" ng-model=\"vm.payment.creditCardNo\" class=\"form-control\" placeholder=\"Credit Card No.\" style=\"padding-left:4px !important\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.required && vm.submitted\">Credit Card No. is required.</p><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.maxlength && vm.submitted\">Credit Card No. is required.</p><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.minlength && vm.submitted\">Credit Card No. is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.cvv.$valid && vm.submitted,\'has-error\': form.cvv.$invalid && vm.submitted }\"><input type=\"text\" numbers-only=\"\" maxlength=\"3\" minlength=\"3\" autocomplete=\"off\" name=\"cvv\" ng-model=\"vm.payment.cvv\" class=\"form-control\" placeholder=\"CVV\" style=\"padding-left:4px !important\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.required && vm.submitted\">CVV is required.</p><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.minlength && vm.submitted\">CVV is required.</p><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.maxlength && vm.submitted\">CVV is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.year.$valid && vm.submitted,\'has-error\': form.year.$invalid && vm.submitted }\"><select ng-model=\"vm.payment.year\" class=\"form-control\" name=\"year\" ng-change=\"vm.selectYear(vm.payment.year)\" required=\"\"><option value=\"\">Year</option><option ng-repeat=\"year in vm.years\" value=\"{{year}}\">{{year}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.year.$error.required && vm.submitted\">Year is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.month.$valid && vm.submitted,\'has-error\': form.month.$invalid && vm.submitted }\"><select ng-model=\"vm.payment.month\" class=\"form-control\" name=\"month\" required=\"\"><option value=\"\" selected=\"\">Month</option><option ng-repeat=\"month in vm.months\" value=\"{{month}}\">{{month}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.month.$error.required && vm.submitted\">Month is required.</p></div><div class=\"form-group col-sm-6\"><input type=\"text\" numbers-only=\"\" disabled=\"\" ng-model=\"vm.amount\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label><input type=\"checkbox\" ng-model=\"vm.payment.recurring\" value=\"false\"> Recurring Payment</label></div></div><h6 class=\"modal-title text-left\">Please Fill Address Details</h6><div><div class=\"row\"><div class=\"form-group col-sm-6\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.FirstName\" name=\"FirstName\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"First Name\"><p class=\"help-block text-danger\" ng-show=\"form.FirstName.$error.required && vm.submitted\">First name is required.</p></div><div class=\"form-group col-sm-6\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.LastName\" name=\"LastName\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Last Name\"><p class=\"help-block text-danger\" ng-show=\"form.LastName.$error.required && vm.submitted\">Last name is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Address\" name=\"Address\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Address\"><p class=\"help-block text-danger\" ng-show=\"form.Address.$error.required && vm.submitted\">Address is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.City\" name=\"City\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"City\"><p class=\"help-block text-danger\" ng-show=\"form.City.$error.required && vm.submitted\">City is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.State\" name=\"State\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"State\"><p class=\"help-block text-danger\" ng-show=\"form.State.$error.required && vm.submitted\">State is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Country\" name=\"Country\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Country\"><p class=\"help-block text-danger\" ng-show=\"form.Country.$error.required && vm.submitted\">Country is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Zipcode\" name=\"ZipCode\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"ZipCode\"><p class=\"help-block text-danger\" ng-show=\"form.ZipCode.$error.required && vm.submitted\">ZipCode is required.</p></div></div></div><div class=\"form-group\"><div ng-class=\"{\'close-event\':vm.loader}\" class=\"edit_profile submit\"><a href=\"javascript:void(0)\" ng-click=\"vm.makePayment(form)\" class=\"btn\">Pay</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/makePaymentModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Payment</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form novalidate=\"\" name=\"form\"><h6 class=\"modal-title text-left\">Please Fill Card Details</h6><div class=\"row\"><input type=\"hidden\" ng-model=\"vm.currency1\"> <input type=\"hidden\" ng-model=\"vm.duration\"><div class=\"form-group col-sm-9\" ng-class=\"{ \'has-success\': form.creditCard.$valid && vm.submitted,\'has-error\': form.creditCard.$invalid && vm.submitted }\"><input type=\"text\" numbers-only=\"\" autocomplete=\"off\" name=\"creditCard\" maxlength=\"16\" minlength=\"16\" ng-model=\"vm.payment.creditCardNo\" class=\"form-control\" placeholder=\"Credit Card No.\" style=\"padding-left:4px !important\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.required && vm.submitted\">Credit Card No. is required.</p><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.maxlength && vm.submitted\">Credit Card No. is required.</p><p class=\"help-block text-danger\" ng-show=\"form.creditCard.$error.minlength && vm.submitted\">Credit Card No. is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.cvv.$valid && vm.submitted,\'has-error\': form.cvv.$invalid && vm.submitted }\"><input type=\"text\" numbers-only=\"\" maxlength=\"3\" minlength=\"3\" autocomplete=\"off\" name=\"cvv\" ng-model=\"vm.payment.cvv\" class=\"form-control\" placeholder=\"CVV\" style=\"padding-left:4px !important\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.required && vm.submitted\">CVV is required.</p><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.minlength && vm.submitted\">CVV is required.</p><p class=\"help-block text-danger\" ng-show=\"form.cvv.$error.maxlength && vm.submitted\">CVV is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.year.$valid && vm.submitted,\'has-error\': form.year.$invalid && vm.submitted }\"><select ng-model=\"vm.payment.year\" class=\"form-control\" name=\"year\" ng-change=\"vm.selectYear(vm.payment.year)\" required=\"\"><option value=\"\">Year</option><option ng-repeat=\"year in vm.years\" value=\"{{year}}\">{{year}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.year.$error.required && vm.submitted\">Year is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.month.$valid && vm.submitted,\'has-error\': form.month.$invalid && vm.submitted }\"><select ng-model=\"vm.payment.month\" class=\"form-control\" name=\"month\" required=\"\"><option value=\"\" selected=\"\">Month</option><option ng-repeat=\"month in vm.months\" value=\"{{month}}\">{{month}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.month.$error.required && vm.submitted\">Month is required.</p></div><div class=\"form-group col-sm-6\"><input type=\"text\" numbers-only=\"\" disabled=\"\" ng-model=\"vm.amount\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\"></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><label><input type=\"checkbox\" ng-model=\"vm.payment.recurring\" value=\"false\"> Recurring Payment</label></div></div><h6 class=\"modal-title text-left\">Please Fill Address Details</h6><div><div class=\"row\"><div class=\"form-group col-sm-6\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.FirstName\" name=\"FirstName\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"First Name\"><p class=\"help-block text-danger\" ng-show=\"form.FirstName.$error.required && vm.submitted\">First name is required.</p></div><div class=\"form-group col-sm-6\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.LastName\" name=\"LastName\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Last Name\"><p class=\"help-block text-danger\" ng-show=\"form.LastName.$error.required && vm.submitted\">Last name is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Address\" name=\"Address\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Address\"><p class=\"help-block text-danger\" ng-show=\"form.Address.$error.required && vm.submitted\">Address is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.City\" name=\"City\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"City\"><p class=\"help-block text-danger\" ng-show=\"form.City.$error.required && vm.submitted\">City is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.State\" name=\"State\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"State\"><p class=\"help-block text-danger\" ng-show=\"form.State.$error.required && vm.submitted\">State is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Country\" name=\"Country\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"Country\"><p class=\"help-block text-danger\" ng-show=\"form.Country.$error.required && vm.submitted\">Country is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\"><input type=\"text\" autocomplete=\"off\" ng-model=\"vm.payment.Zipcode\" name=\"ZipCode\" class=\"form-control\" style=\"padding-left:4px !important\" required=\"\" placeholder=\"ZipCode\"><p class=\"help-block text-danger\" ng-show=\"form.ZipCode.$error.required && vm.submitted\">ZipCode is required.</p></div></div></div><div class=\"form-group\"><div ng-class=\"{\'close-event\':vm.loader}\" class=\"edit_profile submit\"><a href=\"javascript:void(0)\" ng-click=\"vm.makePayment(form)\" class=\"btn\">Pay</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/manageBannerAction.html","<style>\r\n  .modal-dialog {\r\n      max-width: 680px;\r\n      width: 100%;\r\n  }\r\n  .close{\r\n    position: absolute;\r\n    right: 10px;\r\n  }\r\n  .modal-title{\r\n    margin-left: 36%;\r\n    color: black;\r\n  }\r\n  .modal-content{\r\n    padding: 0 !important;\r\n  }\r\n</style><div id=\"login_pop_up\" class=\"\"><div class=\"modal-header theme-clr-theadX\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><h3 class=\"modal-title\">&nbsp; &nbsp;<p><b>{{ vm.isEditable === true ? \'Edit Banner\': vm.isEditable === false ? \'Banner details\': \'Add Banner\'}}</b></p></h3></div><div class=\"modal-body\" id=\"modal-body\" style=\"padding:10px;\"><div class=\"row\"><div class=\"col-md-12\" ng-show=\"vm.loader\"><div class=\"ibox\"><div class=\"ibox-content\" style=\"height:350px;\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:75px;\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div></div></div><div class=\"col-md-12\" ng-class=\"{\'close-event-light\': vm.isEditable === false }\"><form name=\"form\" novalidate=\"\"><div class=\"profile_picture_edit\" ng-class=\"{\'width-full\': !vm.myCroppedImage }\" ng-init=\"vm.initLoad()\"><figure class=\"admin-upload-img\"><img ng-src=\"{{ vm.myCroppedImage || vm.getImageUrl(vm.banner.bannerPicture ) }}\" alt=\"banner\" class=\"img-fluid\"></figure><label ng-show=\"!vm.myCroppedImage && !(vm.isEditable === false)\" class=\"edit_profile_picture\"><input type=\"file\" id=\"fileInput\" size=\"80\" accept=\"image/*\"> Add Picture</label><div ng-if=\"vm.myCroppedImage\"><span><button ng-disabled=\"vm.isBusy\" ng-click=\"vm.cancelUpload(form);\" class=\"btn btn-default\">cancel</button></span></div><div style=\"margin-top:15px;position:absolute;z-index: 999;top: 25px;right: 12px;\"><ui-cropper image=\"myImage\" init-max-area=\"true\" area-type=\"rectangle\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" canvas-scalemode=\"true\"></ui-cropper></div></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.heading.$valid && vm.submitted, \'has-error\': form.heading.$invalid && vm.submitted }\"><label class=\"col-sm-4 control-label\">Heading</label> <input type=\"text\" class=\"col-sm-8 form-control\" ng-model=\"vm.banner.heading\" ng-minlength=\"3\" name=\"heading\" placeholder=\"heading\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'heading\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.heading.$error.required && vm.submitted\">A heading is required.</p><p ng-show=\"form.heading.$error.minlength && vm.submitted\" class=\"help-block\">heading must be atleast 3 characters.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.caption.$valid && vm.submitted, \'has-error\': form.caption.$invalid && vm.submitted }\"><label class=\"col-sm-4 control-label\">caption</label> <input type=\"text\" class=\"col-sm-8 form-control\" ng-model=\"vm.banner.caption\" ng-minlength=\"3\" caption=\"caption\" placeholder=\"caption\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'caption\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.caption.$error.required && vm.submitted\">A caption is required.</p><p ng-show=\"form.caption.$error.minlength && vm.submitted\" class=\"help-block\">caption must be atleast 3 characters.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.buttonText.$valid && vm.submitted, \'has-error\': form.buttonText.$invalid && vm.submitted }\"><label class=\"col-sm-4 control-label\">Button Text</label> <input type=\"text\" class=\"col-sm-8 form-control\" ng-model=\"vm.banner.buttonText\" ng-minlength=\"3\" name=\"buttonText\" placeholder=\"Badge Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Badge Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.buttonText.$error.required && vm.submitted\">A Button Text is required.</p><p ng-show=\"form.buttonText.$error.minlength && vm.submitted\" class=\"help-block\">Button Text must be atleast 3 characters.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.redirectURL.$valid && vm.submitted, \'has-error\': form.redirectURL.$invalid && vm.submitted }\"><label class=\"col-sm-4 control-label\">Redirect URL</label> <input type=\"text\" class=\"col-sm-8 form-control\" ng-model=\"vm.banner.redirectURL\" name=\"redirectURL\" placeholder=\"redirectURL\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'redirectURL\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.redirectURL.$error.required && vm.submitted\">A Redirect URL is required.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.summary.$valid , \'has-error\': form.summary.$invalid && vm.submitted }\"><label class=\"col-sm-12 control-label\">Summary</label> <textarea class=\"col-sm-12 form-control\" style=\"height:120px;resize:vertical;margin-left:10px\" name=\"summary\" ng-model=\"vm.banner.summary\" ng-minlength=\"15\" placeholder=\"Your banner summary...\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'summary\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.summary.$error.minlength && vm.submitted\">A proper summary is required.</p><p class=\"help-block\" ng-show=\"form.summary.$error.required && vm.submitted\">A summary is required.</p></div><br><div class=\"form-group col-sm-12 has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><br><div ng-if=\"vm.isEditable === true\" class=\"form-group col-sm-6 margin-top-15\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateBanners(form, vm.myCroppedImage, myImage.name )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Update</button></div><div ng-if=\"vm.isEditable == \'new\'\" class=\"form-group col-sm-6 margin-top-15\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addBanners(form, vm.myCroppedImage, myImage.name )\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Save</button></div><div ng-if=\"!vm.isEditable === false\" class=\"form-group col-sm-6 margin-top-15\"><button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div><br></form></div></div></div></div>");
$templateCache.put("app/components/modal/manageChapterModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{!vm.chapter._id?\'Create\':\'Update\'}} Chapter</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.saveChapter(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\" ng-init=\"vm.initLoad()\"><input type=\"text\" name=\"name\" ng-model=\"vm.chapter.name\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" placeholder=\"Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry1(vm.chapter.country)\" ng-model=\"vm.chapter.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.chapter.grade\" ng-change=\"vm.getCourse1(vm.chapter.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.course.$valid && vm.submitted, \'has-error\': form.course.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"course\" id=\"course\" ng-change=\"vm.getTopics1(vm.chapter.course)\" ng-model=\"vm.chapter.course\" required=\"\"><option value=\"\">Select Subject</option><option ng-repeat=\"option in vm.courses track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.topic.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"topic\" id=\"topic\" ng-change=\"vm.getChapter1(vm.chapter.topic)\" ng-model=\"vm.chapter.topic\" required=\"\"><option value=\"\">Select Topic</option><option ng-repeat=\"option in vm.topics track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.topic.$error.required && vm.submitted\">A topic is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.units.$valid && vm.submitted, \'has-error\': form.units.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"units\" id=\"units\" ng-model=\"vm.chapter.unit\" required=\"\"><option value=\"\">Select Module</option><option ng-repeat=\"option in vm.units track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.units.$error.required && vm.submitted\">A Module is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.vidURL.$valid && vm.submitted, \'has-error\': form.vidURL.$invalid && vm.submitted }\"><input type=\"url\" name=\"vidURL\" ng-model=\"vm.chapter.vidURL\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'vidURL\'\" placeholder=\"Video URL\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.vidURL.$error.required && vm.submitted\">A Video URL is required</p><p class=\"help-block text-danger\" ng-show=\"form.vidURL.$error.url && vm.submitted\">Please enter valid videoURL.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.summary.$valid && vm.submitted, \'has-error\': form.summary.$invalid && vm.submitted }\"><textarea type=\"text\" name=\"summary\" ng-model=\"vm.chapter.summary\" ng-minlength=\"20\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'summary\'\" placeholder=\"Summary\" required=\"\" autocomplete=\"off\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.summary.$error.required && vm.submitted\">A Summary is required</p><p ng-show=\"form.summary.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Summary must be atleast 20 characters.</p></div><div class=\"form-group\"><input type=\"radio\" ng-model=\"vm.chapter.isPaid\" ng-value=\"true\" name=\"isPaid\"> Paid <input type=\"radio\" ng-model=\"vm.chapter.isPaid\" ng-value=\"false\" name=\"isPaid\"> Unpaid</div><div><span ng-if=\"vm.chapter.content\">Update File</span> <input type=\"file\" name=\"fileInput\" id=\"fileInput\" accept=\".doc, .docx\"></div><div class=\"form-group\" style=\"margin-top:10px!important;\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">{{!vm.chapter._id?\'Save\':\'Update\'}}</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/manageContentModel.html","<div class=\"classes_popup\" disable-right-click=\"\" stopccp=\"\"><style>\r\n        \r\n\r\n        .modal-content {\r\n            width: 900px;\r\n            margin-left: -150px;\r\n        }\r\n    </style><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><div ng-bind-html=\"vm.content\" class=\"customcontent\"></div></div></div>");
$templateCache.put("app/components/modal/manageCourseModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.course._id?\'Update\':\'Create\'}} Subject</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.saveCourse(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry1(vm.course.country)\" ng-model=\"vm.course.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.course.grade\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" name=\"name\" ng-model=\"vm.course.name\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" placeholder=\"Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">Name must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid && vm.submitted, \'has-error\': form.description.$invalid && vm.submitted }\"><textarea type=\"text\" name=\"description\" ng-model=\"vm.course.description\" ng-minlength=\"20\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" placeholder=\"Description\" required=\"\" autocomplete=\"off\"></textarea><p class=\"help-block\" ng-show=\"form.description.$error.required && vm.submitted\">A Description is required</p><p ng-show=\"form.description.$error.minlength && vm.submitted\" class=\"help-block\">Description must be atleast 20 characters.</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/manageGradeModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.grade._id?\'Update\':\'Create\'}} Grade</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.saveGrade(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" name=\"name\" ng-model=\"vm.grade.name\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" placeholder=\"Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-model=\"vm.grade.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid && vm.submitted, \'has-error\': form.description.$invalid && vm.submitted }\"><textarea type=\"text\" name=\"description\" ng-model=\"vm.grade.description\" ng-minlength=\"20\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" placeholder=\"Description\" required=\"\" autocomplete=\"off\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">A Description is required</p><p ng-show=\"form.description.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Description must be atleast 20 characters.</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div><style>\r\n  .ui-select-choices {\r\n    visibility: visible !important;\r\n    transform: inherit !important;\r\n    border-radius: 0px !important;\r\n  }\r\n\r\n  .btn-xs {\r\n    padding: 1px 5px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n    border-radius: 3px;\r\n    background-color: white;\r\n  }\r\n\r\n  .ui-select-search::placeholder {\r\n    color: #7d858c !important;\r\n    margin-left: 4px !important;\r\n  }\r\n</style>");
$templateCache.put("app/components/modal/manageTeamActionModal.html","<style>\r\n    .form-group input[type=file] {\r\n        height: auto !important;\r\n        bottom:auto !important;\r\n    }\r\n    .profile_picture_edit .edit_profile_picture{position: relative;\r\n        outline: none;\r\n    color: #fff;\r\n    box-shadow: none;\r\n    background: #666666;cursor: pointer;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n    padding: 8px 20px;} \r\n</style><div class=\"classes_popup\"><h4 class=\"modal-title\">{{ vm.isEditable === true ? \'Edit Member\': vm.isEditable === false ? \'Member details\': \'Create Member\'}}</h4><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\" id=\"modal-body\" style=\"padding:10px;\"><div class=\"col-md-12\" ng-show=\"vm.loader\"><div class=\"ibox\"><div class=\"ibox-content\" style=\"height:350px;\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:75px;\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div></div></div><div class=\"form-group\" ng-class=\"{\'close-event-light\': vm.isEditable === false }\"><form name=\"form\" novalidate=\"\" class=\"ng-pristine ng-invalid ng-invalid-required ng-valid-minlength\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.name\" ng-minlength=\"3\" name=\"name\" placeholder=\"Name\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\' Name\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">name must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.email.$valid && vm.submitted, \'has-error\': form.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control\" placeholder=\"Email\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.team.email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" required=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">What\'s your email address?</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.profession.$valid && vm.submitted, \'has-error\': form.profession.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.profession\" ng-minlength=\"3\" name=\"profession\" placeholder=\"profession\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'profession\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.profession.$error.required && vm.submitted\">A profession is required.</p><p ng-show=\"form.profession.$error.minlength && vm.submitted\" class=\"help-block\">profession must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.designation.$valid && vm.submitted, \'has-error\': form.designation.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.designation\" ng-minlength=\"3\" name=\"designation\" placeholder=\"designation\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'designation\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.designation.$error.required && vm.submitted\">A designation is required.</p><p ng-show=\"form.designation.$error.minlength && vm.submitted\" class=\"help-block\">designation must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.fb.$valid && vm.submitted, \'has-error\': form.fb.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.fbProfileUrl\" name=\"fb\" placeholder=\"facebook Profile Url\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'facebook Profile Url\'\"></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.link.$valid && vm.submitted, \'has-error\': form.link.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.linkdnProfileUrl\" name=\"link\" placeholder=\"linkedin Profile\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'linkedin Profile\'\"></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.twitter.$valid && vm.submitted, \'has-error\': form.twitter.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.twitterProfileUrl\" name=\"twitter\" placeholder=\"twitter Profile Url\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'twitter Profile Url\'\"></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.title.$valid , \'has-error\': form.title.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.team.title\" name=\"title\" ng-minlength=\"3\" title=\"title\" placeholder=\"Title\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Title\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.title.$error.required && vm.submitted\">A title is required.</p><p ng-show=\"form.title.$error.minlength && vm.submitted\" class=\"help-block\">title must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.brief.$valid , \'has-error\': form.brief.$invalid && vm.submitted }\"><textarea class=\"form-control\" style=\"height:180px;resize:vertical;\" name=\"brief\" ng-model=\"vm.team.brief\" maxlength=\"2000\" ng-minlength=\"10\" placeholder=\"Description\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" autocomplete=\"off\" required=\"\">  </textarea><p class=\"help-block\" ng-show=\"form.brief.$error.minlength && vm.submitted\">Description must be atleast 10 characters.</p><p class=\"help-block\" ng-show=\"form.brief.$error.required && vm.submitted\">Please enter Description.</p></div><div class=\"profile_picture_edit\" ng-class=\"{\'width-full\': !vm.myCroppedImage }\" ng-init=\"vm.initLoad()\"><label class=\"edit_profile_picture btn\" ng-hide=\"vm.isEditable === false\"><input type=\"file\" id=\"fileInput\" size=\"80\" accept=\"image/*\"> Upload Image</label><figure class=\"admin-upload-img\"><img ng-src=\"{{ vm.myCroppedImage || vm.getImageUrl(vm.team.profilePicture ) }}\" alt=\"team\" class=\"img-fluid\"></figure><div style=\"margin-top:15px;position:absolute;z-index: 999;top: 25px;right: 12px;display:none\"><ui-cropper image=\"myImage\" result-image-size=\"{w: 285, h: 285}\" init-max-area=\"true\" area-type=\"rectangle\" chargement=\"\'Loading\'\" result-image=\"vm.myCroppedImage\" canvas-scalemode=\"true\"></ui-cropper></div></div><br><div class=\"form-group col-sm-12 has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><br><div class=\"form-group\"><div ng-if=\"vm.isEditable === true\" class=\"edit_profile submit\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateTeams(form, vm.myCroppedImage, myImage.name )\" class=\"btn\" type=\"submit\" value=\"Save\">Update</button></div><div ng-if=\"vm.isEditable == \'new\'\" class=\"edit_profile submit\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addTeams(form, vm.myCroppedImage, myImage.name )\" class=\"btn\" type=\"submit\" value=\"Save\">Save</button></div><div ng-if=\"!vm.isEditable === false\" class=\"edit_profile close_btn\"><button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn\" style=\"background-color:#18244a !important\" ng-click=\"vm.cancel()\">Cancel</button></div></div><br></form></div></div></div>");
$templateCache.put("app/components/modal/manageTopicModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.topic._id?\'Update\':\'Create\'}} Topic</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.saveTopic(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" name=\"name\" ng-model=\"vm.topic.name\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" placeholder=\"Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry(vm.topic.country)\" ng-model=\"vm.topic.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.topic.grade\" ng-change=\"vm.getCourse1(vm.topic.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.course.$valid && vm.submitted, \'has-error\': form.course.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"course\" id=\"course\" ng-model=\"vm.topic.course\" required=\"\"><option value=\"\">Select Subject</option><option ng-repeat=\"option in vm.courses track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid && vm.submitted, \'has-error\': form.description.$invalid && vm.submitted }\"><textarea type=\"text\" name=\"description\" ng-model=\"vm.topic.description\" ng-minlength=\"20\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" placeholder=\"Description\" required=\"\" autocomplete=\"off\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">A Description is required</p><p ng-show=\"form.description.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Description must be atleast 20 characters.</p></div><div><span><img class=\"img-circle image-responsive user-img\" ng-src=\"{{vm.getImageUrl(vm.topic.thumbnail || vm.topic._id)}}\"></span> <input type=\"file\" name=\"fileInput\" id=\"fileInput\" size=\"60\" accept=\"image/*\"></div><div class=\"form-group\" style=\"margin-top:10px!important;\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div><script>\r\n </script>");
$templateCache.put("app/components/modal/manageUnitModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.unit._id?\'Update\':\'Create\'}} Module</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.saveUnit(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><input type=\"text\" name=\"name\" ng-model=\"vm.unit.name\" ng-minlength=\"4\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Name\'\" placeholder=\"Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry1(vm.unit.country)\" ng-model=\"vm.unit.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.unit.grade\" ng-change=\"vm.getCourse1(vm.unit.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.course.$valid && vm.submitted, \'has-error\': form.course.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"course\" id=\"course\" ng-change=\"vm.getTopics1(vm.unit.course)\" ng-model=\"vm.unit.course\" required=\"\"><option value=\"\">Select Subject</option><option ng-repeat=\"option in vm.courses track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.topic.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"topic\" id=\"topic\" ng-model=\"vm.unit.topic\" required=\"\"><option value=\"\">Select Topic</option><option ng-repeat=\"option in vm.topics track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.topic.$error.required && vm.submitted\">A topic is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.description.$valid && vm.submitted, \'has-error\': form.description.$invalid && vm.submitted }\"><textarea type=\"text\" name=\"description\" ng-model=\"vm.unit.description\" ng-minlength=\"20\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Description\'\" placeholder=\"Description\" required=\"\" autocomplete=\"off\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.description.$error.required && vm.submitted\">A Description is required</p><p ng-show=\"form.description.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Description must be atleast 20 characters.</p></div><div><span><img class=\"img-circle image-responsive user-img\" ng-src=\"{{vm.getImageUrl(vm.unit.thumbnail || vm.unit._id)}}\"></span> <input type=\"file\" name=\"fileInput\" id=\"fileInput\" size=\"60\" accept=\"image/*\"></div><div class=\"form-group\" style=\"margin-top:10px!important;\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/components/modal/subscriptionActionModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Manage Subscription</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form name=\"form\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><label class=\"control-label\">Title</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.title\" ng-minlength=\"3\" name=\"name\" placeholder=\"Title\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Title\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A title is required.</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">title must be atleast 3 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.course.$valid && vm.submitted, \'has-error\': form.course.$invalid && vm.submitted }\"><label class=\"control-label\">Subject</label><select type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.course\" name=\"course\" placeholder=\"-select course-\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'course\'\" ng-options=\"option._id as option.name for option in vm.course\" required=\"\"></select><p class=\"help-block\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required.</p></div><div ng-repeat=\"option in vm.subscription.purchase\" ng-class=\"{ \'has-error\' : form.{{\'option\'+$index}}.$invalid && !form.{{\'option\'+$index}}.$pristine }\"><div class=\"form-group\" style=\"float:inherit;\" ng-class=\"{ \'has-success\': form.{{\'currency\'+$index}}.$valid && vm.submitted, \'has-error\': form.{{\'currency\'+$index}}.$invalid && vm.submitted }\"><label class=\"control-label\">Currency :{{$index+1}}</label><select type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.purchase[$index].currency\" name=\"{{\'currency\'+$index}}\" placeholder=\"-select currency-\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'currency\'\" ng-options=\"option._id as option.currency for option in vm.currency\" required=\"\"></select><p class=\"help-block\" ng-show=\"form.{{\'currency\'+$index}}.$error.required && vm.submitted\">currency:{{$index+1}} is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.{{\'price\'+$index}}.$valid && vm.submitted, \'has-error\': form.{{\'price\'+$index}}.$invalid && vm.submitted }\"><label class=\"control-label\">Price (Mrp):{{$index+1}}</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.purchase[$index].mrp\" ng-pattern=\"vm.pattern.number\" maxlength=\"5\" name=\"{{\'price\'+$index}}\" placeholder=\"price\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Price\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.{{\'price\'+$index}}.$error.required && vm.submitted\">Price:{{$index+1}} is required.</p><p ng-show=\"form.{{\'price\'+$index}}.$error.pattern && vm.submitted\" class=\"help-block\">Numeric Price:{{$index+1}} value is required.</p></div><div class=\"form-group col-sm-1 pull-right\"><div ng-if=\"!$index\"><button ng-click=\"vm.addOption();\" style=\"margin-left: 15px;\"><i class=\"fa fa-plus-circle text-success\"></i></button></div><div ng-if=\"$index\" class=\"col-sm-1\"><button ng-click=\"vm.delOption($index);\"><i class=\"fa fa-minus-circle text-danger\"></i></button></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.duration.$valid && vm.submitted, \'has-error\': form.duration.$invalid && vm.submitted }\"><label class=\"control-label\">Duration</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.duration\" ng-pattern=\"vm.pattern.number\" maxlength=\"5\" name=\"duration\" placeholder=\"duration\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Duration\'\" required=\"\"><p class=\"help-block\" ng-show=\"form.duration.$error.required && vm.submitted\">Duration(in days) is required.</p><p ng-show=\"form.duration.$error.pattern && vm.submitted\" class=\"help-block\">Duration (in days) numeric value is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.feature.$valid && vm.submitted, \'has-error\': form.feature.$invalid && vm.submitted }\"><label class=\"control-label\">Feature:</label><div class=\"quill-text-editor\"><ng-quill-editor name=\"feature\" ng-model=\"vm.subscription.features\" placeholder=\"feature description\" required=\"\"></ng-quill-editor><p class=\"help-block\" ng-show=\"form.feature.$error.required && vm.submitted\">Please enter Feature description!</p></div></div><br><div class=\"form-group has-error\"><p class=\"help-block\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><br><div ng-if=\"vm.isEditable === true\" class=\"form-group\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateSubscription(form)\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Update</button></div><div ng-if=\"vm.isEditable == \'new\'\" class=\"form-group\"><button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.addSubscription(form)\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Save</button></div><div ng-if=\"!vm.isEditable === false\" class=\"form-group\"><button ng-class=\"{\'close-event\': vm.isBusy }\" class=\"btn btn-md btn-danger float-right\" ng-click=\"vm.cancel()\">Cancel</button></div><br></form></div></div>");
$templateCache.put("app/components/modal/testQuesActionModal.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">Manage Question</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.updateQuestion(form)\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry(vm.chapter.country)\" ng-model=\"vm.chapter.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.chapter.grade\" ng-change=\"vm.getCourse(vm.chapter.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : form.course.$invalid && vm.submitted }\"><select ng-model=\"vm.ques.course\" ng-change=\"vm.getTopics(vm.ques.course)\" name=\"course\" class=\"form-control\" required=\"\" ng-options=\"course._id as course.name for course in vm.courses\"><option value=\"\">Select Subject</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : form.level.$invalid && vm.submitted }\"><select ng-model=\"vm.ques.topic\" name=\"topic\" ng-change=\"vm.getUnits(vm.ques.topic)\" class=\"form-control chosen-select\" required=\"\" ng-options=\"topic._id as topic.name for topic in vm.topics\"><option value=\"\">Select Topic</option></select><p class=\"help-block text-danger\" ng-show=\"form.topic.$error.required && vm.submitted\">A topic is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : form.unit.$invalid && vm.submitted }\"><select ng-model=\"vm.ques.unit\" ng-change=\"vm.getChapters(vm.ques.unit)\" name=\"unit\" class=\"form-control chosen-select\" required=\"\" ng-options=\"unit._id as unit.name for unit in vm.units\"><option value=\"\">Select Module</option></select><p class=\"help-block text-danger\" ng-show=\"form.unit.$error.required && vm.submitted\">A Module is required.</p></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : form.chapter.$invalid && vm.submitted }\"><select ng-model=\"vm.ques.chapter\" name=\"chapter\" class=\"form-control\" required=\"\" ng-options=\"chapter._id as chapter.name for chapter in vm.chapters\"><option value=\"\">Select Chapter</option></select><p class=\"help-block text-danger\" ng-show=\"form.chapter.$error.required && vm.submitted\">A chapter is required.</p></div><div><input type=\"file\" name=\"fileInput\" id=\"fileInput1\" accept=\".doc, .docx\"></div><div class=\"form-group\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><button type=\"submit\" class=\"btn\">Save</button></div><div class=\"edit_profile close_btn\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div></div></form></div></div>");
$templateCache.put("app/admin-panel/admin-dashboard/admin-dashboard.html","<div class=\"row\"><div class=\"dashboard\" style=\"min-height:600px\"><h3>Admin Dashboard</h3><div class=\"Admin_details col-sm-12\"><h1>Hi, {{vm.user.name}} ! welcome to the admin dashboard.<h1></h1></h1></div></div></div>");
$templateCache.put("app/admin-panel/edit-profile/editProfile.html","<style>\r\nimg.img-circle.image-responsive.user-img {\r\n  width: 120px !important;\r\n border-radius: 0px !important;\r\n}\r\n  </style><div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Edit Profile</h3></div><div class=\"col-md-6\"></div></div><div class=\"profile_background\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"main_profile_img\"><img ng-if=\"!vm.user.profilePicture\" class=\"img-circle image-responsive user-img\" ui-sref=\"admin.profiles({id: user._id})\" src=\"/assets/img/defaultProfile.png\"> <img ng-if=\"vm.user.profilePicture\" class=\"img-circle image-responsive user-img\" ui-sref=\"admin.profiles({id: user._id})\" ng-src=\"{{ vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\"><a data-toggle=\"modal\" data-target=\"#myModal\" ng-click=\"vm.changeImage()\" style=\"background-color: #f3772e;color:white;margin-top:5px;\" class=\"btn btn-sm\">Change Image</a></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"main_profile_img\"><form method=\"post\"><div class=\"form-group\"><label>Name</label> <input type=\"text\" name=\"name\" ng-model=\"vm.fullName\" ng-pattern=\"vm.pattern.name\" maxlength=\"35\" ng-minlength=\"3\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block\">Name must be atleast 3 characters.</p><p style=\"color:red\" ng-show=\"form.name.$error.pattern && vm.submitted\" class=\"help-block\">Name must be a valid name.</p></div></form></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Email</label><br><span>{{vm.user.email }}</span></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Date Of Joining</label><br><span>{{vm.user.createdAt | date : \'dd/MM/yyyy\' }}</span></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>User Type</label><br><span>{{vm.user.role}}</span></div></div><div ng-if=\"!vm.myCroppedImage\" class=\"col-md-12\"><div class=\"edit_profile update\"><button ng-click=\"vm.upload(form)\" ng-disabled=\"vm.loader\" class=\"btn\">Save</button></div></div></div></div></div></form></div>");
$templateCache.put("app/admin-panel/manage-banner/manage-banner.html","<div class=\"row\"><div class=\"dashboard manage-banner-page\"><h3 class=\"dashboard-heading\">Manage Banners</h3><div class=\"managebanner_details col-sm-12\"><div class=\"table-content\"><div class=\"row\"><div class=\"head col-sm-12\"><span ng-if=\"vm.filterOptions.total\" class=\"pull-left\"><h4>Total : {{vm.filterOptions.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Banner List</h4></div><div class=\"col-md-12\" ng-if=\"vm.loader\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-2 pull-right\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(ques,\'new\')\">Add banner</button></div><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFilteredBanners($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredBanners()\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Banner</th><th>Created On</th><th>Button Text</th><th>Redirect URL</th><th>Summary</th><th>Heading</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"banner in vm.bannerList track by $index\"><td><span><img class=\"img-circle image-responsive banner-img\" ng-src=\"{{vm.getImageUrl(banner.bannerPicture || banner._id)}}\"></span> <span class=\"fa-padd\"><b>caption:</b>{{ banner.caption}}</span></td><td>{{banner.createdAt | date: \'mediumDate\' }}</td><td>{{ banner.buttonText }}</td><td>{{ banner.redirectURL }}</td><td><span ng-if=\"!banner.summary\" class=\"\">......</span><show-more ng-if=\"banner.summary\" text=\"banner.summary\" limit=\"30\"></show-more></td><td>{{ banner.heading }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': banner.verified, \'clr-danger\': !banner.verified }\"></i> {{banner.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(banner,false)\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(banner,true)\"></i></span> <span ng-if=\"!banner.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyBanners(banner._id)\"></i></span> <span><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteBanners(banner._id)\" aria-hidden=\"true\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.bannerList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-badges/manage-badges.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Badges</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(ques,\'new\')\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add Badge</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredBadges($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredBadges()\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Image</th><th>Name</th><th>Description</th><th>Min % Criteria</th><th>Max % Criteria</th><th>Created On</th><th>Is Verified</th><th style=\"width: 120px;\">Action</th></tr></thead><tbody><tr ng-repeat=\"badge in vm.badgeList track by $index\"><td>{{$index+1}}</td><td><span><img class=\"img-circle image-responsive user-img\" ng-src=\"{{vm.getImageUrl(badge.logo || badge._id)}}\"></span></td><td><span class=\"fa-padd\">{{ badge.name}}</span></td><td><span ng-if=\"!badge.description\" class=\"\">......</span><show-more ng-if=\"badge.description\" text=\"badge.description\" limit=\"30\"></show-more></td><td>{{ badge.minAllocatePercntageCriteria }}</td><td>{{ badge.maxAllocatePercntageCriteria }}</td><td>{{badge.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': badge.verified, \'clr-danger\': !badge.verified }\"></i> {{badge.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"View\"><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(badge,false)\" tabindex=\"-1\"></i></span> <span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(badge,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"!badge.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyBadges(badge._id)\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteBadge(badge._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.badgesList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-contents/manage-contents.html","<div class=\"row\"><div class=\"dashboard manage-content-page\"><h3 class=\"dashboard-heading\">Manage Contents</h3><div class=\"managecontent_details col-sm-12\"><div class=\"table-content\"><div class=\"row\"><div class=\"col-md-12\" ng-if=\"vm.loader\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsivex\" ng-show=\"!vm.loader\"><div class=\"table-content\"><form name=\"form\" novalidate=\"\"><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-error\' : form.content.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\"><b>Contents Type</b>:</label><div class=\"col-sm-10\"><select chosen=\"\" allow-single-deselect=\"false\" ng-model=\"vm.contentId\" ng-change=\"vm.getContentInfo(vm.contentId)\" name=\"content\" data-placeholder=\"Subject\" class=\"form-control chosen-select\" required=\"\" ng-options=\"content._id as content.displayName for content in vm.contentList\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.content.$error.required && vm.submitted\">A content is required.</p></div></div><div class=\"all-form\" style=\"margin-top: 20px;\" ng-if=\"!vm.loadContent\"><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.content.$valid && vm.submitted, \'has-error\': form.content.$invalid && vm.submitted }\"><label class=\"col-sm-2 control-label\"><b>content description</b>:</label><div class=\"quill-text-editor col-sm-12\"><ng-quill-editor name=\"content\" ng-model=\"vm.content.content\" placeholder=\"content description\" required=\"\"></ng-quill-editor><p class=\"help-block\" ng-show=\"form.content.$error.required && vm.submitted\">Please enter content description!</p></div></div><div class=\"form-group col-sm-12 margin-top-15\"><button ng-if=\"!vm.content.verified\" ng-class=\"{\'close-event\': vm.isBusy || !admin }\" ng-click=\"vm.verifyContent(vm.contentId)\" class=\"btn btn-md btn-primary float-right\" value=\"verify\">verify</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.updateContent(form)\" class=\"btn btn-md theme-bg\" type=\"submit\" value=\"Save\">Save</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-career/manage-career.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Career</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"col-md-12 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredEnquiry($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredEnquiry()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th class=\"manage-enquiry-first\">Name</th><th>Email</th><th class=\"manage-enquiry-four\">Phone Number</th><th class=\"manage-enquiry-five\">Enquiry on</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"enquiry in vm.enquiryList track by $index\"><td>{{$index+1}}</td><td class=\"manage-enquiry-first\"><span class=\"fa-padd\">{{ enquiry.firstName+\' \'+enquiry.lastName }}</span></td><td>{{enquiry.email}}</td><td class=\"manage-enquiry-four\">{{ enquiry.contactNumber}}</td><td class=\"manage-enquiry-five\">{{enquiry.contactNumber | date:\'mediumDate\' }}</td><td class=\"button-style\"><span ng-if=\"enquiry.message\" title=\"View Document\"><i class=\"fa fa-file-code-o fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.viewChapterContent(enquiry.message)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteEnquiry(enquiry._id);\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.enquiryList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-chapter/manage-chapter.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Chapter</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Chapter</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredchapters($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredchapters()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Name</th><th>Grade</th><th>Subject</th><th>Topic</th><th>Module</th><th>Video Url</th><th>Summary</th><th>Created On</th><th style=\"width: 120px;\">Action</th></tr></thead><tbody><tr ng-repeat=\"chapter in vm.chapters track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ chapter.name}}</span></td><td><span class=\"fa-padd\">{{ chapter.grade.name}}</span></td><td><span class=\"fa-padd\">{{ chapter.course.name}}</span></td><td><span class=\"fa-padd\">{{ chapter.topic.name}}</span></td><td>{{chapter.unit.name}}</td><td>{{chapter.vidURL}}</td><td>{{chapter.summary}}</td><td>{{chapter.createdAt |date :\'mediumDate\'}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(chapter,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteChapter(chapter._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span> <span ng-if=\"chapter.content\" title=\"View Document\"><i class=\"fa fa-file-code-o fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.viewChapterContent(chapter.content)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.usersList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-course-hierarchy/manage-course-hierarchy.html","<div class=\"row\"><div class=\"dashboard manage-hierarchy-page\"><h3 class=\"dashboard-heading\">Manage Course Hierarchy</h3><div class=\"form-group col-sm-6 offset-sm-3\" ng-class=\"{ \'has-error\' : form.showType.$invalid }\"><label class=\"col-sm-5 control-label\"><b>Course Hierarchy Type</b>:</label><div class=\"col-sm-7\"><select chosen=\"\" allow-single-deselect=\"true\" ng-model=\"vm.showType\" name=\"showType\" data-placeholder=\"Course hierarchy\" class=\"form-control chosen-select\" required=\"\" ng-options=\"show._id as show.name for show in vm.showTypeList\"><option value=\"\"></option></select><p class=\"help-block\" ng-show=\"form.content.$error.required\">A Course Hierarchy is required.</p></div></div><div class=\"manageusers_details col-sm-12\"><div class=\"table-content\" ng-if=\"vm.showType == \'grade\'\"><div class=\"ibox-content\"><div class=\"row\"><h2 class=\"col-sm-12 center\"><b>Grade List</b></h2><div class=\"head col-sm-12\"><span ng-if=\"vm.filterGrade.total\" class=\"pull-left\"><h4>Total : {{vm.filterGrade.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Grades</h4></div><div class=\"col-md-12\" ng-if=\"vm.loadGrade\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loadGrade\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterGrade.limit\" ng-change=\"vm.changeFilterOptions(\'Grade\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-2 pull-right\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\',\'Grade\')\">Add Grade</button></div><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Grade\')\" ng-model=\"vm.filterGrade.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Grade\')\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Name</th><th>Slug</th><th>Description</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"grade in vm.gradeList track by $index\"><td><span class=\"fa-padd\">{{ grade.name}}</span></td><td>{{ grade.slug}}</td><td><span ng-if=\"!grade.description\" class=\"\">......</span><show-more ng-if=\"grade.description\" text=\"grade.description\" limit=\"30\"></show-more></td><td>{{ grade.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': grade.verified, \'clr-danger\': !grade.verified }\"></i> {{ grade.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(grade, false, \'Grade\')\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(grade, true, \'Grade\')\"></i></span> <span ng-if=\"!grade.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(grade._id,\'Grade\')\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadGrade && vm.gradeList.length\" items-per-page=\"vm.filterGrade.limit\" ng-model=\"vm.filterGrade.page\" total-items=\"vm.filterGrade.total\" ng-change=\"vm.changeFilterOptions(\'Grade\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div><div class=\"table-content\" ng-if=\"vm.showType == \'course\'\"><div class=\"ibox-content\"><div class=\"row\"><h2 class=\"col-sm-12 center\"><b>Course List</b></h2><div class=\"head col-sm-12\"><span ng-if=\"vm.filterCourse.total\" class=\"pull-left\"><h4>Total : {{vm.filterCourse.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Courses</h4></div><div class=\"col-md-12\" ng-if=\"vm.loadCourse\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loadCourse\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterCourse.limit\" ng-change=\"vm.changeFilterOptions(\'Course\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Course\')\" ng-model=\"vm.filterCourse.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Course\')\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Course</th><th>Slug</th><th>Description</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"course in vm.courseList track by $index\"><td <span=\"\" class=\"fa-padd\">{{ course.name}}</td><td>{{ course.slug}}</td><td><span ng-if=\"!course.description\" class=\"\">......</span><show-more ng-if=\"course.description\" text=\"course.description\" limit=\"30\"></show-more></td><td>{{ course.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': course.verified, \'clr-danger\': !course.verified }\"></i> {{ course.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(course,false,\'Course\')\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(course,true, \'Course\')\"></i></span> <span ng-if=\"!course.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(course._id,\'Course\')\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadCourse && vm.courseList.length\" items-per-page=\"vm.filterCourse.limit\" ng-model=\"vm.filterCourse.page\" total-items=\"vm.filterCourse.total\" ng-change=\"vm.changeFilterOptions(\'Course\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div><div class=\"table-content\" ng-if=\"vm.showType == \'unit\'\"><div class=\"ibox-content\"><div class=\"row\"><h2 class=\"col-sm-12 center\"><b>Unit List</b></h2><div class=\"head col-sm-12\"><span ng-if=\"vm.filterUnit.total\" class=\"pull-left\"><h4>Total : {{vm.filterUnit.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Units</h4></div><div class=\"col-md-12\" ng-if=\"vm.loadUnit\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loadUnit\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterUnit.limit\" ng-change=\"vm.changeFilterOptions(\'Unit\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-2 pull-right\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\', \'Unit\')\">Add Unit</button></div><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Unit\')\" ng-model=\"vm.filterUnit.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Unit\')\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Unit</th><th>Slug</th><th>Course</th><th>Description</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"unit in vm.unitList track by $index\"><td><span class=\"fa-padd\">{{ unit.name}}</span></td><td>{{ unit.slug }}</td><td><span class=\"\">{{ unit.course.name}}</span></td><td><span ng-if=\"!unit.description\" class=\"\">......</span><show-more ng-if=\"unit.description\" text=\"unit.description\" limit=\"30\"></show-more></td><td>{{ unit.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': unit.verified, \'clr-danger\': !unit.verified }\"></i> {{ unit.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(unit,false,\'Unit\')\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(unit,true, \'Unit\')\"></i></span> <span ng-if=\"!unit.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(unit._id,\'Unit\')\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadUnit && vm.unitList.length\" items-per-page=\"vm.filterUnit.limit\" ng-model=\"vm.filterUnit.page\" total-items=\"vm.filterUnit.total\" ng-change=\"vm.changeFilterOptions(\'Unit\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div><div class=\"table-content\" ng-if=\"vm.showType == \'chapter\'\"><div class=\"ibox-content\"><div class=\"row\"><h2 class=\"col-sm-12 center\"><b>Chapter List</b></h2><div class=\"head col-sm-12\"><span ng-if=\"vm.filterChapter.total\" class=\"pull-left\"><h4>Total : {{vm.filterChapter.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Chapters</h4></div><div class=\"col-md-12\" ng-if=\"vm.loadChapter\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loadChapter\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterChapter.limit\" ng-change=\"vm.changeFilterOptions(\'Chapter\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-2 pull-right\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\',\'Chapter\')\">Add Chapter</button></div><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFiltere(\'Chapter\')\" ng-model=\"vm.filterChapter.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Chapter\')\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Chapter</th><th>Course</th><th>Unit</th><th>Description</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"chapter in vm.chapterList track by $index\"><td><span class=\"fa-padd\">{{ chapter.name}}</span></td><td><span class=\"\">{{ chapter.course.name}}</span></td><td>{{ chapter.unit.name}}</td><td><span ng-if=\"!chapter.description\" class=\"\">......</span><show-more ng-if=\"chapter.description\" text=\"chapter.description\" limit=\"30\"></show-more></td><td>{{ chapter.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': chapter.verified, \'clr-danger\': !chapter.verified }\"></i> {{ chapter.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(chapter,false,\'Chapter\')\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(chapter,true, \'Chapter\')\"></i></span> <span ng-if=\"!chapter.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(chapter._id,\'Chapter\')\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadChapter && vm.chapterList.length\" items-per-page=\"vm.filterChapter.limit\" ng-model=\"vm.filterChapter.page\" total-items=\"vm.filterChapter.total\" ng-change=\"vm.changeFilterOptions(\'Chapter\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div><div class=\"table-content\" ng-if=\"vm.showType == \'topic\'\"><div class=\"ibox-content\"><div class=\"row\"><h2 class=\"col-sm-12 center\"><b>Topic List</b></h2><div class=\"head col-sm-12\"><span ng-if=\"vm.filterTopic.total\" class=\"pull-left\"><h4>Total : {{vm.filterTopic.total }}</h4></span><h4><i class=\"fa fa-files fa-2 clr-primary\"></i>Topics</h4></div><div class=\"col-md-12\" ng-if=\"vm.loadTopic\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\" style=\"margin-top:45px\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div><div class=\"col-md-12 table-responsive\" ng-show=\"!vm.loadTopic\"><span style=\"float:left;\">Show&nbsp;<select style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterTopic.limit\" ng-change=\"vm.changeFilterOptions(\'Topic\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><div class=\"col-md-2 pull-right\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\',\'Topic\')\">Add Topic</button></div><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Topic\')\" ng-model=\"vm.filterTopic.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Topic\')\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><thead class=\"theme-clr-thead\"><tr><th>Topic</th><th>Course</th><th>Chapter</th><th>Unit</th><th>Description</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"topic in vm.topicList track by $index\"><td><span class=\"fa-padd\">{{ topic.name}}</span></td><td>{{topic.course.name}}</td><td>{{topic.chapter.name}}</td><td>{{topic.unit.name}}</td><td><span ng-if=\"!topic.description\" class=\"\">......</span><show-more ng-if=\"topic.description\" text=\"topic.description\" limit=\"30\"></show-more></td><td>{{ topic.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': topic.verified, \'clr-danger\': !topic.verified }\"></i> {{ topic.verified ? \"verified\": \"not verified\"}}</td><td><span><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(topic,false,\'Topic\')\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(topic,true,\'Topic\')\"></i></span> <span ng-if=\"!topic.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(topic._id,\'Topic\')\"></i></span></td></tr></tbody></table></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadTopic && vm.topicList.length\" items-per-page=\"vm.filterTopic.limit\" ng-model=\"vm.filterTopic.page\" total-items=\"vm.filterTopic.total\" ng-change=\"vm.changeFilterOptions(\'Topic\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-course/manage-course.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Subject</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Subject</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredCourses($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredCourses()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 table-stripedx table-hover dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Name</th><th>Grade</th><th>Description</th><th>Created On</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"course in vm.courses track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ course.name}}</span></td><td>{{course.grade.name}}</td><td>{{course.description}}</td><td>{{course.createdAt |date :\'mediumDate\'}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(course,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteCourse(course._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.courses.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-enquiry/manage-enquiry.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Enquiry</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"col-md-12 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredEnquiry($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredEnquiry()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th class=\"manage-enquiry-first\">Name</th><th>Email</th><th class=\"manage-enquiry-third\">Enquiry</th><th class=\"manage-enquiry-four\">Status</th><th class=\"manage-enquiry-five\">Enquiry on</th><th>Token</th><th class=\"manage-enquiry-seven\">Revert</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"enquiry in vm.enquiryList track by $index\"><td>{{$index+1}}</td><td class=\"manage-enquiry-first\"><span class=\"fa-padd\">{{ enquiry.firstName+\' \'+enquiry.lastName }}</span></td><td>{{enquiry.email}}</td><td class=\"manage-enquiry-third\"><show-more text=\"enquiry.message\" limit=\"30\"></show-more></td><td class=\"manage-enquiry-four\"><i class=\"fa\" ng-class=\"{\'clr-active fa-check-circle\': enquiry.replyStatus, \'fa-times-circle clr-danger\': !enquiry.replyStatus }\"></i> {{ enquiry.replyStatus ? \"Replied\": \"Not Reply\"}}</td><td class=\"manage-enquiry-five\">{{enquiry.createdAt | date:\'mediumDate\' }}</td><td>{{enquiry.tokenNumber }}</td><td class=\"manage-enquiry-seven\"><show-more ng-if=\"enquiry.replyMessage\" text=\"enquiry.replyMessage\" limit=\"30\"></show-more></td><td class=\"button-style\"><span title=\"View\"><i class=\"fa fa-eye fa-2 fa-padd\" ng-class=\"{\'clr-active close-eventX\': enquiry.replyStatus || vm.isBusy, \'text-muted\': !enquiry.replyStatus}\" ng-click=\"vm.openViewModal(enquiry,true)\" tabindex=\"-1\"></i></span> <span title=\"Reply\"><i class=\"fa fa-reply fa-2 fa-padd\" ng-class=\"{\'clr-active close-eventX\': enquiry.replyStatus || vm.isBusy, \'text-muted\': !enquiry.replyStatus}\" ng-click=\"vm.openModal(enquiry,true)\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteEnquiry(enquiry._id);\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.enquiryList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-faq/manage-faq.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage FAQs</h3></div></div><div class=\"check students_page\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Category List\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 15px 7px 1px;float: right;\"><div class=\"edit_profile read_more\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\',\'Category\')\">Add Category</button></div></div></div><div class=\"col-md-12\"><div class=\"col-md-3 pull-right\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Category\')\" ng-model=\"vm.filterCategory.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Category\')\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterCategory.limit\" ng-change=\"vm.changeFilterOptions(\'Category\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Name</th><th>Description</th><th>Created on</th><th>Is verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"category in vm.categoryList track by $index\"><td>{{$index+1}}</td><td>{{ category.displayName}}</td><td><span ng-if=\"!category.description\" class=\"\">......</span><show-more ng-if=\"category.description\" text=\"category.description\" limit=\"30\"></show-more></td><td>{{ category.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': category.verified, \'clr-danger\': !category.verified }\"></i> {{ category.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(category, true, \'Category\')\" tabindex=\"-1\"></i></span> <span ng-if=\"!category.verified\" title=\"Verify/Not Verify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(category._id, \'Category\')\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteCategory(category._id, \'Category\')\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"vm.categoryList.length\" items-per-page=\"vm.filterCategory.limit\" ng-model=\"vm.filterCategory.page\" total-items=\"vm.filterCategory.total\" ng-change=\"vm.changeFilterOptions(\'Category\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Question List\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 15px 7px 1px;float: right;\"><div class=\"edit_profile read_more\"><button class=\"btn theme-bg\" ng-click=\"vm.openModal(null,\'new\', \'Question\')\">Add Question</button></div></div></div><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterQuestion.limit\" ng-change=\"vm.changeFilterOptions(\'Question\')\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFiltered(\'Question\')\" ng-model=\"vm.filterQuestion.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFiltered(\'Question\')\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Question</th><th>Category</th><th>Answer</th><th>Created on</th><th>Is verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"question in vm.questionList track by $index\"><td>{{$index+1}}</td><td><show-more1 text=\"question.askQuestion\" limit=\"120\"></show-more1></td><td>{{ question.type.displayName}}</td><td><show-more text=\"question.answer\" limit=\"120\"></show-more></td><td>{{ question.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': question.verified, \'clr-danger\': !question.verified }\"></i> {{ question.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(question,true, \'Question\')\" tabindex=\"-1\"></i></span> <span ng-if=\"!question.verified && admin\" title=\"Verify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyMe(question._id,\'Question\')\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteMe(question._id,\'Question\')\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loadQuestion && vm.questionList.length\" items-per-page=\"vm.filterQuestion.limit\" ng-model=\"vm.filterQuestion.page\" total-items=\"vm.filterQuestion.total\" ng-change=\"vm.changeFilterOptions(\'Question\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></uib-tab></uib-tabset></div><style>\r\n        .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active\r\n        {\r\n        background-color: #f3772e;\r\n        color: #fff;\r\n        }\r\n        </style>");
$templateCache.put("app/admin-panel/manage-grade/manage-grade.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Grade</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Grade</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredGrades($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredGrades()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Name</th><th>Country</th><th>Description</th><th>Created On</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"grade in vm.grades track by $index\"><td>{{$index+1}}</td><td>{{ grade.name}}</td><td>{{grade.country.name}}</td><td>{{grade.description}}</td><td>{{grade.createdAt | date: \'mediumDate\' }}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(grade,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteGrade(grade._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.grades.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-question/manage-question.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Test Questions</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a class=\"btn\" href=\"javascript:void(0)\" ng-click=\"vm.MultipleDelete()\">Multiple Delete</a> <a class=\"btn\" href=\"javascript:void(0)\" ng-click=\"vm.openModal()\">Add Docs Question</a></div></div></div><div class=\"col-sm-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredQuestions($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredQuestions()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th></th><th>S.No.</th><th>Subject</th><th>Module</th><th>Chapter</th><th>Topic</th><th>Level</th><th>Questions</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"ques in vm.testQuestionsList track by $index\"><td><input type=\"checkbox\" ng-click=\"vm.selectQuestion(ques._id)\"></td><td>{{$index+1}}</td><td>{{ques.course.name}}</td><td>{{ ques.unit.name }}</td><td>{{ ques.chapter.name }}</td><td>{{ ques.topic.name }}</td><td>{{ ques.levelName }}</td><td style=\"width: 20% !important;\"><p class=\"text-min-show\" ng-bind-html=\"ques.questionDescription\"></p></td><td class=\"button-style\"><span title=\"Edit\"><a ui-sref=\"admin.addquestion({questionId: ques._id})\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-edit fa-2 fa-padd text-primary\" tabindex=\"-1\"></i></a></span> <span title=\"Delete\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-trash fa-2 fa-padd text-danger\" aria-hidden=\"true\" ng-click=\"vm.deleteTestQues(ques._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"!ques.verified && admin\" title=\"Verify/Not Verify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyTestQues(ques._id)\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.testQuestionsList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-story/manage-story.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Story</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.AddModal(null,true)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Story</a></div></div></div><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\" style=\"margin-top: 5px;\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredStory($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredStory()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Name</th><th>Email</th><th>Video Link</th><th>Message</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"story in vm.storyList track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ story.name}}</span></td><td>{{story.email}}</td><td><a style=\"color: #007bff;\" href=\"{{story.videoURL}}\" target=\"_blank\">video-url</a></td><td><p class=\"text-min-show\">{{ story.description }}</p></td><td>{{story.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': story.verified, \'clr-danger\': !story.verified }\"></i> {{story.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"View\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(story,false)\" tabindex=\"-1\"></i></span> <span title=\"Edit\"><i ng-class=\"{\'close-event\': true || vm.isBusy }\" class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(story,true)\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-trash fa-2 fa-padd text-danger\" aria-hidden=\"true\" ng-click=\"vm.deleteStory(story._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"!story.verified && admin\" title=\"Verify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyStory(story._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"story.verified && admin\" title=\"Unverify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.UnverifyStory(story._id)\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.storyList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-subscription/manage-subscription.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Subscription</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section classes\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a ui-sref=\"admin.editsubscription\" class=\"btn\">Add Subscription</a></div></div></div><div class=\"col-md-12\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries<div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredSubscript($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredSubscript()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th>S.No.</th><th>Title</th><th>Currency</th><th>Duration</th><th>Amount</th><th>Discount</th><th>Created On</th><th class=\"manage-subscripton-seven\">Feature</th><th>Status</th><th style=\"width: 120px;\">Action</th></tr></thead><tbody><tr ng-repeat=\"subs in vm.subscriptionList track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ subs.title}}</span></td><td>{{subs.currency }}</td><td>{{subs.duration }}</td><td>{{subs.amount }}</td><td>{{subs.discount }}</td><td>{{subs.createdAt | date: \'mediumDate\' }}</td><td class=\"manage-subscripton-seven\"><show-more text=\"subs.features\" limit=\"30\"></show-more></td><td><i class=\"fa fa-circle\" ng-class=\"{\'text-success\': subs.active, \'text-danger\': !subs.active }\"></i> {{subs.active ? \"Active\": \"Inactive\"}}</td><td class=\"button-style\"><a ui-sref=\"admin.editsubscription({id:subs._id})\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" tabindex=\"-1\"></i></span></a> <span ng-if=\"!subs.active && admin\" title=\"Active\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifySubscription(subs._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"subs.active && admin\" title=\"Inactive\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifySubscription(subs._id)\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteSubscription(subs._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.subscriptionList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-subadmin/manage-subadmin.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Sub Admin</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add Sub Admin</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredUsers($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredUsers()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\" tabindex=\"-1\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 table-stripedx table-hover dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Image</th><th>User</th><th>Email</th><th>Created On</th><th>Is Block</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"user in vm.usersList track by $index\" ng-if=\"!(user._id == vm.me.data._id)\" ng-hide=\"subAdmin\"><td>{{$index+1}}</td><td><span><img ng-if=\"!user.profilePicture\" class=\"img-circle image-responsive user-img\" src=\"/assets/img/defaultProfile.png\"> <img ng-if=\"user.profilePicture\" class=\"img-circle image-responsive user-img\" ui-sref=\"admin.profiles({id: user._id})\" ng-src=\"{{vm.getImageUrl(user.profilePicture || user._id)}}\"></span></td><td><span class=\"fa-padd\">{{ user.name}}</span></td><td>{{user.email}}</td><td>{{user.createdAt | date: \'mediumDate\' }}</td><td>{{user.isBlock ? \"Yes\": \"No\"}}</td><td class=\"button-style\"><span title=\"View\"><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ui-sref=\"admin.profiles({id: user._id})\" tabindex=\"-1\"></i></span> <span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(user,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"!user.isBlock && admin\" title=\"Block\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-lock fa-2 fa-padd text-danger\" ng-click=\"vm.blockUser(user._id, true, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"user.isBlock && admin\" title=\"Unblock\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-unlock-alt fa-2 fa-padd text-success\" ng-click=\"vm.blockUser(user._id, false, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteUser(user._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr><tr ng-if=\"vm.filterOptions.total<=0\" class=\"odd\"><td valign=\"top\" colspan=\"7\" class=\"dataTables_empty\">No data available in table</td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.usersList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-team/manage-team.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Team</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(ques,\'new\')\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add Member</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredTeams($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredTeams()\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Name</th><th>Email</th><th>Profession</th><th>Designation</th><th>Brief</th><th>Created on</th><th>Is Verified</th><th style=\"width: 120px;\">Action</th></tr></thead><tbody><tr ng-repeat=\"team in vm.teamList track by $index\"><td>{{$index+1}}</td><td><div class=\"fa-padd\">{{ team.name}}</div></td><td>{{team.email}}</td><td>{{ team.profession }}</td><td>{{ team.designation }}</td><td><span ng-if=\"!team.brief\" class=\"\">......</span><show-more ng-if=\"team.brief\" text=\"team.brief\" limit=\"30\"></show-more></td><td>{{team.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': team.verified, \'clr-danger\': !team.verified }\"></i> {{team.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"View\"><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(team,false)\" tabindex=\"-1\"></i></span> <span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(team,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"!team.verified && admin\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyTeams(team._id)\" title=\"Verify\" tabindex=\"-1\"></i></span> <span><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteTeams(team._id)\" aria-hidden=\"true\" title=\"Delete\" tabindex=\"-1\"></i></span></td></tr></tbody></table><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.teamList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-transaction/manage-transaction.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Transaction</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\" style=\"margin-top: 5px;\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredTrans($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredTrans()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\" style=\"overflow: scroll;\"><table class=\"table table-stripedx table-bordered table-hover animated fadeInLeft\"><thead><tr><th>S.No.</th><th>Name</th><th>Role</th><th>Payment method</th><th>Payment id</th><th>Subscription</th><th>Created on</th><th>Expired on</th><th>Status</th><th>Refund</th><th>Allowed By Admin</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"trans in vm.transactionList track by $index\"><td>{{$index+1}}</td><td><span><img class=\"img-circle image-responsive user-img\" ng-src=\"{{vm.getImageUrl(trans.uid.profilePicture || trans.uid._id)}}\"></span> <span class=\"fa-padd\">{{ trans.uid.name }}</span></td><td>{{ trans.uid.role }}</td><td>{{trans.payment_method}}</td><td>{{trans.paypal_paymentId }}</td><td>{{trans.subcription.title}}</td><td>{{trans.createdAt | date: \'mediumDate\' }}</td><td>{{trans.expireAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'text-active\': trans.status == \'approved\', \'text-danger\': trans.status == \'pending\' }\"></i> {{trans.status }}</td><td>{{trans.IsRefund ? \"Yes\": \"No\"}}</td><td><i class=\"fa\" ng-class=\"{\'clr-active fa-check-circle\': trans.isAllowedByAdmin, \'fa-times-circle clr-danger\': !trans.isAllowedByAdmin }\"></i> {{trans.isAllowedByAdmin ? \"Yes\": \"No\"}}</td><td class=\"button-style\"><span ng-if=\"trans.uid.role == \'teacher\' && trans.status == \'pending\' && admin\" title=\"Approve/Disapprove\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.approveTransaction(trans._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"trans.IsRefund == false\" title=\"Refund\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-random fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.RefundTransaction(trans._id)\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.transactionList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-topic/manage-topic.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Topic</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Topic</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredtopics($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredtopics()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Name</th><th>Grade</th><th>Subject</th><th>Description</th><th>Created On</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"topic in vm.topics track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ topic.name}}</span></td><td><span class=\"fa-padd\">{{ topic.grade.name}}</span></td><td><span class=\"fa-padd\">{{ topic.course.name}}</span></td><td><show-more text=\"topic.description\" limit=\"120\"></show-more></td><td>{{topic.createdAt |date :\'mediumDate\'}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(topic,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteTopic(topic._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.topics.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-user/manage-user.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Users</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add User</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\" style=\"margin-top: 5px\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredUsers($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredUsers()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 table-stripedx table-hover dataTables-example animated fadeInLeft\"><thead><tr><th>S.No.</th><th>Image</th><th>User</th><th>Email</th><th>User Role</th><th>Joined on</th><th>Is Verified</th><th style=\"width: 120px;\">Action</th></tr></thead><tbody><tr ng-repeat=\"user in vm.usersList track by $index\" ng-if=\"!(user._id == vm.me.data._id)\" ng-hide=\"subAdmin && user.role == \'admin\'\"><td>{{$index+1}}</td><td><span><img ng-if=\"!user.profilePicture\" class=\"img-circle image-responsive user-img\" src=\"/assets/img/defaultProfile.png\"> <img ng-if=\"user.profilePicture\" class=\"img-circle image-responsive user-img\" ui-sref=\"admin.profiles({id: user._id})\" ng-src=\"{{vm.getImageUrl(user.profilePicture || user._id)}}\"></span></td><td>{{ user.name}}</td><td>{{user.email}}</td><td>{{user.role}}</td><td>{{user.createdAt | date: \'mediumDate\' }}</td><td>{{user.emailVerified ? \"Yes\": \"No\"}}</td><td class=\"button-style\"><span title=\"View\"><i class=\"fa fa-eye fa-2 clr-primary fa-padd\" ui-sref=\"admin.profiles({id: user._id})\" tabindex=\"-1\"></i></span> <span><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openEditModal(user,true)\"></i></span> <span ng-if=\"!user.isBlock && admin\" title=\"Block\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-lock fa-2 fa-padd text-danger\" ng-click=\"vm.blockUser(user._id, true, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"user.isBlock && admin\" title=\"Unblock\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-unlock-alt fa-2 fa-padd text-success\" ng-click=\"vm.blockUser(user._id, false, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"!user.isApprovedByAdmin && admin && user.role == \'teacher\'\" title=\"Approve\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-times-circle-o fa-2 text-danger\" ng-click=\"vm.approveUser(user._id, true, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"user.isApprovedByAdmin && admin && user.role == \'teacher\'\" title=\"Disapprove\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-circle-o fa-2 text-success\" ng-click=\"vm.approveUser(user._id, false, user.name)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteUser(user._id)\" aria-hidden=\"true\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.usersList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-unit/manage-unit.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Module</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.openModal(null,false)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Module</a></div></div></div><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredunits($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredunits()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 dataTables-example animated fadeInLeft\"><thead><tr><th>S.NO.</th><th>Name</th><th>Grade</th><th>Subject</th><th>Topic</th><th>Description</th><th>Created On</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"unit in vm.units track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ unit.name}}</span></td><td><span class=\"fa-padd\">{{ unit.grade.name}}</span></td><td><span class=\"fa-padd\">{{ unit.course.name}}</span></td><td><span class=\"fa-padd\">{{ unit.topic.name}}</span></td><td>{{unit.description}}</td><td>{{unit.createdAt |date :\'mediumDate\'}}</td><td class=\"button-style\"><span title=\"Edit\"><i class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(unit,true)\" tabindex=\"-1\"></i></span> <span ng-if=\"admin\" title=\"Delete\"><i class=\"fa fa-trash fa-2 fa-padd text-danger\" ng-class=\"{\'close-event\': vm.isBusy }\" ng-click=\"vm.deleteUnit(unit._id)\" aria-hidden=\"true\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.usersList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-video/manage-video.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Video</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\"><div class=\"button-header\" style=\"margin: 11px 0px 11px 0px;float: right;\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" ng-click=\"vm.AddModal(null,true)\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myModal\">Add New Video</a></div></div></div><div class=\"col-md-12\"><span style=\"float:left;\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterOptions.limit\" ng-change=\"vm.changeFilterOptions()\" ng-options=\"value for value in vm.viewBy\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\" style=\"margin-top: 5px;\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredStory($event)\" ng-model=\"vm.filterOptions.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredStory()\" class=\"btn btn-outline-secondary k-addon search-btn\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead class=\"theme-clr-thead\"><tr><th>S.No.</th><th>Title</th><th>Chapter</th><th>Video Link</th><th>Message</th><th>Created on</th><th>Is Verified</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"story in vm.storyList track by $index\"><td>{{$index+1}}</td><td><span class=\"fa-padd\">{{ story.name}}</span></td><td>{{story.chapter}}</td><td><a style=\"color: #007bff;\" href=\"{{story.videoURL}}\" target=\"_blank\">video-url</a></td><td><p class=\"text-min-show\">{{ story.description }}</p></td><td>{{story.createdAt | date: \'mediumDate\' }}</td><td><i class=\"fa fa-circle\" ng-class=\"{\'clr-active\': story.verified, \'clr-danger\': !story.verified }\"></i> {{story.verified ? \"verified\": \"not verified\"}}</td><td class=\"button-style\"><span title=\"View\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-eye fa-2 clr-primary fa-padd\" ng-click=\"vm.openModal(story,false)\" tabindex=\"-1\"></i></span> <span title=\"Edit\"><i ng-class=\"{\'close-event\': true || vm.isBusy }\" class=\"fa fa-edit fa-2 fa-padd text-primary\" ng-click=\"vm.openModal(story,true)\" tabindex=\"-1\"></i></span> <span title=\"Delete\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-trash fa-2 fa-padd text-danger\" aria-hidden=\"true\" ng-click=\"vm.deleteStory(story._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"!story.verified && admin\" title=\"Verify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.verifyStory(story._id)\" tabindex=\"-1\"></i></span> <span ng-if=\"story.verified && admin\" title=\"Unverify\"><i ng-class=\"{\'close-event\': vm.isBusy }\" class=\"fa fa-check-square-o fa-2 fa-padd clr-primary\" aria-hidden=\"true\" ng-click=\"vm.unverifyStory(story._id)\" tabindex=\"-1\"></i></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"!vm.loader && vm.storyList.length\" items-per-page=\"vm.filterOptions.limit\" ng-model=\"vm.filterOptions.page\" total-items=\"vm.filterOptions.total\" ng-change=\"vm.changeFilterOptions()\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/admin-panel/navbar-sidebar/sidebar.html","<div class=\"logo\"><a href=\"#\" class=\"simple-text logo-normal\"><div class=\"logo-image-big\"><img src=\"../assets/img/dashboardlogo.png\" alt=\"\"></div></a></div><div class=\"profile\"><div class=\"profile_img\"><img ng-if=\"!vm.user.profilePicture\" ui-sref=\"admin.profiles({id: vm.user._id})\" alt=\"user\" src=\"assets/images/defaultProfile.png\" style=\"width: 62px;border-radius: 32px;\"> <img ng-if=\"vm.user.profilePicture\" ui-sref=\"admin.profiles({id: vm.user._id})\" ng-src=\"{{vm.updateImg && vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" alt=\"user\" style=\"width: 62px;border-radius: 32px;\"></div><div class=\"designation\"><strong>{{vm.user.name}}<br></strong> <span>{{vm.user.role}}</span></div></div><div class=\"sidebar-wrapper\"><ul class=\"nav\"><li ui-sref-active=\"active\" id=\"adminmenu\"><a ui-sref=\"admin.manageuser\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i> <span>Manage Users</span></a></li><li ui-sref-active=\"active\" id=\"adminSubmenu\"><a ui-sref=\"admin.managesubadmin\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i> <span>Manage Sub Admin</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.grade\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i> <span>Manage Grade</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managecourse\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Manage Subject</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managetopic\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Manage Topic</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.manageunit\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Manage Module</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managechapter\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file-text\" aria-hidden=\"true\"></i> <span>Manage Chapter</span></a></li><li ui-sref-active=\"active\" ng-class=\"{ active: vm.state.includes(\'admin.addquestion\') }\"><a ui-sref=\"admin.managequestion\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-question-circle\" aria-hidden=\"true\"></i> <span>Manage Questions</span></a></li><li ui-sref-active=\"active\" ng-class=\"{ active: vm.state.includes(\'admin.managebadges\') }\"><a ui-sref=\"admin.managebadges\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-graduation-cap\" aria-hidden=\"true\"></i> <span>Manage Badges</span></a></li><li ng-if=\"admin\" ui-sref-active=\"active\" ng-class=\"{ active: vm.state.includes(\'admin.editsubscription\') }\"><a ui-sref=\"admin.managesubscription\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i> <span>Manage Subscription</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managecontents\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-book\" aria-hidden=\"true\"></i> <span>Manage Contents</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.manageteams\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i> <span>Manage Team</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managestory\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i> <span>Manage Story</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managevideo\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i> <span>Manage Video</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managefaqs\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-book\" aria-hidden=\"true\"></i> <span>Manage FAQs</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.manageenquiry\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> <span>Manage Enquiry</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"admin.managecareer\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> <span>Manage Career</span></a></li><li ng-if=\"admin\" ui-sref-active=\"active\"><a ui-sref=\"admin.managetransaction\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i> <span>Manage Transaction</span></a></li></ul></div>");
$templateCache.put("app/admin-panel/navbar-sidebar/top-navbar.html","<div class=\"container-fluid\"><div class=\"navbar-wrapper\"><div class=\"navbar-toggle\"><button type=\"button\" class=\"navbar-toggler\"><span class=\"navbar-toggler-bar bar1\"></span> <span class=\"navbar-toggler-bar bar2\"></span> <span class=\"navbar-toggler-bar bar3\"></span></button></div></div><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navigation\" aria-controls=\"navigation-index\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-bar navbar-kebab\"></span> <span class=\"navbar-toggler-bar navbar-kebab\"></span> <span class=\"navbar-toggler-bar navbar-kebab\"></span></button><div class=\"collapse navbar-collapse justify-content-end\" id=\"navigation\"><ul class=\"navbar-nav\"><li class=\"nav-item\"><a class=\"nav-link btn-magnify\"><p><img src=\"../assets/img/bell.png\" alt=\"\"></p><span>8</span></a></li><li class=\"nav-item btn-rotate dropdown\"><a class=\"nav-link dropdown-toggle\" id=\"navbarDropdownMenuLink\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><img ng-if=\"!vm.user.profilePicture\" alt=\"\" src=\"assets/images/defaultProfile.png\" style=\"width: 36px;border-radius: 20px;\"> <img ng-if=\"vm.user.profilePicture\" ng-src=\"{{ vm.updateImg && vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" alt=\"\" style=\"width: 36px;border-radius: 20px;\"> {{vm.user.name }}</a><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\"><a class=\"dropdown-item\" ui-sref=\"admin.editprofile\">Edit Profile</a> <a class=\"dropdown-item\" ng-click=\"vm.openChangePasswordModal()\">Change Password</a> <a class=\"dropdown-item logout-clr\" ng-click=\"vm.logout()\">Logout</a></div></li></ul></div></div>");
$templateCache.put("app/admin-panel/profile/profile.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Profile</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"admin.manageuser\">Home</a></li><li><span>/</span></li><li>Profile</li></ul></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-5\"><div class=\"card card-user\"><div class=\"image\"></div><div class=\"content\"><div class=\"author\"><img class=\"avatar border-white\" ng-src=\"{{ vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" src=\"assets/img/defaultProfile.png\" alt=\"user\" style=\"width: 106px;height: 106px;border-radius: 50%;\"><h4 class=\"title\"><b>{{vm.user.name }}</b><br><small>{{vm.user.email }}</small><br><small>{{vm.user.phoneNumber || \'9999999999\'}}</small></h4></div></div></div></div><div class=\"col-lg-8 col-md-7\"><div class=\"card\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Name</label> <span class=\"form-control border-input\">{{vm.user.name }}</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Email</label> <span class=\"form-control border-input\">{{vm.user.email }}</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Birth</label> <span class=\"form-control border-input\">{{vm.userDOB | date : \'dd / MM / yyyy\' }}</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Contact</label> <span class=\"form-control border-input\">{{vm.user.phoneNumber || \'9999999999\'}}</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"exampleInputEmail1\">Degree</label> <span class=\"form-control border-input\">{{vm.user.degreeName}}</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"exampleInputEmail1\">Specialization</label> <span class=\"form-control border-input\">{{vm.user.specialization}}</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Joining</label> <span class=\"form-control border-input\">{{vm.user.createdAt | date : \'dd / MM / yyyy\' }}</span></div></div></div><div class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/dashboard/badges/badges.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Total Badges</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"dashboard.view\">Home</a></li><li><span>/</span></li><li>Badges</li></ul></div></div><div class=\"profile_background\"><div class=\"row\"><div class=\"col-md-4\" ng-repeat=\"badge in vm.badgeList\"><div class=\"budges_container\"><div class=\"bronze_images\"><img ng-src=\"{{vm.getImageUrl(badge.logo || badge._id)}}\" style=\"border-radius: 50%;border: 1px solid #f1f1f1;padding: 1px;\"><h3>{{badge.name}} : {{badge.count}}</h3><p ng-bind-html=\"badge.description\"></p></div></div></div></div></div>");
$templateCache.put("app/dashboard/chapter/chapter.html","<div class=\"classes_popup\"><h4 class=\"modal-title\">{{vm.chapter.name}}</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\">&times;</button><div class=\"modal-body\"><iframe ng-src=\"{{ vm.trustUrl( vm.chapter.vidURL ) }}\" width=\"640\" height=\"300\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen=\"\"></iframe></div></div>");
$templateCache.put("app/dashboard/classes/classes.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Classes</h3></div><div class=\"col-md-6\"><ul><li><a href=\"#\">Home</a></li><li><span>/</span></li><li>Classes</li></ul></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section classes\"><div class=\"card mb-5\"><div class=\"button-header\"><div class=\"edit_profile read_more\"><a href=\"javascript:void(0)\" class=\"btn\" ng-click=\"vm.openModal()\">Join New Class</a></div></div><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-bordered table-sm m-0 table-stripedx table-hover dataTables-example animated fadeInLeft\"><thead class=\"\"><tr><th>S.NO.</th><th>Class Name</th><th>Teacher Name</th><th>Score</th><th>URN</th><th>Action</th></tr></thead><tbody><tr ng-if=\"vm.classes && vm.classes.length\" ng-repeat=\"class in vm.classes track by $index\"><td>{{$index+1}}</td><td><a ui-sref=\"dashboard.selectbystudentclass({ classid: class._id})\" style=\"color: blue;\">{{class.name}}</a></td><td>{{ class.createdBy ? class.createdBy.name : \'n/a\' }}</td><td><div class=\"progress-outer\"><div class=\"progress\"><div class=\"progress-bar active\" style=\"{{\'width:\'+((class.totalEarnScore/class.totalScore)*100)+\'%;\'}}\"></div><div class=\"progress-value\">{{(class.totalEarnScore/class.totalScore)*100|number:2}}%</div></div></div></td><td>{{class.joinCode}}</td><td><ul><li><a href=\"javascript:void(0)\" title=\"View\" ng-click=\"vm.viewClass(class)\"><img src=\"../assets/img/evy.png\" alt=\"\"></a></li><li><a href=\"\" title=\"Delete\" ng-click=\"vm.removeClass(class)\"><img src=\"../assets/img/del.png\" alt=\"\"></a></li></ul></td></tr></tbody></table><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-change=\"vm.changeClassesPagination()\" ng-show=\"!vm.loader && vm.classes && vm.classes.length >15\" items-per-page=\"vm.filterClass.limit\" ng-model=\"vm.filterClass.page\" total-items=\"vm.filterClass.total\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard-view/dashboard-view.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Dashboard</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"dashboard.view\">Home</a></li><li><span>/</span></li><li>Dashboard</li></ul></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6\"><div class=\"card card-stats yellow\"><div class=\"card-body\"><div class=\"row\"><div class=\"col-5 col-md-4\"><div class=\"icon-big text-center icon-warning\"><i class=\"fas fa-book-reader\"></i></div></div><div class=\"col-7 col-md-8\"><div class=\"numbers\"><p class=\"card-category\">Total Modules</p><p>{{vm.TotalModule}}</p></div></div></div></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6\"><div class=\"card card-stats blue\"><div class=\"card-body\"><div class=\"row\"><div class=\"col-5 col-md-4\"><div class=\"icon-big text-center icon-warning\"><i class=\"fas fa-book-reader\"></i></div></div><div class=\"col-7 col-md-8\"><div class=\"numbers\"><p class=\"card-category\">Average Quiz Score</p><p>{{vm.AverageQuiz.toFixed(2)}} %</p></div></div></div></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6\"><div class=\"card card-stats green\"><div class=\"card-body\"><div class=\"row\"><div class=\"col-5 col-md-4\"><div class=\"icon-big text-center icon-warning\"><i class=\"fas fa-book-reader\"></i></div></div><div class=\"col-7 col-md-8\"><div class=\"numbers\"><p class=\"card-category\">Average Exam Score</p><p>{{vm.AverageExam.toFixed(2)}} %</p></div></div></div></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6\"><div class=\"card card-stats pink\"><div class=\"card-body\"><div class=\"row\"><div class=\"col-5 col-md-4\"><div class=\"icon-big text-center icon-warning\"><i class=\"fas fa-book-reader\"></i></div></div><div class=\"col-7 col-md-8\"><div class=\"numbers\"><p class=\"card-category\">Total Badges Earned</p><p>{{vm.TotalBadge}}</p></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"card card-chart\"><div id=\"Milestonechart1Container\" class=\"body\"></div></div></div></div><input type=\"hidden\" value=\"{{vm.GraphData}}\" id=\"tblGraph\"><script>\r\n	var jsondata = \"[\";\r\n	//var aaa=vm.GraphData\r\n	setTimeout(function () {\r\n		var Data = $(\"#tblGraph\").val()\r\n		if (Data != \"\") {\r\n			var AllData = Data.substring(0, Data.length - 1);\r\n			var splitData = AllData.split(\',\');\r\n			splitData.forEach(element => {\r\n				var splitCapData = element.split(\'^\');\r\n				jsondata = jsondata + \'{ \"label\": \"\' + splitCapData[1] + \'\", \"value\": \"\' + parseInt(splitCapData[0]) + \'\"},\'\r\n			});\r\n		}\r\n		jsondata = jsondata.substring(0, jsondata.length - 1);\r\n		jsondata = jsondata + \"]\"\r\n\r\n\r\n		var revenueChart = new FusionCharts({\r\n\r\n			renderAt: \"Milestonechart1Container\",\r\n			//type: \"msarea\",\r\n			type: \"line\",\r\n			width: \"100%\",\r\n			height: \"280\",\r\n			dataFormat: \"json\",\r\n			dataSource: {\r\n				\"chart\": {\r\n					\"caption\": \"\",\r\n					\"subcaption\": \"\",\r\n					\"numbersuffix\": \"\",\r\n					//\"showsum\": \"1\",\r\n					//\"plottooltext\": \"<b>$label</b> {br}<b>$seriesName :  $dataValue</b>\",\r\n					\"plottooltext\": \"<b>$label</b> {br} :  $dataValue</b>\",\r\n					\"theme\": \"zune\",\r\n					\"drawcrossline\": \"1\",\r\n					\"showLabels\": \"1\",\r\n					\"showValues\": \"0\",\r\n					\"toolTipBgAlpha\": \"80\",\r\n					\"showToolTipShadow\": \"1\",\r\n					\"formatNumberScale\": \"0\"\r\n					//\"numberPrefix\": \"Rs \",\r\n					//\"yaxisname\": \"Amount(Rs)\",\r\n					//\"xaxisname\": \"Expensive\"\r\n\r\n				},\r\n\r\n				\"data\": JSON.parse(jsondata)\r\n\r\n\r\n			}\r\n\r\n		});\r\n		revenueChart.render(\"Milestonechart1Container\");\r\n	}, 1000)\r\n</script>");
$templateCache.put("app/dashboard/discussion-topic/discussionTopic.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Discussion</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"dashboard.view\">Home</a></li><li><span>/</span></li><li>Discussion</li></ul></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"button-header\"><div class=\"edit_profile discBtn\"><a href=\"\" class=\"btn\" data-toggle=\"modal\" data-target=\"#myDiscussModal\" ng-click=\"vm.submitted=false;vm.question=\'\'\">Ask Your Question</a></div></div></div><div ng-if=\"vm.loader\" class=\"main-page more_loader margin-all-15\"><h3>Loading.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div></div><div class=\"check discussion\" ng-repeat=\"discussion in vm.getDiscussions\" ng-if=\"vm.getDiscussions && vm.getDiscussions.length\"><div class=\"row\"><div class=\"col-md-12\"><h3>Q{{$index+1}}. {{discussion.discussionTitle}} {{vm[\'ansList\'+$parent.$index]}}</h3><p ng-repeat=\"answers in discussion.answerSheet | limitTo : vm[\'ansList\'+$parent.$index] || 5\" ng-if=\"discussion.answerSheet && discussion.answerSheet.length\"><strong>Answer {{$parent.$index+1}}:</strong> {{answers.answer}} <span class=\"pull-right\">Answered By: <b>{{answers.answeredBy.name}}</b></span><div ng-if=\"discussion.answerSheet.length >5\" class=\"col-sm-12\"><button ng-click=\"vm.loadMore( \'ansList\'+$parent.$index )\" ng-hide=\"vm[\'ansList\'+$parent.$index] >discussion.answerSheet.length\" class=\"load-more-btn float-none btn\">See More.. <i ng-if=\"vm.loader\" class=\"fa fa-refresh fa-spin\"></i></button> <button ng-click=\"vm.loadLess( \'ansList\'+$parent.$index )\" ng-show=\"vm[\'ansList\'+$parent.$index] >5\" class=\"load-more-btn float-none btn\">See Less.. <i ng-if=\"vm.loader\" class=\"fa fa-refresh fa-spin\"></i></button></div></p><form ng-submit=\"vm.postReply( form, discussion, $parent.$index )\" novalidate=\"\" name=\"form\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.answer{{$parent.$index}}.$valid && vm.submitted, \'has-errorX\': form.answer{{$parent.$index}}.$invalid && vm.submitted }\"><textarea rows=\"5\" id=\"comment\" autocomplete=\"off\" name=\"answer{{$parent.$index}}\" ng-model=\"discussion.addReply\" placeholder=\"Post your comment here...\" class=\"form-control\" required=\"\"></textarea><p class=\"help-block text-danger\" style=\"margin-top:5px;margin-left: 0px;\" ng-show=\"form.answer{{$parent.$index}}.$error.required && vm[\'submitted\'+$parent.$index]\">Please enter your comment.</p></div><div class=\"edit_profile\"><a href=\"\" ng-click=\"vm.postReply( form, discussion, $parent.$index )\" ng-class=\"{\'close-event\': vm[\'loadReply\'+$parent.$index] }\" class=\"btn\">Submit <b ng-if=\"vm[\'loadReply\'+$parent.$index]\" class=\"animated fadeInLeft infinite\">...</b></a></div></form></div></div></div><div class=\"row\"><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-change=\"vm.changeDiscussionPage()\" ng-show=\"!vm.loader && vm.getDiscussions && vm.getDiscussions.length >15\" items-per-page=\"vm.filterQues.limit\" ng-model=\"vm.filterQues.page\" total-items=\"vm.filterQues.total\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"modal fade classes_popup\" id=\"myDiscussModal\" role=\"dialog\"><div class=\"modal-dialog modal-content\"><div><h4 class=\"modal-title\">Ask Your Question</h4><button type=\"button\" ng-click=\"vm.cancel()\" class=\"close\" data-dismiss=\"modal\" tabindex=\"-1\">&times;</button><div class=\"modal-body\"><form ng-submit=\"vm.askQuestion(askform)\" novalidate=\"\" name=\"askform\"><div class=\"form-group\" ng-class=\"{ \'has-success\': askform.question.$valid && vm.submitted, \'has-error\': askform.question.$invalid && vm.submitted }\"><textarea id=\"comment\" type=\"text\" maxlength=\"800\" autocomplete=\"off\" name=\"question\" ng-model=\"vm.question\" class=\"form-control\" placeholder=\"Enter your question here....\" required=\"\"></textarea><p class=\"help-block text-danger\" ng-show=\"askform.question.$error.minlength && vm.submitted\">Your question atleast 10 character.</p><p class=\"help-block text-danger\" ng-show=\"askform.question.$error.required && vm.submitted\">Please enter your question. <b ng-if=\"vm.loader\" class=\"animated fadeInLeft infinite\">...</b></p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><a ng-click=\"vm.askQuestion(askform)\" ng-class=\"{\'close-event\': vm.loader}\" ng-disabled=\"vm.loader\" class=\"btn\">Submit</a></div></div></form></div></div></div></div><div class=\"modal-dialog\"><div class=\"modal-content dis_pop_up\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button><h4 class=\"modal-title\">Ask Your Question</h4><div class=\"modal-body\"><form ng-submit=\"vm.askQuestion(askform)\" novalidate=\"\" name=\"askform\"><div class=\"form-group\" ng-class=\"{ \'has-success\': askform.question.$valid && vm.submitted, \'has-error\': askform.question.$invalid && vm.submitted }\"><textarea id=\"comment\" type=\"text\" maxlength=\"800\" autocomplete=\"off\" name=\"question\" ng-model=\"vm.question\" class=\"form-control\" placeholder=\"Enter your question here....\" required=\"\"></textarea><p class=\"help-block text-danger\" ng-show=\"askform.question.$error.minlength && vm.submitted\">Your question atleast 10 character.</p><p class=\"help-block text-danger\" ng-show=\"askform.question.$error.required && vm.submitted\">Please enter your question. <b ng-if=\"vm.loader\" class=\"animated fadeInLeft infinite\">...</b></p></div><div class=\"form-group\"><div class=\"edit_profile submit\"><a ng-click=\"vm.askQuestion(askform)\" ng-class=\"{\'close-event\': vm.loader}\" ng-disabled=\"vm.loader\" class=\"btn\">Submit</a></div></div></form></div></div></div><style>\r\n    .form-group .form-control, .input-group .form-control {\r\n        padding: 10px 10px 30px 10px;\r\n        }\r\n    </style>");
$templateCache.put("app/dashboard/edit-profile/editProfile.html","<div class=\"row\" style=\"display:none\"><div class=\"profile_page edit_profile_page\"><h3>Edit Profile</h3><form name=\"form\" novalidate=\"\"><div class=\"profile_details\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Full Name</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><input type=\"text\" name=\"name\" ng-model=\"vm.fullName\" ng-pattern=\"vm.pattern.name\" maxlength=\"35\" ng-minlength=\"3\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Full Name\'\" placeholder=\"Full Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 3 characters.</p><p style=\"color:red\" ng-show=\"form.name.$error.pattern && vm.submitted\" class=\"help-block text-danger\">Name must be a valid name.</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>User Type</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p style=\"text-transform:capitalize\">{{vm.user.role}}</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Email</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p>{{vm.user.email }}</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Password</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.password.$valid && vm.submitted, \'has-error\': form.password.$invalid && vm.submitted }\"><input type=\"password\" name=\"password\" ng-model=\"vm.password\" class=\"form-control\" ng-pattern=\"vm.pattern.password\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'******\'\" placeholder=\"******\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.password.$error.required && form.password.$touched\">Please enter password</p><p class=\"help-block text-danger\" ng-show=\"form.password.$error.pattern && form.password.$dirty\">Password should be at least 8 characters long and should contain one number,one character and one special character</p></div></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Confirm Password</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.confirmPassword.$valid && form.confirmPassword.$dirty, \'has-error\': form.confirmPassword.$invalid && form.confirmPassword.$dirty }\"><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.confirmPassword\" ng-pattern=\"vm.password\" class=\"form-control\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'******\'\" placeholder=\"******\"><p class=\"help-block text-danger\" ng-show=\"(form.confirmPassword.$error.pattern || !(vm.confirmPassword === vm.password)) && vm.submitted\">Confirm password must be matched.</p></div></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Date of joining</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p>{{vm.user.createdAt | date : \'dd / MM / yyyy\' }}</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Subjects</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p>Mathematics</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Teacher</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p>None</p></div></div><div class=\"form-group\"><div class=\"col-md-4 col-sm-3 col-xs-5\"><label>Parent</label></div><div class=\"col-md-1 col-sm-1 col-xs-1\"><label>:</label></div><div class=\"col-md-7 col-sm-8 col-xs-6\"><p>None</p></div></div></div><div ng-if=\"!vm.myCroppedImage\" class=\"col-md-7 col-sm-8 col-xs-6\"><button ng-click=\"vm.upload()\" ng-disabled=\"vm.loader\" class=\"profile_editbtn\">Save</button></div></form></div></div><div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Edit Profile</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"dashboard.view\">Home</a></li><li><span>/</span></li><li>Profile</li></ul></div></div><div class=\"profile_background\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"main_profile_img\"><img ng-if=\"vm.user.profilePicture\" ng-src=\"{{ vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" alt=\"user\" class=\"img-fluid\" style=\"width: 106px;height: 106px;border-radius: 50%;\"> <img ng-if=\"!vm.user.profilePicture\" alt=\"user\" class=\"img-fluid\" src=\"assets/img/defaultProfile.png\" style=\"width: 106px;height: 106px;border-radius: 50%;\"><ul><li><a href=\"javascript:void(0)\" title=\"Change Image\" ng-click=\"vm.changeImage()\"><i class=\"fas fa-camera\"></i></a></li><li><a href=\"javascript:void(0)\" title=\"Delete Image\" ng-click=\"vm.removeImage()\"><i class=\"fas fa-times\"></i></a></li></ul></div></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"main_profile_img\"><div class=\"form-group\"><label>Name</label> <input type=\"text\" name=\"name\" ng-model=\"vm.fullName\" ng-pattern=\"vm.pattern.name\" maxlength=\"35\" ng-minlength=\"3\" class=\"form-control\" placeholder=\"First Name\" required=\"\" autocomplete=\"off\"><p class=\"help-block text-danger\" ng-show=\"form.name.$error.required && vm.submitted\">A name is required</p><p ng-show=\"form.name.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Name must be atleast 3 characters.</p><p style=\"color:red\" ng-show=\"form.name.$error.pattern && vm.submitted\" class=\"help-block text-danger\">Name must be a valid name.</p></div></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Email</label><br><input type=\"grade\" ng-model=\"vm.user.email\" class=\"form-control\" disabled=\"\"></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Date Of Birth</label> <input type=\"userDOB\" ng-model=\"vm.userDOB | date : \'dd/MM/yyyy\'\" class=\"form-control\" disabled=\"\"><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.required && vm.submitted\">Please enter Date Of Birth.</p><p class=\"help-block text-danger\" ng-show=\"form.dateofBirth.$error.mongoose\">{{ vm.errors.dateofBirth }}</p></div></div><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.phoneNumber.$valid && vm.submitted, \'has-error\': form.phoneNumber.$invalid && vm.submitted }\"><label>Phone Number</label> <input type=\"countryCode\" ng-model=\"vm.countryCode\" class=\"form-control\" style=\"width: 50px;\" disabled=\"\"> <input type=\"text\" style=\"margin-left: 50px;margin-top: -34px;width: 80% !important;\" placeholder=\"Phone Number\" name=\"phoneNumber\" ng-model=\"vm.user.phoneNumber\" class=\"form-control\" numbers-only=\"\" ng-minlength=\"8\" maxlength=\"15\" mongoose-error=\"\" autocomplete=\"off\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.required && vm.submitted || !vm.user.phoneNumber\">Please enter Phone Number.</p><p ng-show=\"form.phoneNumber.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be between 8 to 15 digits.</p><p ng-show=\"form.phoneNumber.$error.maxlength && vm.submitted\" class=\"help-block text-danger\">Phone Number must be atleast 10 characters.</p><p class=\"help-block text-danger\" ng-show=\"form.phoneNumber.$error.mongoose\">{{ vm.errors.phoneNumber }}</p></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Date Of Joining</label> <input type=\"createdAt\" ng-model=\"vm.user.createdAt | date : \'dd/MM/yyyy\'\" class=\"form-control\" disabled=\"\"></div></div><div class=\"col-md-5\"><div class=\"form-group email\"><label>Grade</label> <input type=\"grade\" ng-model=\"vm.grade.join(\', \')\" class=\"form-control\" disabled=\"\"></div></div><div class=\"col-md-12\"><div class=\"edit_profile update\"><a ng-click=\"vm.upload(form)\" ng-class=\"{\'close-event\': vm.loader}\" ng-disabled=\"vm.loader\" class=\"btn\">Update</a></div></div></div></div></div></form></div>");
$templateCache.put("app/dashboard/my-tests/myTests.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Quiz/Exam History</h3></div><div class=\"col-md-6\"><ul><li><a href=\"#\">Home</a></li><li><span>/</span></li><li>Quiz/Exam History</li></ul></div></div><div class=\"check students_page\"><uib-tabset active=\"activeJustified\" justified=\"true\"><uib-tab index=\"0\" heading=\"Quiz List\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;margin-left:8px\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterQuiz.limit\" ng-change=\"vm.changeFilterOptions(\'Quiz\')\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredTests($event)\" ng-model=\"vm.filterQuiz.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredTests()\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead><tr><th>Category</th><th>Subject</th><th>Grade</th><th>Topic</th><th>Module</th><th>Earn Badge</th><th>Score</th><th>Quiz Date</th></tr></thead><tbody><tr ng-repeat=\"exam in vm.myQuizList track by $index\"><td><span ng-if=\"exam.class\">{{ exam.class.name}}</span> <span ng-if=\"!exam.class\">Tutorial</span></td><td>{{ exam.course.name}}</td><td>{{ exam.grade.name}}</td><td>{{ exam.topic.name}}</td><td>{{ exam.unit.name}}</td><td>{{exam.allocatedBadgeID.name}}</td><td><div class=\"progress-outer\"><div class=\"progress\"><div class=\"progress-bar active\" style=\"{{\'width:\'+exam.obtainPercentage+\'%;\'}}\"></div><div class=\"progress-value\">{{exam.obtainPercentage}}%</div></div></div></td><td>{{exam.createdAt | date: \'mediumDate\' }}</td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\" style=\"margin-left:8px;margin-top:30px;\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"vm.myQuizList.length\" items-per-page=\"vm.filterQuiz.limit\" ng-model=\"vm.filterQuiz.page\" total-items=\"vm.filterQuiz.total\" ng-change=\"vm.changeFilterOptions(\'Quiz\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Exam List\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section\"><div class=\"card mb-5\"><div class=\"col-md-12\" ng-show=\"!vm.loader\"><span style=\"float:left;margin-left:8px\">Show&nbsp;<select class=\"dropdown-Select\" style=\"margin-top: 8px;height: 30px;\" ng-model=\"vm.filterQuestion.limit\" ng-change=\"vm.changeFilterOptions(\'Question\')\"><option ng-repeat=\"value in vm.viewBy\">{{value}}</option></select>&nbsp; entries</span><div class=\"col-md-3 pull-right padd-zero\"><div class=\"input-group\"><input class=\"form-control search-textbox\" style=\"height:38px;\" login-enter=\"vm.getFilteredTests($event)\" ng-model=\"vm.filterQuestion.where.q\" placeholder=\"search..\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-append outline-none\"><button ng-click=\"vm.getFilteredTests()\" class=\"btn btn-outline-secondary k-addon\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-12\"><div class=\"card-block p-0\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" class=\"table table-stripedx table-bordered table-hover dataTables-example animated fadeInLeft\"><thead><tr><th>Category</th><th>Subject</th><th>Grade</th><th>Topic</th><th>Module</th><th>Earn Badge</th><th>Score</th><th>Quiz Date</th></tr></thead><tbody><tr ng-repeat=\"exam in vm.myExamList track by $index\"><td><span ng-if=\"exam.class\">{{ exam.class.name}}</span> <span ng-if=\"!exam.class\">Tutorial</span></td><td>{{ exam.course.name}}</td><td>{{ exam.grade.name}}</td><td>{{ exam.topic.name}}</td><td>{{ exam.unit.name}}</td><td>{{exam.allocatedBadgeID.name}}</td><td><div class=\"progress-outer\"><div class=\"progress\"><div class=\"progress-bar active\" style=\"{{\'width:\'+exam.obtainPercentage+\'%;\'}}\"></div><div class=\"progress-value\">{{exam.obtainPercentage}}%</div></div></div></td><td>{{exam.createdAt | date: \'mediumDate\' }}</td></tr></tbody></table></div></div><div class=\"col-sm-12 pagination-div\" style=\"margin-left:8px;margin-top:30px;\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-show=\"vm.myExamList.length\" items-per-page=\"vm.filterQuestion.limit\" ng-model=\"vm.filterQuestion.page\" total-items=\"vm.filterQuestion.total\" ng-change=\"vm.changeFilterOptions(\'Question\')\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div></div></uib-tab></uib-tabset></div><style>\r\n        .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active\r\n        {\r\n        background-color: #f3772e;\r\n        color: #fff;\r\n        }\r\n        </style>");
$templateCache.put("app/dashboard/navbar-sidebar/sidebar.html","<div class=\"sidebar\" data-color=\"white\" data-active-color=\"danger\"><div class=\"logo\"><a ui-sref=\"dashboard.view\" class=\"simple-text logo-normal\"><div class=\"logo-image-big\"><img src=\"assets/img/dashboardlogo.png\" alt=\"\"></div></a></div><div class=\"profile\"><div class=\"profile_img\"><img ng-if=\"vm.user.profilePicture\" style=\"border-radius:50%;border:1px solid #f1f1f1;padding:1px\" ui-sref=\"dashboard.profile\" ng-src=\"{{vm.updateImg && vm.getImageUrl( vm.user.profilePicture || vm.user._id ) }}\" alt=\"user\" class=\"img-fluid\"> <img ng-if=\"!vm.user.profilePicture\" style=\"border-radius:50%;border:1px solid #f1f1f1;padding:1px\" ui-sref=\"dashboard.profile\" alt=\"user\" src=\"assets/img/defaultProfile.png\" class=\"img-fluid\"></div><div class=\"designation\"><strong>{{vm.user.name}}<br></strong> <span class=\"capitalize\">{{vm.user.role}}</span></div></div><div class=\"sidebar-wrapper\"><ul class=\"nav\" style=\"width:260px !important\"><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.tutorial\" ui-sref-opts=\"{reload: true}\"><i class=\"fas fa-book-open\"></i><p>Tutorials</p></a></li><li ui-sref-active=\"active\" id=\"classbyselect\"><a ui-sref=\"dashboard.classes\" ui-sref-opts=\"{reload: true}\"><i class=\"fas fa-school\"></i><p>Classes</p></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.mytests\" ui-sref-opts=\"{reload: true}\"><i class=\"far fa-file-alt\"></i><p>My Quiz/Exam</p></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.discussiontopic({ page: 1})\" ui-sref-opts=\"{reload: true}\"><i class=\"fab fa-rocketchat\"></i><p>Discussion</p></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.view\" ui-sref-opts=\"{reload: true}\"><i class=\"fas fa-th-large\"></i><p>Performance Dashboard</p></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.badges\" ui-sref-opts=\"{reload: true}\"><i class=\"fas fa-graduation-cap\"></i><p>Badges</p></a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboard.subscription\" ui-sref-opts=\"{reload: true}\"><i class=\"fas fa-money-bill-alt\"></i><p>Subscriptions</p></a></li></ul></div></div>");
$templateCache.put("app/dashboard/navbar-sidebar/top-navbar.html","<nav class=\"navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent\"><div class=\"container-fluid\"><div class=\"navbar-wrapper\"><div class=\"navbar-toggle\"><button type=\"button\" class=\"navbar-toggler\"><span class=\"navbar-toggler-bar bar1\"></span> <span class=\"navbar-toggler-bar bar2\"></span> <span class=\"navbar-toggler-bar bar3\"></span></button></div></div><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navigation\" aria-controls=\"navigation-index\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-bar navbar-kebab\"></span> <span class=\"navbar-toggler-bar navbar-kebab\"></span> <span class=\"navbar-toggler-bar navbar-kebab\"></span></button><div class=\"collapse navbar-collapse justify-content-end\" id=\"navigation\"><ul class=\"navbar-nav\"><li class=\"nav-item\"><a class=\"nav-link btn-magnify\" href=\"#pablo\"><p><img src=\"assets/img/bell.png\" alt=\"\"></p><span>8</span></a></li><li class=\"nav-item btn-rotate dropdown\"><a class=\"nav-link dropdown-toggle\" href=\"\" id=\"navbarDropdownMenuLink\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><img ng-if=\"vm.user.profilePicture\" style=\"border-radius:50%;border:1px solid #f1f1f1;padding:1px;height:50px;width:50px\" ng-src=\"{{ vm.updateImg && vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" alt=\"user\" src=\"assets/img/second2.png\"> <img ng-if=\"!vm.user.profilePicture\" style=\"border-radius:50%;border:1px solid #f1f1f1;padding:1px;height:50px;width:50px\" alt=\"user\" src=\"assets/img/defaultProfile.png\"> {{vm.user.name}}</a><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"navbarDropdownMenuLink\"><a class=\"dropdown-item\" ui-sref=\"dashboard.profile\"><i class=\"fas fa-user\"></i>Profile</a> <a class=\"dropdown-item\" href=\"\" ng-click=\"vm.openChangePasswordModal()\"><i class=\"fas fa-key\"></i>Change Password</a> <a class=\"dropdown-item\" href=\"\" ng-click=\"vm.logout()\"><i class=\"fas fa-sign-out-alt\"></i>Logout</a></div></li></ul></div></div></nav>");
$templateCache.put("app/dashboard/mysubscription/mysubscription.html","<div class=\"row\"><div class=\"dashboard subscription_status\"><h3>Subscription Status</h3><div class=\"col-md-12 col-xs-12 col-sm-12\"><table class=\"\" style=\"width:1030px;\"><thead><tr><th width=\"5%\">#</th><th width=\"25%\">Subject Name</th><th width=\"15%\">Your Plan</th><th width=\"15%\">Expiry Date</th><th width=\"15%\">Price</th><th width=\"20%\">Current Status</th></tr></thead><tbody><tr ng-repeat=\"trans in vm.transList\"><td width=\"5%\">{{$index+1}}</td><td width=\"25%\">{{trans.course.name}}</td><td width=\"15%\">{{ trans.subcription.title }}</td><td width=\"15%\">{{ trans.expireAt | date: \'mediumDate\' }}</td><td width=\"15%\"><span ng-if=\"!trans.isAllowedByAdmin\">{{trans.uid.curriculum == \'IN\' ? \'₹\' : \'$\' }} {{trans.amount}}</span></td><td width=\"20%\"><a href=\"#\" class=\"current_status\">{{ trans.expireAt | amDifference : null : \'days\' }} days left</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/dashboard/select-by-class/selectByClass.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>{{ vm.class.name}}</h3></div><div class=\"col-md-6\"><ul><li><a href=\"#\">Home</a></li><li><span>/</span></li><li><a href=\"#/classes\">Classes</a></li><li><span>/</span></li><li>{{ vm.class.name}}</li></ul></div></div><div class=\"tutorials_background\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><select class=\"form-control\" name=\"topic\" id=\"topic\" ng-model=\"vm.tutorial.topic\" ng-change=\"vm.tutorial.unit=\'\';vm.getChapters();vm.getUnits(vm.tutorial.topic);\" required=\"\"><option value=\"\">Select Topic</option><option ng-repeat=\"option in vm.topics track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><select class=\"form-control\" name=\"units\" id=\"units\" ng-model=\"vm.tutorial.unit\" ng-change=\"vm.getChapters();\" required=\"\"><option value=\"\">Select Module</option><option ng-repeat=\"option in vm.units track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select></div></div></div></div><div class=\"check tutorials_content\" ng-repeat=\"chapter in vm.chapters\"><div class=\"row\"><div class=\"col-md-2\"><a href=\"javascript:void(0)\" ng-click=\"vm.viewChapterVideo(chapter._id)\"><img style=\"height: 87px; width: 87px;\" src=\"../assets/img/youtube.png\" alt=\"\"></a></div><div class=\"col-md-10\"><h3>{{chapter.name}}</h3><p>{{chapter.summary}}</p></div><div class=\"col-md-7\"></div><div class=\"col-md-5 text-right\"><div class=\"edit_profile read_more\"><a class=\"btn\" ui-sref=\"dashboard.test({ chapterId: chapter._id,classid: vm.classId})\">Take Quiz</a> <a href=\"javascript:void(0)\" ng-click=\"vm.viewChapterContent(chapter._id)\" class=\"btn\">See Description</a></div></div></div></div><script>\r\n    $(document).ready(function(){\r\n      \r\n        $(\".nav li:eq(1)\").addClass(\'active\');\r\n    });\r\n    \r\n    </script>");
$templateCache.put("app/dashboard/profile/profile.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Profile</h3></div><div class=\"col-md-6\"><ul><li><a ui-sref=\"dashboard.view\">Home</a></li><li><span>/</span></li><li>Profile</li></ul></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-5\"><div class=\"card card-user\"><div class=\"image\"></div><div class=\"content\"><div class=\"author\"><img class=\"avatar border-white\" ng-src=\"{{ vm.getImageUrl(vm.user.profilePicture || vm.user._id) }}\" src=\"assets/img/defaultProfile.png\" alt=\"user\" style=\"width: 106px;height: 106px;border-radius: 50%;\"><h4 class=\"title\"><b>{{vm.user.name }}</b><br><small>{{vm.user.email }}</small><br><small>{{vm.user.phoneNumber || \'9999999999\'}}</small></h4></div></div></div></div><div class=\"col-lg-8 col-md-7\"><div class=\"card\"><div class=\"content\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Name</label> <span class=\"form-control border-input\">{{vm.user.name }}</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Email</label> <span class=\"form-control border-input\">{{vm.user.email }}</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Birth</label> <span class=\"form-control border-input\">{{vm.user.dob | date : \'dd / MM / yyyy\' }}</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Contact</label> <span class=\"form-control border-input\">{{vm.countryCode || \'+91\'}} {{vm.user.phoneNumber || \'9999999999\'}}</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>Date Of Joining</label> <span class=\"form-control border-input\">{{vm.user.createdAt | date : \'dd / MM / yyyy\' }}</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>Grade</label> <span class=\"form-control border-input\">{{vm.grade.join(\', \')}}</span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><div class=\"edit_profile contat_details\"><a style=\"padding: 12px 18px;\" ui-sref=\"dashboard.editprofile\" class=\"btn\">Edit Profile</a></div></div></div></div><div class=\"clearfix\"></div></div></div></div></div>");
$templateCache.put("app/dashboard/subscription/subscription.html","<style>\r\nth.color1, th.color2 {\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\n.kapdec_comptitors td, .kapdec_comptitors th {\r\n    padding: 20px;\r\n}\r\nth.color2 {\r\n    width: 242px;\r\n}\r\n\r\nth.color1, th.color2 {\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\nth.color2 {\r\n    background: #f3772e;\r\n}\r\n.kapdec_comptitors td.first_check {\r\n    background: #fcfcfc;\r\n    text-align: center;\r\n}\r\ntd.second_check {\r\n    text-align: center;\r\n}\r\n.afterDiscountPrice {\r\n    margin-top: 22px;\r\n}\r\n.afterDiscountPrice h2 .priceWrap, .afterDiscountPrice h2 strong{\r\n    color: #f3772e;\r\n}\r\n.afterDiscountPrice .textWrap{\r\n    font-size: 14px;\r\n}\r\n</style><div class=\"content student_classes\"><div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Subscriptions</h3></div><div class=\"col-md-6\"><ul><li><a href=\"#\">Home</a></li><li><span>/</span></li><li>Subscriptions</li></ul></div></div><div class=\"tutorials_background subs_page student_page\"><div class=\"row col-sm-12\"><div class=\"col-sm-9\"></div><div class=\"col-sm-3 pull-right\"><select type=\"text\" class=\"form-control\" ng-model=\"vm.currency\" name=\"currency\" ng-options=\"option.code as option.currency for option in vm.currencies\" ng-change=\"vm.filterSubList(vm.currency)\" required=\"\"><option value=\"\" selected=\"\">Select Currency</option></select><p class=\"help-block text-danger\" ng-show=\"form.currency.$error.required && vm.submitted\">A currency Type is required.</p></div></div><div class=\"row\"><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-6\" ng-repeat=\"subscription in vm.filterSubsList\"><div class=\"student_subscription\"><h3>{{subscription.title}}</h3><div class=\"plans\"><span ng-bind-html=\"subscription.features\"></span></div><div class=\"payments\"><h2><i ng-if=\"vm.currency ==\'IN\'\" class=\"fa fa-rupee-sign fa-2\" style=\"font-size: 31px;vertical-align: super;\"></i> <i ng-if=\"vm.currency ==\'US\'\" class=\"fa fa-usd fa-2\" style=\"font-size: 31px;vertical-align: super;\"></i>{{subscription.amount}} <span ng-if=\"subscription.duration == 30\">/mo</span> <span ng-if=\"subscription.duration == 365\">/year</span></h2></div><div class=\"afterDiscountPrice\"><h2><span class=\"priceWrap\"><sup><i class=\"fa fa-rupee-sign fa-2\" style=\"font-size: 31px;vertical-align: super;\"></i></sup> {{(subscription.amount-(((subscription.amount*subscription.discount)/100).toFixed(2)))}}</span> <span class=\"textWrap\">/After Discount <strong>{{subscription.discount}}%</strong> a year</span></h2></div><div class=\"edit_profile\"><a href=\"javascript:void(0)\" class=\"btn\" ng-click=\"vm.openModal(subscription)\">Upgrade Now</a></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"benifit_learn\"><h3>Benefits in Learning With Kapdec</h3><p>Whether you select a monthly or an annual plan, each plan comes with fully loaded features for 100% effective learning.</p></div><div class=\"kapdec_comptitors\"><table><tr><th></th><th></th><th class=\"color1\">Competitors</th><th class=\"color2\">Kapdec</th></tr><tr><td><strong>Study Materials and Resources</strong></td><td><p>Engaging Video Lectures</p><p>Previous Year Exam Papers With Solutions</p><p>Personalized Reports</p><p>Study Material Aligned with School Curriculum</p><p>Links to Additional Online Resources</p></td><td class=\"first_check\"><p><i class=\"fas fa-check\"></i></p><p>With Premium Fee</p><p>With Premium Fee</p><p>With Premium Fee</p><p>Not Available</p><p><i></i></p><p><i></i></p></td><td class=\"second_check\"><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p></td></tr><tr><td><strong>Learning by Practice</strong></td><td><p>Adaptive Practicing</p><p>Unlimited Access to Practice Questions</p><p>Access to Mental Math Tips</p><p>Infinite Database of Practice Questions</p><p>Exposure to International Level Mathematics</p></td><td class=\"first_check\"><p>With Premium Fee</p><p>With Premium Fee</p><p>Not Available</p><p>Not Available</p><p>Not Available</p></td><td class=\"second_check\"><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p></td></tr><tr><td><strong>Help, Guidance and Collaboration</strong></td><td><p>Doubts Clarification within 24 hours</p><p>Unlimited Doubts Clarification</p><p>Free Access to Join a class (if seats available)</p><p>Discussion Boards</p></td><td class=\"first_check\"><p>With Premium Fee</p><p>With Premium Fee</p><p>Not Available</p><p>With Premium Fee</p></td><td class=\"second_check\"><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p><p><i class=\"fas fa-check\"></i></p></td></tr><tr><td><strong>Scholarships and Rewards</strong></td><td><p>Rewards - on Good performance</p></td><td class=\"first_check\"><p></p><p>Not Available</p><p></p></td><td class=\"second_check\"><p><i class=\"fas fa-check\"></i></p></td></tr></table></div></div></div></div></div>");
$templateCache.put("app/dashboard/test/test.html","<style>\r\n.check-item {\r\n    font-size: 16px;\r\n    margin-bottom: 6px;\r\n}\r\n.disabled-radio::after{\r\n  display: none\r\n}\r\n    </style><div class=\"profile_background text-center\" ng-if=\"!vm.loader && vm.instruction\"><h1><b>Exam Instruction</b></h1><p ng-bind-html=\"vm.instruction.description\"></p><div class=\"edit_profile read_more\"><a class=\"btn\" ng-click=\"vm.getStartExam();\">Start</a></div></div><div class=\"row breadcrumb_section\" ng-if=\"!vm.loader && !vm.instruction\"><div class=\"col-md-6\"><h3 ng-if=\"vm.isQuiz\">Quiz Module :- {{vm.unitName}}</h3><h3 ng-if=\"vm.isQuiz\">Quiz Chapter :- {{vm.chapterName}}</h3><h3 ng-if=\"!vm.isQuiz\">Exam Module :- {{vm.unitName}}</h3></div><div class=\"col-md-6\"></div></div><div class=\"profile_background\" ng-if=\"!vm.loader && !vm.instruction\"><div class=\"question-item\"><h5><p><span>Q{{vm.question.attempt+1}} of {{vm.questionCount}}</span> {{vm.question.data.heading}}</p></h5><p ng-bind-html=\"vm.question.data.questionDescription\" style=\"font-size: 16px;\"></p><h6><span>Answer Choices</span></h6><div class=\"check-item\" ng-repeat=\"option in vm.question.data.answerChoices\" ng-class=\"{\'text-success\': vm.result.data.correctAnswer-1 ==$index }\"><div class=\"custom-control custom-radio\"><input class=\"custom-control-input\" type=\"radio\" id=\"blankRadio{{$index}}\" ng-model=\"vm.selectOption\" name=\"blankRadio\" value=\"{{option.option}}\" aria-label=\"...\"> <label ng-class=\"{\'disabled-radio\': vm.isNext }\" class=\"custom-control-label\" for=\"blankRadio{{$index}}\"><span ng-bind-html=\"option.value\"></span></label></div></div></div><div class=\"edit_profile read_more\"><a ng-if=\"!vm.isNext\" ng-class=\"{\'close-event\': !vm.selectOption }\" ng-click=\"vm.submitAnswer(vm.question.data._id,vm.selectOption)\" class=\"btn\">Submit</a> <a ng-if=\"vm.isNext\" ng-click=\"vm.getQuestion();\" class=\"btn\">Next</a></div><div class=\"col-md-12 animated fadeInLeft\" ng-if=\"vm.isNext\" style=\"padding: 17px;background-color: #f1f1f1;margin-top: 10px;\"><p></p><h5>Result</h5><p></p><p style=\"font-size: 16px;\">Correct Answer :- <span class=\"currect-span\">{{vm.question.data.answerChoices[vm.result.data.correctAnswer-1].value}}</span></p><div class=\"explain-row\"><h6>Explanation</h6><p ng-bind-html=\"vm.explanation\" style=\"font-size: 16px;\"></p></div></div></div>");
$templateCache.put("app/dashboard/tutorial/tutorial.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Tutorials</h3></div><div class=\"col-md-6\"><ul><li><a href=\"#\">Home</a></li><li><span>/</span></li><li>Tutorials</li></ul></div></div><div class=\"tutorials_background\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><select class=\"form-control\" name=\"topic\" id=\"topic\" ng-model=\"vm.tutorial.topic\" ng-change=\"vm.tutorial.unit=\'\';vm.getChapters();vm.getUnits(vm.tutorial.topic);\" required=\"\"><option value=\"\">Select Topic</option><option ng-repeat=\"option in vm.topics track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><select class=\"form-control\" name=\"units\" id=\"units\" ng-model=\"vm.tutorial.unit\" ng-change=\"vm.getChapters()\" required=\"\"><option value=\"\">Select Module</option><option ng-repeat=\"option in vm.units track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select></div></div></div></div><div class=\"check tutorials_content\" ng-repeat=\"chapter in vm.chapters\"><div class=\"row\"><div class=\"col-md-2\"><a href=\"javascript:void(0)\" ng-click=\"vm.viewChapterVideo(chapter._id)\"><img style=\"height: 87px; width: 87px;\" src=\"../assets/img/youtube.png\" alt=\"\"></a></div><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-6\"><h3>{{chapter.name}}</h3></div><div class=\"col-md-6 text-right\"><div class=\"edit_profile read_more\" style=\"margin-top: 0px;\"><a class=\"btn\" ui-sref=\"dashboard.test({ chapterId: chapter._id})\">Take Quiz</a> <a href=\"javascript:void(0)\" ng-click=\"vm.viewChapterContent(chapter._id)\" class=\"btn\">See Description</a></div></div></div><div class=\"row\"><p>{{chapter.summary}}</p></div></div></div></div><div class=\"row\" ng-if=\"vm.tutorial.unit && vm.chapters.length >0\"><div class=\"col-md-2\"><div class=\"edit_profile read_more\"><a class=\"btn\" ui-sref=\"dashboard.test({ unitid: vm.tutorial.unit})\">Take Exam</a></div></div></div>");
$templateCache.put("app/dashboard/test-paper-result/testResult.html","<style>\r\n  .grade-topic {\r\n    font-size: 16px;\r\n}\r\n.main-borader-section {\r\n    padding: 25px;\r\n    border: 1.2px dashed #f3772e;\r\n    border-radius: 15px;\r\n    background: #cccccc36;\r\n}\r\n\r\nh2 {\r\n    text-align: center;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    font-size: 50px;\r\n    color: #5bc236;\r\n}\r\n\r\nh5 {\r\n    text-align: center;\r\n    letter-spacing: 0.5px;\r\n    font-weight: 400;\r\n}\r\n  </style><div class=\"profile_background test-result-page\" ng-if=\"!vm.loader\"><div class=\"main-borader-section\"><div class=\"test-header\" ng-if=\"vm.result.allocatedBadgeID.name\"><div class=\"bronze_images\"><img ng-src=\"{{vm.getImageUrl(vm.result.allocatedBadgeID.logo || vm.result.allocatedBadgeID._id)}}\" alt=\"\"></div><h2>Congratulations!</h2><h5>You have won a {{vm.result.allocatedBadgeID.name}} medal! Keep it up !</h5></div><div class=\"grade-topic\"><div class=\"row\"><div class=\"col-md-6\"><label><strong>Module :-</strong></label> <span>{{vm.result.unit.name}}</span></div><div class=\"col-md-6\"><label><strong>Chapter :-</strong></label> <span>{{vm.result.chapter.name}}</span></div><div class=\"col-md-6\"><label><strong>Total Score :-</strong></label> <span>{{vm.result.totalEarnScore.toFixed(2) }}</span></div><div class=\"col-md-6\"><label><strong>Quiz Value :-</strong></label> <span>{{vm.result.totalScore.toFixed(2) }}</span></div><div class=\"col-md-6\"><label><strong>K-Score :-</strong></label> <span>{{vm.result.obtainPercentage.toFixed(2) }} %</span></div><div class=\"col-md-6\"><label><strong>Badge earned :-</strong></label> <span><i class=\"fa\" ng-class=\"{\'text-success fa-check-circle\': vm.result.isUserPassed, \'fa-times-circle text-danger\': !vm.result.isUserPassed }\"></i> {{vm.result.isUserPassed ? vm.result.allocatedBadgeID.name: \"Keep trying! Practice makes one perfect\"}}</span></div></div></div></div></div>");
$templateCache.put("app/static/FAQs/FAQs.html","<div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>FAQs</strong></li></ul></div></div><div class=\"education_center pt-0\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 faq_heading\"><h1 class=\"head-title pb-5\">Frequently Asked Questions</h1><p>Please read the most common questions asked by users regarding our website and services</p></div></div><div class=\"row\"><div class=\"col-md-3 faq_tabs\"><div class=\"span12\"><form id=\"custom-search-form\" class=\"form-search form-horizontal\"><div class=\"input-append span12\"><input type=\"text\" login-enter=\"vm.getFilteredCat($event)\" ng-model=\"vm.filterOptions.where.q\" class=\"search-query mac-style\" placeholder=\"Search\"> <button ng-click=\"vm.getFilteredCat()\" type=\"submit\" class=\"btn\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button></div></form></div><ul class=\"nav nav-tabs border-bottom-0\" id=\"myTab\" role=\"tablist\"><h5>Browse by Categories</h5><li class=\"nav-item\" ng-repeat=\"cat in vm.category\"><a class=\"nav-link show\" data-toggle=\"tab\" role=\"tab\" ng-click=\"vm.getQuestionById(cat)\" ng-class=\"{\'active\': vm[cat.displayName], \'gray2\': $odd,\'white\': $even }\">{{cat.displayName}}</a></li></ul></div><div class=\"col-md-9 faq_questions\"><div class=\"tab-content\"><div class=\"tab-pane active\" id=\"{{vm.contentId}}\" role=\"tabpanel\"><div id=\"accordion\"><div class=\"card\" ng-repeat=\"ques in vm.question\"><div class=\"card-header\" id=\"headingOne\" style=\"border-bottom:0\"><h5 class=\"mb-0\"><button class=\"btn btn-link collapsed\" data-toggle=\"collapse\" data-target=\"{{\'#collapsea\'+$index}}\" aria-expanded=\"true\" aria-controls=\"{{\'collapsea\'+$index}}\"><span>Q{{$index+1}}. {{ques.askQuestion}}</span></button></h5></div><div id=\"{{\'collapsea\'+$index}}\" class=\"collapse\" aria-labelledby=\"headingOne\" data-parent=\"#accordion\"><div class=\"card-body\"><p ng-bind-html=\"ques.answer\"></p></div></div></div></div></div></div></div></div></div></div><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n       // $(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/aboutUs/about.html","<style>\r\n	.box {\r\n    position: absolute;\r\n    transform: translate(-50%, -50%);\r\n    top: 45%;\r\n    left: 50%;\r\n    width: 90%;\r\n}\r\n.Our-Value h3 {\r\n    font-size: 40px !important;\r\n    color: #495057 !important;\r\n    position: unset !important;\r\n    transform: none !important;\r\n    margin-bottom: 15px;\r\n}\r\n.Our-Value p {\r\n    font-size: 18px !important;\r\n    font-style: normal !important;\r\n    line-height: 30px;\r\n}\r\n.Our-Value {\r\n    margin-top: 0px !important;\r\n    margin-bottom: 30px;\r\n    text-align: center !important;\r\n}\r\n\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>ABOUT KAPDEC</strong></li></ul></div></div><div class=\"container\"><div class=\"main-info\"><h1 class=\"head-title pb-5\">Welcome To Kapdec Education Center</h1><div class=\"mt-5\"><div class=\"row justify-content-center\"><div class=\"col-lg-4 col-md-6\"><div class=\"border border-box\"><div class=\"logo d-flex justify-content-center\"><img src=\"assets/img/unsel_mission.png\" class=\"logo-fit\"></div><h3 class=\"text-center box-title\">Our Mission</h3><p class=\"mb-0\">To be the leading online portal delivering high-quality supplemental education, at the lowest cost in mathematics and non-medical sciences and to help every student achieve his/her full potential in the comfort and safety of their homes.</p></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"border border-box\"><div class=\"logo d-flex justify-content-center\"><img src=\"assets/img/unsel_vision.png\" class=\"logo-fit\"></div><h3 class=\"text-center box-title\">Our Vision</h3><p class=\"mb-0\">Making Student Centric Quality Education Available To All.</p></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"border border-box\"><div class=\"logo d-flex justify-content-center\"><img src=\"assets/img/unsel_value.png\" class=\"logo-fit\"></div><h3 class=\"text-center box-title\">Our Values</h3><p class=\"mb-0\">At Kapdec our foundations rest on the triple helix pillars of trust, honesty, and integrity in everything we do. Our six core foundational principles, guide us in this journey towards student-centric progres- sive excellence in education.</p></div></div></div></div></div><div class=\"sub-info\"><div class=\"row\"><div class=\"col-lg-6 pl-md-5\"><div><h3 class=\"box-title\">Kapdec Education Center</h3><p>At Kapdec our foundations rest on the triple helix pillars of trust, honesty, and integrity in everything we do. Our six core foundational principles, guide us in this journey towards student-centric progres- sive excellence in education.</p></div><div class=\"mt-5\"><h3 class=\"box-title\">Kapdec’s Teaching</h3><p>\"Teaching touches lives forever\", is our belief and our practice. We aim to aid learning without the agony of confusion, strengthen the fundamentals, and provide guidance to improve at each student’s pace while challenging every student to improve continuously. We believe that good quality education should be available to all, and our efforts are to provide an affordable, high-quality education using the tools and technology that appeal to students and leads to making learning simply a natural process.</p></div></div><div class=\"col-lg-6 text-center\"><img src=\"assets/img/image_01.png\" class=\"info-img\"></div></div></div></div><div class=\"slider-bg\"><div class=\"container-fluid\"><div class=\"about-slider\"><div class=\"row mt-5\"><div class=\"col-md-4 pr-0\"><div class=\"arrow-section\"><h4 class=\"arrow-title\">Our special quality</h4></div></div><div class=\"col-md-8\"><div class=\"owl-carousel owl-theme\" id=\"owl-about\"><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">Students First</h3><div class=\"box-about\"><p>\"Teaching touches lives forever\", is our belief and our practice. We aim to aid learning without the agony of confusion, strengthen the fundamentals, and provide guidance to improve at each student’s pace while challenging every student to improve continuously. We believe that good quality education should be available to all, and our efforts are to provide an affordable, high-quality education using the tools and technology that appeal to students and leads to making learning simply a natural process.</p></div></div></div><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">Teachers Build The Nation</h3><div class=\"box-about\"><p>We believe teachers are the most potent medium for imparting knowledge from one generation to next. Our effort is to create an environment of creativity, trust, innovation, and interaction for highly motivated teachers - to aid their efforts in teaching.</p><p>KAPDEC is proud to include in its community such unique teachers, who thrive on their unique skills and aide us in our mission.</p></div></div></div><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">unity in diversity</h3><div class=\"box-about\"><p>We thrive on the diversity of ideas and people generating such ideas, we value and celebrate our differences, yet we are united by our desire to be the best and to be ONE team with one aim- to have a solid foundation of knowledge that lasts a lifetime.</p></div></div></div><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">integrity foremost</h3><div class=\"box-about\"><p>We believe honesty and candor are the foundation of a good organization. We build and thrive on mutually beneficial relations with all our stakeholders - our students, our employees, our customers, our teachers and business partners in this journey of providing education.</p></div></div></div><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">community connection</h3><div class=\"box-about\"><p>We believe dedication to education is about more than merely providing resources for education. We strive to make our resources affordable and hence available to all.</p></div></div></div><div class=\"item\"><div class=\"item-about\"><h3 class=\"box-title title-section\">excellence in everything</h3><div class=\"box-about\"><p>“The Pursuit of Excellence”, is a way of life for everyone at KAPDEC. It is what we strive to achieve every day in every way.</p></div></div></div></div></div></div></div></div></div><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(1)\").addClass(\'active\');\r\n\r\n  \r\n  $(\"#owl-about\").owlCarousel({\r\n		items: 3,\r\n		navigation: true,\r\n		loop: true,\r\n		pagination: false,\r\n		margin: 10,\r\n		autoplay: true,\r\n		autoplayTimeout: \'3000\',\r\n		navContainer: \'#nav\',\r\n		navigationText: [\r\n			\'<img src=\"assets/img/left_arrow.png\" class=\"arrow-img\">\',\r\n			\'<img src=\"assets/img/right_arrow.png\" class=\"arrow-img\">\'\r\n		],\r\n		itemsDesktop : [1199,2.8],\r\n		itemsDesktopSmall : [980,2],\r\n		itemsTablet: [768,2],\r\n		itemsMobile : [479,1]\r\n  });\r\n  \r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/contactUs/contact.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>CONTACT US</strong></li></ul></div></div><div class=\"education_center pt-0\"><div class=\"container\"><div class=\"msg-info\"><h1 class=\"head-title pb-5\">Send us a message</h1><p class=\"col-lg-12 head-text text-center my-4\">Facing issues? Have suggestions? Send us an email and one of our agent will contact you with in 24 hours. Please do not forget to provide your phone number, if you would like us to call you!</p></div><div class=\"row\"><div class=\"col-lg-8 offset-lg-2 contact-info\"><form id=\"contact\" ng-submit=\"vm.contactUs(contactForm)\" novalidate=\"\" name=\"contactForm\" class=\"form contact-form\" role=\"form\"><div class=\"row justify-content-center\"><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': contactForm.firstName.$valid && vm.submitted, \'has-error\': contactForm.firstName.$invalid && vm.submitted }\"><input type=\"text\" ng-minlength=\"3\" maxlength=\"25\" ng-pattern=\"vm.pattern.name\" class=\"form-control form-box\" name=\"firstName\" ng-model=\"vm.contact.firstName\" placeholder=\"First Name*\" autofocus=\"\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"contactForm.firstName.$error.required && vm.submitted\">Please enter First name.</span> <span class=\"help-block text-danger\" ng-show=\"contactForm.firstName.$error.pattern && vm.submitted\">Doesn\'t look like a valid First Name.</span></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': contactForm.lastName.$valid && vm.submitted, \'has-error\': contactForm.lastName.$invalid && vm.submitted }\"><input type=\"text\" ng-minlength=\"3\" maxlength=\"25\" ng-pattern=\"vm.pattern.name\" class=\"form-control form-box\" name=\"lastName\" ng-model=\"vm.contact.lastName\" placeholder=\"Last Name*\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"contactForm.lastName.$error.required && vm.submitted\">Please enter Last name.</span> <span class=\"help-block text-danger\" ng-show=\"contactForm.lastName.$error.pattern && vm.submitted\">Doesn\'t look like a valid Last Name.</span></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': contactForm.contactNo.$valid && vm.submitted, \'has-error\': contactForm.contactNo.$invalid && vm.submitted }\"><input type=\"text\" numbers-only=\"\" class=\"form-control form-box\" name=\"contactNo\" ng-minlength=\"8\" maxlength=\"15\" ng-model=\"vm.contact.contactNo\" ng-pattern=\"vm.pattern.contact\" placeholder=\"Contact No*\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"contactForm.contactNo.$error.pattern && vm.submitted\">Doesn\'t look like a valid contact No.</span> <span class=\"help-block text-danger\" ng-show=\"contactForm.contactNo.$error.required && vm.submitted\">Please enter contact no.</span></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': contactForm.email.$valid && vm.submitted, \'has-error\': contactForm.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control form-box\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.contact.email\" placeholder=\"Email*\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"contactForm.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</span> <span class=\"help-block text-danger\" ng-show=\"contactForm.email.$error.required && vm.submitted\">Please enter your email address.</span></div><div class=\"col-lg-10 form-group\" ng-class=\"{ \'has-success\': contactForm.message.$valid && vm.submitted, \'has-error\': contactForm.message.$invalid && vm.submitted }\"><textarea style=\"height:170px;resize:none;\" ng-model=\"vm.contact.message\" name=\"message\" maxlength=\"500\" class=\"form-control contact-msg\" placeholder=\"Message\" required=\"\">  </textarea><div class=\"text-right text-muted\"><span class=\"main-counter-container\"><span id=\"message-char\">{{vm.contact.message.length || 0 }}</span>/500</span> <span class=\"help-block text-danger\" ng-show=\"contactForm.message.$error.minlength && vm.submitted\">A proper message is required ( min 15 character).</span> <span class=\"help-block text-danger\" style=\"float:left\" ng-show=\"contactForm.message.$error.required && vm.submitted\">A message is required.</span></div></div><div class=\"col-md-12 text-center\"><input type=\"submit\" name=\"submit\" class=\"btn btn-pink\" value=\"Send\"></div></div></form></div></div><div class=\"row my-5 align-items-center\"><div class=\"col-lg-8 col-md-12\"><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14022.151584352643!2d77.20014063194795!3d28.523547719372864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce1f0dd053fdd%3A0x97d95c1a5860139f!2sSaket%2C+New+Delhi%2C+Delhi+110017!5e0!3m2!1sen!2sin!4v1550062363001\" width=\"100%\" height=\"420\" frameborder=\"0\" style=\"border:0\" allowfullscreen=\"\" class=\"map-frame\"></iframe></div><div class=\"col-lg-4 col-md-12\"><div class=\"address-info\"><h1 class=\"address-title\">Keep in Touch</h1><h4><strong>Kapdec</strong></h4><p class=\"mt-4 pb-2\"><strong>Corp. Office:</strong> 26753,<br>Annesley RD,<br>Beachwood,<br>OH – 44122, USA.</p><p>B-8, Noida One,<br>C-722A, Noida,<br>UP – 201309, India.</p></div></div></div></div></div><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(5)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/career/career.html","<style>\r\n  .carrer p {\r\n    margin: 0px 0px 0px 0px !important;\r\n  }\r\n  div.education_center_text h2{color: #000000;}\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Career</strong></li></ul></div></div><div class=\"education_center pt-0\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-7 education_center_text\"><h2>Opportunities Available</h2><p>We are seeking a Maths Teacher.</p><p>In order to promote our products and develop sales in the market, we are seeking a regional sales manager closely involved in the field of healthcare. You will benefit from all technical and marketing support as well as personalized training and guidance.</p><p>Hygie employees are known for their passion, innovation and for achieving results.</p></div><div class=\"col-md-5 education_images\"><img src=\"assets/img/carrer.jpg\" alt=\"\"></div></div></div></div><div class=\"carrer\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"head-title pb-5\">Send us your CV</h1><p class=\"career-header\">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p></div></div><div class=\"row\"><div class=\"col-lg-8 offset-lg-2 contact-info\" style=\"float:none\"><form id=\"contact\" ng-submit=\"vm.careerApply(careerForm)\" novalidate=\"\" name=\"careerForm\" class=\"form contact-form\" role=\"form\"><div class=\"row justify-content-center\"><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': careerForm.firstName.$valid && vm.submitted, \'has-error\': careerForm.firstName.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control form-box\" name=\"firstName\" ng-minlength=\"3\" maxlength=\"20\" ng-pattern=\"vm.pattern.name\" ng-model=\"vm.career.firstName\" placeholder=\"First Name*\" autofocus=\"\" required=\"\"><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.firstName.$error.required && vm.submitted\">Please enter First name.</p><p class=\"help-block text-left\" ng-show=\"careerForm.firstName.$error.pattern && vm.submitted\">Doesn\'t look like a valid First Name.</p></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': careerForm.lastName.$valid && vm.submitted, \'has-error\': careerForm.lastName.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control form-box\" ng-minlength=\"3\" maxlength=\"20\" ng-pattern=\"vm.pattern.name\" name=\"lastName\" ng-model=\"vm.career.lastName\" placeholder=\"Last Name*\" required=\"\"><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.lastName.$error.required && vm.submitted\">Please enter Last name.</p><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.lastName.$error.pattern && vm.submitted\">Doesn\'t look like a valid Last Name.</p></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': careerForm.contactNo.$valid && vm.submitted, \'has-error\': careerForm.contactNo.$invalid && vm.submitted }\"><input type=\"text\" class=\"form-control form-box\" numbers-only=\"\" name=\"contactNo\" ng-minlength=\"8\" maxlength=\"15\" ng-model=\"vm.career.contactNumber\" ng-pattern=\"vm.pattern.contact\" placeholder=\"Contact No*\" autofocus=\"\" required=\"\"><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.contactNo.$error.pattern && vm.submitted\">Doesn\'t look like a valid contact No.</p><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.contactNo.$error.required && vm.submitted\">Please enter contact no.</p></div><div class=\"col-lg-5 col-md-6 form-group\" ng-class=\"{ \'has-success\': careerForm.email.$valid && vm.submitted,\'has-error\': careerForm.email.$invalid && vm.submitted }\"><input type=\"email\" class=\"form-control form-box\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.career.email\" placeholder=\"Email*\" required=\"\"><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.email.$error.pattern && vm.submitted\">Doesn\'t look like a valid email.</p><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.email.$error.required && vm.submitted\">Please enter email address.</p></div><div class=\"col-lg-10 col-md-12 form-group\"><label class=\"w-100\">Upload Your CV<em>*</em></label> <input type=\"file\" name=\"file\" class=\"hidden\" id=\"uploadTrigger\" accept=\".doc, .docx, .pdf, .txt\" required=\"\"><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"(careerForm.file.$error.required || !vm.career.resume) && vm.submitted\">Please select only pdf file format only.</p></div><div class=\"col-lg-10 col-md-12 form-group\"><input id=\"remember-me\" name=\"aggreed\" ng-model=\"vm.career.agree\" type=\"checkbox\" required=\"\"> <label for=\"remember\">I agree to <a ui-sref=\"index.terms\" target=\"_blank\">Terms and Conditions</a> & <a ui-sref=\"index.privacy\" target=\"_blank\">Privacy Policy</a>.</label><p class=\"help-block text-left\" style=\"color:red\" ng-show=\"careerForm.aggreed.$invalid && vm.submitted\">Please accept Term and Condition.</p></div><div class=\"col-md-12 form-group text-center\"><input type=\"submit\" name=\"submit\" class=\"btn btn-pink\" value=\"Send Your CV\"></div></div></form></div></div></div></div><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        //$(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/howitworks/howitworks.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><style>\r\n		.aboutinner p {color: #495057;line-height: 30px;font-size: 16px;letter-spacing: 0.3px;margin-bottom: 10px;}\r\n		.aboutinner h2 {font-weight: 600;}\r\n	\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Kapdec’s Philosophy</strong></li></ul></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text\"><h1 class=\"head-title pb-5\">Creating a perfect content</h1></div></div></div><div class=\"education_center how_work pb-lg-5 mb-lg-5\"><div class=\"container\"><div class=\"animation-content animation-contentt1 d-flex align-items-center justify-content-center flex-column\" id=\"animation-content1\"><div class=\"row rowanimate1\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-1.svg\" class=\"img-fluid\"></div><div class=\"col-md-6 wow fadeInDown\"><h4>Curriculum design</h4><h5>We establish the foundation to ensure that every topic our students study is in alignment with the state standards.</h5></div></div></div></div><div class=\"road-map wow fadeIn roadmap-revert\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"#animation-content2\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext1\">Next</a></div></div><div class=\"animation-content animation-contentt2 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content2\"><div class=\"row textshow1\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><h4>Curriculum Validation</h4><h5>Done by subject matter experts to ensure 100% coverage of board (curriculum) requirements.</h5></div><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-2.svg\" class=\"img-fluid\"></div></div></div></div><div class=\"road-map wow fadeIn\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"javascript:void(0)\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext2\">Next</a></div></div><div class=\"animation-content animation-contentt3 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content3\"><div class=\"row textshow2 align-items-center\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-3.svg\" class=\"img-fluid\"></div><div class=\"col-md-6 wow fadeInDown\"><h4>Development of Study Material</h4><h5>Our global team of top educators in India and the USA creates the study material relevant to a curriculum offered by Kapdec.</h5></div></div></div></div><div class=\"road-map wow fadeIn roadmap-revert\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"javascript:void(0)\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext3\">Next</a></div></div><div class=\"animation-content animation-contentt4 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content4\"><div class=\"row align-items-center\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><h4>Development of Instructional Video</h4><h5>Engaging, simple and effective. Period.</h5></div><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-4.svg\" class=\"img-fluid\"></div></div></div></div><div class=\"road-map wow fadeIn\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"javascript:void(0)\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext4\">Next</a></div></div><div class=\"animation-content animation-contentt5 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content5\"><div class=\"row align-items-center\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-5.svg\" class=\"img-fluid\"></div><div class=\"col-md-6 wow fadeInDown\"><h4>Development of Practice Questions Test Bank</h4><h5>Our large and unique data base is fast approach 1 million questions. Our students will positively beat the competition.</h5></div></div></div></div><div class=\"road-map wow fadeIn roadmap-revert\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"javascript:void(0)\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext5\">Next</a></div></div><div class=\"animation-content animation-contentt6 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content6\"><div class=\"row align-items-center\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><h4>Triple Quality Check</h4><h5>A highly trained team of subject matter experts check everything, yes they do it “three” times.</h5></div><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-6.svg\" class=\"img-fluid\"></div></div></div></div><div class=\"road-map wow fadeIn\" data-wow-delay=\"0.8s\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"760\" height=\"270\" viewbox=\"0 0 760 270\"><path class=\"cls-1\" d=\"M18.117,300V250.200c0-110.316,110.5-122.300,125.5-122.300H250.50C744,124.951,744,140.362,744,10.3V-100.4c0-137.741-158.739-139.539-158.739-139.300H100.600C0-272.943,0-469\"></path></svg><div class=\"svg-img\"><span><img src=\"assets/img/logo-animate.png\"></span></div><a href=\"javascript:void(0)\" class=\"animatenext wow fadeIn\" data-wow-delay=\"3s\" id=\"animatenext6\">Next</a></div></div><div class=\"animation-content animation-contentt7 d-flex align-items-center flex-column justify-content-center\" id=\"animation-content7\"><div class=\"row align-items-center\"><div class=\"col-lg-10 offset-lg-1\"><div class=\"row align-items-center\"><div class=\"col-md-6 wow fadeInDown\"><img src=\"assets/img/step-7.svg\" class=\"img-fluid\"></div><div class=\"col-md-6 wow fadeInDown\"><h4>Delivered, a Unique Content</h4><h5>Finally, we deliver to you, a wonderful collection of content & information available at your finger-tips.</h5></div></div></div></div><div class=\"road-map wow fadeIn d-flex justify-content-center mt-4\" data-wow-delay=\"0.4s\"><a href=\"javascript:void(0)\" class=\"btn-pink wow fadeIn\" id=\"animatenext7\">Back to top</a></div></div></div></div><script>\r\n    $(document).ready(function () {\r\n	//	$(\'body\').addClass(\'howbody\');\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n		$(\".navbar-nav li:eq(2)\").addClass(\'active\');\r\n		$(\'body\').addClass(\'howitworks-body\');\r\n		$(\'html\').addClass(\'howitworks-html\');\r\n		new WOW().init();\r\n		setTimeout(function(){\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content1\").offset().top\r\n			}, 1000);\r\n		},1000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content2\').addClass(\'animate-show1\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content2\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext1\').hide();\r\n		},5000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content3\').addClass(\'animate-show2\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content3\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext2\').hide();\r\n		},10000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content4\').addClass(\'animate-show3\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content4\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext3\').hide();\r\n		},15000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content5\').addClass(\'animate-show4\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content5\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext4\').hide();\r\n		},20000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content6\').addClass(\'animate-show5\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content6\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext5\').hide();\r\n		},25000);\r\n		setTimeout(function(){\r\n			$(\'#animation-content7\').addClass(\'animate-show6\');\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\"#animation-content7\").offset().top\r\n			}, 1000);\r\n			$(\'#animatenext6\').hide();\r\n		},30000);\r\n		$(\'#animatenext7\').on(\'click\', function(event) {\r\n			$(\'.howitworks-body,.howitworks-html\').animate({\r\n				scrollTop: $(\'header\').offset().top\r\n			}, 2000);\r\n		});\r\n  	// $(\"#animatenext1\").on(\'click\', function(event) {\r\n	// 	$(\'#animation-content2\').addClass(\'animate-show1\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content2\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext1\').hide();\r\n	// 	new WOW().init();\r\n  	// });\r\n  	// $(\'#animatenext2\').on(\'click\', function(event) {\r\n	// 	$(\'#animation-content3\').addClass(\'animate-show2\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content3\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext2\').hide();\r\n	// 	new WOW().init();\r\n	// });\r\n	// $(\'#animatenext3\').on(\'click\', function(event) {\r\n	// 	$(\'#animation-content4\').addClass(\'animate-show3\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content4\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext3\').hide();\r\n	// 	new WOW().init();\r\n	// });\r\n	// $(\'#animatenext4\').on(\'click\', function(event) {\r\n	// 	$(\'#animation-content5\').addClass(\'animate-show4\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content5\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext4\').hide();\r\n	// 	new WOW().init();\r\n	// });\r\n	// $(\'#animatenext5\').on(\'click\', function(event) {\r\n	// 	$(\'#animation-content6\').addClass(\'animate-show5\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content6\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext5\').hide();\r\n	// 	new WOW().init();\r\n	// });\r\n	// $(\'#animatenext6\').on(\'click\', function(event) {\r\n	// 	$(\'#animation-content7\').addClass(\'animate-show6\');\r\n	// 	$(\'html, body\').animate({\r\n	// 		scrollTop: $(\"#animation-content7\").offset().top\r\n	// 	}, 1000);\r\n	// 	$(\'#animatenext6\').hide();\r\n	// 	new WOW().init();\r\n	// });\r\n    })\r\n\r\n    </script>");
$templateCache.put("app/static/privacy/privacy.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><style>\r\n    .Term-Condtion-Section h2 {\r\n        color: #495057;\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .Term-Condtion-Section p {\r\n        color: #495057;\r\n        line-height: 30px;\r\n        font-size: 16px;\r\n        letter-spacing: 0.3px;\r\n        margin-bottom: 10px;\r\n        width: 100%;\r\n    }\r\n\r\n    .Term-Condtion-Section h2 {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .Term-Condtion-Section h3 {\r\n        font-size: 18px;\r\n        font-weight: 600;\r\n        letter-spacing: 0.5px;\r\n        color: #ea2188;\r\n        margin-top: 15px;\r\n        font-family: \'proxima_novabold\';\r\n        width: 100%;\r\n    }\r\n\r\n    .Term-Condtion-Section a {\r\n        color: #f3772e;\r\n        text-decoration: underline;\r\n    }\r\n\r\n    .Term-Condtion-Section ul {\r\n        float: left;\r\n        width: 100%;\r\n        padding: 0px;\r\n        margin: 0px auto;\r\n    }\r\n\r\n        .Term-Condtion-Section ul li {\r\n            line-height: 30px;\r\n            list-style: none;\r\n            position: relative;\r\n            padding-left: 25px;\r\n            font-size: 16px;\r\n            letter-spacing: 0.5px;\r\n        }\r\n\r\n    .Term-Condtion-Section .panel-group {\r\n        float: left;\r\n        width: 100%;\r\n        margin: 15px auto;\r\n    }\r\n\r\n    .Term-Condtion-Section ul li:before {\r\n        content: \"\";\r\n        background-color: #7fafc9;\r\n        width: 8px;\r\n        height: 8px;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 12px;\r\n        -webkit-transition: all 0.3s;\r\n        -moz-transition: all 0.3s;\r\n        -o-transition: all 0.3s;\r\n        -ms-transition: all 0.3s;\r\n        transition: all 0.3s;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .Term-Condtion-Section h2 {\r\n      margin-top: 15px;\r\n    margin-bottom: 10px;\r\n    background: #f5f5f5;\r\n    padding: 10px 15px;\r\n    border-radius: 3px;\r\n    color: #333;\r\n    width: 100%;\r\n    }\r\n\r\n    .Term-Condtion-Section h4.panel-title a {\r\n        font-size: 16px;\r\n        letter-spacing: 0.5px;\r\n        text-decoration: none;\r\n        font-weight: 600;\r\n        color: #032e6b;\r\n    }\r\n\r\n    .Term-Condtion-Section .panel-group .panel-default .panel-collapse .panel-body ol li {\r\n        line-height: 30px;\r\n    }\r\n\r\n    .Term-Condtion-Section .panel-group .panel-default .panel-collapse .panel-body ol li {\r\n        line-height: 30px;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .Term-Condtion-Section .panel-group .panel-default .panel-heading {\r\n        padding: 0px;\r\n        display: inline-block;\r\n        width: 100%;\r\n    }\r\n\r\n        .Term-Condtion-Section .panel-group .panel-default .panel-heading h4.panel-title {\r\n            display: inline-block;\r\n            width: 100%;\r\n        }\r\n\r\n            .Term-Condtion-Section .panel-group .panel-default .panel-heading h4.panel-title a {\r\n                float: left;\r\n                width: 100%;\r\n                padding: 15px;\r\n                font-weight: 400;\r\n            }\r\n            /* .Term-Condtion-Section h2 {\r\n    margin-top: 15px;\r\n    margin-bottom: 10px;\r\n    background: #7fafc9;\r\n    padding: 15px;\r\n    border-radius: 3px;\r\n    color: #fff;\r\n} */\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Privacy Policy</strong></li></ul></div></div><section class=\"education_center py-2\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text contact_us\"><main id=\"main\"><section class=\"Term-Condtion-Section\"><div class=\"container\"><div class=\"row\"><p ng-bind-html=\"vm.content.content\"></p></div></div></section></main></div></div></div></section><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        //$(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/notFound404/notFound.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><div class=\"container text-center\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"error-template\"><h1><b>Oops!</b></h1><h2><b>404 Not Found</b></h2><div class=\"error-details\"><h3>Sorry, an error has occured, Requested page not found!</h3></div><div class=\"error-actions\"><a ng-click=\"vm.getmeHome();\" class=\"btn btn-info btn-lg clr-white\"><span class=\"glyphicon glyphicon-home\"></span> Take Me Home</a> <a ng-click=\"vm.getmeContact();\" class=\"btn btn-warning btn-lg clr-whitex\"><span class=\"glyphicon glyphicon-envelope\"></span> Contact Support</a></div><br></div></div></div></div>");
$templateCache.put("app/static/sitemap/sitemap.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><div class=\"about_banner\"><div class=\"container\"><div class=\"row\"><div class=\"breadcrumb\"><div class=\"col-md-6\"><h1>Sitemap</h1></div><div class=\"col-md-6 pull-right\"><ul><li><a ui-sref=\"index.home\">Home</a></li><li>/</li><li>Sitemap</li></ul></div></div></div></div></div><section class=\"education_center\"><div class=\"page_section\"><div class=\"sitemap_page\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"elementor-widget-container\"><div class=\"elementor-text-editor elementor-clearfix\"><ul><li><a ui-sref=\"index.home\">Home</a></li><li><a ui-sref=\"index.about\">About us</a></li><li><a ui-sref=\"index.howItWorks\">How It Works</a></li><li><a ui-sref=\"index.stories\">Stories</a></li><li><a ui-sref=\"index.contact\">Contact Us</a></li><li><a ui-sref=\"index.career\">Career</a></li><li><a ui-sref=\"index.terms\">Terms & Conditions</a></li><li><a ui-sref=\"index.privacy\">Privacy Policy</a></li><li><a ui-sref=\"index.FAQs\">FAQs</a></li></ul></div></div></div></div></div></div></div></section><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        //$(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/team/team.html","<style>\r\n	.box {\r\n    position: absolute;\r\n    transform: translate(-50%, -50%);\r\n    top: 45%;\r\n    left: 50%;\r\n    width: 90%;\r\n}\r\n.Our-Value h3 {\r\n    font-size: 40px !important;\r\n    color: #495057 !important;\r\n    position: unset !important;\r\n    transform: none !important;\r\n    margin-bottom: 15px;\r\n}\r\n.Our-Value p {\r\n    font-size: 18px !important;\r\n    font-style: normal !important;\r\n    line-height: 30px;\r\n}\r\n.Our-Value {\r\n    margin-top: 0px !important;\r\n    margin-bottom: 30px;\r\n    text-align: center !important;\r\n}\r\n\r\n.stitle2, .meet-professors .stitle{\r\n	color:#495057 !important;\r\n}\r\n\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Our Team</strong></li></ul></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text\"><h1 class=\"head-title pb-5\">Our Team</h1></div></div></div><div class=\"meet-professors py-lg-5 my-3\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row mx-0\"><div class=\"col-md-4 col-sm-6 px-0 team-list\" ng-repeat=\"team in vm.teams\"><img ng-src=\"{{vm.getImageUrl(team.profilePicture)}}\" onerror=\"this.src=\'assets/img/professor1.jpg\'\" alt=\"{{team.name}}\" src=\"assets/img/professor1.jpg\"><div class=\"team-name\"><a href=\"javacript:void(0)\" id=\"team{{team._id}}\" class=\"team-listt\" data-teamid=\"{{team._id}}\" data-toggle=\"modal\" data-target=\"#myModal{{team._id}}\"><h5>{{team.name}}</h5><strong>{{team.designation || team.profession }}</strong></a></div></div><div class=\"pt-md-5 pt-2 col-md-12 d-flex justify-content-center more-team\"><a href=\"javacript:void(0)\" class=\"btn-pink team-listt\" data-teamid=\"{{vm.teams[0]._id}}\" data-toggle=\"modal\" data-target=\"#myModal{{vm.teams[0]._id}}\">More</a></div></div></div></div></div><div ng-repeat=\"team in vm.teams\"><div class=\"modal fade\" role=\"dialog\" id=\"myModal{{team._id}}\"><div class=\"modal-dialog modal-xl modal-dialog-centered\"><div class=\"modal-content p-0 carousel-controlteam\"><a class=\"carousel-control-prev\" href=\"#carouselExampleControls{{team._id}}\" role=\"button\" data-slide=\"prev\"><img src=\"assets/img/left_arrow.png\"></a> <a class=\"carousel-control-next\" href=\"#carouselExampleControls{{team._id}}\" role=\"button\" data-slide=\"next\"><img src=\"assets/img/right_arrow.png\"></a><div id=\"carouselExampleControls{{team._id}}\" class=\"carousel team-carousel slide\" data-ride=\"carousel\"><div class=\"carousel-inner\"><div class=\"carousel-item\" id=\"carousel{{team._id}}\" ng-repeat=\"team in vm.teams\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"p-3 pr-0\"><div class=\"team-popup-top\"><button type=\"button\" class=\"text-uppercase\" data-dismiss=\"modal\">< Back to team</button></div><div class=\"team-popup p-lg-4 py-3\"><h3 class=\"text-capitalize\">{{team.name}}</h3><strong>{{team.designation || team.profession }}</strong><p class=\"pt-4\">{{team.brief}}</p><ul class=\"team-social\"><li><a ng-href=\"team.fbProfileUrl\"><i class=\"fa fa-facebook-f\"></i></a></li><li><a ng-href=\"team.twitterProfileUrl\"><i class=\"fa fa-twitter\"></i></a></li><li><a ng-href=\"team.linkdnProfileUrl\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i></a></li><li><a href=\"\"><i class=\"fa fa-google-plus\" aria-hidden=\"true\"></i></a></li></ul></div></div></div><div class=\"col-md-7\"><div class=\"profile-imgteam\"><img ng-src=\"{{vm.getImageUrl(team.profilePicture)}}\" onerror=\"this.src=\'assets/img/professor1.jpg\'\" alt=\"{{team.name}}\" src=\"assets/img/professor1.jpg\"></div></div></div></div></div></div></div></div></div></div><link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n		});\r\n		\r\n		$(\".navbar-nav li:eq(1)\").addClass(\'active\');\r\n	});\r\n	$(document).on(\'click\', \'.team-listt\', function(){\r\n			var cid = $(this).data(\'teamid\');\r\n			$(\'#myModal\'+cid + \' .carousel-item\').removeClass(\'active\');\r\n			$(\'#myModal\'+cid + \' #carousel\'+cid).addClass(\'active\');\r\n    })\r\n\r\n</script></div>");
$templateCache.put("app/static/termsCondition/tc.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><style>\r\n    .Term-Condtion-Section h2 {color: #000000;font-size: 30px;font-weight: 600;}\r\n            .Term-Condtion-Section p {\r\n                color: #495057;\r\n                line-height: 30px;\r\n                font-size: 16px;\r\n                letter-spacing: 0.3px;\r\n                margin-bottom: 10px;\r\n            }\r\n            .Term-Condtion-Section h2 {\r\n                font-family: \'proxima_novabold\';\r\n            }\r\n            .Term-Condtion-Section h3 {\r\n                font-size: 18px;\r\n                font-family: \'proxima_novabold\';\r\n                letter-spacing: 0.5px;\r\n                color: #ea2188;\r\n                margin-bottom: 10px;\r\n            }\r\n            .Term-Condtion-Section a {\r\n                color: #f3772e;\r\n                text-decoration: underline;\r\n            }\r\n            \r\n  </style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Terms & Conditions</strong></li></ul></div></div><section class=\"education_center pt-0\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text contact_us\"><section class=\"Term-Condtion-Section\"><div class=\"container\"><p ng-bind-html=\"vm.content.content\"></p></div></section></div></div></div></section><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        //$(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/static/subscription/subscription.html","<link type=\"text/css\" rel=\"stylesheet\" href=\"assets/css/style.css\"><link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.7.2/css/all.css\"><style>\r\n    .term-condition-Heading h2 {\r\n        color: #495057;\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .term-condition-Heading p {\r\n        color: #495057;\r\n        line-height: 30px;\r\n        font-size: 16px;\r\n        letter-spacing: 0.3px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .term-condition-Heading h2 {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .term-condition-Heading h3 {\r\n        font-size: 18px;\r\n        font-weight: 600;\r\n        letter-spacing: 0.5px;\r\n        color: #032e6b;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .term-condition-Heading a {\r\n        color: #f3772e;\r\n        text-decoration: underline;\r\n    }\r\n\r\n    .term-condition-Heading ul {\r\n        float: left;\r\n        width: 100%;\r\n        padding: 0px;\r\n        margin: 0px auto;\r\n    }\r\n\r\n        .term-condition-Heading ul li {\r\n            line-height: 30px;\r\n            list-style: none;\r\n            position: relative;\r\n            padding-left: 25px;\r\n            font-size: 16px;\r\n            letter-spacing: 0.5px;\r\n        }\r\n\r\n    .term-condition-Heading .panel-group {\r\n        float: left;\r\n        width: 100%;\r\n        margin: 15px auto;\r\n    }\r\n\r\n    .term-condition-Heading ul li:before {\r\n        content: \"\";\r\n        background-color: #7fafc9;\r\n        width: 8px;\r\n        height: 8px;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 12px;\r\n        -webkit-transition: all 0.3s;\r\n        -moz-transition: all 0.3s;\r\n        -o-transition: all 0.3s;\r\n        -ms-transition: all 0.3s;\r\n        transition: all 0.3s;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .term-condition-Heading ul h2 {\r\n        margin-top: 15px;\r\n        margin-bottom: 10px;\r\n        background: #7fafc9;\r\n        padding: 15px;\r\n        border-radius: 3px;\r\n        color: #fff;\r\n    }\r\n\r\n    .term-condition-Heading h4.panel-title a {\r\n        font-size: 16px;\r\n        letter-spacing: 0.5px;\r\n        text-decoration: none;\r\n        font-weight: 600;\r\n        color: #032e6b;\r\n    }\r\n\r\n    .term-condition-Heading .panel-group .panel-default .panel-collapse .panel-body ol li {\r\n        line-height: 30px;\r\n    }\r\n\r\n    .term-condition-Heading .panel-group .panel-default .panel-collapse .panel-body ol li {\r\n        line-height: 30px;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .term-condition-Heading .panel-group .panel-default .panel-heading {\r\n        padding: 0px;\r\n        display: inline-block;\r\n        width: 100%;\r\n    }\r\n\r\n        .term-condition-Heading .panel-group .panel-default .panel-heading h4.panel-title {\r\n            display: inline-block;\r\n            width: 100%;\r\n        }\r\n\r\n            .term-condition-Heading .panel-group .panel-default .panel-heading h4.panel-title a {\r\n                float: left;\r\n                width: 100%;\r\n                padding: 15px;\r\n                font-weight: 400;\r\n            }\r\n            .student_subscription {\r\n    padding: 20px 20px 40px 20px;\r\n    background: #fff;\r\n    border-top: 10px solid #586377;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n}\r\n.student_subscription, .subs_page .subscription_container, .discussion, .check.tutorials_content, .content.tutorial_pages .check, .profile_background, .card.mb-5 {\r\n    box-shadow: 1px 1px 5px #d4cfcf;\r\n}\r\n.subscriptionItems {\r\n    margin-bottom: 20px;\r\n}\r\n.kapdec_comptitors tr {\r\n    border-bottom: 1px solid #ddd;\r\n}\r\nth.color1 {\r\n    background: #333;\r\n}\r\n\r\nth.color1, th.color2 {\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\n.kapdec_comptitors td, .kapdec_comptitors th {\r\n    padding: 20px;\r\n}\r\nth.color2 {\r\n    width: 242px;\r\n}\r\n\r\nth.color1, th.color2 {\r\n    color: #fff;\r\n    text-align: center;\r\n}\r\nth.color2 {\r\n    background: #f3772e;\r\n}\r\n.kapdec_comptitors td.first_check {\r\n    background: #fcfcfc;\r\n    text-align: center;\r\n}\r\ntd.second_check {\r\n    text-align: center;\r\n}\r\n.afterDiscountPrice {\r\n    margin-top: 22px;\r\n}\r\n.afterDiscountPrice h2 .priceWrap, .afterDiscountPrice h2 strong{\r\n    color: #f3772e;\r\n}\r\n.afterDiscountPrice .textWrap{\r\n    font-size: 14px;\r\n}\r\n</style><div class=\"breadcrumb\"><div class=\"container\"><ul><li><img src=\"assets/img/home.png\" class=\"home-img\"></li><li><a ui-sref=\"index.home\">HOME</a></li><li><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></li><li><strong>Pricing</strong></li></ul></div></div><section class=\"education_center py-0\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 education_center_text contact_us pb-lg-5 mb-md-5 mb-3\"><main id=\"main\"><section class=\"Term-Condtion-Section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"benefit-info\"><h1 class=\"head-title pb-5\">Benefits in learning with kapdec</h1><h5 class=\"col-lg-10 offset-lg-1 text-center my-md-5 my-3\">Whether you select a monthly or an annual plan, each plan comes with fully loaded features for 100% effective learning.</h5></div><div class=\"row\"><div class=\"col-lg-8 offset-lg-2 pricing-box\"><div class=\"row\"><div class=\"col-lg-6 col-7 pricing-title\"><strong class=\"text-color\">Study Materials and Resources</strong></div><div class=\"col-lg-3 col-3 competitors-bg pricing-title\"><strong class=\"text-color\">Competitors</strong></div><div class=\"col-lg-3 col-2 kapdec-bg pricing-title\"><strong class=\"text-color\">Kapdec</strong></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Engaging Video Lectures</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Previous Year Exam Papers With Solutions</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Personalized Reports</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Study Material Aligned with School Curriculum</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Links to Additional Online Resources</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 pricing-title\"><strong class=\"text-color\">Learning by Practice</strong></div><div class=\"col-lg-3 col-3 competitors-bg\"></div><div class=\"col-lg-3 col-2 kapdec-bg\"></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Adaptive Practicing</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Unlimited Access to Practice Questions</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Access to Mental Math Tips</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Infinite Database of Practice Questions</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 main-data\"><p>Exposure to International Level Mathematics</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 pricing-title\"><strong class=\"text-color\">Help, Guidance and Collaboration</strong></div><div class=\"col-lg-3 col-3 competitors-bg\"></div><div class=\"col-lg-3 col-2 kapdec-bg\"></div><div class=\"col-lg-6 col-7 main-data\"><p>Doubts Clarification within 24 hours</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div><div class=\"col-lg-6 col-7 main-data\"><p>Unlimited Doubts Clarification</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div><div class=\"col-lg-6 col-7 main-data\"><p>Free Access to Join a class (if seats available)</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div><div class=\"col-lg-6 col-7 main-data\"><p>Discussion Boards</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>With Premium Fee</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div><div class=\"row\"><div class=\"col-lg-6 col-7 pricing-title\"><strong class=\"text-color\">Scholarships and Rewards</strong></div><div class=\"col-lg-3 col-3 competitors-bg\"></div><div class=\"col-lg-3 col-2 kapdec-bg\"></div><div class=\"col-lg-6 col-7 main-data\"><p>Rewards - on Good performance</p></div><div class=\"col-lg-3 col-3 competitors-bg\"><p>Not Available</p></div><div class=\"col-lg-3 col-2 kapdec-bg\"><p><img src=\"/assets/img/tick_price.png\"></p></div></div></div></div></div></div></div></section></main></div></div></div></section><script>\r\n    $(document).ready(function () {\r\n        $(\".navbar-nav li\").each(function () {\r\n            $(this).removeClass(\'active\');\r\n        });\r\n        $(\".navbar-nav li:eq(4)\").addClass(\'active\');\r\n\r\n    })\r\n\r\n</script>");
$templateCache.put("app/components/partials/footer/footer.html","<div class=\"footer-main\"><footer ng-controller=\"PartialCtrl as vm\"><div class=\"container pt-md-4\"><div class=\"row\"><div class=\"col-md-6 col-lg-3\"><div class=\"footer_content mb-lg-0 mb-4\"><a ui-sref=\"index.home\" style=\"padding-left: 0px;\" ui-sref-opts=\"{reload: true}\"><img src=\"assets/img/logo.png\" alt=\"\"></a><p class=\"pb-3\">We believe that good quality education should be available to all, we aim to provide affordable, high-quality education using the best methods and techniques from around the globe to help students everywhere.</p><p class=\"address\"><img src=\"assets/img/icn_mappin.png\" alt=\"\"> <strong>Kapdec</strong><br>26753, Annesley RD, Beachwood, OH – 44122, USA.</p></div></div><div class=\"col-md-6 col-lg-3\"><div class=\"footer_content mb-lg-0 mb-4\"><h4>Quick Links</h4><ul><li class=\"py-1\"><a ui-sref=\"index.about\" ui-sref-opts=\"{reload: true}\">About Us</a></li><li class=\"py-1\"><a ui-sref=\"index.stories\" ui-sref-opts=\"{reload: true}\">Stories</a></li><li class=\"py-1\"><a ui-sref=\"index.howItWorks\" ui-sref-opts=\"{reload: true}\">Kapdec’s Philosophy</a></li><li class=\"py-1\"><a href=\"#\">Team</a></li><li class=\"py-1\"><a ui-sref=\"index.FAQs\" ui-sref-opts=\"{reload: true}\">FAQs</a></li><li class=\"py-1\"><a ui-sref=\"index.career\" ui-sref-opts=\"{reload: true}\">Career</a></li></ul></div></div><div class=\"col-md-6 col-lg-3\"><div class=\"footer_content mb-lg-0 mb-4\"><h4>Other</h4><ul><li class=\"py-1\"><a ui-sref=\"index.contact\">Contact Us</a></li><li class=\"py-1\"><a ui-sref=\"index.terms\" ui-sref-opts=\"{reload: true}\">Terms & Conditions</a></li><li class=\"py-1\"><a ui-sref=\"index.privacy\" ui-sref-opts=\"{reload: true}\">Privacy policy</a></li><li class=\"py-1\"><a ui-sref=\"index.subscription\" ui-sref-opts=\"{reload: true}\">Pricing</a></li></ul></div></div><div class=\"col-md-6 col-lg-3\"><div class=\"footer_newslater\"><h4>Subscribe</h4><p>Subscribe Us Now</p><form novalidate=\"\" name=\"form\" ng-submit=\"vm.subscribe(form)\" ng-class=\"{ \'has-success\': form.email.$valid, \'has-error\': form.email.$invalid}\"><input type=\"email\" placeholder=\"Your Email\" name=\"email\" ng-pattern=\"vm.pattern.email\" ng-model=\"vm.subscriber.email\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'Email\'\" required=\"\" mongoose-error=\"\" autocomplete=\"off\"><p class=\"help-block\" ng-show=\"form.email.$error.pattern\" style=\"color: red\">Doesn\'t look like a valid email.</p><p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submit\" style=\"color: red\">Please enter email address.</p><input type=\"submit\" value=\"\"></form></div></div></div></div></footer><div class=\"copyright_Section\"><div class=\"container\"><div class=\"row align-items-center\"><div class=\"col-lg-8\"><div class=\"reserved text-lg-left text-center\">Copyright © 2019. Kapdec. All Rights Reserved. | <a ui-sref=\"index.terms\">Terms & Condition</a>| <a ui-sref=\"index.privacy\">Privacy Policy</a> <a ui-sref=\"index.sitemap\">| Sitemap</a></div></div><div class=\"col-lg-4\"><div class=\"social_icons\"><ul class=\"mb-0 d-flex justify-content-lg-end justify-content-center my-lg-0 my-1\"><li><a href=\"https://www.facebook.com/Kapdec/\" target=\"_blank\"><i class=\"fa fa-facebook\"></i></a></li><li><a href=\"https://twitter.com/kapdec/\" target=\"_blank\"><i class=\"fa fa-twitter\"></i></a></li><li><a href=\"#\"><i class=\"fa fa-linkedin\"></i></a></li><li><a href=\"#\"><i class=\"fa fa-google-plus\"></i></a></li><li><a href=\"#\"><i class=\"fa fa-youtube\"></i></a></li></ul></div></div></div></div></div><div id=\"scrollup\" class=\"scroll-to-up\"><i class=\"fa fa-angle-double-up\"></i></div></div><script>\r\n  $(document).ready(function () {\r\n  // declare variable\r\n  var scrollTop = $(\"#scrollup\");\r\n\r\n  $(window).scroll(function() {\r\n    // declare variable\r\n    var topPos = $(this).scrollTop();\r\n\r\n    // if user scrolls down - show scroll to top button\r\n    if (topPos > 100) {\r\n      $(scrollTop).css(\"opacity\", \"1\");\r\n\r\n    } else {\r\n      $(scrollTop).css(\"opacity\", \"0\");\r\n    }\r\n\r\n  }); // scroll END\r\n\r\n  $(\'#scrollup\').on(\'click\', function(event) {\r\n    $(\'html, body\').animate({\r\n      scrollTop: $(\'header\').offset().top\r\n    }, 1000);\r\n  });\r\n  });\r\n  </script>");
$templateCache.put("app/components/partials/header/header.html","<div class=\"top-header-content\" ng-controller=\"PartialCtrl as vm\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\"><div class=\"header-button\"><ul class=\"nav justify-content-end\"><li><a href=\"javascript:void(0)\" ng-click=\"vm.login()\">Login</a></li><li>|<a href=\"javascript:void(0)\" ng-click=\"vm.signup()\">Signup</a></li></ul></div></div></div></div></div><div class=\"header-container\"><div class=\"container\"><div class=\"row align-items-center\"><div class=\"col-md-3 col-9\"><h1><a href=\"javascript:void(0)\" ui-sref=\"index.home\" ui-sref-opts=\"{reload: true}\"><img src=\"assets/img/logo.png\" class=\"img-fluid\" alt=\"logo\"></a></h1></div><div class=\"col-md-9 col-3\"><nav class=\"navbar navbar-expand-lg navbar-light p-0 justify-content-end\"><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button><div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\"><ul class=\"navbar-nav ml-auto align-items-center\"><li class=\"nav-item active\"><a class=\"nav-link\" ui-sref=\"index.home\" ui-sref-opts=\"{reload: true}\">Home</a></li><li class=\"nav-item\" id=\"sub-nav-bar\"><a class=\"nav-link dropdown-toggle\" id=\"navbarDropdown\" role=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">About Kapdec</a><div class=\"dropdown-menu\" aria-labelledby=\"navbarDropdown\"><a class=\"dropdown-item\" ui-sref=\"index.about\" ui-sref-opts=\"{reload: true}\">About Us</a> <a class=\"dropdown-item\" ui-sref=\"index.team\" ui-sref-opts=\"{reload: true}\">Our Team</a></div></li><li class=\"nav-item\"><a class=\"nav-link\" ui-sref=\"index.howItWorks\" ui-sref-opts=\"{reload: true}\">Kapdec’s Philosophy</a></li><li class=\"nav-item\"><a class=\"nav-link\" ui-sref=\"index.stories\" ui-sref-opts=\"{reload: true}\">Stories</a></li><li class=\"nav-item\"><a class=\"nav-link\" ui-sref=\"index.subscription\" ui-sref-opts=\"{reload: true}\">Pricing</a></li><li class=\"nav-item\"><a class=\"nav-link pr-md-0\" ui-sref=\"index.contact\" ui-sref-opts=\"{reload: true}\">Contact</a></li></ul></div></nav></div></div></div></div><script>\r\n    $(document).ready(function () {\r\n        $(\".nav-item\").click(function () {\r\n            $(this).siblings().removeClass(\'active\');\r\n            $(this).addClass(\'active\');\r\n         \r\n        });\r\n       \r\n       \r\n    })\r\n    \r\n    </script>");
$templateCache.put("app/admin-panel/manage-question/add-question/add-question.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>Manage Question</h3></div></div><div class=\"check students_page\"><div class=\"table_section classes\"><div class=\"card mb-5\"><div class=\"col-sm-12\"><form ng-submit=\"vm.updateQuestion(form)\" novalidate=\"\" name=\"form\"><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><label>Country</label><select class=\"form-control\" name=\"country\" id=\"country\" ng-change=\"vm.getGradeByCountry(vm.ques.country)\" ng-model=\"vm.ques.country\" required=\"\"><option value=\"\">Select Country</option><option ng-repeat=\"option in vm.curriculum track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.country.$error.required && vm.submitted\">A Country is required</p><p ng-show=\"form.country.$error.minlength && vm.submitted\" class=\"help-block text-danger\">Country must be atleast 4 characters.</p></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.grade.$valid && vm.submitted, \'has-error\': form.grade.$invalid && vm.submitted }\"><label>Grade</label><select class=\"form-control\" name=\"grade\" id=\"grade\" ng-model=\"vm.ques.grade\" ng-change=\"vm.getCourse(vm.ques.grade)\" required=\"\"><option value=\"\">Select Grade</option><option ng-repeat=\"option in vm.grades track by option._id\" value=\"{{option._id}}\">{{option.name}}</option></select><p class=\"help-block text-danger\" ng-show=\"form.grade.$error.required && vm.submitted\">A grade is required</p></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.course.$invalid && vm.submitted }\"><label>Subject</label><select ng-model=\"vm.ques.course\" ng-change=\"vm.getTopics(vm.ques.course)\" name=\"course\" class=\"form-control\" required=\"\" ng-options=\"course._id as course.name for course in vm.courses\"><option value=\"\">Select Subject</option></select><p class=\"help-block text-danger\" ng-show=\"form.course.$error.required && vm.submitted\">A Subject is required.</p></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.level.$invalid && vm.submitted }\"><label>Topic</label><select ng-model=\"vm.ques.topic\" name=\"topic\" ng-change=\"vm.getUnits(vm.ques.topic)\" class=\"form-control chosen-select\" required=\"\" ng-options=\"topic._id as topic.name for topic in vm.topics\"><option value=\"\">Select Topic</option></select><p class=\"help-block text-danger\" ng-show=\"form.topic.$error.required && vm.submitted\">A topic is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.unit.$invalid && vm.submitted }\"><label>Module</label><select ng-model=\"vm.ques.unit\" ng-change=\"vm.getChapters(vm.ques.unit)\" name=\"unit\" class=\"form-control chosen-select\" required=\"\" ng-options=\"unit._id as unit.name for unit in vm.units\"><option value=\"\">Select Module</option></select><p class=\"help-block text-danger\" ng-show=\"form.unit.$error.required && vm.submitted\">A Module is required.</p></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.chapter.$invalid && vm.submitted }\"><label>Chapter</label><select ng-model=\"vm.ques.chapter\" name=\"chapter\" class=\"form-control\" required=\"\" ng-options=\"chapter._id as chapter.name for chapter in vm.chapters\"><option value=\"\">Select Chapter</option></select><p class=\"help-block text-danger\" ng-show=\"form.chapter.$error.required && vm.submitted\">A chapter is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.level.$invalid && vm.submitted }\"><label>Level</label><select ng-model=\"vm.ques.level\" name=\"level\" class=\"form-control\" required=\"\" ng-options=\"level.id as level.text for level in vm.level | orderBy:\'weight\'\"><option value=\"\">Select Level</option></select><p class=\"help-block text-danger\" ng-show=\"form.level.$error.required && vm.submitted\">A level is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.question.$valid , \'has-error\': form.question.$invalid && vm.submitted }\"><label>Question</label><div class=\"quill-text-editor\"><ng-quill-editor name=\"questionDescription\" ng-model=\"vm.ques.questionDescription\" placeholder=\"Question description\" required=\"\"></ng-quill-editor><p class=\"help-block text-danger\" ng-show=\"form.questionDescription.$error.required && vm.submitted\">Please enter Question!</p></div></div></div><div class=\"row\"><div ng-repeat=\"option in vm.ques.answerChoices\" class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.{{\'option\'+$index}}.$valid ,\'has-error\': form.{{\'option\'+$index}}.$invalid && vm.submitted }\"><label>Option {{$index+1}}</label><div class=\"row\"><div class=\"col-sm-11\"><ng-quill-editor ng-minlength=\"1\" ng-model=\"vm.ques.answerChoices[$index].value\" name=\"{{\'option\'+$index}}\" placeholder=\"option {{$index+1}}\" onfocusin=\"this.placeholder=\'\'\" onfocusout=\"this.placeholder=\'option\'\" required=\"\"></ng-quill-editor><p class=\"help-block text-danger\" ng-show=\"form.{{\'option\'+$index}}.$error.required && vm.submitted\">option {{$index+1}} is required.</p></div><div ng-if=\"!$index\" class=\"col-sm-1\"><a href=\"javascript:void(0)\" class=\"btn btn-warning\" style=\"margin-left: -21px;\" ng-click=\"vm.addOption();\"><i class=\"fa fa-plus\"></i></a></div><div ng-if=\"$index\" ng-hide=\"vm.ques.answerChoices.length == 2\" class=\"col-sm-1\"><a href=\"javascript:void(0)\" class=\"btn btn-danger\" style=\"margin-left: -21px;\" ng-click=\"vm.delOption($index);\"><i class=\"fa fa-minus\"></i></a></div></div></div></div><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\' : form.answer.$invalid && vm.submitted }\"><label>Correct Choice</label><select ng-model=\"vm.ques.correctChoice\" name=\"answer\" data-placeholder=\"option answer\" class=\"form-control\" required=\"\" ng-options=\"answer.option as \'option \'+answer.option for answer in vm.ques.answerChoices\"><option value=\"\">Select Answer</option></select><p class=\"help-block text-danger\" ng-show=\"form.answer.$error.required && vm.submitted\">A answer is required.</p></div><div class=\"form-group col-sm-12\" ng-class=\"{ \'has-success\': form.explanation.$valid , \'has-error\': form.explanation.$invalid && vm.submitted }\"><label>Explaination</label><div class=\"quill-text-editor\"><ng-quill-editor name=\"explaination\" ng-model=\"vm.ques.explaination\" placeholder=\"Explanation description\" required=\"\"></ng-quill-editor><p class=\"help-block text-danger\" ng-show=\"form.explaination.$error.required && vm.submitted\">Please enter Explanation!</p></div></div></div><div class=\"form-group col-sm-6\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group col-sm-12\"><div class=\"edit_profile close_btn pull-right\"><a href=\"javascript:void(0)\" class=\"btn\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Cancel</a></div><div class=\"edit_profile submit pull-right\" style=\"margin-right:5px\"><button type=\"submit\" class=\"btn\">Save</button></div></div></form></div></div></div></div>");
$templateCache.put("app/admin-panel/manage-subscription/edit-subscription/edit-subscription.html","<div class=\"row breadcrumb_section\"><div class=\"col-md-6\"><h3>{{vm.subscription._id?\'Update\':\'Create\'}} Subscription Plan</h3></div></div><div class=\"check students_page\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table_section classes\"><div class=\"card mb-5\"><div class=\"col-sm-12\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.name.$valid && vm.submitted, \'has-error\': form.name.$invalid && vm.submitted }\"><label class=\"control-label\">Title</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.title\" ng-minlength=\"3\" name=\"title\" placeholder=\"Title\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.title.$error.required && vm.submitted\">A title is required.</p><p ng-show=\"form.title.$error.minlength && vm.submitted\" class=\"help-block text-danger\">title must be atleast 3 characters.</p></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.currency.$valid && vm.submitted, \'has-error\': form.currency.$invalid && vm.submitted }\"><label class=\"control-label\">Currency :</label><select type=\"text\" class=\"form-control\" ng-model=\"vm.subscription.currency\" name=\"currency\" ng-options=\"option.code as option.currency for option in vm.currency\" required=\"\"><option value=\"\" selected=\"\">Select Currency</option></select><p class=\"help-block text-danger\" ng-show=\"form.currency.$error.required && vm.submitted\">A currency Type is required.</p></div></div><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-success\': form.duration.$valid && vm.submitted, \'has-error\': form.duration.$invalid && vm.submitted }\"><label class=\"control-label\">Duration</label><select class=\"form-control\" ng-model=\"vm.subscription.duration\" name=\"duration\" required=\"\"><option value=\"\" selected=\"\">Select Duration</option><option value=\"30\">Monthly</option><option value=\"365\">Yearly</option></select><p class=\"help-block text-danger\" ng-show=\"form.duration.$error.required && vm.submitted\">Duration is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.duration.$valid && vm.submitted, \'has-error\': form.duration.$invalid && vm.submitted }\"><label class=\"control-label\">Amount</label> <input type=\"text\" class=\"form-control\" numbers-only=\"\" ng-model=\"vm.subscription.amount\" maxlength=\"7\" name=\"amount\" placeholder=\"Amount\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.amount.$error.required && vm.submitted\">Amount is required.</p></div><div class=\"form-group col-sm-3\" ng-class=\"{ \'has-success\': form.duration.$valid && vm.submitted, \'has-error\': form.duration.$invalid && vm.submitted }\"><label class=\"control-label\">Discount (%)</label> <input type=\"text\" class=\"form-control\" numbers-only=\"\" ng-model=\"vm.subscription.discount\" maxlength=\"2\" name=\"discount\" placeholder=\"Discount\" required=\"\"><p class=\"help-block text-danger\" ng-show=\"form.discount.$error.required && vm.submitted\">Discount is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-success\': form.feature.$valid && vm.submitted, \'has-error\': form.feature.$invalid && vm.submitted }\"><label class=\"control-label\">Feature:</label> <textarea class=\"form-control\" rows=\"5\" style=\"max-height: 100px !important;\" ng-model=\"vm.subscription.features\" placeholder=\"feature description\" required=\"\"></textarea><p class=\"help-block text-danger\" ng-show=\"form.feature.$error.required && vm.submitted\">Please enter Feature description!</p></div><div class=\"form-group has-error\"><p class=\"help-block text-danger\" ng-show=\"vm.errors && vm.errors.other\">{{\" \"+ vm.errors.other }}</p></div><div class=\"form-group edit_profile submit\"><a class=\"btn col-offset-sm-1\" style=\"margin-left: 13px;\" ui-sref=\"admin.managesubscription\">Cancel</a> <button ng-class=\"{\'close-event\': vm.isBusy }\" ng-if=\"vm.subscription._id\" ng-click=\"vm.updateSubscription(form)\" class=\"btn\" type=\"submit\" value=\"Save\">Save</button> <button ng-class=\"{\'close-event\': vm.isBusy }\" ng-if=\"!vm.subscription._id\" ng-click=\"vm.addSubscription(form)\" class=\"btn\" type=\"submit\" value=\"Save\">Save</button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/discussion-topic/my-discussion/myDiscussion.html","<div class=\"row margin-left-15\"><div class=\"col-md-12 discussion_topic_page\" style=\"margin-left:-15px\"><h3 class=\"discussion_question_heading\">My Discussion</h3><div ng-if=\"vm.loader\" class=\"main-page more_loader margin-all-15\"><h3>Loading.. <i class=\"fa fa-circle-o-notch fa-spin\"></i></h3></div><div class=\"askque\"><button type=\"button\" class=\"question\" data-toggle=\"modal\" data-target=\"#askquestion\" ng-click=\"vm.submitted=false;vm.question=\'\'\">Ask Your Question</button></div><div class=\"discussion_box\" ng-repeat=\"discussion in vm.myDiscussions\" ng-if=\"vm.myDiscussions && vm.myDiscussions.length\"><h4 class=\"discussion_question\">Q {{$index+1}}. {{discussion.discussionTitle}}</h4><p class=\"discussed_views\" ng-repeat=\"answers in discussion.answerSheet | limitTo : vm[\'ansList\'+$parent.$index] || 5\" ng-if=\"discussion.answerSheet && discussion.answerSheet.length\"><span>Answer {{$parent.$index+1}}.</span> {{answers.answer}} <span class=\"answerBy\">Answered By <b>{{answers.answeredBy.name}}</b></span><div ng-if=\"answers.length >5\" class=\"col-sm-12 text-center\"><button ng-click=\"vm.loadMore( \'ansList\'+$parent.$index )\" class=\"load-more-btn float-none btn btn-xs btn-default\">see more.. <i ng-if=\"vm.loader\" class=\"fa fa-refresh fa-spin\"></i></button></div><form ng-submit=\"vm.postReply( form, discussion, $parent.$index )\" novalidate=\"\" name=\"form\"><div class=\"answer-here\"><div class=\"form-group\" ng-class=\"{ \'has-success\': form.answer{{$parent.$index}}.$valid && vm.submitted, \'has-errorX\': form.answer{{$parent.$index}}.$invalid && vm.submitted }\"><textarea autocomplete=\"off\" ng-minlength=\"10\" name=\"answer{{$parent.$index}}\" ng-model=\"discussion.addReply\" placeholder=\"Post your answer here...\" class=\"form-control\" required=\"\"></textarea></div><p class=\"help-block\" ng-show=\"form.answer{{$parent.$index}}.$error.required && vm[\'submitted\'+$parent.$index]\">Please enter your answer.</p></div><button ng-disabled=\"vm[\'loadReply\'+$parent.$index]\" type=\"submit\" class=\"posturanswer\">Post Your Answer <b ng-if=\"vm[\'loadReply\'+$parent.$index]\" class=\"animated fadeInLeft infinite\">...</b></button></form></p></div><div class=\"col-sm-12 pagination-div\"><ul uib-pagination=\"\" class=\"pagination-sm\" ng-change=\"vm.changeDiscussionPage()\" ng-show=\"!vm.loader && vm.myDiscussions && vm.myDiscussions.length >15\" items-per-page=\"vm.filterQues.limit\" ng-model=\"vm.filterQues.page\" total-items=\"vm.filterClass.total\" max-size=\"10\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div><div class=\"modal fade\" id=\"askquestion\" role=\"dialog\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button></div><div class=\"modal-body\"><h3>Ask Your Question</h3><form ng-submit=\"vm.askQuestion(askform)\" novalidate=\"\" name=\"askform\"><div class=\"form-group\" ng-class=\"{ \'has-success\': askform.question.$valid && vm.submitted, \'has-error\': askform.question.$invalid && vm.submitted }\"><input type=\"text\" ng-minlength=\"10\" maxlength=\"800\" autocomplete=\"off\" name=\"question\" ng-model=\"vm.question\" class=\"form-control\" placeholder=\"Enter your question here....\" required=\"\"></div><p class=\"help-block\" ng-show=\"askform.question.$error.minlength && vm.submitted\">Your question atleast 10 character.</p><p class=\"help-block\" ng-show=\"askform.question.$error.required && vm.submitted\">Please enter your question.</p><button ng-disabled=\"vm.loader\" type=\"submit\" class=\"post_question\">Submit <b ng-if=\"vm.loader\" class=\"animated fadeInLeft infinite\">...</b></button></form></div></div></div></div>");}]);